import _, { initial, isNaN } from 'lodash'
import { v4 as uuid } from 'uuid'
import moment from 'moment'
import { fromJS, Map, List, isImmutable } from 'immutable'
import {
  getOpposite,
  processActionsSFItem,
  toJS,
  isValidDomain,
  resetLoadingFlags,
  ftGetLocalStorage,
  ftRemoveLocalStorage,
  ftSetLocalStorage,
  revertActionID,
  parseURLParameters,
  updateTabValue,
  getElemName,
  isTextAndBlank,
} from './common'
import { setVisibilityOfSFMappingElem } from "./setVisibilityOfSFMappingElem";
import { getRules } from "./getRules";
import { getMappingCount } from "../constants/getMappingCount";
import { webProjectSSOLogout } from '../lib/auth'
import { getPreviewDynamicData } from './projectAxios';
import { IS_SERVER } from '../constants/ssr';
import { processValueRules } from './rules';
import { compactArrayPath, initializePowerFields, recalculatePowerFields } from './powerFields';
import { getElementDataRoot } from '../constants/getElementDataRoot';
import { exportToCsv, exportToJpeg, exportToPdf, exportToPng } from '../components/WidgetBuilder/Widgets/Chart/Common/ExportPlugin';
import { LIST_BASED_FIELDS } from "../constants/LIST_BASED_FIELDS";
import { DRAWER_MOBILE, getFirstParentElement, getParentIdInModal, getRepeatParent, getValueForMode, isProjectContainer, LAYOUT_MODE } from '../constants/toUnits';
import { eProductFields } from "../constants/eProductFields";
import { CHAT_BOT_TYPE } from '../constants/features';
import { clearHTML, getAllChildren, getAllVisibleChildren } from '../components/WidgetBuilder/UI/Components/lib';
import { setCartToLocalStorage } from '../store/project/cart';
import { TAB_TYPES } from './tab-utils';
import { shallowEqual as _shallowEqual } from 'react-redux';
import { getProjectLocalKey, getSessionProjectLocaKey } from '../components/WidgetPreview/ProjectPersistSessionParameter';
import { isAllowFeatureState } from './web-license';
import { isParentRepeat, getParentRepeatUID } from '../store/project/processCondCache.js'
import { toNumber } from './getBreakPoints';
import { collectAllChildren, getChildUIDs } from './widgets';
import { filterChangedPathAC, filterRulesAC, getACByState, recursiveParentInvisibleValidation } from '../hooks/useACRule';
import { getFormDateFormat } from './format';
import { ftDeleteOfflineValue } from './offline-storage';
import { collectFieldForRestore, collectFieldForStore, collectFieldGroupForRestore, collectFieldGroupForStore } from './processPortalRules/collectFromLocalStorage';
import { mapInteractivity } from './processPortalRules/mapInteractivity';
import { handleTextReviewInteractivity } from './processPortalRules/textReviewInteractivity';
import { safeSetIn } from './immutable-tools';
import { eCartFields } from '../constants/GalleryGridFields';
import { reverseIt } from './reverseIt';
import { getPageState } from '../store/project/getPageState.js';
import { fixObjectArrayState } from '../store/project/processDocGen.js';
import {events, nameSpaces, publish, generateEventName} from "./pubsub";
import {alterTrackerOptions} from "./processPortalRules/utils";
import {handleRenameGroup} from "./processPortalRules/renameGroup";
import { ACTION_TYPES } from './constants/ActionTypes';
import { ELEM_TYPES } from './constants/ElementTypes';
import { setValueForElementType, updateState, detectIsTargetKeyInRepeatEl } from './StateUtils';
import { resetTabValue, updateResetStateForRepeatElements, setResetValueOnAction, getDefaultValueForFormFieldByType } from './ResetValueActionUtils';
import { evaluateCustomExpression } from './SetCustomValueActionUtils';
import { getElementInfo } from './AffectElementsUtils'
import { extractSourceValue } from './SetValueFromActionUtils'
import { normalizeKeyPath } from './PathUtils'
import { buildStyleObjectFromActions, getColorValueFromAction, isColorAction, resolveColorValue, colorPrefixesActionMap } from './dynamicColors.utils'

const DISPLAY_DEVICE = {
    lg: 'Desktop',
    md: 'Laptop',
    sml: 'Tablet (L)',
    sm: 'Tablet (S)',
    xs: 'Mobile (L)',
    ss: 'Mobile (S)',
}

export const collectChildID = (state, root, id, processedHash = []) => {
  let elem = state.getIn([...root, 'elements', id], Map())
  let child = []
  if (processedHash.includes(id)) {
    return child
  }
  if (elem.get('type') === 'Form') {
    _.each(LAYOUT_MODE, mode => {
      const childList = elem.getIn(['props', mode, 'children'], Map());

      childList.map(row => {
        row.get('children', Map())
          .map(col => {
            if (col && List.isList(col.get('children', List()))) {
              child = [
                ...child,
                ...col.get('children', List()).toJS()
              ]
            }
          })
      })
    });
  } else if (TAB_TYPES.includes(elem.get('type')) || elem.get('type') === 'Modal' && elem.getIn(['props', 'isExp'])) {
    _.each(LAYOUT_MODE, mode => {
      const tabs = elem.getIn(['props', mode, 'tabs'], List()).toJS()
      child = [
        ...child,
        ..._.flatMap(tabs, tab => tab.children)
      ]
    })
  } else {
    elem.get('children', List()).map(childList => {
      if (List.isList(childList)) {
        child = [...child, ...childList.toJS()]
      } else {
        child.push(childList)
      }
    })
  }
  let allChildList = [];
  _.each(child, (uid) => {
    allChildList = [
      ...allChildList,
      uid,
      ...collectChildID(state, root, uid, processedHash)
    ]
  })
  return _.uniq(allChildList)
}

export const addPathToStateChanges = (inState, path = []) => {
  return inState.setIn(
    ['ft', 'changes'],
    inState.getIn(['ft', 'changes'], List())
      .push(fromJS(path))
  )
}

export const shallowEqual = (a, b) => {
  if (_.isArray(a) && _.isArray(b)) {
    return _shallowEqual(_.compact(a), _.compact(b))
  } else {
    return _shallowEqual(a, b)
  }
}

const setNextModalZIndex = (state, modalID) => {
  const modalZIndexPath = ['rules', 'z-index', modalID]
  const values = _.values(state.getIn(['rules', 'z-index'], Map()).toJS())
  const nextZIndex = values.length > 0
    ? _.maxBy(values, val => {
      let num = parseInt(val, 10)
      if (isNaN(num)) {
        return 0
      }
      return num
    }) + 1
    : 1
  let next = state
    .deleteIn(modalZIndexPath)

  const openedModals = state.getIn(['project', 'Settings', 'ui', 'Modal'], List())
    .reduce((r, id) => {
      if (!state.getIn(['state', 'project', id], true)) {
        r.push(id)
      }
      return r
    }, [])

  next = next.setIn(modalZIndexPath, nextZIndex)

  return next
}

export const getElementFromPath = (path, state) => {
  const repeatRoot = state.getIn(['project', 'Settings', 'RepeatedStripsID'], List()).toJS()
  let elID = path[1]
  if (repeatRoot.includes(elID)) {
    elID = path[2]
  }
  let elem = state.hasIn(['project', 'Settings', 'elements', elID])
    ? state.getIn(['project', 'Settings', 'elements', elID], Map())
    : state.getIn(['pages', state.get('page'), 'Props', 'elements', elID], Map())
  if (isImmutable(elem)) {
    return elem
  } else {
    return Map()
  }
}

export const getStripElementFromPath = (path, state) => {
  const repeatRoot = state.getIn(['project', 'Settings', 'RepeatedStripsID'], List()).toJS()
  let elID = path[1]
  if (!repeatRoot.includes(elID)) {
    return Map()
  }
  let elem = state.hasIn(['project', 'Settings', 'elements', elID])
    ? state.getIn(['project', 'Settings', 'elements', elID], Map())
    : state.getIn(['pages', state.get('page'), 'Props', 'elements', elID], Map())
  if (isImmutable(elem)) {
    return elem
  } else {
    return Map()
  }
}

export const toPlainValue = val => {
  if (_.isObject(val)) {
      if (val.IMG_SRC || val.IMG_SRC === '') {
          return val.IMG_SRC
      } else if (val.ftListLabel || val.ftListLabel === '') {
          return val.ftListLabel
      } else if (val.ft_fileupload) {
        return _.isArray(val.ft_fileupload) ? _.join(val.ft_fileupload, ', ') : val.ft_fileupload
      } else if (val.ftListValue || val.ftListValue === '') {
          return val.ftListValue
      } else if (val.formattedValue || val.formattedValue === '') {
          return val.formattedValue
      } else if (val.ft_text || val.ft_text === '') {
        return val.ft_text
      } else if (val.value || val.value === '' || val.value === 0) {
          return val.value
      } else {
          return val
      }
  } else {
      return val
  }
}

export const isTableRuleKey = (key) => {
  let result = false;
  result = _.startsWith(key, 'tableWidget:');

  return result;
}

export const isListRuleKey = (key) => {
  let result = false;
  result = _.startsWith(key, 'listWidget:') || _.startsWith(key, 'PowerTableWidget:');

  return result;
}

const setValueToObject = (retState, keyPath, value, isList) => {
  try {
    let initialPath = initial(keyPath);

    if(Map.isMap(initialPath)) {
      retState = retState.setIn(keyPath, value);
    } else {
      let pathValidation = [];
      _.each(initialPath, function(key, index){
        pathValidation.push(key);
        if(isList && index == initialPath.length - 1) {
          return false;
        }
        if(retState.getIn(pathValidation) && List.isList(retState.getIn(pathValidation))) {
          retState = retState.setIn(pathValidation, retState.getIn(pathValidation).toMap());
        }
      })

      if(isList) {
          if(!retState.getIn(initialPath, List()).size) {
            retState = retState.setIn(initialPath, List())
          }
      }
      retState = retState.setIn(keyPath, value);
    }

  } catch(err) {
    console.error(err);
  }

  return retState;
}

const transformActions = actions => {
  let ret = Map()

  actions.map((value, key) => {
    if (String(key).indexOf('%') !== -1) {
      const fixedKeyPath = String(key).split('-tab:')
      const newKey = [fixedKeyPath[0], revertActionID(fixedKeyPath[1])].join('-tab:')
      ret = ret.set(newKey, value)
    } else {
      ret = ret.set(key, value)
    }
  })

  return ret
}

const isAllowIndexForPath = (state, path) => {
  let repeatRoot = state.getIn(['project', 'Settings', 'RepeatedStripsID'], List())
  if (_.isArray(path)) {
    let type = state.getIn(['pages', state.get('page'), 'Props', 'elements', path[1], 'type'])
    if (type === 'Widget') {
      type = state.getIn(['pages', state.get('page'), 'Props', 'elements', path[1], 'props', 'data', 'Type'])
    }
    if (!repeatRoot.includes(path[1]) && !['PowerTable', 'list', 'table', 'InteractiveImage'].includes(type)) {
      return false
    }
  }
  return true //default true, like not added change
}

const isListCondition = (rule) => {
  let isTableRule = false, isListRule = false, isParamCondition = false;
  try {
    let conditions;
    if(rule.get('modeType') == 'flow') {
      if(rule.getIn(['actions', 'actionFlow', '0'])) {
        rule.getIn(['actions', 'actionFlow', '0', 'list'], List()).map(flow=>{
          if(!conditions && flow && flow.get('type') == 'condition') {
            conditions = List();
            flow.getIn(['data'], List()).map(rule=>{
              if(rule) {
                rule.getIn(['conditions'], List()).map(cond=>{
                  conditions = conditions.push(cond);
                })
              }
            })
          }
        })
      }
    } else {
      conditions = rule.get('conditions', List())
    }
    if(conditions) {
      conditions.map(condition => {
        isTableRule = isTableRuleKey(condition.getIn(['field', 'group'], ''));
        if(!isTableRule) {
          isTableRule = isTableRuleKey(condition.getIn(['value', 'group'], ''));
        }

        isListRule = isListRuleKey(condition.getIn(['field', 'group'], ''));
        if(!isListRule) {
          isListRule = isListRuleKey(condition.getIn(['value', 'group'], ''));
        }

        if (condition.getIn(['field', 'group']) == 'param') {
          isParamCondition = true;
        }
      });
    }
  } catch(err) {
    console.error(err);
  }

  return {
    isTableRule,
    isListRule,
    isParamCondition
  }
}

export const getPersistentDrawerWidth = (state) => {
  const drawer = state.getIn(['state', 'drawer'], '')
  const drawerVisibility = state.getIn(['state', 'project', drawer], true)
  const mode = state.get('layoutMode', 'lg')
  if (drawer && getValueForMode(state.getIn(['project', 'Settings', 'elements', drawer], Map()), mode, ['props'], ['isPersistent'], false)) {
    const ref = state.getIn(['project', 'Settings', 'elements', drawer, 'props', 'styleRef'], null)
    const drawerWidth = state.getIn(['project', 'Settings', 'styles', ref, mode, 'root', '--drawer-width'])
    if (!drawerVisibility && !DRAWER_MOBILE.includes(mode)) {
      if (drawerWidth) {
        return `${toNumber(drawerWidth)}px`
      }
    }
  }
  return ''
}
export const getPersistentDrawerIsCut = (state) => {
  const drawer = state.getIn(['state', 'drawer'], '')
  const drawerVisibility = state.getIn(['state', 'project', drawer], true)
  const mode = state.get('layoutMode', 'lg')
  if (drawer && getValueForMode(state.getIn(['project', 'Settings', 'elements', drawer], Map()), mode, ['props'], ['isPersistent'], false)) {
    return getValueForMode(state.getIn(['project', 'Settings', 'elements', drawer], Map()), mode, ['props'], ['isIsCut'], false)
  }
  return false
}

const toFloat = val => {
  let num = parseFloat(val)
  if (Number.isNaN(num)) {
    return 0
  } else {
    return num
  }
}

const formtICSDate = date => {
  let momentDate = moment(date)
  if (momentDate.format() !== 'Invalid date') {
    return moment(date).format('YYYY-M-D-H-m').split("-").map(v => parseInt(v, 10))
  }
  return undefined
}

const updateEventDuration = conf => {
  if (conf.duration) {
    let {
      weeks, days, hours, minutes, seconds
    } = conf.duration
    if (seconds > 60) {
      let extraMinutes = Math.floor(seconds / 60)
      seconds = seconds % 60
      minutes += extraMinutes
    }
    if (minutes > 60) {
      let extraHours = Math.floor(minutes / 60)
      minutes = minutes % 60
      hours += extraHours
    }
    if (hours > 24) {
      let extraDays = Math.floor(hours / 60)
      hours = hours % 24
      days += extraDays
    }
    if (days > 7) {
      let extraWeeks = Math.floor(hours / 60)
      days = days % 7
      weeks += extraWeeks
    }
    conf.duration.seconds = seconds
    conf.duration.minutes = minutes
    conf.duration.hours = hours
    conf.duration.days = days
    conf.duration.weeks = weeks
  }
  return conf
}

export const getCalendarFileContent = async (id, state) => {
  let event = state.getIn(['project', 'Settings', 'store', 'public', id], Map())
  let appState = {
    ...getParams(state),
    ...getState(state)
  }

  const getValue = key => {
    if (event.getIn([key, 'type'], 'static') === 'static') {
      return event.getIn([key, 'textValue'], '')
    } else {
      return _.get(appState, String(event.getIn([key, 'field'], '')).split(':'), '')
    }
  }

  let categories = getValue('categories')
  if (!_.isArray(categories)) {
    categories = _.isString(categories) ? String(categories).split(',') : [categories]
  }
  let attendeesName = getValue('attendeesName')
  let attendeesEmail = getValue('attendeesEmail')
  let attendees = []
  if (_.isArray(attendeesName)) {
    _.each(attendeesName, (name, index) => {
      attendees.push({
        name,
        email: _.get(attendeesEmail, [index], '')
      })
    })
  } else {
    attendees.push({
      name: attendeesName,
      email: attendeesEmail
    })
  }

  let end = formtICSDate(getValue('end'))
  let start = formtICSDate(getValue('start'))

  let eventConf = {
    title: getValue('title'),
    description: getValue('description'),
    start,

    ...end ? {
      end,
    } : {
      duration: {
        weeks: parseInt(getValue('durationWeeks'), 10) || 0,
        days: parseInt(getValue('durationDays'), 10) || 0,
        hours: parseInt(getValue('durationHours'), 10) || 0,
        minutes: parseInt(getValue('durationMinutes'), 10) || 0,
        seconds: parseInt(getValue('durationSeconds'), 10) || 0,
      },
    },
    startInputType: 'local',
    startOutputType: 'local',
    location: getValue('address'),
    url: getValue('url'),
    geo: {
      lat: toFloat(getValue('lat')),
      lon: toFloat(getValue('lon'))
    },
    categories,
    status: getValue('status'),
    organizer: {
      name: getValue('organizerName'),
      email: getValue('organizerEmail')
    },
    attendees: attendees
  }
  eventConf = updateEventDuration(eventConf)
  // console.log(eventConf)
  const { createEvent } = await import('ics')
  return await new Promise(resolve => {
    createEvent(eventConf, (error, file) => {
      if (error) {
        console.log(error, eventConf)
        return resolve('')
      }
      resolve(file)
    })
  })
}

const processDownloadEvent = (evID, state) => {
  let [__, eventID] = String(evID).split(':')
  getCalendarFileContent(eventID, state).then(file => {
    if (file) {
      let filename = 'calendar.ics'
      var blob = new Blob([file], { type: 'text/calendar;charset=utf-8;' });
      if (navigator.msSaveBlob) { // IE 10+
        navigator.msSaveBlob(blob, filename);
      } else {
        try {
          var link = document.createElement("a");
          if (link.download !== undefined) { // feature detection
            // Browsers that support HTML5 download attribute
            var url = URL.createObjectURL(blob);
            link.setAttribute("href", url);
            link.setAttribute("download", filename);
            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }
        } catch (error) { }
      }
    }
  })
}

const getReadOnlyParameters = state => {
  const pageReadOnly = state.getIn(['pages', state.get('page'), 'Props', 'params'], List())
    .map(param => param.get('isReadOnly') ? param.get('id') : null)
    .filter(v => v).toJS()
  const readOnlyId = state.getIn(['project', 'params'], List())
    .map(param => param.get('isReadOnly') ? param.get('id') : null)
    .filter(v => v).toJS()
  return [
    ...pageReadOnly,
    ...readOnlyId
  ]
}
const isValidJSON = (jsonString) =>{
  try {
      JSON.parse(jsonString);
      return true;
  } catch (error) {
      return false;
  }
}

const ALLOW_MANDATORY_TYPE = ['FormField', 'AddressFinder', 'Search', 'Button', 'TextReview']

export const isElementsValid = (elements, retState, isBtnRepeat, index, repeatID, pageUID) => {
  let page = retState.get('page')
  let isValid = true

  const getRootParent = (uid, root) => {
    const parent = retState.getIn([...root, 'elements', uid, 'parent'])
    if (parent) {
        let parentType = retState.getIn([...root, 'elements', parent, 'type'])
        if (parentType === 'Strip' || parentType === 'RepeatAutoFit') {
            return parent
        } else {
            return getRootParent(parent, root)
        }
    } else {
        return null
    }
}

  let appState = getState(retState)
  _.each(elements, elemUID => {
    const elPath = getElementDataRoot(
      retState.hasIn(['project', 'Settings', 'elements', elemUID]) ? 'project' : page
    )
    let component = retState.getIn([...elPath, 'elements', elemUID], Map())
    const isRepeat = isParentRepeat(retState, elemUID)
    if (isRepeat && (index === undefined || index === null)) {
      let repeatID = getParentRepeatUID(retState, elemUID)
      let repStatePath = [pageUID, repeatID]
      let repState = _.get(appState, repStatePath, {})
      let count = getMappingCount(repState)
      const repeatElem = retState.getIn([...elPath, 'elements', repeatID], Map())
      if (Map.isMap(repeatElem) && repeatElem.getIn(['props', 'allowEmptyRow']) && count === 0) {
        count = 1
      }
      for (let i = 0; i < count; i++) {
        let index = i
        let isBtnRepeat = true
        const parentStatus = getParentRulesStatus(
          component.get('parent'),
          page,
          pageUID,
          index,
          elemUID,
          repeatID,
          retState
        )
        let localPath = ['formFieldStatuses', pageUID, elemUID];
        let rulesPath = ['rules', pageUID, elemUID];
        let value;
        if (isBtnRepeat && index !== undefined && index !== null) {
          rulesPath = ['rules', pageUID, repeatID, elemUID, index];
          localPath = ['formFieldStatuses', pageUID, repeatID, elemUID, String(index)];

          let repState = retState.getIn(['state', pageUID, repeatID, elemUID], Map());
          if (isImmutable(repState)) {
            repState = repState.toJS();
          } else {
            repState = {};
          }
          if (component.get('type') === 'FormField' && component.getIn(['props', 'control']) === 'fileupload') {
            value = _.get(repState, [index, 'ft_fileupload']);
          } else if (component.get('type') === 'FormField' && component.getIn(['props', 'control']) === 'daterange') {
            value = _.get(repState, [index, 'endDate']);
          } else if (component.get('type') === 'FormField' && LIST_BASED_FIELDS.indexOf(component.getIn(['props', 'control'])) > -1) {
            value = _.get(repState, ['ftListValue', index]);
          } else if (component.get('type') === 'FormField' && component.getIn(['props', 'control']) === 'radio') {
            value = _.get(repState, [index, 'ftListValue']);
          } else if (component.get('type') === 'FormField' && component.getIn(['props', 'control']) === 'lookup') {
            value = _.get(repState, ['ft_value', index]);
          } else if (component.get('type') === 'FormField' && component.getIn(['props', 'control']) === 'currency') {
            value = _.get(repState, ['value', index]);
          } else {
            value = _.get(repState, [index]);
          }
        }
        const rulesStatus = retState.getIn(rulesPath, List())
        let rules = List.isList(rulesStatus) ? rulesStatus.toJS() : []

        let ruleStatus = processValueRules(elemUID, component, undefined, index, value, rulesPath, 'sfValidation', retState.getIn(localPath))(null, () => retState);
        //@note error for visible elements
        if (ruleStatus.status && rules.indexOf('hide') === -1 && parentStatus.indexOf('hide') === -1) {
          retState = retState.setIn(localPath, fromJS(ruleStatus.ruleStatus))
          if (ruleStatus?.ruleStatus?.status === 'error' && ruleStatus.error) {
            isValid = false
          }
        }
      }
    } else {
      const parentStatus = getParentRulesStatus(
        component.get('parent'),
        page,
        pageUID,
        index,
        elemUID,
        repeatID,
        retState
      )
      let localPath = ['formFieldStatuses', pageUID, elemUID];
      let rulesPath = ['rules', pageUID, elemUID];
      let value;
      if (isBtnRepeat && index !== undefined && index !== null) {

        rulesPath = ['rules', pageUID, repeatID, elemUID, index];
        localPath = ['formFieldStatuses', pageUID, repeatID, elemUID, String(index)];

        let repState = retState.getIn(['state', pageUID, repeatID, elemUID], Map());
        if (isImmutable(repState)) {
          repState = repState.toJS();
        } else {
          repState = {};
        }
        if (component.get('type') === 'FormField' && component.getIn(['props', 'control']) === 'fileupload') {
          value = _.get(repState, [index, 'ft_fileupload']);
        } else if (component.get('type') === 'FormField' && component.getIn(['props', 'control']) === 'daterange') {
          value = _.get(repState, [index, 'endDate']);
        } else if (component.get('type') === 'FormField' && LIST_BASED_FIELDS.indexOf(component.getIn(['props', 'control'])) > -1) {
          value = _.get(repState, ['ftListValue', index]);
        } else if (component.get('type') === 'FormField' && component.getIn(['props', 'control']) === 'radio') {
          value = _.get(repState, [index, 'ftListValue']);
        } else if (component.get('type') === 'FormField' && component.getIn(['props', 'control']) === 'lookup') {
          value = _.get(repState, ['ft_value', index]);
        } else {
          value = _.get(repState, [index]);
        }
      }
      const rulesStatus = retState.getIn(rulesPath, List())
      let rules = List.isList(rulesStatus) ? rulesStatus.toJS() : []

      let ruleStatus = processValueRules(elemUID, component, undefined, index, value, rulesPath, 'sfValidation', retState.getIn(localPath))(null, () => retState);
      //@note error for visible elements
      if (ruleStatus.status && rules.indexOf('hide') === -1 && parentStatus.indexOf('hide') === -1) {
        retState = retState.setIn(localPath, fromJS(ruleStatus.ruleStatus))
        if (ruleStatus?.ruleStatus?.status === 'error' && ruleStatus.error) {
          isValid = false
        }
      }
    }
  })
  return { isValid, retState }
}

export const processUserCondition = (rule, storeState) => {
  let params = getParams(storeState)
  let state = getState(storeState)
  const smartVParams = typeof window !== 'undefined' ? _.get(getPreviewDynamicData(), 'svParams', {}) : {}

  if (rule.conditions) {
    return processRuleCondition(
      rule.conditions,
      state,
      params,
      smartVParams,
      null,
      {},
      false,
      {},
      {},
      storeState
    )
  } else {
    return false
  }
}

export const makeFormViewList = (component, layoutMode, storeState) => {
  let tabs = toJS(component.getIn(['props', layoutMode, 'tabs'], List()))
  if(component.get('type') === 'PageConditionalForm' && storeState.getIn(['project', 'Settings', 'survey', 'shuffleQuestion'], false)){
    return tabs
  }
  if (component.getIn(['props', 'useCustomFlow'])) {
    let flow = component.getIn(['props', 'flow'], List()).toJS()
    const start = _.first(tabs)
    if (start) {
      let params = getParams(storeState)
      let state = getState(storeState)
      const smartVParams = typeof window !== 'undefined' ? _.get(getPreviewDynamicData(), 'svParams', {}) : {}

      const processCondition = rule => {
        if (rule.conditions) {
          return processRuleCondition(
            rule.conditions,
            state,
            params,
            smartVParams,
            null,
            {},
            false,
            {},
            {},
            storeState
          )
        } else {
          return false
        }
      }

      const getNextTab = (connectionNode, flow) => {
        let target = _.find(flow, node => node.id === connectionNode.target)
        if (target) {
          if (target.type === 'condition') {
            let connections = _.filter(flow, node => node.source === target.id)
            if (connections.length > 0) {
              if (processCondition(target?.data?.rule?.[0])) {
                let nextNode = _.find(connections, node => node.sourceHandle === 'then')
                if (nextNode) {
                  return getNextTab(nextNode, flow)
                }
              } else {
                let nextNode = _.find(connections, node => node.sourceHandle === 'else')
                if (nextNode) {
                  return getNextTab(nextNode, flow)
                }
              }
              return null
            } else {
              return null
            }
          } else {
            let targetNodeID = target.id
            let tab = _.find(tabs, tab => tab.id === targetNodeID)
            return tab
          }
        } else {
          return null
        }
      }
      let tabList = [];
      const processNode = (tab, flow) => {
        if (!tab) {
          tab = {};
        }
        if(tab && tab.id) {
          let existTab = _.find(tabList, node => node.id === tab.id);
          if(existTab) {
            return [];
          }
          tabList.push(tab);
        }

        flow = _.filter(flow, node => (node && node.id));
        let currentNode = _.find(flow, node => node.id === tab.id)
        if (!currentNode) { return [tab] }

        let connectionNode = _.find(flow, node => node.source === tab.id)
        if (!connectionNode) { return [tab] }

        let target = _.find(flow, node => node.id === connectionNode.target)
        if (target) {
          if (target.type === 'condition') {
            let connections = _.filter(flow, node => node.source === target.id)
            if (connections.length > 0) {
              let nexTab = null
              let ruleIndex = null
              const rules = _.filter(
                target?.data?.rule,
                rule => _.get(rule, 'enable', true)
              )
              _.forEach(rules, (rule, index) => {
                if (processCondition(rule)) {
                  ruleIndex = index
                  return false
                }
              })
              if (ruleIndex !== null) {
                let nextNode = _.find(connections, node => node.sourceHandle === `then-${ruleIndex}`)
                if (nextNode) {
                  nexTab = getNextTab(nextNode, flow)
                }
              } else {
                let nextNode = _.find(connections, node => node.sourceHandle === 'else')
                if (nextNode) {
                  nexTab = getNextTab(nextNode, flow)
                }
              }
              if (nexTab) {
                return [tab, ...processNode(nexTab, flow)]
              } else {
                return [tab]
              }
            } else {
              return [tab]
            }
          } else {
            let targetNodeID = target.id
            let nextTab = _.find(tabs, tab => tab.id === targetNodeID)
            return [tab, ...processNode(nextTab, flow)]
          }
        } else {
          return [tab]
        }
      }

      let resultList = processNode(start, flow)
      return resultList;
    }
  }
  return tabs
}

const flipToast = (pos, isRTL) => {
  if (isRTL) {
    switch (pos) {
      case 'top-left':
        return 'top-right'
      case 'top-right':
        return 'top-left'
      case 'bottom-left':
        return 'bottom-right'
      case 'bottom-right':
        return 'bottom-left'
      default: return pos
    }
  } else {
    return pos
  }
}

export const getParentRulesStatus = (
  parent,
  pageID,
  pageUID,
  index,
  child,
  repeatID,
  retState
) => {
  let rules = []
  let elem = retState.getIn(
    [...getElementDataRoot(pageID), 'elements', parent],
    Map()
  )
  if (parent === null || !elem || elem.size === 0) {
    return []
  }
  const layoutMode = retState.get('layoutMode', 'lg')
  const indexPath = typeof index !== 'undefined' && index !== null ? [index] : []
  const repeatPath = typeof index !== 'undefined' && index !== null ? [repeatID] : []
  if (elem.get('type') === 'RepeatAutoFit') {
    const rootRules = retState.getIn(
      ['rules', pageUID, parent, parent, ...indexPath],
      List()
    )
    try {
      if(rootRules.includes('hide')) {
        return _.concat(
          [],
          rules,
          rootRules.toJS() || []
        )
      }
    } catch(err) {
      console.error(err.stack);
    }
  } else if (elem.get('type') === 'Form') {
    const rootRules = retState.getIn(
      ['rules', pageUID, ...repeatPath, parent, ...indexPath],
      List()
    )
    if (isImmutable(rootRules)) {
      rules.push(...rootRules.toJS())
    }
    if (rules.indexOf('hide') !== -1) {
      return rules // already have hide, so no need find it more
    }
    const lgChildren = elem.getIn(['props', layoutMode, 'children'], Map()).toJS()
    const children = getValueForMode(elem, layoutMode, ['props'], ['children'], Map()).toJS()
    const processChildren = layoutMode => (row, id) => {
      const rowChildren = []
      _.each(row.children, col => {
        rowChildren.push(...col.children)
      })
      if (rowChildren.indexOf(child) !== -1) {
        if (row?.originRow && layoutMode !== 'lg') {
          const rootRules = retState.getIn(
            ['rules', pageUID, ...repeatPath, `${parent}-row`, row?.originRow, ...indexPath],
            List()
          )
          if(rootRules && 'toJS' in rootRules){
              rules.push(...rootRules.toJS())
          }
        } else {
          const rootRules = retState.getIn(
            ['rules', pageUID, ...repeatPath, `${parent}-row`, id, ...indexPath],
            List()
          )
          if(rootRules && 'toJS' in rootRules){
            rules.push(...rootRules.toJS())
          }
        }
      }
    }
    _.each(lgChildren, processChildren('lg'))
    _.each(children, processChildren(layoutMode))
    if (rules.indexOf('hide') !== -1) {
      return rules // already have hide, so no need find it more
    }
  } else if (TAB_TYPES.includes(elem.get('type'))) {
    const rootRules = retState.getIn(
      ['rules', pageUID, ...repeatPath, parent, ...indexPath],
      List()
    )
    const rootRulesJS = toJS(rootRules)
    const collectRules = (val, key) => {
      if (_.isArray(val)) {
        rules = _.concat([], rules, val)
      } else if (_.isObject(val)) {
        _.each(val, collectRules)
      } else {
        rules.push(val)
      }
    }
    _.each(rootRulesJS, collectRules)
    // rules.push(...rootRules.toJS())
    if (rules.indexOf('hide') !== -1) {
      return rules // already have hide, so no need find it more
    }

    const lgTabs = getValueForMode(elem, 'lg', ['props'], ['tabs'], List()).toJS()
    const tabs = getValueForMode(elem, layoutMode, ['props'], ['tabs'], List()).toJS()
    const processTabItem = (tab, id) => {
      if (_.get(tab, 'children', []).indexOf(child) !== -1) {
        const rootRules = retState.getIn(
          ['rules', pageUID, ...repeatPath, `${parent}-tab`, tab.id, ...indexPath],
          List()
        )
        rules.push(...rootRules.toJS())
      }
    }
    _.each(lgTabs, processTabItem)
    _.each(tabs, processTabItem)
    if (rules.indexOf('hide') !== -1) {
      return rules // already have hide, so no need find it more
    }
  } else if (elem.get('type') === 'Stack') {
    const rootRules = retState.getIn(
      ['rules', pageUID, ...repeatPath, parent, ...indexPath],
      List()
    )
    try {
      rules = _.concat(
        [],
        rules,
        rootRules.toJS() || []
      )
    } catch (err) {
      console.error(err.stack);
    }
  }
  rules.push(
    ...getParentRulesStatus(
      elem.get('parent'),
      pageID,
      pageUID,
      index,
      parent,
      repeatID,
      retState
    )
  )
  return rules
}

export const hideSFLoadingMessages = (state) => {
  let retState = state;
  let isNeedHideLoading = true;
  try {
    if (window) {
      if (window.processingRequest) {
        if (Object.keys(window.processingRequest).length) {
          return state;
        }
      }
    }
  } catch (err) {
    console.error(err);
  }

  if (retState.getIn(['sfActions', 'needCall'])) {
    retState.getIn(['sfActions', 'params'], List()).map((row) => {
      if (!row.get('runInBackground')) {
        row.get('items', List()).map((sfItem) => {
          if (!sfItem.get('isPush')) {
            isNeedHideLoading = false;
          }
        })
      }
    })
  }

  if (retState.getIn(['query', 'status']) == 'active') {
    retState.getIn(['query', 'list'], List()).map(row => {
      if (!row.get('runInBackground')) {
        row.get('list', List()).map((sfItem) => {
          if (!sfItem.get('isPush')) {
            isNeedHideLoading = false;
          }
        })
      }
    })
  }

  if (isNeedHideLoading) {
    retState = retState.setIn(['widgets', 'isShowLoading'], false)
      .setIn(['widgets', 'isPortalLoadData'], false)
      .setIn(['widgets', 'loadingMessages'], Map())
    //   retState = retState.setIn(
    //     ['__cache__'],
    //     retState.getIn(['__cache__'], List())
    //       .push(fromJS({
    //         type: 'close_loading_message',
    //         payload: {

    //         }
    //       }))
    //   )
  }

  return retState;
}

export const processDownloadImageExport = (key, action, appState) => {
  const actJS = action.toJS()
  const el = _.last(
    String(
      _.get(actJS, [0, 'elUID'])
    ).split(':')
  )

  let fileName = ''
  if (_.get(actJS, [0, 'filename', 'type'], 'static') === 'static') {
    fileName = _.get(actJS, [0, 'filename', 'textValue'], '')
  } else {
    let key = _.get(actJS, [0, 'filename', 'field'], '')
    fileName = _.get(appState, String(key).split(':'), '')
  }

  const elNode = document.getElementById(el)
  if (elNode) {
    switch (key) {
      case 'Export JPEG':
        if (fileName && !_.endsWith(fileName, '.jpeg')) {
          fileName += '.jpeg'
        }
        exportToJpeg(elNode, fileName)
        break;
      case 'Export PNG':
        if (fileName && !_.endsWith(fileName, '.png')) {
          fileName += '.png'
        }
        exportToPng(elNode, fileName)
        break;
      case 'Export PDF':
        if (fileName && !_.endsWith(fileName, '.pdf')) {
          fileName += '.pdf'
        }
        exportToPdf(elNode, fileName)
        break;
    }
  }
}


export const processDownloadCart = (action, appState, state, isData) => {
  let actJS = action.toJS();
  if (actJS[0]?.enabled) {
    let elID = _.last(
      String(_.get(actJS, [0, 'elUID'])).split(':')
    );
    if (String(elID).indexOf('##') > -1) {
      let splitID = String(elID).split('##');
      colUID = _.last(splitID);
      elID = splitID[0];
    }

    const cartElem = state.getIn(['state', elID, 'e_cart'], Map()).toJS();
    const cartElemFiltered = cartElem.map((cartItem) => {
      return _.omit(cartItem, ['var', 'value', 'quantity']);
    });
    let cartData = [];
    let head = [];
    if (cartElemFiltered) {
      _.each(cartElemFiltered[0], (value, key) => {
        if (key === 'attr') {
          if (Array.isArray(value) && value.length > 0 && (_.every(value, attrValue => attrValue !== null))) {
            head.push('attribute');
          }
        } else if (key === 'salePrice') {
          head.push('sale price');
        } else if (key === 'isShippable') {
          head.push('is shippable');
        } else if (key === 'discountPrice') {
          head.push('discount price');
        } else {
          head.push(key);
        }
      });
      cartData.push(head);
      _.each(cartElemFiltered, (cartItem) => {
        let row = [];
        _.each(cartItem, (value, key) => {
          let formattedValue = value;
          if ((key === 'salePrice' || key === 'discountPrice' || key === 'price') && typeof value === 'number') {
            formattedValue = parseFloat(value.toFixed(2));
          }
          if (key === 'attr') {
            let attrTextArray = [];
            if (Array.isArray(value) && value.length > 0 && _.every(value, attrValue => attrValue !== null)){
              _.each(value, (attrValue, attrKey) => {
                attrTextArray.push(`${attrKey}-${attrValue}<br>`);
              });
              row.push(attrTextArray.join(''));
            }
          } else {
            row.push(formattedValue ?? '');
          }
        });
        cartData.push(row);
      });
      return cartData;
    }
  }
}



export const processDownloadCSV = (action, appState, state, isData) => {
  let actJS = action.toJS()
  if (actJS[0]?.enabled) {

    // console.log('elID >>> ', _.get(actJS, [0, 'elUID']))
    let valueSeparator = _.get(actJS, [0, 'valueSeparator'])
    // console.log('valueSeparator >>> ', valueSeparator);
    let fileName = ''
    if (_.get(actJS, [0, 'filename', 'type'], 'static') === 'static') {
      fileName = _.get(actJS, [0, 'filename', 'textValue'], '')
      if (fileName && !_.endsWith(fileName, '.csv')) {
        fileName += '.csv'
      }
    } else {
      let key = _.get(actJS, [0, 'filename', 'field'], '')
      fileName = _.get(appState, String(key).split(':'), '')
    }

    let elID = _.last(
      String(_.get(actJS, [0, 'elUID'])).split(':')
    );
    let colUID;
    if (String(elID).indexOf('##') > -1) {
      let splitID = String(elID).split('##');
      colUID = _.last(splitID);
      elID = splitID[0];
    }
    // console.log('elID >>> ', elID, colUID)
    const isProject = state.hasIn(['project', 'Settings', 'elements', elID])
      ? 'project'
      : state.get('page')


    const el = state.getIn([...getElementDataRoot(isProject), 'elements', elID], Map())
    let isSelectedOnly = _.get(actJS, [0, 'isExportSelected']) && el.get('type') === 'PowerTable'

    let filterUID = elID;
    let pageUID = String(_.get(actJS, [0, 'elUID'])).split(':')[0];
    if (colUID) {
      filterUID += '##' + colUID;
    }
    const filter = state.getIn(['filter', pageUID, filterUID], Map()).toJS();
    if (el.get('type') === 'Strip' || el.get('type') === 'RepeatAutoFit') {
      let data = _.get(appState, [pageUID, elID])
      const children = collectAllChildren(el.get('children', List()).toJS(), ['pages', state.getIn(['page']), 'Props'], state)
      const size = getMappingCount(data)
      const csvData = [];

      _.times(size, index=>{
        let row = {};
        _.each(children, (childId)=>{
            const child = state.getIn([...getElementDataRoot(isProject), 'elements', childId], Map())
            if (child.get('type') === 'FormField') {
              const control = child.getIn(['props', 'control'], 'text')

              const key = [childId]

              if (control === 'lookup') {
                key.push(index)
                key.push('ft_text')
              } else if (control === 'currency') {
                key.push('value')
                key.push(index)
              } else if (LIST_BASED_FIELDS.indexOf(control) !== -1) {
                if(control == 'radio') {
                  key.push(index)
                  key.push('ftListValue')
                } else {
                  key.push('ftListValue')
                  key.push(index)
                }

              } else if (control == 'checkbox' && child.getIn(['props', 'source'], 'single') !== 'single') {
                key.push('ftListValue')
                key.push(index)
              } else {
                key.push(index)
              }
              const value = _.get(data, key, '')
              let elemName = getElemName(child.toJS(), null, childId);
              if(!row[elemName] !== undefined) {
                elemName = elemName + `(${childId})`;
              }
              row[elemName] = value;
            }
        })
        csvData.push(row)
      });
      if(isData) {
        return csvData;
      }
      exportToCsv(fileName, csvData, valueSeparator)
    } else if (el.get('type') === 'PowerTable') {
      let recursiveGetTable = (cols) => {
        if (!colUID) {
          return cols;
        }
        let result;
        if (!cols) {
          return result;
        }
        let allCols = List();
        let buildFlattenCols = (list) => {
          list.map(function (col) {
            if (col) {
              if (col.get('columns', List()).size) {
                buildFlattenCols(col.get('columns', List()))
              } else {
                allCols = allCols.push(col);
              }
            }
          })
        }
        buildFlattenCols(cols)
        allCols.map(col => {
          if (!result) {
            if (col.get('id') == colUID) {
              if (col.getIn(['meta', 'subCtrl', 'enable'])) {
                result = col.getIn(['meta', 'subCtrl', 'Props', 'columns'])
              }
            } else if (col.getIn(['meta', 'subCtrl', 'enable'])) {
              result = recursiveGetTable(col.getIn(['meta', 'subCtrl', 'Props', 'columns']))
            }
          }
        })
        return result;
      }
      let cols = recursiveGetTable(el.getIn(['props', 'columns'], List()));
      if (!cols) {
        return false
      }
      cols = cols.toJS()
      if (!cols.length) {
        return false;
      }


      let data;
      if (colUID) {
        data = _.get(appState, [pageUID, `${elID}##${colUID}`], {})
      } else {
        data = _.get(appState, String(_.get(actJS, [0, 'elUID'])).split(':'), {})
      }
      let csvData = []
      let maxRows = 0;

      if (data && data.valueFTHash && _.isArray(data.valueFTHash)) {
        maxRows = data.valueFTHash.length
      }
      if (data && data.value && _.isArray(data.value) || maxRows == 0) {
        maxRows = _.size(data.value)
      } else {
        if (cols[0] && cols[0].id && data[cols[0].id]) {
          if (_.isArray(data[cols[0].id])) {
            maxRows = data[cols[0].id].length;
          } else {
            maxRows = 1;
          }
        } else {
          maxRows = 1;
        }
      }
      let filteredResult = [];
      _.times(maxRows, index => {
        let row = {};
        let isFiltered = true, isSearchRow = false;
        if (!filter.search) {
          isSearchRow = true;
        }
        if(isSelectedOnly){
          if (maxRows == 1) {
            row['selected'] = _.get(data, ['selected'], '');
          } else {
            row['selected'] = _.get(data, ['selected', index], '');
          }
        }
        _.each(cols, function (col) {
          if(_.get(col, ['meta','role']) === 'index'){
            row[col.id] = index + 1
          } else if(_.get(col, ['meta','role']) === 'static'){
            row[col.id] = _.get(col, ['meta', 'static'], '')
          } else if (maxRows == 1) {
            row[col.id] = _.get(data, [col.id], '');
          } else {
            row[col.id] = _.get(data, [col.id, index], '');
          }
          if (filter.search) {
            if (String(row[col.id]).toLowerCase().indexOf(String(filter.search).toLowerCase()) > -1) {
              isSearchRow = true;
            }
          }
          if (_.get(filter, ['cols', col.id])) {
            if (String(row[col.id]).toLowerCase().indexOf(String(_.get(filter, ['cols', col.id])).toLowerCase()) == -1) {
              isFiltered = false;
            }
          }
        })
        if (!isSearchRow) {
          isFiltered = false;
        }
        if (isFiltered) {
          if(isSelectedOnly){
            if(row.selected){
              _.unset(row, 'selected')
              filteredResult.push(row);
            }
          }else{
            filteredResult.push(row);
          }
        }
      });
      let head = [];
      _.each(cols, function (col) {
        head.push(col.Header)
      })
      csvData.push(head);
      _.each(filteredResult, function (dataRow) {
        let row = [];
        _.each(cols, function (col) {
          row.push(dataRow[col.id] ?? '')
        })
        csvData.push(row);
      })

      if (!fileName) {
        fileName = 'table.csv'
      }
      if(isData) {
        return csvData;
      }
      exportToCsv(fileName, csvData, valueSeparator)
    } else if (el.get('type') === 'Form') {
      const csvData = []
      const rows = el.getIn(['props', 'lg', 'children'], Map()).toJS()
      _.each(rows, row => {
        _.each(row.children, col => {
          _.each(col.children, id => {
            const child = state.getIn([...getElementDataRoot(isProject), 'elements', id], Map())
            if (child.get('type') === 'FormField') {
              const control = child.getIn(['props', 'control'], 'text')
              const row = []
              row.push(child.getIn(['props', 'lg', 'label'], control))
              const key = [..._.initial(String(_.get(actJS, [0, 'elUID'])).split(':')), id]
              if (control === 'currency') {
                key.push('value')
              } else if (LIST_BASED_FIELDS.indexOf(control) !== -1) {
                key.push('ftListValue')
              } else if (control == 'checkbox' && child.getIn(['props', 'source'], 'single') !== 'single') {
                key.push('ftListValue')
              }
              const value = _.get(appState, key, '')
              row.push(value)
              csvData.push(row)
            }
          })
        })
      })
      if (csvData.length > 0) {
        if (!fileName) {
          fileName = 'form.csv'
        }
        exportToCsv(fileName, csvData, valueSeparator)
      }
    } else if (el.get('type') === 'Widget') {
      switch (el.getIn(['props', 'data', 'Type'])) {
        case 'table': {
          const data = _.get(appState, String(_.get(actJS, [0, 'elUID'])).split(':'), {})
          let csvData = []
          const cols = el.getIn(['props', 'data', 'Props', 'mapping'], List()).toJS()
          csvData.push(
            _.map(cols, field => field.label)
          )

          let hashFilterCols = {};
          if (filter && filter.cols) {
            _.each(filter.cols, function (col) {
              if (col && col.value) {
                hashFilterCols[col.columnName] = col.value;
              }
            })
          }
          let filteredData = data;
          if (Object.keys(hashFilterCols).length || filter.search) {
            filteredData = _.filter(data, dataRow => {
              let isFiltered = true, isSearchRow = false;
              if (!filter.search) {
                isSearchRow = true;
              }
              _.each(cols, field => {
                let val = dataRow[field.id] ?? '';
                if (filter.search) {
                  if (String(val).toLowerCase().indexOf(String(filter.search).toLowerCase()) > -1) {
                    isSearchRow = true;
                  }
                }
                if (hashFilterCols[field.id]) {
                  if (String(val).toLowerCase().indexOf(String(hashFilterCols[field.id]).toLowerCase()) == -1) {
                    isFiltered = false;
                  }
                }
              })
              if (!isSearchRow) {
                isFiltered = false;
              }
              return isFiltered;
            });
          }
          _.each(filteredData, dataRow => {
            let row = []
            _.each(
              cols,
              field => {
                row.push(dataRow[field.id] ?? '')
              }
            )
            csvData.push(row)
          })
          if (!fileName) {
            fileName = 'table.csv'
          }
          exportToCsv(fileName, csvData, valueSeparator)
          break;
        }
        case 'list': {
          const data = _.get(appState, String(_.get(actJS, [0, 'elUID'])).split(':'), {})
          const size = _.size(_.first(_.keys(data)))
          let csvData = []
          const cols = el.getIn(['props', 'data', 'Props', 'columns'], List()).toJS()
          csvData.push(
            _.map(cols, col => col.label)
          )
          _.times(size, index => {
            csvData.push(
              _.map(cols, col => _.get(data, [col.id, index], ''))
            )
          })
          if (!fileName) {
            fileName = 'list.csv'
          }
          exportToCsv(fileName, csvData, valueSeparator)
          break;
        }
        case 'chart': {
          const data = _.get(appState, String(_.get(actJS, [0, 'elUID'])).split(':'), {})
          const size = _.size(data.x)
          let keys = ['x', 'y']
          if (el.getIn(['props', 'data', 'Props', 'ChartType']) == 'bubble') {
            keys.push('r')
          }
          let csvData = [_.map(keys, _.capitalize)]
          _.times(size, n => {
            csvData.push(
              _.map(keys, key => _.get(data, [key, n]), '')
            )
          })
          if (!fileName) {
            fileName = 'chart.csv'
          }
          exportToCsv(fileName, csvData, valueSeparator)
          break;
        }
      }
    }
  }
}

export function getQueryVariable(variable, defValue) {
  if (IS_SERVER) {
    return ''
  } else {
    const query = window.location.search.substring(1) || '';
    const vars = query.split('&');
    for (let i = 0; i < vars.length; i++) {
      const pair = vars[i].split('=');
      try {
        if (decodeURIComponent(pair[0]) == variable) {
          return decodeURIComponent(pair[1]);
        }
      } catch (error) {
        return defValue
      }
    }
    return defValue
  }
}

const removeActionFromRule = (rules, action) => {
  if ([ACTION_TYPES.SET_COLOR, ACTION_TYPES.SET_BG, ACTION_TYPES.SET_BORDER].indexOf(action) > -1) {
    let isFound = false;
    _.each(rules, (rule, index) => {
      if (!isFound && rule && rule.indexOf(action) > -1) {
        isFound = true;
        rules.splice(index, 1);
      }
    })
  } else {
    let index = rules.indexOf(action);
    if (index > -1) {
      rules.splice(index, 1);
    }
  }
  return rules;
}

const setNewRules = (currentRules, newRules, keyPath) => {
  try {
    if (!currentRules) {
      currentRules = [];
    } else if (typeof currentRules == 'string') {
      currentRules = [currentRules];
    }
    let rules = fromJS(currentRules).toJS();
    let setRules = fromJS(newRules).toJS();
    _.each(rules, (value, key) => {
      if (_.isArray(value)) {
        let val = value.join('')
        if (val === 'hide' && _.includes(setRules, 'show') || val === 'show' && _.includes(setRules, 'hide')) {
          _.unset(rules, key)
        }
      }
    })
    if ((_.isObject(setRules) && !_.isArray(setRules)) || (_.isObject(rules) && !_.isArray(rules) && !_.isEmpty(rules))) {
      _.each(setRules, function (list, index) {
        if (list) {
          if(typeof list == 'string') {
            list = [list];
          }
          let rule = _.get(rules, index, []);
          _.each(list, function (type) {
            if (String(type).indexOf('bg_color_') > -1) {
              rule = removeActionFromRule(rule, 'bg_color_');
              rule.push(type);
            } else if (String(type).indexOf('color_') > -1) {
              rule = removeActionFromRule(rule, 'color_');
              rule.push(type);
            } else if (type && rule.indexOf(type) == -1) {
              if(!_.isArray(rule)) {
                if(typeof rule == 'string') {
                  rule = [rule];
                }
              }
              if (type == 'hide') {
                rule = removeActionFromRule(rule, 'show');
              } else if (type == 'show') {
                rule = removeActionFromRule(rule, 'hide');
              } else if (type == 'enable') {
                rule = removeActionFromRule(rule, 'disable');
              } else if (type == 'disable') {
                rule = removeActionFromRule(rule, 'enable');
              } else if (type == 'mandatory') {
                rule = removeActionFromRule(rule, 'notMandatory');
              } else if (type == 'notMandatory') {
                rule = removeActionFromRule(rule, 'mandatory');
              } else if (type == 'readOnly') {
                rule = removeActionFromRule(rule, 'notReadOnly');
              } else if (type == 'notReadOnly') {
                rule = removeActionFromRule(rule, 'readOnly');
              }
              rule.push(type);
            }
          })
          rules = _.set(rules, index, rule)
        }
      })
    } else {
      if(_.isEmpty(rules)) {
        rules = [];
      }
      _.each(setRules, function (type) {

        if (String(type).indexOf('bg_color_') > -1) {
          rules = removeActionFromRule(rules, 'bg_color_');
          rules.push(type);
        } else if (String(type).indexOf('color_') > -1) {
          rules = removeActionFromRule(rules, 'color_');
          rules.push(type);
        } else if (type && _.isArray(rules) && rules.indexOf(type) == -1) {
          if (type == 'hide') {
            rules = removeActionFromRule(rules, 'show');
          } else if (type == 'show') {
            rules = removeActionFromRule(rules, 'hide');
          } else if (type == 'enable') {
            rules = removeActionFromRule(rules, 'disable');
          } else if (type == 'disable') {
            rules = removeActionFromRule(rules, 'enable');
          } else if (type == 'mandatory') {
            rules = removeActionFromRule(rules, 'notMandatory');
          } else if (type == 'notMandatory') {
            rules = removeActionFromRule(rules, 'mandatory');
          } else if (type == 'readOnly') {
            rules = removeActionFromRule(rules, 'notReadOnly');
          } else if (type == 'notReadOnly') {
            rules = removeActionFromRule(rules, 'readOnly');
          }
          rules.push(type);
        }
      })
    }
    return fromJS(rules);
  } catch (err) {
    console.log('currentRules >>> ', currentRules);
    console.log('newRules >>> ', newRules);
    console.log('keyPath >>> ', keyPath);
    console.error(err);
    return fromJS(newRules);
  }
}

const setChildWidgetParams = (children, widgets) => _.reduce(children, (ret, child, uid) => {
  if (child.type === 'Widget') {
    const widget = widgets.get(child.ref)
    if (widget) {
      const widgetParams = {}
      widget.getIn(['Props', 'params'], List()).map(param => {
        widgetParams[param.get('id')] = getQueryVariable(param.get('name'), param.get('value', ''))
      })
      return {
        ...ret,
        [uid]: {
          [child.ref]: {
            ...widgetParams,
            ...setChildWidgetParams(widget.getIn(['Props', 'elements'], Map()).toJS(), widgets)
          }
        }
      }
    } else {
      return ret
    }
  } else {
    return ret
  }
}, {})

const getChildWidgetDefaultParams = (children, widgets) => _.reduce(children, (ret, child, uid) => {
  if (child.type === 'Widget') {
    const widget = widgets.get(child.ref)
    if (widget) {
      const widgetParams = {}
      widget.getIn(['Props', 'params'], List()).map(param => {
        widgetParams[param.get('id')] = ''
      })
      return {
        ...ret,
        [uid]: {
          [child.ref]: {
            ...widgetParams,
            ...getChildWidgetDefaultParams(widget.getIn(['Props', 'elements'], Map()).toJS(), widgets)
          }
        }
      }
    } else {
      return ret
    }
  } else {
    return ret
  }
}, [])

export const getBrowserName = () => {

  var isOpera = (!!window.opr && !!opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;
  if (isOpera) {
    return "opera";
  }
  var isFirefox = typeof InstallTrigger !== 'undefined';
  if (isFirefox) {
    return "firefox";
  }
  var isSafari = Object.prototype.toString.call(window.HTMLElement).indexOf('Constructor') > 0;
  if (isSafari) {
    return "safari";
  }
  var isIE = false || !!document.documentMode;
  if (isIE) {
    return "internet explorer";
  }
  var isEdge = (!isIE && !!window.StyleMedia) || navigator.userAgent.indexOf(' Edg/') > -1;
  if (isEdge) {
    return "edge";
  }
  var isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);
  if (isChrome) {
    return "chrome";
  }
  var isBlink = (isChrome || isOpera) && !!window.CSS;
  if (isBlink) {
    return "blink";
  }

  if (navigator.userAgent.indexOf("Safari") > -1 && navigator.userAgent.indexOf("Chrome") == -1) {
    return "safari";
  }

  return navigator.userAgent;
}

export const getClientOS = () => {
  try {
    var userAgent = window.navigator.userAgent,
      platform = window.navigator.platform,
      macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
      windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
      iosPlatforms = ['iPhone', 'iPad', 'iPod'],
      os = null;

    if (macosPlatforms.indexOf(platform) !== -1) {
      os = 'Mac OS';
    } else if (iosPlatforms.indexOf(platform) !== -1) {
      os = 'iOS';
    } else if (windowsPlatforms.indexOf(platform) !== -1) {
      os = 'Windows';
    } else if (/Android/.test(userAgent)) {
      os = 'Android';
    } else if (!os && /Linux/.test(platform)) {
      os = 'Linux';
    } else if (platform.indexOf("Win") !== -1) {
      os = 'Windows';
    } else if (platform.indexOf("Mac") !== -1) {
      os = 'iOS';
    } else if (platform.indexOf("X11") !== -1) {
      os = 'UNIX';
    } else if (platform.indexOf("Linux") !== -1) {
      os = 'Linux';
    } else if (platform.indexOf("iPhone") !== -1) {
      os = 'iOS';
    } else if (platform.indexOf("Android") !== -1) {
      os = 'Android';
    } else {
      os = 'N/A';
    }

    return os;
  } catch (err) {
    console.error(err.stack);
  }
}

export const getSystemVariable = (key, state) => {
  let value;
  switch (key) {
    case 'locationByIp': {
      return state.getIn(['params', 'locationByIp'], null)
    }
    case 'sf_event_session_id': {
      let prevData = getPreviewDynamicData();
      value = _.get(prevData, ['freshState', 'sfEventSessionId'], '');
      break;
    }
    case 'ip': {
      return state.getIn(['params', 'ip'], null)
    }
    case 'geoLat': return state.getIn(['params', 'geoLat'], null)
    case 'geoLong': return state.getIn(['params', 'geoLong'], null)
    case 'geoAccuracy': return state.getIn(['params', 'geoAccuracy'], null)
    case 'lang':
      value = navigator.language || navigator.userLanguage;
      if (typeof value == "string") {
        value = value.toLowerCase();
      }
      break;
    case "year":
      value = new Date().getFullYear();
      break;
    case "month":
      value = parseInt(new Date().getMonth()) + 1;
      break;
    case "day":
      value = new Date().getDate();
      break;
    case "hour":
      value = new Date().getHours();
      break;
    case "minute":
      value = new Date().getMinutes();
      break;
    case "today":
      value = moment().format("YYYY-MM-DD");
      break;
    case "mm_dd_yyyy":
      value = moment().format("MM/DD/YYYY");
      break;
    case "dd_mm_yyyy":
      value = moment().format("DD/MM/YYYY");
      break;
    case "now":
      value = moment().format("YYYY-MM-DD") + "T" + moment().format("HH:mm") + ":00Z";
      break;
    case "nowUTC":
      value = moment().utc(false).format("YYYY-MM-DD HH:mm:00Z")
      break;
    case 'browser':
      value = getBrowserName();
      break;
    case 'os':
      value = getClientOS();
      break;
    case 'user_agent':
      value = window.navigator.userAgent;
      break;
    case 'device_layout_full':
      value = DISPLAY_DEVICE[state.getIn(['layoutMode'], 'lg')];
      break;
    case 'device_layout':
      value = state.getIn(['layoutMode'], 'lg');
      break;
    case 'guid':
      value = String(uuid()).replace(/-/g, '');
      break;
    case 'random':
      value = parseInt(Math.random() * (999999 - 100000))
      break;
    case 'project_id':
      value = state.getIn(['project', '_id'], null)
      break;
    case 'openerRef':
      value = getQueryVariable('ftopenerref', '')
      break;
    case 'ActualDeviceType':
      try {
        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
          value = 'Mobile';
        } else {
          value = 'Desktop';
        }
      } catch (err) {

      }
      break;
    case 'subdomain':
      value = String(location.host).split('.')[0];
      break;
    case 'referrer':
      value = document.referrer;
      break;
    case "utm_source":
    case "utm_medium":
    case "utm_campaign":
    case "utm_term":
    case "utm_content":
    case "gclid":
    case "gclsrc":
    case "dclid":
    case "fbclid":
    case "mscklid":
    case "zanpid":
      try {
        var searchObject = String(location.search);
        if (searchObject.indexOf("?") > -1) {
          searchObject = searchObject.replace("?", "");
          searchObject = searchObject.split("&");
          var hashObject = {};
          _.each(searchObject, function (row) {
            row = row.split("=");
            if (row[1] != "" && row[1] != undefined) {
              try {
                hashObject[row[0]] = decodeURIComponent(row[1])
              } catch (error) {
                console.error(error)
                hashObject[row[0]] = ''
              }
            }
          });
          value = hashObject[key];
        }
      } catch (err) {
        console.error(err);
      }
      break;
  }

  return value;
}

export const getInitialParams = state => {
  let retState = state
  let paramsState = _.assign(
    {},
    retState.getIn(['params'], Map()).toJS(),
  )
  let ssoParams = {

  }

  let projectID = state.getIn(['project', '_id']);
  let localParams = ftGetLocalStorage('local_params_' + projectID);
  let isNoBackGroundLoad = false;
  if (localParams) {
    try {
      ssoParams = JSON.parse(localParams);
      if (Object.keys(ssoParams)) {
        isNoBackGroundLoad = true;
      }
    } catch (err) {
      console.log(err)
    }
  }
  let localPageJobs = ftGetLocalStorage('local_pagejobs_' + projectID);
  if (localPageJobs) {
    try {
      let pageJobs = JSON.parse(localPageJobs);
      retState = retState.setIn(['pageJob'], fromJS(pageJobs));
    } catch (err) {
      console.log(err)
    }
  }
  ftRemoveLocalStorage('local_params_' + projectID);
  ftRemoveLocalStorage('local_pagejobs_' + projectID);

  _.each(_.get(getPreviewDynamicData(), ['ssoParams', 'data'], {}), function (val, key) {
    if (key && String(key).indexOf(':') > -1) {
      key = String(key).split(':')[1];
      ssoParams[key] = val;
    } else {
      ssoParams[key] = val;
    }
  });

  if (typeof window !== 'undefined') {
    paramsState = _.assign(
      {},
      retState.getIn(['params'], Map()).toJS(),
      _.get(getPreviewDynamicData(), 'svParams', {}),
      ssoParams
    )

    if (getQueryVariable('FTLang', '') != '') {
      retState = retState.setIn(['FTLang'], getQueryVariable('FTLang', ''))
    }

    const params = state.getIn(['project', 'params'], List()).toJS()
    _.map(params, param => {
      if (param.valueType == 'system') {
        param.value = '';
      }
      let defValue = _.get(param, 'value', '');
      if (paramsState[param.id] !== undefined) {
        defValue = paramsState[param.id];
      }
      /**
       * @todo uncomment system protection
       */
      // if (param.valueType == 'system') {
      //   try {
      //     paramsState[param.id] = getSystemVariable(param.systemValue, state);
      //   } catch (err) {
      //     console.error(err);
      //   }
      // } else
      if (param.isReadOnly) {
        paramsState[param.id] = defValue
      } else if (param.paramType !== "system" && getQueryVariable(param.name, defValue) !== '') {
        paramsState[param.id] = getQueryVariable(param.name, defValue)
      } else if (param.valueType == 'system') {
        try {
          paramsState[param.id] = getSystemVariable(param.systemValue, state);
        } catch (err) {
          console.error(err);
        }
      }
    })

    let projectID = retState.getIn(['project', '_id']);
    try {
      let loadCart = ftGetLocalStorage(`e_cart_${projectID}`);
      if (loadCart) {
        loadCart = JSON.parse(loadCart);
        if (loadCart && _.isArray(loadCart)) {
          retState = retState.setIn(['state', 'eCommerce', 'e_cart'], fromJS(loadCart))
        }
      }
    } catch (err) {

    }
  }

  retState = retState.setIn(['isNoBackGroundLoad'], isNoBackGroundLoad);
  return retState.setIn(['params'], fromJS(paramsState))
}

export const getParams = state => {
  // const paramsState = {}
  // state.getIn(['project', 'Settings', 'params'], List()).map(param => {
  //   paramsState[param.get('id')] = getQueryVariable(param.get('name'), param.get('value', ''))
  // })

  const surveyValue = getQueryVariable('value', '')
  const isLogged = Boolean(getPreviewDynamicData()?.user)

  return _.assign({}, state.getIn(['params'], Map()).toJS(), { surveyValue, isLogged })
}

export const getPapamFrom = (params, key) => _.get(params, String(key).split(/:/g), '')

export const getDefaultParams = state => {
  let paramsState = {}
  //@todo check this
  // _.map(_.get(window.__FT_APP_STATE__, 'project.params', []), param => {
  //   paramsState[param.id] = ''
  // })
  return paramsState
}

export const getNamedParams = state => {
  const paramsState = {}
  const namedParams = {}
  state.getIn(['project', 'Settings', 'params'], List()).map(param => {
    paramsState[param.get('id')] = state.getIn(['params', param.get('id')], getQueryVariable(param.get('name'), param.get('value', '')))
    namedParams[param.get('name')] = state.getIn(['params', param.get('id')], getQueryVariable(param.get('name'), param.get('value', '')))
  })
  return namedParams
}

const applyRulesToAppState = (state, rules, path, retState, processed = []) => {
  const elPath = ['pages', retState.get('page'), 'Props', 'elements', _.last(path)]
  if (retState.getIn([...elPath, 'props', 'isRepeatCol']) || retState.getIn([...elPath, 'props', 'isRepeat'])) {
    path = _.uniq(path)
  }
  _.each(rules, (v, k) => {
    if (_.isObject(v)) {
      processed = applyRulesToAppState(state, v, [...path, k], retState, processed)
    } else if (_.isArray(v) && (v.indexOf('hide') !== -1 || v.indexOf('show') !== -1)) {
      processed = applyRulesToAppState(state, v, [...path, k], retState, processed)
    } else {
      if (v === 'hide') {
        if (_.get(state, path) !== undefined && _.get(state, path) !== null) {
          if(retState.getIn(['project', 'Settings', 'elements', _.last(path), 'type']) === 'Modal'){
            _.set(state, path, true)
          }else{
            _.set(state, path, '')
            if (_.get(state, [..._.initial(path), `${_.last(path)}-formattedValue`]) !== undefined) {
              _.set(state, [..._.initial(path), `${_.last(path)}-formattedValue`], '')
            }
          }
        }
        try {
          let elemUID = path[path.length -1];
          if(path.length > 2) {
            elemUID = path[path.length - 2];
          }
          let repeatRoot = retState.getIn(['project', 'Settings', 'RepeatedStripsID'], List()).toJS();
          let pageId = retState.get('page');
          let uidOfElement = elemUID;
          if(String(elemUID).indexOf('-') > -1) {
            uidOfElement = String(elemUID).split('-')[0];
          }
          let elements;
          if(retState.getIn(['pages', pageId, 'Props', 'elements', uidOfElement])) {
            elements = retState.getIn(['pages', pageId, 'Props', 'elements']);
          } else {
            elements = retState.getIn(['project', 'Settings', 'elements']);
          }

          let resetChildren = [];
          if(elements && String(elemUID).endsWith('-tab')) {
            let uid = uidOfElement;
            let elem = elements.get(uid);
            if(elem && TAB_TYPES.includes(elem.get('type'))) {
              let tab = elem.getIn(['props', 'lg', 'tabs'], List()).find(tab=>{
                if(tab && tab.get('id') == path[path.length -1]) {
                  return true;
                }
                return false;
              })
              if(tab && tab.get('children') && tab.get('children').size) {
                resetChildren = tab.get('children', List()).toJS()
              }
            }
          } else if(elements && (String(elemUID).endsWith('-cell') || String(elemUID).endsWith('-row') || String(elemUID).endsWith('-col'))) {
            let uid = uidOfElement;
            let elem = elements.get(uid);
            if(elem) {
              if(elem.get('type') == 'Form') {
                let children = elem.getIn(['props', 'lg', 'children'], List()).toJS();
                let condRowId, condCellId, conColIndex = -1;
                if(String(elemUID).endsWith('-col')) {
                  conColIndex = String(path[path.length -1]);
                  conColIndex = parseInt(conColIndex.replace('c', ''));
                  if(isNaN(conColIndex)) {
                    conColIndex = -1;
                  }
                } else if(String(elemUID).endsWith('-cell')) {
                  condCellId = path[path.length -1];
                } else {
                  condRowId = path[path.length -1];
                }

                _.each(children, function(row, rowID){
                  if(row) {
                    if(condRowId) {
                      if(rowID == condRowId) {
                        _.each(row.children, function(col, colID){
                          if(col) {
                            resetChildren = _.concat(col.children, resetChildren);
                          }
                        })
                      }
                    } else {
                      _.each(row.children, function(col, colID){
                        if(conColIndex > -1) {
                          if(col && col.index == conColIndex) {
                            resetChildren = _.concat(col.children, resetChildren);
                          }
                        } else if(condCellId) {
                          if(col && colID == condCellId) {
                            resetChildren = col.children;
                          }
                        }
                      })
                    }
                  }
                })
              }
            }
          } else if (repeatRoot.includes(elemUID)) {
            if ((path.length === 4 || path.length === 3) && Number.isInteger(_.last(path))) {
              if (!processed.includes(`${elemUID}#${_.last(path)}`)) {
                processed.push(`${elemUID}#${_.last(path)}`)
              } else {
                return
              }
              const index = _.last(path)
              let path2 = [path[0], path[1]];
              let repState = _.get(state, path2, {})
              _.set(state, [...path2, 'isInvisible', index], true)
              _.set(state, path2, repState)
              _.set(state, [path[0], path[1] + '-totalRows'], getMappingCount(repState))
            } else {
              if (!processed.includes(elemUID)) {
                processed.push(elemUID)
                let path2 = [path[0], path[1]];
                _.set(state, path2, [])
                _.set(state, [path[0], path[1] + '-totalRows'], 0)
              }
            }
          } else if(!repeatRoot.includes(elemUID)) {
            let elem = retState.getIn(['pages', pageId, 'Props', 'elements', elemUID])
            if(elements && elem && elem.get('children') && elem.get('children', List()).size) {
              const children = getAllChildren(elem.get('children', List()).toJS(), elements);
              let isParentAllHide = true
              let parentRules = retState.getIn(['rules', ..._.initial(path)], List())
              if (repeatRoot.includes(path[1])) {
                try {
                  let repeatData = retState.getIn(['state', path[0], path[1]], Map())
                  const size = getMappingCount(toJS(repeatData))
                  _.times(size, n => {
                    const rules = toJS(parentRules.get(n, List()))
                    if (!_.includes(rules, 'hide')) {
                      isParentAllHide = false
                    }
                  })
                } catch (error) {
                  console.error(error)
                }
              }
              _.map(children, (childId) => {
                let child = retState.getIn(['pages', pageId, 'Props', 'elements', childId], Map())
                if (child.get('type') === 'FormField' && ['time', 'date', 'datetime', 'number'].includes(child.getIn(['props', 'control']))) {
                  _.set(state, [path[0], childId], '')
                  _.set(state, [path[0], `${childId}-formattedValue`], '')
                } else {
                  let path2 = [path[0], childId];
                  if (child.get('type') === 'FormField' && child.getIn(['props', 'control']) === 'lookup') {
                    if (isParentAllHide) {
                      _.set(state, path2, '')
                      if (_.get(state, [path[0], `${childId}-formattedValue`]) !== undefined) {
                        _.set(state, [path[0], `${childId}-formattedValue`], '')
                      }
                    }
                  } else {
                    _.set(state, path2, '')
                    if (_.get(state, [path[0], `${childId}-formattedValue`]) !== undefined) {
                      _.set(state, [path[0], `${childId}-formattedValue`], '')
                    }
                  }
                }
              })
            }
          }
          if(resetChildren && resetChildren.length) {
            _.each(resetChildren, function(uid){
              let path2 = [...path];
              path2.splice(-2);
              path2.push(uid);
              _.set(state, path2, '');
              if (_.get(state, [..._.initial(path2), `${_.last(path2)}-formattedValue`]) !== undefined) {
                _.set(state, [..._.initial(path2), `${_.last(path2)}-formattedValue`], '')
              }
              let elem = elements.get(uid);
              if(elem && elem.get('children') && elem.get('children', List()).size) {
                const children = getAllChildren(elem.get('children', List()).toJS(), elements);
                _.map(children, (childId)=>{
                  let path2 = [...path];
                  path2.splice(-2);
                  path2.push(childId);
                  _.set(state, path2, '')
                  if (_.get(state, [..._.initial(path2), `${_.last(path2)}-formattedValue`]) !== undefined) {
                    _.set(state, [..._.initial(path2), `${_.last(path2)}-formattedValue`], '')
                  }
                })
              }
            })
          }

        } catch(err) {
          console.error(err);
        }
      }
    }
  })
  return processed
}

export const buildURLWithParams = (state, providedSettings, asCallback) => {
  let settings = providedSettings;
  if (isImmutable(settings)) {
    settings = settings.toJS();
  }

  let type = _.get(settings, ['type'], 'other');
  let url;
  if (type === 'other' && _.get(settings, ['typeOfRedirect']) != 'Internal') {
    url = _.get(settings, ['customURL'], '');
  } else {
    let page = state.getIn(['project', 'Pages'], List()).find(page => {
      if (_.get(settings, ['redirect', 'value'], '')) {
        return page.get('uid') === _.get(settings, ['redirect', 'value'], '');
      } else {
        return page.get('uid') === _.get(settings, ['value'], '');
      }

    });
    const projectURL = state.getIn(['project', 'URL']);
    if (typeof window?.__FT_PROJECT__API__?.FTGetPortalURL === 'function') {
      if (page) {
        url = window.__FT_PROJECT__API__.FTGetPortalURL('/' + page.get('url', ''), asCallback);
      } else {
        url = window.__FT_PROJECT__API__.FTGetPortalURL(page, asCallback);
      }
    } else if (page) {
      url = `${location.origin}/ftproject/${projectURL}/${page.get('url', '')}`;
    }
  }
  if (!url) {
    return '';
  }
  let modalParams = {};
  if (_.get(settings, ['typeOfRedirect'], '') == 'Internal') {
    modalParams = buildParams(state, settings.internalRedirectParams);
  } else {
    modalParams = buildParams(state, settings.redirectParams, true);
  }

  let queryParams = [];
  _.each(modalParams, function (val, key) {
    if (key) {
      queryParams.push(`${key}=${val}`)
    }
  })

  if (String(url).indexOf('?') > -1) {
    return url + '&' + queryParams.join('&');
  } else {
    return url + '?' + queryParams.join('&');
  }

}

export const getTabChildrenByPath = (elements, path, elem) => {
  let resetChildren = [];
  let tab = elem.getIn(['props', 'lg', 'tabs'], List()).find(tab=>{
    if(tab && tab.get('id') == path[path.length -1]) {
      return true;
    }
    return false;
  })
  if(tab && tab.get('children') && tab.get('children').size) {
    resetChildren = tab.get('children', List()).toJS()
  }

  _.each(resetChildren, function(uid){
    let elem = elements.get(uid);
    if(elem && elem.get('children') && elem.get('children', List()).size) {
      const children = getAllChildren(elem.get('children', List()).toJS(), elements);
      _.map(children, (childId)=>{
        resetChildren.push(childId);
      })
    }
  })

  return resetChildren;
}

export const getFormChildrenByPath = (elements, elemUID, path, elem) => {
  let children = elem.getIn(['props', 'lg', 'children'], List()).toJS();
  let condRowId, condCellId, conColIndex = -1;
  if(String(elemUID).endsWith('-col')) {
    conColIndex = String(path[path.length -1]);
    conColIndex = parseInt(conColIndex.replace('c', ''));
    if(isNaN(conColIndex)) {
      conColIndex = -1;
    }
  } else if(String(elemUID).endsWith('-cell')) {
    condCellId = path[path.length -1];
  } else {
    condRowId = path[path.length -1];
  }
  let resetChildren = [];
  _.each(children, function(row, rowID){
    if(row) {
      if(condRowId) {
        if(rowID == condRowId) {
          _.each(row.children, function(col, colID){
            if(col) {
              resetChildren = _.concat(col.children, resetChildren);
            }
          })
        }
      } else {
        _.each(row.children, function(col, colID){
          if(conColIndex > -1) {
            if(col && col.index == conColIndex) {
              resetChildren = _.concat(col.children, resetChildren);
            }
          } else if(condCellId) {
            if(col && colID == condCellId) {
              resetChildren = col.children;
            }
          }
        })
      }
    }
  })

  _.each(resetChildren, function(uid){
    let elem = elements.get(uid);
    if(elem && elem.get('children') && elem.get('children', List()).size) {
      const children = getAllChildren(elem.get('children', List()).toJS(), elements);
      _.map(children, (childId)=>{
        resetChildren.push(childId);
      })
    }
})

  return resetChildren;
}

export const buildParams = (state, providedSettings, isExternal) => {
  let portalState = getState(state);
  let params = getParams(state)
  let settings = providedSettings;
  if (!providedSettings) {
    return providedSettings;
  }
  if (isImmutable(settings)) {
    settings = settings.toJS();
  }
  let result = {};
  let repeatRoot = state.getIn(['project', 'Settings', 'RepeatedStripsID'], List()).toJS()
  let pageID = state.get('page');
  _.each(settings, (row, key) => {
    if (isExternal) {
      const [fieldKey, group] = String(key).split('##-##')
      if (group === 'param') {
        result[row] = _.get(params, String(fieldKey).replace(/\:/g, '.'), '');
      } else {
        result[row] = _.get(portalState, String(fieldKey).split(':'), '');
      }
    } else {
      if (row.id) {
        key = row.id;
      }
      if (_.get(row, ['valueType'], 'static') == 'field') {
        const [fieldKey, group] = String(_.get(row, ['field'], '')).split('##-##')
        if (group === 'param') {
          result[key] = _.get(params, String(fieldKey).replace(/\:/g, '.'), '');
        } else {
          let pathKey = String(fieldKey).split(':');
          if(repeatRoot.includes(pathKey[1])) {
            try {
              let elem = state.getIn(['pages', pageID, 'Props', 'elements', pathKey[2]])
              if(elem && elem.get('type') == 'FormField') {
                if(['radio', 'lookup'].includes(elem.getIn(['props', 'control']))) {
                  let valueKey = _.last(pathKey);
                  let listValue = _.get(portalState, _.initial(pathKey), '');
                  if(listValue && (_.isArray(listValue) || _.isObject(listValue))) {
                    let maxIndex = -1;
                    _.each(listValue, (row, index)=>{
                      index = parseInt(index);
                      if(!isNaN(index)) {
                        maxIndex = _.max([maxIndex, index])
                      }
                    })
                    result[key] = _.times((maxIndex + 1), index=>{
                      return _.get(listValue, [index, valueKey], '')
                    });
                  } else {
                    result[key] = _.get(portalState, pathKey, '');
                  }
                  return true;
                }
              }
            } catch(err) {
              console.error(err);
            }
          }
          result[key] = _.get(portalState, pathKey, '');
        }
      } else {
        result[key] = _.get(row, ['value'], '');
      }
    }
  })
  return result;
}

export const effectElementsInsideCondition = (state, fullPath) => {
  try {
    if(!isAllowIndexForPath(state, fullPath)){
      let last = _.last(fullPath)
      if(/^d+$/.test(last)){
        fullPath = _.initial(fullPath)
      }
    }
    let pageId = state.get('page');
    let elemID = _.last(fullPath)
    let elements = state.getIn(['pages', pageId, 'Props', 'elements'], Map())
    elements = elements.merge(state.getIn(['project','Settings', 'elements'], Map()));
    if(elements && elements.get(elemID)) {
      let elem = elements.get(elemID);
      if(elem.get('children') && elem.get('children', List()).size) {
        let result = state.getIn(['ft', 'changes'], List()).push(fromJS(fullPath));
        const children = getAllVisibleChildren(elem.get('children', List()).toJS(), elements, state.getIn(['rules', fullPath[0]], Map()));
        _.each(children, function(childUID){
          result = result.push(fromJS([fullPath[0], childUID]));
        });
        return result
      }
    } else if(elements && fullPath.length > 2) {
      elemID = fullPath[fullPath.length -2];
      if(String(elemID).endsWith('-tab')) {
        let uid = String(elemID).split('-')[0];
        let elem = elements.get(uid);
        if(elem && TAB_TYPES.includes(elem.get('type'))) {
          let result = state.getIn(['ft', 'changes'], List()).push(fromJS(fullPath));
          let children = getTabChildrenByPath(elements, fullPath, elem)
          _.each(children, function(childID){
            let path2 = [...fullPath];
            path2.splice(-2);
            path2.push(childID);
            result = result.push(fromJS(path2));
          });
          return result;
        }
      } else if(String(elemID).endsWith('-cell') || String(elemID).endsWith('-row') || String(elemID).endsWith('-col')) {
          let uid = String(elemID).split('-')[0];
          let elem = elements.get(uid);
          if(elem && elem.get('type') == 'Form') {
            let result = state.getIn(['ft', 'changes'], List()).push(fromJS(fullPath));
            let children = getFormChildrenByPath(elements, elemID, fullPath, elem)
            _.each(children, function(childID){
              let path2 = [...fullPath];
              path2.splice(-2);
              path2.push(childID);
              result = result.push(fromJS(path2));
            });
            return result;
          }
      }
    }
  } catch(err) {
    console.error(err);
  }
  return state.getIn(['ft', 'changes'], List()).push(fromJS(fullPath));
}

let getStateCache = null
let prevCacheRefreshed = null
let stateHash = null
let rulesHash = null
export const getState = (state, isForce = false) => {
  if(!state.getIn(['project', 'Settings', 'experiment', 'isPtSingleLoop'], false) || isForce) {
    return _getState(state);
  }
  if (getStateCache === null || Date.now() - prevCacheRefreshed > 500 ||
    stateHash !== state.get('state', Map()).hashCode() ||
    rulesHash !== state.get('rules', Map()).hashCode()
  ) {
    getStateCache = _getState(state)
    prevCacheRefreshed = Date.now()
    stateHash = state.get('state', Map()).hashCode()
    rulesHash = state.get('rules', Map()).hashCode()
  }
  return getStateCache
}

const _getState = state => {
  const rulesState = state.getIn(['rules'], Map()).toJS()
  const appState = state.getIn(['state'], Map()).toJS()
  const regFormState = state.get('ftFormState', Map()).toJS()
  const layoutMode = state.get('layoutMode', 'lg')
  let currentPageId = state.get('page')

  let repeatRoot = state.getIn(['project', 'Settings', 'RepeatedStripsID'], List()).toJS();
  let aclRule = getACByState(state);
  let elements = state.getIn(['pages', currentPageId, 'Props', 'elements'], Map());

  _.each(appState, function (page, pageID) {
    if(isProjectContainer(state, pageID) && !['Header', 'Footer'].includes(pageID)) {
      if(
        state.getIn(['state', 'project', pageID]) !== false
        && state.getIn(['state', 'projectHover', pageID]) !== 'show'
      ) {
        appState[pageID] = {}
        return true;
      }
    }
    _.each(page, function (elem, elemUID) {
      if (elemUID && repeatRoot.indexOf(elemUID) > -1) {
        appState[pageID][`${elemUID}-totalRows`] = getMappingCount(elem);
      }
      if(aclRule) {
        try {
          if(recursiveParentInvisibleValidation(elemUID, state, aclRule)) {
            let elem = state.getIn(['pages', currentPageId, 'Props', 'elements', elemUID]);
            appState[pageID][elemUID] = '';
            if(elem) {
              if(elem.get('children') && elem.get('children', List()).size) {
                const children = getAllChildren(elem.get('children', List()).toJS(), elements);
                _.map(children, (childId)=>{
                  appState[pageID][childId] = '';
                });
              }
            }
          } else {
            let elem = state.getIn(['pages', currentPageId, 'Props', 'elements', elemUID]);
            if(Map.isMap(elem) && elem.get('type') === 'Image' && appState[pageID][elemUID] === undefined){
              _.set(
                appState,
                [pageID, elemUID, 'IMG_SRC'],
                elem.getIn(['props', layoutMode, 'src'])
              )
            }
          }
        } catch(err) {
          console.error(err);
        }
      }
    });
  });

  applyRulesToAppState(appState, rulesState, [], state, [])

  let result = appState;

  const pageID = state.getIn(['project', 'Pages'], List())
    .find(page => page.get('_id') === currentPageId)
    ?.get?.('uid')

  pageID && elements.map((elem, elemUID) => {
    if (elem.get('type') === 'Image') {
      const parentID = getParentIdInModal(state, elem.get('parent'), false)
      let path = repeatRoot.includes(parentID) ? [pageID, parentID, elemUID] : [pageID, elemUID]
      if (_.get(appState, path) === undefined) {
        if (aclRule) {
          try {
            if (!recursiveParentInvisibleValidation(elemUID, state, aclRule)) {
              let elem = state.getIn(['pages', currentPageId, 'Props', 'elements', elemUID]);
              _.set(
                appState,
                [...path, 'IMG_SRC'],
                elem.getIn(['props', layoutMode, 'src'])
              )
            }
          } catch (err) {
            console.error(err);
          }
        } else {
          _.set(
            appState,
            [...path, 'IMG_SRC'],
            elem.getIn(['props', layoutMode, 'src'])
          )
        }
      }
    }
  })

  _.each(regFormState, function (val, key) {
    if (!result[key]) {
      result[key] = val;
    }
  });
  return result;
}

export const getStateValues = getState;

const toListVal = (k, i) => {
  if (k === 'device') return k
  if (_.endsWith(k, 'ft_value') || _.endsWith(k, 'ft_text')) {
    let path = String(k).split(':')
    return [..._.initial(path), i, _.last(path)].join(':')
  } else {
    return [...String(k).split(':'), i].join(':')
  }
}

const toTableVal = (k, i, retState) => {
  if (k === 'device') return k
  const path = String(k).split(':')
  return [...initial(path), i, _.last(path)].join(':')
}
const toRepeatVal = (k, i, retState) => {
  if (k === 'device') return k
  if (String(k).split(':').length !== 2 && i !== null) {
    if (retState && isImmutable(retState) && (_.endsWith(k, 'ftListValue') || _.endsWith(k, 'ftListValue'))) {
      let path = String(k).split(':')
      let elemUID = path[2];
      let pageID = retState.get('page');
      let isRadioType = false;
      let control = retState.getIn(['pages', pageID, 'Props', 'elements', elemUID])
      if(!control) {
        control = retState.getIn(['project', 'Settings', 'elements', elemUID])
      }
      if(control) {
        if(['CES', 'SurveyList'].includes(control.get('type'))) {
          isRadioType = true;
        } else if(control.getIn(['props', 'control']) == 'radio') {
          isRadioType = true;
        }
      }
      if (isRadioType) {
        let path = String(k).split(':')
        return [..._.initial(path), i, _.last(path)].join(':')
      } else {
        return `${k}:${i}`
      }
    } else if (_.endsWith(k, 'ft_value') || _.endsWith(k, 'ft_text') || _.endsWith(k, 'startDate') || _.endsWith(k, 'endDate')) {
      let path = String(k).split(':')
      return [..._.initial(path), i, _.last(path)].join(':')
    } else {
      return `${k}:${i}`
    }
  } else {
    return k
  }
}

// This function is deprecated. Use normalizeKeyPath instead.
export const updateOldValue = value => {
  return normalizeKeyPath(value);
};
export const showOldValue = value => String(value).replace(':ftListValue', ':ft_picklist')


const getParamType = (param) => {
  let type = 'string';
  switch (param.get('systemValue')) {
    case "year":
    case "month":
    case "day":
    case "hour":
    case "minute":
      type = 'number'
      break;
    case "today":
      type = 'date'
      break;
    case "now":
      type = 'datetime'
      break;
  }
  return type;
}

const getValueType = (field, retState) => {

  let type = 'string';
  try {
    if (field) {
      if (field.subType) {
        type = field.subType
      } else if (field.group == 'pageParam' && retState) {
        if (field.value) {
          let [pageUID, paramUID] = String(field.value).split(':');
          let pageID;
          retState.getIn(['project', 'Pages'], List()).map(page => {
            if (page && page.get('uid') == pageUID) {
              pageID = page.get('_id')
            }
          })
          if (pageID) {
            let page = retState.getIn(['pages', pageID], Map())
            if (page) {
              page.getIn(['Props', 'params'], List()).map(row => {
                if (row && row.get('valueType') == 'system' && row.get('id') == paramUID) {
                  type = getParamType(row);
                }
              })
            }
          }
        }
      } else if (field.group == 'param' && retState) {
        retState.getIn(['project', 'params'], List()).map(row => {
          if (row && row.get('valueType') == 'system' && row.get('id') == field.value) {
            type = getParamType(row);
          }
        })
      }
    }
  } catch (err) {
    console.error(err);
  }

  return `'${type}'`
}

const getValue = (field, providedRepeatIndex, tableIndex, listIndex, retState) => {
  let repeatIndex = providedRepeatIndex;
  let repeatRoot = [];
  if (isImmutable(retState)) {
    repeatRoot = retState.getIn(['project', 'Settings', 'RepeatedStripsID'], List()).toJS()
  }
  if (field && field.value !== null && typeof field.value !== 'undefined' && repeatRoot.length) {
    let localPath = String(field.value).split(':');
    let stripUID = localPath[1];
    if (!stripUID || repeatRoot.indexOf(stripUID) == -1) {
      repeatIndex = null;
      try {
        if (isImmutable(retState)) {
          if(field && field.value) {
            let localPath = String(field.value).split(':');
            if(String(field.value).includes('##')){
              localPath = _.first(String(field.value).split('##')).split(':')
            }
            let fieldUID = localPath[1];
            if(['Stripe', 'PowerTable', 'Widget', 'InteractiveImage'].includes(retState.getIn(['pages', retState.getIn(['page']), 'Props', 'elements', fieldUID, 'type']))) {
              repeatIndex = providedRepeatIndex;
            }
          }
        }
      } catch(err) {
        console.error(err);
      }
    } else if(repeatIndex === null && localPath.length > 2 && repeatRoot.indexOf(stripUID) > -1) {
      repeatIndex = 0;
    }
  } else if (isImmutable(retState)) {
    try {
      if(field && field.value) {
        let localPath = String(field.value).split(':');
        if(String(field.value).includes('##')){
          localPath = _.first(String(field.value).split('##')).split(':')
        }
        let fieldUID = localPath[1];
        if(!fieldUID) {
          repeatIndex = null;
        } else if(!['Stripe', 'PowerTable', 'Widget', 'InteractiveImage'].includes(retState.getIn(['pages', retState.getIn(['page']), 'Props', 'elements', fieldUID, 'type']))) {
          repeatIndex = null;
        }
      }
    } catch(err) {
      console.error(err);
    }
  }
  if (typeof listIndex !== 'undefined' && listIndex !== null) {
    if (field && field.value !== null && typeof field.value !== 'undefined') {
      if (_.startsWith(field.group, 'widgetParam:')) {
        return `_.get(params, '${String(toListVal(field.value, listIndex)).replace(/:/g, '.')}', '')`
      } else if (_.startsWith(field.group, 'view:')) {
        return `_.get(state, "${String(updateOldValue(field.value)).replace(/:/g, '.')}", '')`
      } else if (field.group === 'pageParam') {
        return `_.get(state, "${updateOldValue(field.value).replace(/:/g, '.')}", '')`
      } else if (field.group === 'smartvReg') {
        return `_.get(state, [${field.value}], '')`
      } else if (field.group === 'smartv') {
        return `_.get(smartVParams, [${field.value}], '')`
      } else if (_.startsWith(field.value, 'CWDB:')) { //element.uid.
        const path = String(toListVal(field.value, listIndex))
          .replace('CWDB:', '')
          .replace(/\:/g, '.')
        if (field.group) {
          return `_.get(state, '${field.group}.${path}', '')`
        } else {
          return `_.get(state, '${path}', '')`
        }
      } else if (field.group === 'static') {
        switch (field.value) {
          case 'true':
            return true
          case 'false':
            return false
          default:
            return '""';
        }
      } else if (field.group === 'param') {
        return `_.get(params, '${String(field.value).replace(/:/g, '.')}', '')`
      } else if (_.startsWith(field.group, 'form:')) {
        return `(_.has(state, '${field.value}.value') ? _.get(state, '${field.value}.value', '') : _.get(state, '${field.value}', ''))`
      } else if (_.startsWith(field.group, 'PowerTableWidget:')) {
        const columnValue = `_.get(state, '${String(toListVal(field.value, listIndex)).replace(/:/g, '.')}', '')`
        const originValue = `_.get(state, '${String(toListVal(`${field.value}_origin`, listIndex)).replace(/:/g, '.')}', ${columnValue})`
        return originValue
      } else {
        return `_.get(state, '${String(toListVal(field.value, listIndex)).replace(/:/g, '.')}', '')`
      }
    } else {
      return `''`
    }
  } else if (typeof tableIndex !== 'undefined' && tableIndex !== null) {
    if (field && field.value !== null && typeof field.value !== 'undefined') {
      if (_.startsWith(field.group, 'widgetParam:')) {
        return `_.get(params, '${String(toTableVal(field.value, tableIndex)).replace(/:/g, '.')}', '')`
      } else if (_.startsWith(field.group, 'view:')) {
        return `_.get(state, "${String(updateOldValue(field.value)).replace(/:/g, '.')}", '')`
      } else if (field.group === 'pageParam') {
        return `_.get(state, "${updateOldValue(field.value).replace(/:/g, '.')}", '')`
      } else if (field.group === 'smartv') {
        return `_.get(smartVParams, [${field.value}], '')`
      } else if (_.startsWith(field.value, 'CWDB:')) { //element.uid.
        const path = String(toTableVal(field.value, tableIndex))
          .replace('CWDB:', '')
          .replace(/\:/g, '.')
        if (field.group) {
          return `_.get(state, '${field.group}.${path}', '')`
        } else {
          return `_.get(state, '${path}', '')`
        }
      } else if (field.group === 'static') {
        switch (field.value) {
          case 'true':
            return true
          case 'false':
            return 'false'
          default:
            return '""';
        }
      } else if (field.group === 'param') {
        return `_.get(params, '${String(field.value).replace(/:/g, '.')}', '')`
      } else if (_.startsWith(field.group, 'form:')) {
        return `(_.has(state, '${field.value}.value') ? _.get(state, '${field.value}.value', '') : _.get(state, '${field.value}', ''))`
      } else {
        return `_.get(state, '${String(toTableVal(field.value, tableIndex)).replace(/:/g, '.')}', '')`
      }
    } else {
      return `''`
    }
  } else {
    if (field && field.value !== null && typeof field.value !== 'undefined') {
      if (field.subType === 'fileupload' && _.endsWith(field.value, ':ft_fileupload') && repeatIndex !== null && repeatIndex !== undefined) {
        const fPath = String(field.value).split(':')
        const statePath = [
          ..._.initial(fPath),
          repeatIndex,
          _.last(fPath)
        ].join('.')
        return `_.get(state, "${statePath}", '')`
      } else if (_.endsWith(field.value, ':ftStripRow')) {
        if (typeof repeatIndex == 'number') {
          return repeatIndex + 1;
        } else {
          return repeatIndex;
        }
      } else if (_.startsWith(field.group, 'widgetParam:')) {
        return `_.get(params, '${String(toRepeatVal(field.value, repeatIndex)).replace(/:/g, '.')}', '')`
      } else if (_.startsWith(field.group, 'view:')) {
        if(_.includes(field.value, 'ft_fileupload')) {
          return `_.join(_.get(state, "${toRepeatVal(updateOldValue(field.value), repeatIndex, retState).replace(/:/g, '.')}", ''))`
        } else {
          return `_.get(state, "${toRepeatVal(updateOldValue(field.value), repeatIndex, retState).replace(/:/g, '.')}", '')`
        }
      } else if (field.group === 'pageParam') {
        return `_.get(state, "${updateOldValue(field.value).replace(/:/g, '.')}", '')`
      } else if (field.group === 'smartv') {
        return `_.get(smartVParams, [${field.value}], '')`
      } else if (_.startsWith(field.value, 'CWDB:')) { //element.uid.
        const path = String(toRepeatVal(field.value, repeatIndex))
          .replace('CWDB:', '')
          .replace(/\:/g, '.')
        if (field.group) {
          return `_.get(state, '${field.group}.${path}', '')`
        } else {
          return `_.get(state, '${path}', '')`
        }
      } else if (field.group === 'static') {
        switch (field.value) {
          case 'true':
            return true
          case 'false':
            return 'false'
          case 'Desktop': return '"Desktop"'
          case 'Laptop': return '"Laptop"'
          case 'Tablet': return '"Tablet"'
          case 'Tablet (L)': return '"Tablet (L)"'
          case 'Tablet (S)': return '"Tablet (S)"'
          case 'Mobile (L)': return '"Mobile (L)"'
          case 'Mobile (S)': return '"Mobile (S)"'
          default:
            return '""';
        }
      } else if (field.group === 'param') {
        return `_.get(params, '${String(field.value).replace(/:/g, '.')}', '')`
      } else if (_.startsWith(field.group, 'form:')) {
        return `(_.has(state, '${field.value}.value') ? _.get(state, '${field.value}.value', '') : _.get(state, '${field.value}', ''))`
      } else if (_.startsWith(field.group, 'PowerTableWidget:') && isImmutable(retState)) {
        let valPath = String(toRepeatVal(field.value, repeatIndex)).split(':');
        if(retState.getIn(['state', valPath[0], valPath[1], valPath[2] + '_origin'])) {
          valPath[2] = valPath[2] + '_origin';
        }
        return `_.get(state, '${String(valPath.join('.'))}', '')`
      } else {
        return `_.get(state, '${String(toRepeatVal(field.value, repeatIndex)).replace(/:/g, '.')}', '')`
      }
    } else {
      return `''`
    }
  }
}

const getOldValue = (field, providedRepeatIndex, tableIndex, listIndex, retState) => {
  let repeatIndex = providedRepeatIndex;
  let repeatRoot = [];
  if (isImmutable(retState)) {
    repeatRoot = retState.getIn(['project', 'Settings', 'RepeatedStripsID'], List()).toJS()
  }
  if (field && field.value !== null && typeof field.value !== 'undefined' && repeatRoot.length) {
    let localPath = String(field.value).split(':');
    let stripUID = localPath[1];
    if (!stripUID || repeatRoot.indexOf(stripUID) == -1) {
      repeatIndex = null;
    } else if(repeatIndex === null && localPath.length > 2 && repeatRoot.indexOf(stripUID) > -1) {
      repeatIndex = 0;
    }
  } else if (isImmutable(retState)) {
    try {
      if(field && field.value) {
        let localPath = String(field.value).split(':');
        let fieldUID = localPath[1];
        if(!fieldUID) {
          repeatIndex = null;
        } else if(!['Stripe', 'PowerTable', 'Widget', 'InteractiveImage'].includes(retState.getIn(['pages', retState.getIn(['page']), 'Props', 'elements', fieldUID, 'type']))) {
          repeatIndex = null;
        }
      }
    } catch(err) {
      console.error(err);
    }
  }
  if (typeof listIndex !== 'undefined' && listIndex !== null) {
    if (field && field.value !== null && typeof field.value !== 'undefined') {
      if (_.startsWith(field.group, 'widgetParam:')) {
        return `_.get(oldParams, '${String(toListVal(field.value, listIndex)).replace(/:/g, '.')}', '')`
      } else if (_.startsWith(field.group, 'view:')) {
        return `_.get(oldState, "${String(updateOldValue(field.value)).replace(/:/g, '.')}", '')`
      } else if (field.group === 'smartv') {
        return `_.get(smartVParams, [${field.value}], '')`
      } else if (_.startsWith(field.value, 'CWDB:')) { //element.uid.
        const path = String(toListVal(field.value, listIndex))
          .replace('CWDB:', '')
          .replace(/\:/g, '.')
        if (field.group) {
          return `_.get(oldState, '${field.group}.${path}', '')`
        } else {
          return `_.get(oldState, '${path}', '')`
        }
      } else if (field.group === 'static') {
        switch (field.value) {
          case 'true':
            return true
          case 'false':
            return 'false'
          default:
            return '""';
        }
      } else if (field.group === 'param') {
        return `_.get(oldParams, '${String(field.value).replace(/:/g, '.')}', '')`
      } else if (_.startsWith(field.group, 'form:')) {
        return `(_.has(oldState, '${field.value}.value') ? _.get(oldState, '${field.value}.value', '') : _.get(oldState, '${field.value}', ''))`
      } else {
        return `_.get(oldState, '${String(toListVal(field.value, listIndex)).replace(/:/g, '.')}', '')`
      }
    } else {
      return `''`
    }
  } else if (typeof tableIndex !== 'undefined' && tableIndex !== null) {
    if (field && field.value !== null && typeof field.value !== 'undefined') {
      if (_.startsWith(field.group, 'widgetParam:')) {
        return `_.get(oldParams, '${String(toTableVal(field.value, tableIndex)).replace(/:/g, '.')}', '')`
      } else if (_.startsWith(field.group, 'view:')) {
        return `_.get(oldState, "${String(updateOldValue(field.value)).replace(/:/g, '.')}", '')`
      } else if (field.group === 'smartv') {
        return `_.get(smartVParams, [${field.value}], '')`
      } else if (_.startsWith(field.value, 'CWDB:')) { //element.uid.
        const path = String(toTableVal(field.value, tableIndex))
          .replace('CWDB:', '')
          .replace(/\:/g, '.')
        if (field.group) {
          return `_.get(oldState, '${field.group}.${path}', '')`
        } else {
          return `_.get(oldState, '${path}', '')`
        }
      } else if (field.group === 'static') {
        switch (field.value) {
          case 'true':
            return true
          case 'false':
            return 'false'
          default:
            return '""';
        }
      } else if (field.group === 'param') {
        return `_.get(oldParams, '${String(field.value).replace(/:/g, '.')}', '')`
      } else if (_.startsWith(field.group, 'form:')) {
        return `(_.has(oldState, '${field.value}.value') ? _.get(oldState, '${field.value}.value', '') : _.get(oldState, '${field.value}', ''))`
      } else {
        return `_.get(oldState, '${String(toTableVal(field.value, tableIndex)).replace(/:/g, '.')}', '')`
      }
    } else {
      return `''`
    }
  } else {
    if (field && field.value !== null && typeof field.value !== 'undefined') {
      if (_.startsWith(field.group, 'widgetParam:')) {
        return `_.get(oldParams, '${String(toRepeatVal(field.value, repeatIndex)).replace(/:/g, '.')}', '')`
      } else if (_.startsWith(field.group, 'view:')) {
        return `_.get(oldState, "${toRepeatVal(updateOldValue(field.value), repeatIndex, retState).replace(/:/g, '.')}", '')`
      } else if (field.group === 'smartv') {
        return `_.get(smartVParams, [${field.value}], '')`
      } else if (_.startsWith(field.value, 'CWDB:')) { //element.uid.
        const path = String(toRepeatVal(field.value, repeatIndex))
          .replace('CWDB:', '')
          .replace(/\:/g, '.')
        if (field.group) {
          return `_.get(oldState, '${field.group}.${path}', '')`
        } else {
          return `_.get(oldState, '${path}', '')`
        }
      } else if (field.group === 'static') {
        switch (field.value) {
          case 'true':
            return true
          case 'false':
            return 'false'
          default:
            return '""';
        }
      } else if (field.group === 'param') {
        return `_.get(oldParams, '${String(field.value).replace(/:/g, '.')}', '')`
      } else if (_.startsWith(field.group, 'form:')) {
        return `(_.has(oldState, '${field.value}.value') ? _.get(oldState, '${field.value}.value', '') : _.get(oldState, '${field.value}', ''))`
      } else {
        return `_.get(oldState, '${String(toRepeatVal(field.value, repeatIndex)).replace(/:/g, '.')}', '')`
      }
    } else {
      return `''`
    }
  }
}

const formatConditionValue = function (value, type, operator) {
  try {
    if (['greaterThan', 'lessThan', 'between', 'notBetween'].indexOf(operator) > -1) {
      if (!type || ['currency', 'time', 'date', 'datetime'].indexOf(type) === -1) {
        type = 'number'
      }
    }

    switch (type) {
      case 'time': {
        if (!value) {
          return 0;
        }
        if (String(value).indexOf(' ') > -1) {
          let val = moment(value)
          if (String(val) != 'Invalid date') {
            val = val.getMinutes() + (val.getHours() * 60);
            return val;
          } else {
            return 0;
          }
        } else if (String(value).indexOf(':') > -1) {
          let val = String(value).split(':');
          val = (parseFloat(val[0]) * 60) + parseFloat(val[1])
          if (isNaN(val)) {
            return 0;
          } else {
            return val
          }
        } else {
          return 0;
        }
      }
        break;
      case 'date': {
        let val = moment(value)
        if (String(val) == 'Invalid date') {
          val = moment(value, 'DD/MM/YYYY')
        } else if (String(val) == 'Invalid date') {
          val = moment(value, 'MM/DD/YYYY')
        } else if (String(val) == 'Invalid date') {
          val = moment(value, 'YYYY-MM-DD')
        }
        if (String(val) != 'Invalid date') {
          val = new Date(val.format())
          val.setMinutes(0)
          val.setHours(0)
          val.setSeconds(0)
          val.setMilliseconds(0);
          return val.getTime();
        } else {
          return val;
        }
      }
        break;
      case 'datetime': {
        let val = moment(value)
        if (String(val) == 'Invalid date') {
          val = moment(value, 'DD/MM/YYYY')
        } else if (String(val) == 'Invalid date') {
          val = moment(value, 'MM/DD/YYYY')
        } else if (String(val) == 'Invalid date') {
          val = moment(value, 'YYYY-MM-DD')
        }
        if (String(val) != 'Invalid date') {
          val = new Date(val.format())
          val.setSeconds(0)
          val.setMilliseconds(0);
          return val.getTime();
        } else {
          return val;
        }
      }
        break;
      case 'currency': {
        if(value && _.isObject(value) && value.value !== undefined) {
          value = value.value;
        }
        if (isTextAndBlank(value)) {
          return null
        }
        let val = parseFloat(value);
        if (isNaN(val)) {
          val = 0;
        }
        return val;
      }
      case 'number': {
        if (isTextAndBlank(value)) {
          return null
        }
        let val = parseFloat(value);
        if (isNaN(val)) {
          val = 0;
        }
        return val;
      }
      case 'boolean': {
        if (['false', 'no', '0'].includes(String(value).toLowerCase())) {
          return value
        } else {
          return Boolean(value)
        }
      }
      case 'string':
      default:
        return String(value).toLowerCase()
    }
  } catch (err) {
    console.error(err);
  }
  return value;
}

const isValidIsraelID = function (str) {
  //INPUT VALIDATION

  // Just in case -> convert to string
  var IDnum = String(str);
  // Validate correct input
  if ((IDnum.length > 9) || (IDnum.length < 5)) {
    return false;
  }

  if (isNaN(IDnum)) {
    return false;
  }

  if (IDnum == '00000000' || IDnum == '000000000') {
    return false;
  }
  // The number is too short - add leading 0000
  if (IDnum.length < 9) {
    while (IDnum.length < 9) {
      IDnum = '0' + IDnum;
    }
  }

  // CHECK THE ID NUMBER
  var mone = 0, incNum;
  for (var i = 0; i < 9; i++) {
    incNum = Number(IDnum.charAt(i));
    incNum *= (i % 2) + 1;
    if (incNum > 9)
      incNum -= 9;
    mone += incNum;
  }
  if (mone % 10 == 0) {
    return true;
  } else {
    return false;
  }
}

const isValidSNN = str => {
  var ssnPattern = /^[0-9]{3}\-?[0-9]{2}\-?[0-9]{4}$/;
  var isValid = ssnPattern.test(str);
  return isValid;
}

const getCountsOfWords = function (str) {
  var regexp = /\S+/g;
  var words = String(str).replace(/[^\w\s]|_/g, '')
    .replace(/\s+/g, ' ')
    .toLowerCase().match(regexp) || [];
  return words.length;
}


const getCondValue = (cond, staticValues, index, repeatIndex, tableIndex, listIndex, retState) => {
  if (cond.valueType === 'value') {
    staticValues[index] = cond.value
    return `staticValues[${index}]`
  } else if (cond.valueType === 'field') {
    return getValue(cond.value, repeatIndex, tableIndex, listIndex, retState)
  } else {
    return '""'
  }
}

const getCondValue2 = (cond, staticValues, index, repeatIndex, tableIndex, listIndex, retState) => {
  if (cond.value2Type === 'value') {
    staticValues[`${index}_2`] = cond.value2
    return `staticValues['${`${index}_2`}']`
  } else if (cond.value2Type === 'field') {
    return getValue(cond.value2, repeatIndex, tableIndex, listIndex, retState)
  } else {
    return '""'
  }
}

/**
 * Finds actions of specified types in rules that have matching condition field values
 * @param {Map} state - project state
 * @param {string} elementPath - The element path to match against conditions
 * @param {string[]} actionTypes - Array of action types to search for (e.g., ['sfAction', 'msgDlgtoast'])
 * @returns {Object|boolean} - Found action object or false if none found
 */
const findActionInRulesForElement = (state, elementPath, actionTypes) => {
  
  let foundAction = false
  const rulesPath = ['project', 'Settings', 'rules']
  const rules = state.getIn(rulesPath, Map())
  
  // Iterate through rule entries using Immutable's entrySeq
  rules.entrySeq().forEach(([ruleKey, ruleArray]) => {
    if (foundAction) return // Early exit if action already found
    
    // Check if ruleArray is a List and iterate through it
    if (List.isList(ruleArray)) {
    
      ruleArray.forEach(rule => {
        if (foundAction) return // Early exit if action already found
        
        // Check if rule has actionFlow
        const actionFlow = rule.getIn(['actions', 'actionFlow'])
        if (!actionFlow) return
        
        // Iterate through actionFlow entries
        actionFlow.entrySeq().forEach(([flowKey, flow]) => {
          if (foundAction) return // Early exit if action already found
          
          // Get the list from the flow
          const flowList = flow.get('list')
          if (!List.isList(flowList)) return
          
          // Find condition action with matching field value
          const conditionAction = flowList.find(action => 
            action.get('actionType') === 'condition' && 
            action.getIn(['data', 0, 'conditions', 0, 'field', 'value']) === elementPath
          )
          
          if (conditionAction) {
            // Look for any of the specified action types in the same flow
            const targetAction = flowList.find(action => 
              actionTypes.includes(action.get('actionType'))
            )
            
            if (targetAction) {
              foundAction = targetAction.toJS()
            }
          }
        })
      })
    }
  })
  
  return foundAction
}

const checkRepeatedStripRowsChange = (elementPath, retState, oldState, portalState) => {

  if (_.isEmpty(oldState)) {
    return false
  }

  const [pageUID, stripUID] = elementPath.split(':')
  if (!pageUID || !stripUID) {
    return false
  }

  const repeatRoot = retState.getIn(['project', 'Settings', 'RepeatedStripsID'], List()).toJS()
  const isRepeatStrip = repeatRoot.includes(stripUID)

  if (isRepeatStrip) {
    const totalRowsPath = `${pageUID}.${stripUID}-totalRows`;
    return _.get(oldState, totalRowsPath) !== _.get(portalState, totalRowsPath)
  }

  return false
}

const shouldPreventProcessCondition = (condition, retState, oldState, portalState) => {
  const elementPath = condition?.field?.value
  if (typeof elementPath !== 'string') { 
    return false
  }

  const isChangeByRepeatedStripRowsNumber = checkRepeatedStripRowsChange(elementPath, retState, oldState, portalState)
  if (!isChangeByRepeatedStripRowsNumber) {
    return false
  }

  const REPEAT_STRIP_ROWS_CHANGE_ACTION_TYPES = ['sfAction', 'msgDlgtoast']
  const actionFound = findActionInRulesForElement(retState, elementPath, REPEAT_STRIP_ROWS_CHANGE_ACTION_TYPES)

  return !!actionFound
}

const getFlags = str => str.replace(/^.*?\/([a-z]*)$/, '$1');
const trimRegExp = str => str.replace(/^\/?(.*?)\/?[a-z]*$/, '$1');
const getRegExp = str => {
  if (getFlags(str).length > 4) {
    return new RegExp(trimRegExp(str));
  } else {
    return new RegExp(trimRegExp(str), getFlags(str));
  }
};

export const processRuleCondition = (conditions, portalState, params, smartVParams, repeatIndex, { tableIndex, listIndex } = {}, isOnload, oldState, oldParams, retState) => {
  const instructions = []
  const staticValues = {}
  if(_.size(conditions) === 0 || !conditions){
    return false
  }

  _.each(conditions, (cond, index) => {

    if (shouldPreventProcessCondition(cond, retState, oldState, portalState)) {
      return true
    }

    let isNeedPostCond = true;
    if (conditions.length - 1 === index) {
      isNeedPostCond = false;
    }
    try {
      if(_.get(conditions, [index+1, 'field', 'value']) == ')') {
        isNeedPostCond = false;
      }

      if(cond.field && (cond.field.value == '(' || cond.field.value == ')')) {

        let postVal = _.get(cond, 'post', 'and') || 'and'

        if (conditions.length == 1) {
          postVal = '';
        }
        let postCond = ''
        if (isNeedPostCond && cond.field.value != '(') {
          if (postVal === 'and') {
            postCond = ' && '
          }
          if (postVal === 'or') {
            postCond = ' || '
          }
        } else {
          postVal = '';
        }

        instructions.push(` ${cond.field.value} ${postCond} `);
        return true;
      }
    } catch(err) {
      console.error(err);
    }

    const field = getValue(cond.field, repeatIndex, tableIndex, listIndex, retState)
    const fieldOld = getOldValue(cond.field, repeatIndex, tableIndex, listIndex, retState)
    const value = getCondValue(cond, staticValues, index, repeatIndex, tableIndex, listIndex, retState)
    const value2 = getCondValue2(cond, staticValues, index, repeatIndex, tableIndex, listIndex, retState)
    let startBracket = cond.bracket === '(' ? '(' : ''
    let endBracket = cond.bracket === ')' ? ')' : ''
    if (index == 0) {
      endBracket = '';
    }
    let postVal = _.get(cond, 'post', 'and') || 'and'
    if (conditions.length == 1) {
      startBracket = '';
      postVal = '';
    }
    let postCond = ''
    if (isNeedPostCond) {
      if (postVal === 'and') {
        postCond = ' && '
      }
      if (postVal === 'or') {
        postCond = ' || '
      }
    }

    let format = getValueType(cond.field, retState);
    let valueFormat = getValueType(cond.value, retState);
    if(String(format).includes('string') && !String(valueFormat).includes('string')){
      format = valueFormat
    }

    let fileIndex = ''
    if (repeatIndex !== null && repeatIndex !== undefined) {
      fileIndex = repeatIndex
    } else if (tableIndex !== null && tableIndex !== undefined) {
      fileIndex = tableIndex
    } if (listIndex !== null && listIndex !== undefined) {
      fileIndex = listIndex
    }

    switch (cond.operator) {
      case "maxSingleFileSizeInMB":
      case "maxSingleFileSizeInKB":
      case "minSingleFileSizeInMB":
      case "minSingleFileSizeInKB":
        instructions.push(`${startBracket} true ${endBracket} ${postCond}`)
        break;
      case 'minFileSizeInKB':
        instructions.push(`${startBracket} window.__FT_PROJECT__API__.getFilesSizeByID('${cond.field.uid}', 'kb', ${fileIndex}) >= Number(${value}) ${endBracket} ${postCond}`)
        break;
      case 'minFileSizeInMB':
        instructions.push(`${startBracket} window.__FT_PROJECT__API__.getFilesSizeByID('${cond.field.uid}', 'mb', ${fileIndex}) >= Number(${value}) ${endBracket} ${postCond}`)
        break;
      case 'maxFileSizeInMB':
        instructions.push(`${startBracket} window.__FT_PROJECT__API__.getFilesSizeByID('${cond.field.uid}', 'mb', ${fileIndex}) <= Number(${value}) ${endBracket} ${postCond}`)
        break;
      case 'maxFileSizeInKB':
        instructions.push(`${startBracket} window.__FT_PROJECT__API__.getFilesSizeByID('${cond.field.uid}', 'kb', ${fileIndex}) <= Number(${value}) ${endBracket} ${postCond}`)
        break;
      case 'between':
        instructions.push(`${startBracket} __.formatConditionValue(${field}, ${format}, '${cond.operator}') > __.formatConditionValue(${value}, ${format}, '${cond.operator}') && __.formatConditionValue(${field}, ${format}, '${cond.operator}') < __.formatConditionValue(${value2}, ${format}, '${cond.operator}') ${endBracket} ${postCond} `)
        break;
      case 'notBetween':
        instructions.push(`${startBracket} !(__.formatConditionValue(${field}, ${format}, '${cond.operator}') > __.formatConditionValue(${value}, ${format}, '${cond.operator}') && __.formatConditionValue(${field}, ${format}, '${cond.operator}') < __.formatConditionValue(${value2}, ${format}, '${cond.operator}')) ${endBracket} ${postCond} `)
        break;
      case 'greaterThan':
        instructions.push(`${startBracket} __.formatConditionValue(${field}, ${format}, '${cond.operator}') > __.formatConditionValue(${value}, ${format}, '${cond.operator}') ${endBracket} ${postCond}`)
        break;
      case 'lessThan':
        instructions.push(`${startBracket} __.formatConditionValue(${field}, ${format}, '${cond.operator}') < __.formatConditionValue(${value}, ${format}, '${cond.operator}') ${endBracket} ${postCond}`)
        break;
      case 'Change':
        instructions.push(`${startBracket} (${field} !== ${fieldOld}) ${endBracket} ${postCond}`)
        break;
      case 'checked':
        instructions.push(`${startBracket} ${field} === true ${postCond}`)
        break;
      case 'notChecked':
        instructions.push(`${startBracket} ${field} !== true ${endBracket} ${postCond}`)
        break;
      case 'isnotempty':
        if (cond?.field?.subType === 'fileupload' && _.endsWith(cond?.field?.value, ':ft_fileupload')) {
          instructions.push(`${startBracket} ${field} !== undefined && ${field} !== '' && ${field} !== null && ${field} !== 0 && !_.isEqual(${field}, []) ${endBracket} ${postCond}`)
        } else {
          instructions.push(`${startBracket} ${field} !== undefined && ${field} !== '' && ${field} !== null && ${field} !== 0 ${endBracket} ${postCond}`)
        }
        break;
      case 'isempty':
        instructions.push(`${startBracket} (${field} === undefined || ${field} === '' || ${field} === null || ${field} === 0 || (_.isArray(${field}) || _.isObject(${field})) && _.size(${field}) === 0) ${endBracket} ${postCond}`)
        break;
      case 'contains':
        instructions.push(`${startBracket} String(${field}).toLowerCase().indexOf(String(${value}).toLowerCase()) !== -1 ${endBracket} ${postCond}`)
        break;
      case 'notcontain':
        instructions.push(`${startBracket} String(${field}).toLowerCase().indexOf(String(${value}).toLowerCase()) === -1 ${endBracket} ${postCond}`)
        break;
      case 'startswith':
        instructions.push(`${startBracket} _.startsWith(String(${field}).toLowerCase(), String(${value}).toLowerCase()) ${endBracket} ${postCond}`)
        break;
      case 'endswith':
        instructions.push(`${startBracket} _.endsWith(String(${field}).toLowerCase(), String(${value}).toLowerCase()) ${endBracket} ${postCond}`)
        break;
      case 'equalsnotcase':
        instructions.push(`${startBracket} __.formatConditionValue(${field}, ${format}, '${cond.operator}') === __.formatConditionValue(${value}, ${format}, '${cond.operator}') ${endBracket} ${postCond}`)
        break;
      case 'equalcase':
        instructions.push(`${startBracket} ${field} === ${value}`)
        break;
      case 'notequalstring':
        instructions.push(`${startBracket} __.formatConditionValue(${field}, ${format}, '${cond.operator}') !== __.formatConditionValue(${value}, ${format}, '${cond.operator}') ${endBracket} ${postCond}`)
        break;
      case 'notequalcasestring':
        instructions.push(`${startBracket} String(${field}) !== String(${value}) ${endBracket} ${postCond}`)
        break;
      case 'equalor':
        instructions.push(`${startBracket} String(${value}).toLowerCase().split(',').indexOf(String(${field}).toLowerCase()) !== -1 ${endBracket} ${postCond}`)
        break;
      case 'equalorcase':
        instructions.push(`${startBracket} String(${value}).split(',').indexOf(String(${field})) !== -1 ${endBracket} ${postCond}`)
        break;
      case 'notequalor':
        instructions.push(`${startBracket} String(${value}).toLowerCase().split(',').indexOf(String(${field}).toLowerCase()) === -1 ${endBracket} ${postCond}`)
        break;
      case 'notequalorcase':
        instructions.push(`${startBracket} String(${value}).split(',').indexOf(String(${field})) === -1 ${endBracket} ${postCond}`)
        break;
      case 'minlength':
        instructions.push(`${startBracket} String(${field}).length >= ~~${value} ${endBracket} ${postCond}`)
        break;
      case 'maxlength':
        instructions.push(`${startBracket} String(${field}).length <= ~~${value} ${endBracket} ${postCond}`)
        break;
      case 'israelID':
        instructions.push(`${startBracket} __.isValidIsraelID(String(${field})) ${endBracket} ${postCond}`)
        break;
      case 'usssn':
        instructions.push(`${startBracket} __.isValidSNN(String(${field})) ${endBracket} ${postCond}`)
        break;
      case 'usssn':
        instructions.push(`${startBracket} __.isValidSNN(String(${field})) ${endBracket} ${postCond}`)
        break;
      case 'maxCountOfWords':
        instructions.push(`${startBracket} __.getCountsOfWords(String(${field})) <= ~~ ${value} ${endBracket} ${postCond}`)
        break;
      case 'minCountOfWords':
        instructions.push(`${startBracket} __.getCountsOfWords(String(${field})) >= ~~ ${value} ${endBracket} ${postCond}`)
        break;
      case 'custom':
        try {
          var functionName = "(function() { var isValid = true; ";
          if (cond.customRule && cond.customRule.code) {
            functionName += cond.customRule.code;
          }
          functionName += "; return isValid;  })() ";
          instructions.push(`${startBracket} ${functionName} === true ${endBracket} ${postCond}`)
        } catch (err) {
          console.error(" rule err ", err);
        }
        break;
      case 'regex':
        instructions.push(`${startBracket} __.getRegExp(${value}).test(${field})  ${endBracket} ${postCond}`)
        break;
      case 'numbersonly':
        instructions.push(`${startBracket} /^\\d+$/.test(${field}) ${endBracket} ${postCond}`)
        break;
      case 'alfaonly':
        instructions.push(`${startBracket} /^[a-zA-Z\\s]+$/.test(${field}) ${endBracket} ${postCond}`)
        break;
      case 'alfanumeric':
        instructions.push(`${startBracket} /^[a-zA-Z0-9\\s]+$/.test(${field}) ${endBracket} ${postCond}`)
        break;
    }
  })

  if (!IS_SERVER && window.location.href.indexOf('__COND__') !== -1) {
    console.log('---------------------')
    console.log('conditions', conditions)
    console.log('params', params)
    console.log('portalState', portalState)
    console.log('portalOldState', oldState)
    console.log('portalOldParams', oldParams)
    console.log('staticValues', staticValues)
    console.log('instructions: ', instructions.join(' '))
    console.log('retState', retState.toJS())
  }
  try {

    let fieldValues = {};
    _.each(portalState, function (page) {
      fieldValues = {
        ...fieldValues,
        ...page
      }
    });
    const func = eval(`(function(isOnload, params, state, staticValues, smartVParams, _, __, oldState, oldParams, fieldValues) { return ${instructions.join(' ')}; }) `)
    if (!IS_SERVER && window.location.href.indexOf('__COND__') !== -1) {
      console.log('result: ', func(isOnload, params, portalState, staticValues, smartVParams, _, {
        formatConditionValue,
        isValidIsraelID,
        isValidSNN,
        getCountsOfWords,
        getRegExp
      }, oldState, oldParams, fieldValues))
      console.log('---------------------')
    }

    let isSuccess = func(isOnload, params, portalState, staticValues, smartVParams, _, {
      formatConditionValue,
      isValidIsraelID,
      isValidSNN,
      getCountsOfWords,
      getRegExp
    }, oldState, oldParams, fieldValues)
    return isSuccess;
  } catch (error) {
    console.error('error', error)
    // console.log('---------------------')
    // console.log('conditions', conditions)
    // console.log('params', params)
    // console.log('portalState', portalState)
    // console.log('portalOldState', oldState)
    // console.log('portalOldParams', oldParams)
    // console.log('staticValues', staticValues)
    // console.log('instructions: ', instructions.join(' '))
    return false
  }
}

// classic conditions only - handles situations where one rule needs to wait for another rule (rules queue)
export const isNeedProcessQueCondition = function (retState, processUID, providedCurrentRule) {
  let isNeedProcess = true;


  let sfActions = retState.getIn(['sfActions', 'params'], List());

  sfActions.map(sfAction => {
    if (isImmutable(sfAction) && sfAction.get('processUID') == processUID) {
      let isFoundAction = false;
      sfAction.get('items', List()).map(function (row) {
        if (row) {
          if (row.get('isPush')) {
            retState.getIn(['project', 'Settings', 'pushToSalesforce']).map(sfPush => {
              if (sfPush && sfPush.get('uid') == row.get('value')) {
                isFoundAction = true;
              }
            })
          } else {
            if (retState.getIn(['project', 'Settings', 'sfMapping', row.get('value')])) {
              isFoundAction = true;
            }
          }
        }
      });
      if (isFoundAction) {
        isNeedProcess = false;
      }
    }
  })

  if (providedCurrentRule) {
    if (!providedCurrentRule.getIn(['actions', 'sfAction', 0, 'items', 0])) {
      return isNeedProcess;
    }
  }


  return isNeedProcess;
}

export const processRule = (rule, retState, path = [], { smartVParams, portalState, params }, isOnlyEffects, isOnload, oldState, oldParams, fullPath) => {
  let processUID = uuid();
  let processIndex = 0;
  rule.map(currentRule => {
    portalState = portalState || getState(retState)
    let dataProps = {
      providedCurrentRule: currentRule,
      path,
      portalState,
      params,
      smartVParams,
      retState,
      isOnlyEffects,
      isOnload,
      oldState,
      oldParams,
      fullPath,
      processUID,
      processIndex
    }
    retState = processSingleRuleProps(dataProps);
    processIndex++;
  })
  return retState
}

/**
 * processAffectedDisplayValueRulesForPaths is called
 * upon a rule that affected some element.
 * It gets the relevant paths that are affected
 * by this rule (for example, child elements),
 * and processes the display value rules for these elements when needed.
 * @param state
 * @param changedPaths
 * @param currentPageUID
 * @param rowIndex
 * @returns {*}
 */
const processAffectedDisplayValueRulesForPaths = (state, changedPaths, currentPageUID, rowIndex) => {
  try {
    let retState = state;
    let pageElements = retState.getIn(['pages', retState.get('page'), 'Props', 'elements'], Map());
    let repeatRoot = state.getIn(['project', 'Settings', 'RepeatedStripsID'], List()).toJS();
    if (pageElements) {
      pageElements.map(function (elem, elemUID) {
        if (elem.get('type') == 'FormField') {
          let isEffected = false;
          let localIndex = rowIndex;
          if (elem.getIn(['props', 'valueRule']) && elem.getIn(['props', 'valueRule']).size) {
            elem.getIn(['props', 'valueRule']).map(function (row) {
              if (row && row.getIn(['conditions'])) {
                row.getIn(['conditions']).map(cond => {
                  if (cond && cond.getIn(['value', 'uid'])) {
                    _.each(changedPaths, function (path) {
                      if (path && path[path.length - 1] == cond.getIn(['value', 'uid'])) {
                        isEffected = true;
                      } else if (path && path[path.length - 2] == cond.getIn(['value', 'uid'])) {
                        let tmp = parseInt(path[path.length - 1]);
                        if (!isNaN(tmp)) {
                          localIndex = path[path.length - 1];
                        }
                        isEffected = true;
                      }
                    })
                  }
                })
              }
            })
          }
          let getRepeatPath;
          if (isEffected) {
            let localPath = ['formFieldStatuses', currentPageUID, elemUID];
            let rulesPath = ['rules', currentPageUID, elemUID];
            if (typeof localIndex == 'number') {
              let parent = getFirstParentElement(pageElements, elemUID);
              if(repeatRoot.includes(parent)) {
                let elem = pageElements.get(elemUID);
                if(elem) {
                  const control = elem.getIn(['props', 'control'], 'text')
                  let isListCheckbox = false;
                  if (control == 'checkbox') {
                    isListCheckbox = elem.getIn(['props', 'source'], 'single') !== 'single';
                  }

                  getRepeatPath = () => {
                    let propName = [];
                    if ((LIST_BASED_FIELDS.indexOf(control) > -1 || isListCheckbox) && prefix == 'state') {
                      propName = ['ftListValue'];
                    }
                    return ['state',currentPageUID, parent, elemUID, ...propName, localIndex]
                  };
                }
                localPath = ['formFieldStatuses', currentPageUID, parent , elemUID, String(localIndex)];
                rulesPath = ['rules', currentPageUID, parent , elemUID, localIndex];
              }
            }

            // no previous values for this path - don't process it
            // this means that the value rules will be processed only
            // if once triggered from a manual value change.
            if(retState.getIn(localPath) === undefined) {
              return true;
            }

            let ruleStatus = processValueRules(elemUID, elem, getRepeatPath, localIndex, undefined, rulesPath)(null, () => retState);
            retState = retState.setIn(localPath, fromJS(ruleStatus.ruleStatus))
          }
        }
      });
    }

    return retState;
  } catch (err) {
    console.error('processAffectedDisplayValueRulesForPaths err', err);
  }
  return state;
};

// listens to what path changed
// both classic and regular conditions
export const doProcessRules = (state, isPortal = false, __nopath, fullPathProvided, changesPathProvided, isOnlyEffects = false, isOnload, rowIndex, isShowState, processMeta = {}) => {
  let fullPath = fullPathProvided

  let originChanges = changesPathProvided;
  changesPathProvided = filterChangedPathAC(state, changesPathProvided);
  if(originChanges && originChanges.length) {
    if(!changesPathProvided.length) {
      return state;
    }
  }
  let changesPath = changesPathProvided
  let processUID = processMeta?.processUID || uuid();
  let processIndex = 0;
  const path = []
  // console.log('before doProcessRules', { isPortal, fullPath, changesPath, isOnlyEffects, isOnload, rowIndex, processMeta })
  // fullPath && console.log(fullPath.join(':'))
  // fullPath && console.log(window.rulesHashMap)
  const rulesPath = ['project', 'Settings', 'rules']
  if (state.get('isWebBuilder')) {
    return state
  }
  let retState = state
  const smartVParams = typeof window !== 'undefined' ? _.get(getPreviewDynamicData(), 'svParams', {}) : {}
  if (_.isArray(changesPath) && changesPath.length) {
    let portalState = getState(retState)
    if (rowIndex !== undefined && rowIndex !== null && !isShowState) {
      let isStop = false
      const RepeatedStripsID = state.getIn(['project', 'Settings', 'RepeatedStripsID'], List()).toJS();
      let processChanges = _.filter(
        changesPath,
        path => {
          let totalId = String(path[1]).replace('-totalRows', '')
          if (RepeatedStripsID.includes(path[1]) || _.endsWith(path[1], '-totalRows') && RepeatedStripsID.includes(totalId)) {
            let size = _.endsWith(path[1], '-totalRows') ? getMappingCount(_.get(portalState, [path[0], totalId], {})) : getMappingCount(_.get(portalState, _.slice(path, 0, 2), {}))
            if ((size - 1) < rowIndex) {
              isStop = true
              return false
            }
          }
          return true
        }
      )
      processChanges = _.compact(processChanges)
      const [st, changes] = recalculatePowerFields(retState, processChanges)
      changesPath.push(...changes)
      retState = st
      if (isStop) {
        return retState
      }
    } else {
      const [st, changes] = recalculatePowerFields(retState, changesPath)
      changesPath.push(...changes)
      retState = st
    }
  } else if (fullPath && fullPath.length) {
    const [st, changes] = recalculatePowerFields(retState, [fullPath])
    changesPath = [fullPath, ...changes]
    fullPath = []
    retState = st
  } else {
    const [st] = initializePowerFields(retState)
    retState = st
  }
  changesPath = compactArrayPath(changesPath)

  /**
   * block refresh sf pick list for record type id
   */
  let mappingList = retState.getIn(['project', 'Settings', 'sfMapping'], Map()).toJS();
  if (mappingList) {
    let hashSfByRecordType = {};
    _.each(mappingList, function (row, uid) {
      if (row && row.recordTypeID) {
        if (!hashSfByRecordType[row.recordTypeID]) {
          hashSfByRecordType[row.recordTypeID] = [];
        }
        hashSfByRecordType[row.recordTypeID].push(uid);
      }
    });
    if (Object.keys(hashSfByRecordType).length) {
      let sfNeedProcess = [];
      _.each(changesPath, function (path) {
        if (path && _.isArray(path)) {

          let localList = [];
          _.each(hashSfByRecordType, function (row, key) {
            if (key.endsWith(path.join(':'))) {
              localList = _.concat(localList, row);
            }
          })
          if (localList.length) {
            let newValue = state.getIn(['params', ...path]);
            let oldValue = state.getIn(['state', 'recordType', 'params', ...path]);
            if (newValue != oldValue) {
              sfNeedProcess = _.concat(sfNeedProcess, localList);
            }
          }
        }
      });
      if (sfNeedProcess.length) {
        retState = retState.setIn(
          ['__cache__'],
          retState.getIn(['__cache__'], List())
            .push(fromJS({
              type: 'RefreshPickList',
              payload: {
                uid: uuid(),
                list: sfNeedProcess
              }
            }))
        )
      }
    }
  }
  /**
   * end block refresh sf pick list for record type id
   */
  // console.log('doProcessRules', { isPortal, fullPath, changesPath, isOnlyEffects, isOnload })
  let portalState = getState(retState)
  let params = getParams(retState)
  const oldState = state.get('prevRulesState', Map()).toJS();
  const oldParams = state.get('prevRulesParams', Map()).toJS();
  retState = retState.set('prevRulesState', fromJS(portalState))
  retState = retState.set('prevRulesParams', fromJS(params))
  const projectID = state.getIn(['project', '_id'])

  let repeatRoot = state.getIn(['project', 'Settings', 'RepeatedStripsID'], List()).toJS();
  const runRules = []
  const currentPageID = state.get('page')
  const currentPageUID = state.getIn(['project', 'Pages'], List())
    .find(page => page.get('_id') === currentPageID)
    ?.get?.('uid')
  const currentPage = state.getIn(['project', 'Pages'], List())
    .find(page => page.get('_id') === currentPageID)
  if (_.isArray(changesPath) && changesPath.length) {
    retState = processAffectedDisplayValueRulesForPaths(retState, changesPath, currentPageUID, rowIndex);
    _.each(changesPath, fullPath => {
      let localPath = fullPath.join(':');
      let isRepeat = false, repeatIndex = -1;
      if (fullPath && fullPath.length == 1) {
        localPath = fullPath[0];
      } else if (fullPath[1] && repeatRoot.indexOf(fullPath[1]) > -1 && fullPath.length == 4) {
        localPath = [fullPath[0], fullPath[1], fullPath[2]].join(':');
        if(fullPath[1] == fullPath[2]) {
          repeatIndex = parseInt(fullPath[3]);
          if(!isNaN(repeatIndex)) {
            isRepeat = true;
          }
        }
      }
      let runRule = getRules(localPath, currentPageUID, projectID, retState)
      if(isRepeat && !runRule) {
        localPath = [fullPath[0], fullPath[1]].join(':');
        runRule = getRules(localPath, currentPageUID, projectID, retState)
      }
      if (!runRule && isPortal) {
        runRule = getRules(fullPath.slice(1, fullPath.length).join(':'), currentPageUID, projectID, retState)
      }
      _.map(runRule, ruleItem => {
        let rule = retState.getIn([...rulesPath, ...ruleItem])
        if (rule) {
          if(repeatIndex > -1) {
            if (runRules.indexOf([...rulesPath, ...ruleItem, repeatIndex].join('.')) !== -1) {
              return true
            }
            runRules.push([...rulesPath, ...ruleItem, repeatIndex].join('.'))
          } else {
            if (runRules.indexOf([...rulesPath, ...ruleItem].join('.')) !== -1) {
              return true
            }
            runRules.push([...rulesPath, ...ruleItem].join('.'))
          }
          if(rule.get('modeType') == 'flow' && rule.get('actions') && String(fullPath[1]).includes('-totalRows')) {
            rule = fromJS({
              isActionRule:true,
              action:[rule]
            })
          }
          if(processMeta?.processUID && processMeta?.runID === rule.get('uid')){
            const list = rule.getIn(['actions', 'actionFlow', '0', 'list'], List())
            const cond = list.filter(node => node.get('actionType') === 'condition')
            if (cond.size > 0 && (processMeta.runTimes === undefined || processMeta.runTimes < 2)) { } else {
              console.log('Recursive conditions loop detected [%s]', rule.get('name'))
              return true
            }
          }
          rule = rule
            .setIn(['options', 'runID'], processMeta?.runID || rule.get('uid'))
            .setIn(['options', 'processUID'], processUID)
            .setIn(['options', 'runTimes'], 1)

          processMeta.runTimes = (processMeta.runTimes ?? 0) + 1

          portalState = getState(retState)
          params = getParams(retState)
          let dataProps = {
            providedCurrentRule: rule,
            path,
            portalState,
            params,
            smartVParams,
            retState,
            isOnlyEffects,
            isOnload,
            oldState,
            oldParams,
            fullPath,
            processUID,
            processIndex,
            processMeta,
            rowIndex
          }
          retState = processSingleRuleProps(dataProps);
          processIndex++;
        }
      })
    })

    if (retState.getIn(['redirectToPage'], '') !== '') {
      const pageUID = retState.getIn(['redirectToPage'], '')

      if (pageUID) {
        retState = retState.setIn(
          ['__cache__'],
          retState.getIn(['__cache__'], List())
            .push(fromJS({
              type: 'redirectToPage',
              payload: {
                uid: pageUID
              }
            }))
        )
      }
    }

    if (!retState.getIn(['sfActions', 'needCall'], false)) {
      retState = retState.setIn(['ProjectIsLoadingTrigger'], false);
    }
    return retState
  } else if (fullPath && fullPath.length) {
    let runRule = getRules(fullPath.join(':'), currentPageUID, projectID, retState)
    portalState = getState(retState)
    params = getParams(retState)
    _.map(runRule, (ruleItem) => {
      if (!isOnload && currentPageUID) { //not onload && current page === ID in run rule for page
        let keys = String(ruleItem[0]).split(':')
        if ((keys[0] === keys[1] || keys[0] !== currentPageUID) && keys[0] !== projectID) {
          return true
        }
      }
      if (runRules.indexOf([...rulesPath, ...ruleItem].join('.')) !== -1) {
        return true
      }
      const rule = retState.getIn([...rulesPath, ...ruleItem])
      runRules.push([...rulesPath, ...ruleItem].join('.'))
      // rule && console.log(rule.toJS())
      if (rule) {
        // console.log('process single root widget rule', path)
        // portalState = getState(retState)
        // params = getParams(retState)
        let dataProps = {
          providedCurrentRule: rule,
          path,
          portalState,
          params,
          smartVParams,
          retState,
          isOnlyEffects,
          isOnload,
          oldState,
          oldParams,
          fullPath,
          processUID,
          processIndex,
          rowIndex
        }
        retState = processSingleRuleProps(dataProps);
        processIndex++;
      } else {
        const rule = retState.getIn([...rulesPath, ..._.initial(ruleItem)])
        if (rule) {
          // console.log('process single simple root widget rule', path, portalState)
          // portalState = getState(retState)
          // params = getParams(retState)
          let dataProps = {
            providedCurrentRule: rule,
            path: [],
            portalState,
            params,
            smartVParams,
            retState,
            isOnlyEffects,
            isOnload,
            oldState,
            oldParams,
            fullPath,
            processUID,
            processIndex,
            rowIndex
          }
          retState = processSingleRuleProps(dataProps)
          processIndex++;
        }
      }
    })

    if (retState.getIn(['redirectToPage'], '') !== '') {
      const pageUID = retState.getIn(['redirectToPage'], '')
      retState = retState.setIn(['redirectToPage'], '')
      if (pageUID) {
        retState = retState.setIn(
          ['__cache__'],
          retState.getIn(['__cache__'], List())
            .push(fromJS({
              type: 'redirectToPage',
              payload: {
                uid: pageUID
              }
            }))
        )
      }
    }

    if (!retState.getIn(['sfActions', 'needCall'], false)) {
      retState = retState.setIn(['ProjectIsLoadingTrigger'], false);
    }

    return retState
  }

  let rules = retState.getIn(rulesPath, Map())
  rules = filterRulesAC(retState, rules);
  rules.map((rule, key) => {
    portalState = getState(retState)
    const [page, elemKey] = String(key).split(':')
    let isAllowPage = state.getIn(['project', 'isPublic'], true) ? true : false
    if (!isAllowPage && currentPage) {
      isAllowPage = currentPage.get('access') === 'public'
        ? true
        : Boolean(getPreviewDynamicData()?.user)
    }
    if (page === currentPageUID && isAllowPage) {
      retState = processRule(rule, retState, [], { smartVParams, portalState, params }, isOnlyEffects, isOnload, oldState, oldParams, fullPath)
    } else if (page === projectID) {
      retState = processRule(rule, retState, [], { smartVParams, portalState, params }, isOnlyEffects, isOnload, oldState, oldParams, fullPath)
    }
  })

  if (retState.getIn(['redirectToPage'], '') !== '') {
    const pageUID = retState.getIn(['redirectToPage'], '')
    retState = retState.setIn(['redirectToPage'], '')
    if (pageUID) {
      retState = retState.setIn(
        ['__cache__'],
        retState.getIn(['__cache__'], List())
          .push(fromJS({
            type: 'redirectToPage',
            payload: {
              uid: pageUID
            }
          }))
      )
    }
  }

  if (!retState.getIn(['sfActions', 'needCall'], false)) {
    retState = retState.setIn(['ProjectIsLoadingTrigger'], false);
  }

  if (!isOnload) {
    retState = resetLoadingFlags(retState);
  }

  return retState
}

export const compileMessageWithValues = function (message, params, portalState, isBtnRepeat, path, index, retState, isPlain = false) {
  if (!message) {
    message = '';
  }
  var tmpElement = document.createElement('div');
  tmpElement.innerHTML = message;

  const processElem = (elem) => {
    let key = 'data-id'
    if(!elem.getAttribute(key)){
      key = 'data-uid'
    }
    if (elem.getAttribute(key)) {
      let uid = elem.getAttribute(key);
      let [group, fieldKey] = String(uid).includes('##')
        ? updateOldValue(String(uid)).split('##')
        : updateOldValue(String(uid)).split('#-#')
      if (String(uid).includes('##') && _.startsWith(uid, 'PowerTableWidget:') && String(uid).split('##').length === 4) {
        let parts = String(uid).split('##')
        group = parts[0] + '##' + parts[1]
        fieldKey = parts[2] + '##' + parts[3]
      }
      let val = '';
      if (_.endsWith(fieldKey, ':ft_value') || _.endsWith(fieldKey, ':ft_text')) {
        try {
          let repeatRoot = retState.getIn(['project', 'Settings', 'RepeatedStripsID'], List()).toJS()
          const elemPath = String(fieldKey).split(':')
          if (repeatRoot.includes(elemPath[1])) {
            if (index === null || index === undefined) {
              let size = getMappingCount(_.get(portalState, [elemPath[0], elemPath[1]], {}))
              val = []
              _.times(size, n => {
                val.push(_.get(portalState, [..._.initial(elemPath), n, _.last(elemPath)], ''))
              })
              val = _.compact(val).join(',')
            } else {
              val = _.get(portalState, [..._.initial(elemPath), index, _.last(elemPath)], '')
            }
          } else {
            val = _.get(portalState, elemPath, '')
          }
        } catch (error) {
          console.error(error)
          val = _.get(portalState, String(fieldKey).split(':'), '')
        }
      } else if (String(fieldKey).indexOf(':ftStripRow') > -1) {
        if (typeof index == 'number') {
            val = index + 1;
          } else {
            val = index;
          }
      } else if (String(fieldKey).indexOf('-totalRows') > -1) {
        let [pageUID, stripUID] = fieldKey.replace('-totalRows', '').split(':');
        let repeatRoot = retState.getIn(['project', 'Settings', 'RepeatedStripsID'], List()).toJS()
        if (repeatRoot.indexOf(stripUID) > -1) {
          const stripState = retState.getIn(['state', pageUID, stripUID], Map());
          val = getMappingCount(stripState.toJS());
        } else {
          val = '';
        }
      } else if (group === 'param') {
        val = _.get(params, String(fieldKey).replace(/\:/g, '.'), '')
      } else {
        if (isBtnRepeat && index !== undefined && index !== null) {
          let rows = _.get(
            path.length > 0 && _.last(path) !== index
              ? _.get(portalState, path)
              : portalState,
            [...String(fieldKey).split(':')], ''
          )
          if (_.has(rows, [index])) {
            val = _.get(rows, [index], '')
          } else {
            val = rows
          }
        } else {
          val = _.get(
            path.length > 0 && _.last(path) !== index
              ? _.get(portalState, path)
              : portalState,
            [
              ...String(fieldKey).split(':'),
              ...(isBtnRepeat && index !== undefined && index !== null) && typeof index !== 'undefined' ? [index] : []
            ],
            ''
          )
        }
      }
      if (val === undefined || val === null) {
        val = '';
      }
      elem.innerHTML = val;
    } else {
      elem.remove();
    }
  }
  let list = tmpElement.getElementsByClassName('pdf-mapping-element');
  _.each(list, processElem);
  list = tmpElement.getElementsByClassName('highlight');
  _.each(list, processElem);
  if(isPlain){
    return tmpElement.textContent
  }
  return tmpElement.innerHTML;
}

export const setValueByField = function (retState, field, value) {
  let path;
  if (field.getIn(['group']) === 'param') {
    path = String(field.getIn(['value'], '')).replace(/:/g, '.');
    return retState.setIn(['params', path], value)
  } else if (_.startsWith(field.getIn(['group']), 'tableWidget')) {
    let key = String(field.getIn(['value'], '')).split(':')
    key = [
      ..._.initial(key),
      index,
      _.last(key)
    ]
    path = key;
  } else {
    path = String(field.getIn(['value'], '')).replace(/:/g, '.');
  }

  return updateState(retState, path, value);
}

export const getValueByField = function (field, params, portalState, index) {
  let value = '';
  if (field.getIn(['group']) === 'smartv' && field.getIn(['value']) === 'id') {
    value = 'ft-smartv-record'
  } else if (field.getIn(['group']) === 'param') {
    value = _.get(
      params,
      String(field.getIn(['value'], '')).replace(/:/g, '.').replace('param', ''),
      ''
    )
  } else if (_.startsWith(field.getIn(['group']), 'tableWidget')) {
    let key = String(field.getIn(['value'], '')).split(':')
    key = [
      ..._.initial(key),
      index,
      _.last(key)
    ]
    value = _.get(portalState, key, '');
  } else {
    value = _.get(portalState, String(field.getIn(['value'], '')).replace(/:/g, '.'), '');
    if(_.isArray(value) && typeof index === 'number') {
      value = value[index];
    }
  }
  return value;
}

export const processSingleRule = function (providedCurrentRule, path, portalState, params, smartVParams, retState, isOnlyEffects, isOnload, oldState = {}, oldParams = {}, fullPath = [], processUID) {

  let dataProps = {
    providedCurrentRule,
    path,
    portalState,
    params,
    smartVParams,
    retState,
    isOnlyEffects,
    isOnload,
    oldState,
    oldParams,
    fullPath,
    processUID
  }
  return processSingleRuleProps(dataProps);
}

export const refreshOnProcessOpposite = function (retState, actionTarget, isOnload, oldState) {
  let changesPath = [];
  transformActions(actionTarget).map((action, keyIndex) => {
    if (['show', 'hide'].indexOf(action.get('type')) > -1) {
      let fullPath = String(keyIndex).split(':');
      if (fullPath[1]) {
        changesPath.push(fullPath)
        retState = retState.setIn(
          ['ft', 'changes'],
          effectElementsInsideCondition(retState, fullPath)
        )
      }
    }
  })
  // if (changesPath.length) {
  //   retState = doProcessRules(retState, false, [], [], changesPath, true, isOnload, oldState)
  // }
  return retState;
}

function getTrackerVisibleChoices(component, layoutMode) {
  const options = component.getIn(['props', layoutMode, 'options'], List())?.toJS()
  return options.reduce((acc, group) => {
        if (!group.hideOnLoad || (group.hideOnLoad && group.isHide === false)) {
          acc = [...acc, ...group.options]
        }
        return acc
      }, []
  )
}

// historically the structure of radio button state is different:
// first the index then the value
const repairRadioCorruptStatePath = (keyIndex, statePath) => {
  if (keyIndex.endsWith('ftListValue')) {
    statePath.pop();
  }
};

/**
 * Repair the state path for list elements if needed
 * If the Set Value action is set on the list element (i.e. MultiSelect)
 * instead of list element value (i.e. Multiselect value), we add the missing ftListValue
 * to the additionalPath
 * @param formFieldType - to exclude radio buttons (with different path structure)
 * @param keyIndex
 * @param additionalPath
 * @returns the repaired additional path
 */
const repairListElementsStatePath = (formFieldType, keyIndex, additionalPath) => {
  if(formFieldType !== ELEM_TYPES.RADIO && !_.endsWith(keyIndex, 'ftListValue')) {
    return ['ftListValue', ...additionalPath];
  }
  return additionalPath;
};

const handleSetValueForRepeatElements = (action, retState, keyPath, index, keyIndex,
                                 isPossibleRepeat, elementData) => {
  const elemType = action.get('elemType');

  let statePath = _.initial(keyPath);
  const additionalPath = !_.isNil(index) ? [index] : [];
  const value = action.get('value');

  switch (elemType) {
    case ELEM_TYPES.RANGE:
      retState = setValueForElementType(retState, statePath, additionalPath, value);
      break;
    case ELEM_TYPES.BUTTON:
      retState = retState.setIn(['state', ...statePath, 'BTN_TEXT', ...additionalPath], value);
      break;
    case ELEM_TYPES.IMAGE:
      retState = retState.setIn(['state', ...statePath, 'IMG_SRC', ...additionalPath], value);
      break;
    case ELEM_TYPES.TYPOGRAPHY:
      retState = retState.setIn(['state', ...statePath, 'TYPO_TEXT', ...additionalPath], value);
      break;
    case ELEM_TYPES.YOUTUBE:
    case ELEM_TYPES.VIMEO:
      retState = setValueForElementType(retState, statePath, additionalPath, value);
      break;
    case ELEM_TYPES.FORM_FIELD:
      if (elementData) {
        let formFieldValue = value;
        let formFieldAdditionalPath = [...additionalPath];
        const formFieldType = elementData.getIn(['props', 'control']);
        const source = elementData.getIn(['props', 'source']);

        if (formFieldType === ELEM_TYPES.CHECKBOX) {
          if (typeof value === 'string' && source === 'single') {
            formFieldValue = ['true', '1', 'yes', 'on', 'check'].includes(value.toLowerCase());
          } else {
            formFieldAdditionalPath = ['ftListValue', ...additionalPath];
          }
        } else if (formFieldType === ELEM_TYPES.RADIO) {
          repairRadioCorruptStatePath(keyIndex, statePath);
        } else if (formFieldType === ELEM_TYPES.CURRENCY) {
          formFieldAdditionalPath = ['value', ...additionalPath];
        } else if (formFieldType === ELEM_TYPES.LOOKUP && isPossibleRepeat && (_.endsWith(keyIndex, 'ft_text') || _.endsWith(keyIndex, 'ft_value'))) {
          const key = String(keyIndex).replace(/:/g, '.').split('.');
          formFieldAdditionalPath = [index, _.last(key)];
          statePath = _.initial(key);
        } else if (LIST_BASED_FIELDS.includes(formFieldType)) {
          formFieldAdditionalPath = repairListElementsStatePath(formFieldType, keyIndex, additionalPath);
        }
        retState = setValueForElementType(retState, statePath, formFieldAdditionalPath, formFieldValue);
      } else {
        retState = setValueForElementType(retState, statePath, additionalPath, value);
      }
      break;
    default:
      retState = setValueForElementType(retState, statePath, additionalPath, value);
  }
  return retState;
};


const setRulesForPath = (retState, rulesObj, path, newRules) => {
  const current = retState.getIn(['rules', ...path], List());
  const updated = setNewRules(current, fromJS(newRules), path);
  return _.set({ ...rulesObj }, path, updated.toJS());
};

const applyRuleForSingleRepeatItem = (retState, rulesObj, pageUID, repeatId, targetId, index, newRules) => {
  const path = [pageUID, repeatId, targetId, index];
  return setRulesForPath(retState, rulesObj, path, newRules);
};

const applyRuleForAllRepeatItems = (retState, rulesObj, pageUID, repeatId, targetId, count, newRules) => {
  let out = rulesObj;
  _.times(count, (i) => {
    out = setRulesForPath(retState, out, [pageUID, repeatId, targetId, i], newRules);
  });
  return out;
};

const applyRuleForNonRepeated = (retState, rulesObj, keyPath, newRules) =>
  setRulesForPath(retState, rulesObj, keyPath, newRules);

// processor for applied rules (factory like, returns the function to apply)
export function getProcessTargetsFunction(state, currentRule, isOnlyEffects, appState, appParams, isNotNeedProcessSF, isOnload, processUID, processIndex, oldState, oldParams, path, originIndex) {
  return function (index, isBtnRepeat = false, isSkipReRun = false, currentSingleRule, actions = Map(), rowIndex, processMeta) {
    let retState = state
    let portalState = appState
    let params = appParams

    transformActions(actions).map(function (actionTarget, keyIndex) {
      keyIndex = updateOldValue(keyIndex)
      if (!actionTarget.size) {
        return true;
      }
      let isNeedOnValueChange = false;
      if (_.endsWith(keyIndex, ':list_row_style')) {
        let keyPath = String(keyIndex).split(':')
        let rules = retState.getIn(['rules'], Map()).toJS();
        let colorKeyPath = [..._.initial(keyPath), 'ptRow', String(index), _.last(keyPath) + '_col']

        if(_.isArray(_.get(rules, _.initial(keyPath)))) {
          _.set(rules, _.initial(keyPath), {
            '0':_.get(rules, _.initial(keyPath))
          })
        }
        keyPath = [..._.initial(keyPath), 'ptRow', String(index), _.last(keyPath)]
        actionTarget.map(el => {
          if (el.get('type') === 'set_bg_color') {
            rules = _.set(rules, keyPath, el.getIn(['value'], ''));
          } else if (el.getIn(['type']) === 'set_color') {
            rules = _.set(rules, colorKeyPath, el.getIn(['valueColor'], ''));
          }
        })

        retState = retState.setIn(['rules'], fromJS(rules));
      } else if (keyIndex.indexOf(':listFieldStyle:') !== -1) {
        let keyPath = String(keyIndex).split(':')
        keyPath = [..._.initial(keyPath), String(index), _.last(keyPath)]

        const styleObject = buildStyleObjectFromActions(actionTarget, retState)
        retState = retState.setIn(['rules', ...keyPath], Map(styleObject))
      } else if (_.endsWith(keyIndex, ':row_style')) {
        let keyPath = String(keyIndex).split(':')
        let preKey = _.initial(keyPath)
        preKey[preKey.length - 1] = `${preKey[preKey.length - 1]}-row_style`
        keyPath = [...preKey, String(index), _.last(keyPath)]
        retState = retState.setIn(
          ['rules', ...keyPath],
          actionTarget.getIn([0, 'value'], '')
        )
      } else if (keyIndex.indexOf(':fieldStyle:') !== -1) {
        if (actionTarget.size) {
          let keyPath = String(keyIndex).split(':')

          keyPath = [
            ..._.slice(keyPath, 0, keyPath.length - 2),
            String(index),
            ..._.slice(keyPath, keyPath.length - 2, keyPath.length)
          ]
          const styleObject = buildStyleObjectFromActions(actionTarget, retState)
          let rules = retState.getIn(['rules'], Map()).toJS();
          rules = _.set(rules, keyPath, styleObject)
          retState = retState.setIn(['rules'], fromJS(rules));
        }
      } else if (actionTarget.getIn([0, 'type']) == 'allowQuickUpdate' || actionTarget.getIn([0, 'type']) == 'disallowQuickUpdate') {
        let path = String(keyIndex).split(':');
        let meta = retState.getIn(['metaInfo', ...path], Map());
        meta = meta.set('allowQuickUpdate', actionTarget.getIn([0, 'type']) == 'allowQuickUpdate');
        retState = retState.setIn(['metaInfo', ...path], meta);
      } else {
        const key = String(keyIndex)
        let keyPath = String(key).replace(/:/g, '.').split('.');
        const isPossibleRepeat = detectIsTargetKeyInRepeatEl(keyPath, retState)
        if (isBtnRepeat && !currentRule.get('isTableRule', false)) {
          keyPath = typeof index !== 'undefined' && isPossibleRepeat ? [...keyPath, index] : keyPath
        }
        if (key==='mapInteractivity') {
          retState = mapInteractivity(actionTarget,retState, _.assign({}, appParams, appState), detectIsTargetKeyInRepeatEl, index !== null || index !== undefined ? index : rowIndex)
        }
        if (keyIndex.indexOf(':link:') !== -1) {
          keyPath = String(keyIndex).split(':')
          keyPath = [
            ..._.slice(keyPath, 0, keyPath.length - 2),
            String(index),
            ..._.slice(keyPath, keyPath.length - 2, keyPath.length)
          ]
        }
        if (_.last(keyPath) === 'executeJS' && !isOnlyEffects) {
          if (actionTarget.getIn(['0', 'enabled'])) {
            let code = actionTarget.getIn(['0', 'code'], '');
            retState = retState.setIn(
              ['__cache__'],
              retState.getIn(['__cache__'], List())
                .push(fromJS({
                  type: 'executeJS',
                  payload: {
                    code: code,
                    index:index
                  }
                }))
            )
          }
        } else if (_.last(keyPath) === 'autoTrigger' && !isOnlyEffects) {
          if (actionTarget.getIn(['0', 'enabled'])) {
            retState = retState.setIn(
              ['__cache__'],
              retState.getIn(['__cache__'], List())
                .push(fromJS({
                  type: 'processSFAutoTrigger',
                  payload: {
                    index: index
                  }
                }))
            )
          }
        } else if (_.last(keyPath) === 'geoLoc' && !isOnlyEffects) {
          if (actionTarget.getIn(['0', 'enabled'])) {
            retState = retState.setIn(['isLocalLogout'], false);
            retState = retState.setIn(
              ['__cache__'],
              retState.getIn(['__cache__'], List())
                .push(fromJS({
                  type: 'RefreshGeoLoc',
                }))
            )
          }
        } else if (_.last(keyPath) === 'LoginAction' && !isOnlyEffects) {
          if (actionTarget.getIn(['0', 'enabled'])) {
            retState = retState.setIn(['isLocalLogout'], false);
            retState = retState.setIn(
              ['__cache__'],
              retState.getIn(['__cache__'], List())
                .push(fromJS({
                  type: 'LoginActionRedirect',
                  isLoginAction: actionTarget.getIn(['0', 'isLoginAction'])
                }))
            )
          }
        } else if (_.last(keyPath) === 'projectUI' && !isOnlyEffects) {
          if(actionTarget.getIn(['0', 'isEnableHeaderAct'])){
            switch(actionTarget.getIn(['0', 'Header', 'action'])){
              case 'Show':
                retState = retState.setIn(['project', 'Settings', 'Header', 'enable'], true)
                break;
              case 'Hide':
                retState = retState.setIn(['project', 'Settings', 'Header', 'enable'], false)
                break;
              case 'Toggle':
                retState = retState.setIn(
                  ['project', 'Settings', 'Header', 'enable'],
                  !retState.getIn(['project', 'Settings', 'Header', 'enable'], false)
                )
                break;
            }
          }
          if(actionTarget.getIn(['0', 'isEnableFooterAct'])){
            switch(actionTarget.getIn(['0', 'Footer', 'action'])){
              case 'Show':
                retState = retState.setIn(['project', 'Settings', 'Footer', 'enable'], true)
                break;
              case 'Hide':
                retState = retState.setIn(['project', 'Settings', 'Footer', 'enable'], false)
                break;
              case 'Toggle':
                retState = retState.setIn(
                  ['project', 'Settings', 'Footer', 'enable'],
                  !retState.getIn(['project', 'Settings', 'Footer', 'enable'], false)
                )
                break;
            }
          }
        } else if (_.last(keyPath) === 'localStorage' && !isOnlyEffects) {
          const parseLocalData = (key) => {
            let data = ftGetLocalStorage(key);
            if (!data) {
              return data;
            }
            try {
              data = JSON.parse(data);
              if (data.validFor) {
                if (data.validFor < new Date().getTime()) {
                  return null;
                }
                delete data.validFor;
              }
              return data;
            } catch (err) {

            }
            return null;
          }
          if (actionTarget.getIn(['0', 'enabled'])) {
            let payload = actionTarget.getIn(['0']).toJS();
            let storeData, pathToStorage;
            let changes = []
            switch (payload.target) {
              case 'onPage': {
                if (payload.pageUID) {
                  pathToStorage = `ftstd_${retState.getIn(['project', '_id'], '')}_${payload.pageUID}`
                  if (payload.action == 'Restore') {
                    let localData = parseLocalData(pathToStorage);
                    if (localData) {
                      try {
                        const [prop, uid] = payload.pageUID.split(':')
                        if (prop === 'param' && uid) {
                            //eg. payload.pageUID = "param:some-param-uuid"
                            //eg. localData = {"param:some-param-uuid":some value}
                            retState = retState.setIn(['params', uid], fromJS(localData[payload.pageUID]));
                            changes.push([uid])
                        } else {
                            retState = retState.setIn(['state', payload.pageUID], fromJS(localData));
                            changes.push([payload.pageUID])
                        }
                      } catch (err) {

                      }
                    }
                  } else if (payload.action == 'Store') {
                    storeData = retState.getIn(['state', payload.pageUID], Map());
                    const [prop, uid] = payload.pageUID.split(':')
                    if (prop === 'param' && uid) {
                        storeData = storeData.setIn([payload.pageUID], params[uid]);
                    }
                  }
                }
                break;
              }
              case 'onFieldGroup': {
                if (payload.elemList && payload.elemList.length) {
                  let list = _.sortBy(payload.elemList, function (field) {
                    return field;
                  })
                  pathToStorage = `ftstd_${retState.getIn(['project', '_id'], '')}_${list.join('_')}`
                  if (payload.action == 'Restore') {
                    let localData = parseLocalData(pathToStorage);
                    if (localData) {
                      try {
                        _.each(localData.list, function (row) {
                          if (row) {
                            retState = collectFieldGroupForRestore(row , retState, changes)
                          }
                        })
                      } catch (err) {
                        console.error(err);
                      }
                    }
                  } else if (payload.action == 'Store') {
                    let storeDataFields = List();
                    storeData = Map();
                    _.each(payload.elemList, function (elemUID) {
                      if (elemUID) {
                        const {data, path} =  collectFieldGroupForStore(elemUID,retState);
                        storeDataFields = storeDataFields.push({
                            path,
                            data
                        })
                    }
                    });
                    storeData = storeData.set('list', storeDataFields)
                  }
                }
                break;
              }
              case 'onField': {
                if (payload.elemUID) {
                  pathToStorage = `ftstd_${retState.getIn(['project', '_id'], '')}_${payload.elemUID}`
                  let elemUID = String(payload.elemUID).split(':');
                  if (payload.action == 'Restore') {
                    let localData = parseLocalData(pathToStorage);
                    if (localData) {
                      try {
                        retState = collectFieldForRestore(localData, elemUID ,retState, changes)
                      } catch (err) {

                      }
                    }
                  } else if (payload.action == 'Store') {
                    const {data, path} =  collectFieldForStore(elemUID,retState);
                    storeData = Map();
                    storeData = storeData.setIn(path, data);
                  }
                }
              }
                break;
              case 'project': {
                pathToStorage = `ftstd_${retState.getIn(['project', '_id'], '')}`
                if (payload.action == 'Restore') {
                  let localData = parseLocalData(pathToStorage);
                  if (localData) {
                    try {
                      _.each(localData, function (val, uid) {
                        if (val) {
                          changes.push([uid])
                          if (uid==='params') {
                            retState = retState.setIn([uid], fromJS(val));
                          } else {
                            retState = retState.setIn(['state', uid], fromJS(val));
                          }
                        }
                      })
                    } catch (err) {

                    }
                  }
                } else if (payload.action == 'Store') {
                  storeData = Map();
                  retState.getIn(['project', 'Pages'], List()).map(function (page) {
                    if (page) {
                      storeData = storeData.set(page.get('uid'), retState.getIn(['state', page.get('uid')], Map()))
                      storeData = storeData.setIn(['params'], retState.getIn(['params'], Map()))
                    }
                  });
                }
              }
                break;
            }

            if (pathToStorage && payload.action == 'Invalidate') {
              ftRemoveLocalStorage(pathToStorage)
            } else if (storeData && pathToStorage && payload.action == 'Store') {
              if (payload.validFor) {
                payload.validFor = parseInt(payload.validFor);
                if (!isNaN(payload.validFor)) {
                  let validFor = new Date();
                  validFor.setHours(validFor.getHours() + payload.validFor)
                  storeData = storeData.set('validFor', validFor.getTime());
                }
              }
              ftSetLocalStorage(pathToStorage, JSON.stringify(storeData.toJS()))
            }
            changes = _.compact(changes)
            retState = retState.setIn(
              ['ft', 'changes'],
              retState.getIn(['ft', 'changes'], List()).concat(fromJS(changes))
            )
          }
        } else if (_.last(keyPath) === 'validate' && !isOnlyEffects) {
          if (actionTarget.getIn(['0', 'enabled'])) {
            const payload = {
              type: 'ValidateAction',
              payload: {
                action: actionTarget.getIn(['0', 'action']),
                pageUID: actionTarget.getIn(['0', 'pageUID']),
                elemList: actionTarget.getIn(['0', 'elemList']),
                elemUID: actionTarget.getIn(['0', 'elemUID']),
                onInValid: actionTarget.getIn(['0', 'onInValid']),
                onValid: actionTarget.getIn(['0', 'onValid']),
                index: index,
                currentId: currentRule.get('uid'),
                options: currentRule.get('options'),
              }
            }
            retState = retState.setIn(
              ['__cache__'],
              retState.getIn(['__cache__'], List())
                .push(fromJS(payload))
            )
          }
        } else if (_.last(keyPath) === 'DrawerUI' && !isOnlyEffects) {
          if (actionTarget.getIn(['0', 'enabledGroup'], actionTarget.getIn(['0', 'enabled']) || actionTarget.getIn(['0', 'modalEnabled']))) {
            let isChangedStatus;
            if (isAllowFeatureState('CustomDrawer', retState) && actionTarget.getIn(['0', 'enabled'])) {
              const drawerPath = actionTarget.getIn(['0', 'action'], '')
              let drawerKey = String(drawerPath).split(':')
              if (drawerPath) {
                switch (actionTarget.getIn(['0', 'operation'], '')) {
                  case 'Reset state':
                    retState = retState.setIn(['state', _.last(drawerKey)], Map())
                    break
                  case 'Show':
                    isChangedStatus = drawerKey;
                    retState = retState.setIn(['state', ...drawerKey], false)
                    break
                  case 'Hide':
                    isChangedStatus = drawerKey;
                    retState = retState.setIn(['state', ...drawerKey], true)
                    break
                  case 'Toggle':
                    isChangedStatus = drawerKey;
                    retState = retState.setIn(['state', ...drawerKey], !retState.getIn(['state', ...drawerKey], true))
                    break
                }
                const uid = _.first(_.last(drawerKey).split('-'))
                const mode = retState.get('layoutMode', 'lg')
                if (!retState.getIn(['state', ...drawerKey], true)) {
                  const elem = retState.getIn(['project', 'Settings', 'elements', uid], Map())
                  if (['lg', 'md', 'sml'].includes(mode) && elem.getIn(['props', mode, 'isPersistent'], false)) {
                    retState = retState.setIn(['state', 'drawer'], uid)
                  } else {
                    retState = retState.setIn(['state', 'drawer'], '')
                  }
                  retState.getIn(['project', 'Settings', 'ui', 'Drawer'], List()).map(id => {
                    if (id !== uid) {
                      const elem = retState.getIn(['project', 'Settings', 'elements', id], Map())
                      if (elem.getIn(['props', mode, 'isPersistent'], false)) {
                        retState = retState.setIn(['state', 'project', id], true)
                      }
                    }
                  })
                } else {
                  retState = retState.setIn(['state', 'drawer'], '')
                }
              }
            }
            if (isAllowFeatureState('CustomModal', retState) && actionTarget.getIn(['0', 'modalEnabled'])) {
              const modalPath = actionTarget.getIn(['0', 'modalAction'], '')
              let modalKey = String(modalPath).split(':')
              if (modalPath) {
                switch (actionTarget.getIn(['0', 'modalOperation'], '')) {
                  case 'Custom Title':{
                    let title = compileMessageWithValues(actionTarget.getIn(['0', 'customTitle', 'settings', 'expression'], ''), params, portalState, isBtnRepeat, path, index, retState, true)
                    retState = retState.setIn(['state', `${_.last(modalKey)}-title`], title)
                    break;
                  }
                  case 'Reset state':
                    retState = retState.setIn(['state', _.last(modalKey)], Map())
                    let allChildren = collectChildID(retState, ['project', 'Settings'], _.last(modalKey), [])
                    let projectJs = retState.getIn(['project'], Map()).toJS();
                    retState.getIn(['project', 'Settings', 'elements'], Map()).map((elem, elemUID) => {
                      if (allChildren.includes(elemUID)) {
                        let parent = getParentIdInModal(retState, elem.get('parent'), true)
                        try {
                          if (retState.getIn(['state', parent, elemUID]) === undefined) {
                            let elemState = getPageState(parent, projectJs, null, 'lg', elemUID);
                            _.each(elemState, function (val, uid) {
                              retState = retState.setIn(['state', parent, uid], fromJS(val))
                              retState = addPathToStateChanges(retState, [parent, uid])
                            });
                          }
                        } catch (err) {
                          console.error(err);
                        }
                      }
                    });
                    break
                  case 'Show':
                    isChangedStatus = modalKey;
                    retState = retState
                      .setIn(['state', ...modalKey], false)
                      .setIn(['rules', ...modalKey], fromJS([]))
                      .setIn(['widgets', 'clientY', ...modalKey], currentRule.getIn(['options', 'clientY'], window.ftLastClientY))

                    retState = setNextModalZIndex(retState, _.last(modalKey))

                    break
                  case 'Hide':
                    isChangedStatus = modalKey;
                    retState = retState.setIn(['state', ...modalKey], true)
                      .setIn(['rules', ...modalKey], fromJS([]))
                      .deleteIn(['rules', 'z-index', _.last(modalKey)])
                    break
                  case 'Toggle':
                    isChangedStatus = modalKey;
                    let status = !retState.getIn(['state', ...modalKey], true)
                    retState = retState
                      .setIn(['state', ...modalKey], status)
                      .setIn(['rules', ...modalKey], fromJS([]))
                      .setIn(['widgets', 'clientY', ...modalKey], currentRule.getIn(['options', 'clientY'], window.ftLastClientY))

                    if (status) {
                      retState = retState.deleteIn(['rules', 'z-index', _.last(modalKey)])
                    } else {
                      retState = setNextModalZIndex(retState, _.last(modalKey))
                    }
                    break
                }
              }
            }
            try {
              if(isChangedStatus && isChangedStatus.length > 1) {
                if(isChangedStatus[0] == 'project') {
                  let modal = retState.getIn(['project', 'Settings', 'elements', isChangedStatus[1]])
                  if(modal) {
                    let allModalChildren = [];
                    modal.get('children', List()).map(list=>{
                      if (List.isList(list)) {
                        allModalChildren = allModalChildren.concat(list.toJS())
                      }

                      if (_.isString(list)) {
                        allModalChildren = allModalChildren.concat([list])
                      }
                    })
                    let children = collectAllChildren(allModalChildren, ['project', 'Settings'], retState);
                    children = _.uniq(_.flatten(children))
                    let ftChanges = retState.getIn(['ft', 'changes'], List());
                    _.each(children, function(child){
                      ftChanges = ftChanges.push(fromJS([
                        isChangedStatus[1], child
                      ]))
                    });
                    retState = retState.setIn(['ft', 'changes'], ftChanges);
                  }
                }
              }
            } catch(err) {
              console.error(err);
            }
          }



        } else if (_.last(keyPath) === 'postMessage' && !isOnlyEffects) {
          if (actionTarget.getIn(['0', 'enabled'])) {
            let data = {};
            _.each(actionTarget.getIn(['0', 'fields'], Map()).toJS(), function (field, key) {
              if (field.use) {
                let value = '';
                if (String(key).split(':').length === 1) {
                  value = _.get(params, String(key).split(':'), '');
                } else {
                  if (currentRule.get('isTableRule', false)) {
                    const _key = String(key).split(':')
                    if (_.size(_key) === 3) {
                      const type = retState.getIn(['pages', retState.getIn(['page']), 'Props', 'elements', _key[1], 'type'])
                      let ikey = _.initial(_key)
                      let lkey = _.last(_key)
                      if(_.isArray(_.get(portalState, _key))) {
                        value = _.get(
                          portalState,
                          [
                            ..._key,
                            index
                          ],
                          ''
                        )
                      } else if(type === 'Widget'){
                        value =  _.get(
                          portalState,
                          [
                            ...ikey,
                            index,
                            lkey
                          ],
                          ''
                        )
                      } else {
                        value = _.get(
                          portalState,
                          _key,
                          ''
                        )
                      }
                    } else {
                      value = _.get(
                        portalState,
                        [
                          ..._key,
                          ...isBtnRepeat && typeof index !== 'undefined' && index !== null ? [index] : []
                        ],
                        ''
                      )
                    }
                  } else {
                    value = _.get(
                      portalState,
                      [
                        ...String(key).split(':'),
                        ...(isBtnRepeat && typeof index !== 'undefined' && index !== null) ? [index] : []
                      ],
                      ''
                    )
                  }
                }
                data[field.name] = value;
              }
            });
            try {
              if (actionTarget.getIn(['0', 'target'], 'parent') === 'parent') {
                if (typeof window !== 'undefined') {
                  let domains = isValidDomain(actionTarget.getIn(['0', 'allowDomains'], '*'));
                  _.each(domains, function (domain) {
                    if (window.parent) {
                      window.parent.postMessage(JSON.stringify(data), domain);
                    } else if (window.opener) {
                      window.opener.postMessage(JSON.stringify(data), domain);
                    }
                  });
                }
              } else {

                const target = String(actionTarget.getIn(['0', 'target'], 'parent')).split(':');
                let elemUID = target[0];
                let targetPageID = target[1];
                let pages = retState.getIn(['project', 'Pages'], Map());
                pages.map(page => {
                  if (page && page.get('uid') == targetPageID) {
                    targetPageID = page.get('_id');
                  }
                })
                // console.log('data >>> ', data);
                if (targetPageID && targetPageID != retState.get('page')) {
                  retState = retState.setIn(['postMessagesTasks', targetPageID, elemUID], fromJS({
                    allowDomains: actionTarget.getIn(['0', 'allowDomains']),
                    data: data
                  }))
                } else {
                  const el = document.getElementById(target)
                  if (el) {
                    let iframe = _.lowerCase(el.nodeName) === 'iframe' ? [el] : el.getElementsByTagName('iframe')
                    if (iframe.length > '0') {
                      iframe = _.first(iframe)
                      if (typeof window !== 'undefined') {
                        let domains = isValidDomain(actionTarget.getIn(['0', 'allowDomains']));
                        _.each(domains, function (domain) {
                          iframe.contentWindow.postMessage(JSON.stringify(data), domain);
                        })
                      }
                    } else {
                      retState = retState.setIn(['postMessagesTasks', targetPageID, elemUID], fromJS({
                        allowDomains: actionTarget.getIn(['0', 'allowDomains']),
                        data: data
                      }))
                    }
                  } else {
                    retState = retState.setIn(['postMessagesTasks', targetPageID, elemUID], fromJS({
                      allowDomains: actionTarget.getIn(['0', 'allowDomains']),
                      data: data
                    }))
                  }
                }
              }
            } catch (error) {
              console.error('cannot send data', error)
            }
          }
        } else if (['predefined', 'ExportDownload', 'uac', 'TabInter', 'ECommerce', 'closeModal', 'reloadPage', 'setParentParam'].indexOf(key) !== -1) {
          let sett = actionTarget.getIn([0], actionTarget.getIn(['0'], Map()));
          if (sett.getIn(['enabled'], true) && !isOnlyEffects) {
            if (key === 'reloadPage' || key === 'closeModal' || key === 'setParentParam') {
              sett = sett.setIn(['action'], key)
            }
            switch (sett.getIn(['action'])) {
              case 'SmartVProcessActualLogout':
                retState = retState.setIn(
                  ['__cache__'],
                  retState.getIn(['__cache__'], List())
                    .push(fromJS({
                      type: 'SmartVProcessActualLogout'
                    }))
                )
              case 'otpLogin':
                retState = retState.setIn(
                  ['__cache__'],
                  retState.getIn(['__cache__'], List())
                    .push(fromJS({
                      type: 'SmartVOtpLoginProcess'
                    }))
                )
                break;
              case 'otpLogout':
                retState = retState.setIn(
                  ['__cache__'],
                  retState.getIn(['__cache__'], List())
                    .push(fromJS({
                      action:'otpLogout',
                      type: 'SmartVLogoutProcess'
                    }))
                )
                break;
              case 'SmartV Logout':
                if (retState.getIn(['project', 'Settings', 'isSSOPrivate'], false)) {
                  webProjectSSOLogout();
                } else {
                  const isSSOPrivate = retState.getIn(['project', 'Settings', 'isSSOPrivate'], false)
                  let haveSession = Boolean(getPreviewDynamicData()?.user)
                  if (!haveSession) {
                    if (isSSOPrivate) {
                      haveSession = Boolean(_.get(getPreviewDynamicData(), ['ssoParams', 'data']))
                    }
                  }
                  if (haveSession) {
                    retState = retState.setIn(
                      ['__cache__'],
                      retState.getIn(['__cache__'], List())
                        .push(fromJS({
                          type: 'SmartVLogoutProcess'
                        }))
                    )
                  }
                }
                break;
              case 'Go to Page':
                let pageUID = sett.getIn(['pageUID']);
                if (_.startsWith(pageUID, 'param:')) {
                  const paramPath = _.tail(String(pageUID).split(':'))
                  let id = ''
                  if (paramPath.length === 1) { ///project var
                    id = _.get(params, paramPath, '')
                  } else { //page var
                    id = _.get(portalState, paramPath, '')
                  }
                  if (id) {
                    let page = retState.getIn(['project', 'Pages'], List()).find(page => page.get('uid') === id);
                    if (page && page.get('access') == 'inherit' && !retState.getIn(['project', 'isPublic'], false)) {
                      if (!_.get(getPreviewDynamicData(), ['user'])) {
                        isNotNeedProcessSF = true;
                      }
                    }
                    retState = retState.setIn(
                      ['__cache__'],
                      retState.getIn(['__cache__'], List())
                        .push(fromJS({
                          type: 'redirectToPage',
                          payload: {
                            uid: id
                          }
                        }))
                    )
                  }
                } else {
                  let page = retState.getIn(['project', 'Pages'], List()).find(page => page.get('uid') === pageUID);
                  if (page && page.get('access') == 'inherit' && !retState.getIn(['project', 'isPublic'], false)) {
                    if (!_.get(getPreviewDynamicData(), ['user'])) {
                      isNotNeedProcessSF = true;
                    }
                  }
                  retState = retState.setIn(
                    ['__cache__'],
                    retState.getIn(['__cache__'], List())
                      .push(fromJS({
                        type: 'redirectToPage',
                        payload: {
                          uid: pageUID
                        }
                      }))
                  )
                }

                // setTimeout(() => {
                //   typeof window !== 'undefined' && window.__FT_PROJECT__API__.goToPage(pageUID)
                // }, 300)
                break;
              case 'clearLS': {
                const projectID = retState.getIn(['project', '_id'])
                const projectURL = retState.getIn(['project', 'URL'])

                let keys = _.filter(
                  _.keys(localStorage),
                  key => key === getProjectLocalKey(projectID) ||
                    key === getSessionProjectLocaKey(projectURL) ||
                    key === `offline_${projectID}` ||
                    _.startsWith(key, projectID) ||
                    key.includes(`ftstd_${projectID}`)
                )
                ftDeleteOfflineValue(`offline_${projectID}`)
                _.each(keys, key => {
                  ftRemoveLocalStorage(key)
                })
                break;
              }
              case 'SSO Logout':
                webProjectSSOLogout();
                break;
              case 'Set Parent Parameters':
              case 'setParentParam':

                if (sett.getIn(['parentParams'], Map()).size) {
                  let parentParams = sett.getIn(['parentParams'], Map());

                  retState = retState.setIn(
                    ['__cache__'],
                    retState.getIn(['__cache__'], List())
                      .push(fromJS({
                        type: 'FTSetParameters',
                        payload: {
                          parentParams,
                          index
                        }
                      }))
                  )
                }
                break;
              case 'reloadPage':
                if (sett.get('enabled')) {
                  retState = retState.setIn(
                    ['__cache__'],
                    retState.getIn(['__cache__'], List())
                      .push(fromJS({
                        type: 'FTReloadPage',
                        payload: {}
                      }))
                  )
                }
                break;
              case 'Close Modal':
              case 'closeModal':
                if (sett.get('enabled')) {
                  retState = retState
                    .setIn(['widgets', 'PreviewDocGen'], Map())
                    .setIn(['widgets', 'RedirectModal', 'needShow'], false)
                  retState = retState.setIn(
                    ['__cache__'],
                    retState.getIn(['__cache__'], List())
                      .push(fromJS({
                        type: 'FTCloseModal',
                        payload: {}
                      }))
                  )
                }

                break;
              case 'Export CSV':
                processDownloadCSV(actionTarget, portalState, retState)
                break;
              case 'Export JPEG':
              case 'Export PNG':
              case 'Export PDF':
                processDownloadImageExport(sett.getIn(['action']), actionTarget, portalState)
                break;
              case 'Download Attachment':
              case 'Download File':
                let recordIDPath = sett.getIn(['fileID']);
                let recordID;
                if (recordIDPath) {
                  if (String(recordIDPath).indexOf('pageParam:') > -1) {
                    recordIDPath = recordIDPath.split(':');
                    recordIDPath.splice(0, 1);
                    recordID = _.get(portalState, recordIDPath, '');
                  } else {
                    recordIDPath = recordIDPath.split(':');
                    if(_.includes(retState.getIn(['project', 'Settings', 'RepeatedStripsID'], List()).toJS(), recordIDPath[1])){
                      recordID = _.get(portalState, [...recordIDPath, ...index !== undefined && index !== null ? [index]: []], '');
                      if(_.isArray(recordID)){
                        recordID = recordID.join(',')
                      }
                    }else{
                      recordID = _.get(params, recordIDPath, '');
                    }
                  }
                }
                let type;
                if (sett.getIn(['action']) == 'Download Attachment') {
                  type = 'Attachment';
                } else {
                  type = 'ContentVersion';
                }
                if (_.startsWith(sett.getIn(['fileID']), 'calEvent:')) {
                  processDownloadEvent(sett.getIn(['fileID']), retState)
                } else {
                  if(String(recordID).includes(',')){
                    retState = retState.setIn(
                      ['__cache__'],
                      retState.getIn(['__cache__'], List())
                        .push(fromJS({
                          type: 'downloadFileModal',
                          payload: {
                            processUID,
                            processIndex,
                            recordID,
                            type
                          }
                        }))
                    )
                  } else {
                    retState = retState.setIn(
                      ['__cache__'],
                      retState.getIn(['__cache__'], List())
                        .push(fromJS({
                          type: 'downloadFile',
                          payload: {
                            processUID,
                            processIndex,
                            recordID,
                            type
                          }
                        }))
                    )
                  }
                }

                // let recordIDPath = _.get(portalState, String(action.getIn(['from', 'value'], '')).replace(/:/g, '.'), '');
                // let paramID = _.get(portalState, String(action.getIn(['from', 'value'], '')).replace(/:/g, '.'), '')
                // console.log('actionTarget >>> ', actionTarget.getIn(['0', 'fileID']))
                break;
              case 'ECommerce Catalog':
                if (!isAllowFeatureState('Commerce', retState)) {
                  break
                }
                _.each(eProductFields, ({ key }) => {
                  retState = retState.setIn(['state', 'eCommerce', 'eProductList', key], List())
                })
                retState = retState.setIn(['state', 'eCommerce', 'search'], '')
                retState = retState.setIn(
                  ['__cache__'],
                  retState.getIn(['__cache__'], List())
                    .push(fromJS({
                      type: 'redirectToCatalog',
                      isCartEmpty: actionTarget.getIn(['0', 'isCartEmpty']),
                      payload: {}
                    }))
                )
                break;
              case 'RefreshSmartVProfile':
                retState = retState.setIn(
                  ['__cache__'],
                  retState.getIn(['__cache__'], List())
                    .push(fromJS({
                      type: 'RefreshSmartVProfile',
                      payload: {}
                    }))
                )
                break;
              case 'ECommerce ProductDialog':
                if (!isAllowFeatureState('Commerce', retState)) {
                  break
                }
                retState = retState.setIn(
                  ['panels', 'productDlg', 'show'],
                  true
                )
                retState = retState.setIn(
                  ['panels', 'productDlg', 'uid'],
                  actionTarget.getIn(['0', 'uid'])
                )
                break;
              case 'ECommerce Checkout':
                if (!isAllowFeatureState('Commerce', retState)) {
                  break
                }
                retState = retState.setIn(
                  ['__cache__'],
                  retState.getIn(['__cache__'], List())
                    .push(fromJS({
                      type: 'redirectToCheckout',
                      payload: {}
                    }))
                )
                break;
              case 'ECommerce Cart':
                if (!isAllowFeatureState('Commerce', retState)) {
                  break
                }
                retState = retState.setIn(
                  ['__cache__'],
                  retState.getIn(['__cache__'], List())
                    .push(fromJS({
                      type: 'redirectToCart',
                      payload: {}
                    }))
                )
                // setTimeout(() => {
                //   typeof window !== 'undefined' && window.__FT_PROJECT__API__?.navigation?.profilePage?.()
                // }, 150)
                break;
              case 'ECommerce Product':
                if (!isAllowFeatureState('Commerce', retState)) {
                  break
                }
                retState = retState.setIn(['state', 'eCommerce', 'e_product'], Map())
                retState = retState.setIn(['state', 'eCommerce', 'e_product - relatedProducts'], Map())
                retState = retState.setIn(['state', 'eCommerce', 'e_product - productSlides'], Map())
                retState = retState.setIn(
                  ['__cache__'],
                  retState.getIn(['__cache__'], List())
                    .push(fromJS({
                      type: 'redirectToProduct',
                      payload: {}
                    }))
                )
                // setTimeout(() => {
                //   typeof window !== 'undefined' && window.__FT_PROJECT__API__?.navigation?.profilePage?.()
                // }, 150)
                break;
              case 'SmartV Profile':
                retState = retState.setIn(
                  ['__cache__'],
                  retState.getIn(['__cache__'], List())
                    .push(fromJS({
                      type: 'redirectToProfile',
                      payload: {}
                    }))
                )
                // setTimeout(() => {
                //   typeof window !== 'undefined' && window.__FT_PROJECT__API__?.navigation?.profilePage?.()
                // }, 150)
                break;
              case 'SmartV Login':
                retState = retState.setIn(
                  ['__cache__'],
                  retState.getIn(['__cache__'], List())
                    .push(fromJS({
                      type: 'redirectToLogin',
                      payload: {}
                    }))
                )
                break;
              case 'SmartV Registration':
                retState = retState.setIn(
                  ['__cache__'],
                  retState.getIn(['__cache__'], List())
                    .push(fromJS({
                      type: 'redirectToRegistration',
                      payload: {}
                    }))
                )
                break;
              case 'Print':
                retState = retState.setIn(['sfActions', 'isNeedPrint'], true)
                // setTimeout(function(){
                //   window.print();
                // }, 300);
                break;
              case 'Expand Column':
              case 'Collapse Column': {
                let isExpand = sett.getIn(['action']) === 'Expand Column'
                const elUID = sett.get('elUID', '')
                const elemPath = String(elUID).split(':')
                const pageID = retState.getIn(['project', 'Pages'], List())
                  .find(page => page.get('uid') === elemPath[0])
                  ?.get?.('_id')
                let colID = _.last(elemPath)
                let parentColumn = null
                let elemID = _.includes(retState.getIn(['project', 'Settings', 'RepeatedStripsID'], List()).toJS(), elemPath[1])
                  ? elemPath[2]
                  : elemPath[1]
                if (String(elemID).includes('##')) {
                  let [id, colPath] = String(elemID).split('##')
                  elemID = id
                  parentColumn = _.first(String(colPath).split(':'))
                  colID = _.last(elemPath)
                }
                const columns = retState.getIn(['pages', pageID, 'Props', 'elements', elemID, 'props', 'columns'], List())
                const is1stLvl = !parentColumn && Boolean(columns.find(col => col.get('id') === colID))
                let initialPath = ['filter', ..._.map(_.initial(elemPath), str => _.first(String(str).split('##')))]
                let rowIndex = null
                if (isExpand) {
                  let expandOtp = sett.get('expandOtp', 'index')
                  if (expandOtp === 'index') {
                    let indexType = sett.getIn(['indexType'], 'static')
                    if (indexType === 'static') {
                      rowIndex = parseInt(sett.get('index', ''), 10)
                      if (Number.isNaN(rowIndex)) {
                        rowIndex = 0
                      }
                      rowIndex -= 1
                      if (rowIndex < 0) {
                        rowIndex = 0
                      }
                    } else {
                      let key = sett.get('indexEl', '')
                      let pathKey = String(key).split(':');
                      if (pathKey.length == 3 && index !== undefined && index !== null) {
                        pathKey.splice(2, 0, index);
                      }
                      rowIndex = _.get(
                        _.assign({}, params, portalState),
                        pathKey,
                        ''
                      )
                      rowIndex = parseInt(rowIndex, 10)
                      if (Number.isNaN(rowIndex)) {
                        rowIndex = 0
                      }
                      rowIndex -= 1
                      if (rowIndex < 0) {
                        rowIndex = 0
                      }
                    }
                    if (rowIndex !== null) {
                      if (is1stLvl) {
                        retState = retState
                          .setIn([...initialPath, 'expandedTree', _.last(elemPath)], null)
                          .setIn([...initialPath, 'expanded'], `${rowIndex}:${_.last(elemPath)}`)
                      } else {
                        retState = retState
                          .setIn([...initialPath, 'expandedTree', parentColumn], `${rowIndex}:${colID}`)
                      }
                    }
                  } else if (expandOtp === 'RecID') {
                    let indexType = sett.getIn(['indexType'], 'static')
                    let searchValue = null
                    if (indexType === 'static') {
                      searchValue = sett.get('index', '')
                    } else {
                      let key = sett.get('indexEl', '')
                      let pathKey = String(key).split(':');
                      if (pathKey.length == 3 && index !== undefined && index !== null) {
                        pathKey.splice(2, 0, index);
                      }
                      searchValue = _.get(
                        _.assign({}, params, portalState),
                        pathKey,
                        ''
                      )
                    }
                    let rowsData = retState.getIn(['state', ..._.initial(elemPath), 'value'], List())
                    rowIndex = rowsData.findIndex(value => value === searchValue)
                    if (rowIndex === -1) {
                      rowIndex = null
                    }
                    if (is1stLvl) {
                      retState = retState
                        .setIn([...initialPath, 'expandedTree', _.last(elemPath)], null)
                        .setIn([...initialPath, 'expanded'], `${rowIndex}:${_.last(elemPath)}`)
                    } else {
                      retState = retState
                        .setIn([...initialPath, 'expandedTree', parentColumn], `${rowIndex}:${colID}`)
                    }
                  } else if (expandOtp === 'current') {
                    if (is1stLvl) {
                      rowIndex = index
                      retState = retState
                        .setIn([...initialPath, 'expandedTree', _.last(elemPath)], null)
                        .setIn([...initialPath, 'expanded'], `${rowIndex}:${_.last(elemPath)}`)
                    } else {
                      rowIndex = index
                      retState = retState
                        .setIn([...initialPath, 'expandedTree', parentColumn], `${rowIndex}:${colID}`)
                    }
                  }
                } else {
                  if (is1stLvl) {
                    retState = retState
                      .setIn([...initialPath, 'expandedTree', _.last(elemPath)], null)
                      .setIn([...initialPath, 'expanded'], '')
                  } else {
                    retState = retState
                      .setIn([...initialPath, 'expandedTree', parentColumn], null)
                  }
                }
                let callPath = is1stLvl ? path : _.initial(elemPath)
                if (isExpand) {
                  const sfItemID = retState
                    .getIn(['project', 'Settings', 'sfMapping'], Map())
                    .findKey(elem => elem.get('elemUID') === `${elemID}##${colID}`)
                  if (sfItemID) {
                    retState = retState
                      .setIn(['sfActions', 'needCall'], true)
                      .setIn(['sfActions', 'params'], retState.getIn(['sfActions', 'params'], List())
                        .push(fromJS({
                          "items": [
                            {
                              "label": '',
                              "value": sfItemID,
                              "order": ""
                            }
                          ],
                          "elemUID": elemID,
                          processUID: uuid(),
                          processIndex: null,
                          path: callPath,
                          index: rowIndex,
                          ruleUID: currentSingleRule.get('uid'),
                          "isParallelLoad": false,
                          "isVerifyCaptcha": false,
                          "customOrder": false,
                          "runInBackground": false,
                          "options": {}
                        })));
                  }
                }
                break;
              }
              case 'Allow Clear Column':
              case 'Disallow Clear Column': {
                const layoutMode = retState.getIn(['layoutMode'], 'lg')
                let value = sett.getIn(['action']) === 'Allow Clear Column'
                let elemListlUID = sett.getIn(['elemListlUID'], List()).toJS()
                _.each(elemListlUID, elemPathList => {
                  let elemPath = String(elemPathList).split(':')
                  const pageID = retState.getIn(['project', 'Pages'], List())
                    .find(page => page.get('uid') === elemPath[0])
                    ?.get?.('_id')
                  let elemID = _.includes(retState.getIn(['project', 'Settings', 'RepeatedStripsID'], List()).toJS(), elemPath[1])
                    ? elemPath[2]
                    : elemPath[1]
                  let isRepeat = _.includes(retState.getIn(['project', 'Settings', 'RepeatedStripsID'], List()).toJS(), elemPath[1])
                  if (isRepeat && elemPath.length === 3 || !isRepeat && elemPath.length === 2) {
                    retState.getIn(['pages', pageID, 'Props', 'elements', elemID, 'props', 'columns'], List())
                      .map((column, columnIndex) => {
                        retState = retState
                          .setIn(['pages', pageID, 'Props', 'elements', elemID, 'props', 'columns', columnIndex, 'meta', 'allowClear'], value)
                      })
                  } else {
                    let columns = retState.getIn(['pages', pageID, 'Props', 'elements', elemID, 'props', 'columns'], List())
                    let columnIndex = columns.findIndex(col => col.get('id') === _.last(elemPath))
                    if (columnIndex !== -1) {
                      retState = retState
                        .setIn(['pages', pageID, 'Props', 'elements', elemID, 'props', 'columns', columnIndex, 'meta', 'allowClear'], value)
                    }
                  }
                })
                break;
              }
              case 'Show Column':
              case 'Hide Column': {
                const layoutMode = retState.getIn(['layoutMode'], 'lg')
                let isAllowStatus = sett.getIn(['action']) === 'Show Column'
                let elemListlUID = sett.getIn(['elemListlUID'], List()).toJS()
                _.each(elemListlUID, elemPathList => {
                  let elemPath = String(elemPathList).split(':')
                  const pageID = retState.getIn(['project', 'Pages'], List())
                    .find(page => page.get('uid') === elemPath[0])
                    ?.get?.('_id')
                  let elemID = _.includes(retState.getIn(['project', 'Settings', 'RepeatedStripsID'], List()).toJS(), elemPath[1])
                    ? elemPath[2]
                    : elemPath[1]
                  const colPath = String(elemPath[1]).split('##')
                  if(String(elemPath[1]).includes('##')){
                    elemID = _.includes(retState.getIn(['project', 'Settings', 'RepeatedStripsID'], List()).toJS(), colPath[0])
                      ? colPath[1]
                      : colPath[0]
                  }
                  const colID = _.last(elemPath)
                  let isRepeat = _.includes(retState.getIn(['project', 'Settings', 'RepeatedStripsID'], List()).toJS(), elemPath[1])
                  if (isRepeat && elemPath.length === 3 || !isRepeat && elemPath.length === 2) {
                    let columns = retState.getIn(['pages', pageID, 'Props', 'elements', elemID, 'props', 'columns'], List())
                    const processCol = col => {
                      try {
                        if (col.get('id') === colID) {
                          if (Map.isMap(col.get('isVisible'))) {
                            return col.setIn(['isVisible', layoutMode], isAllowStatus)
                          } else {
                            return col.set('isVisible', fromJS({
                              [layoutMode]: isAllowStatus
                            }))
                          }
                        } else {
                          return col.set('columns', col.get('columns', List()).map(processCol))
                        }
                      } catch (error) {
                        console.error(error)
                        return col
                      }
                    }
                    columns = columns.map(processCol)
                    retState = retState.setIn(['pages', pageID, 'Props', 'elements', elemID, 'props', 'columns'], columns)
                  } else {
                    let columns = retState.getIn(['pages', pageID, 'Props', 'elements', elemID, 'props', 'columns'], List())
                    const processCol = col => {
                      try {
                        if (col.get('id') === colID) {
                          if (Map.isMap(col.get('isVisible'))) {
                            return col.setIn(['isVisible', layoutMode], isAllowStatus)
                          } else {
                            return col.set('isVisible', fromJS({
                              [layoutMode]: isAllowStatus
                            }))
                          }
                        } else {
                          if (col.get('columns', List())?.size > 0) {
                            return col.set('columns', col.get('columns', List()).map(processCol))
                          }
                          const cols = col.getIn(['meta', 'subCtrl', 'Props', 'columns'], List())
                          if (cols?.size > 0) {
                            return col.setIn(['meta', 'subCtrl', 'Props', 'columns'], cols.map(processCol))
                          }
                        }
                      } catch (error) {
                        console.error(error)
                        return col
                      }
                      return col
                    }
                    columns = columns.map(processCol)
                    retState = retState.setIn(['pages', pageID, 'Props', 'elements', elemID, 'props', 'columns'], columns)
                  }
                })
                break;
              }
              case 'ClearFilterTable':{
                const [pageUID, prID, peID] = String(actionTarget.getIn(['0', 'elUID'])).split(':')
                const pageID = retState.getIn(['project', 'Pages'], List())
                  .find(page => page.get('uid') === pageUID)
                  ?.get?.('_id')
                const elem = retState.hasIn(['pages', retState.get('page'), 'Props', 'elements', prID])
                  ? retState.getIn(['pages', retState.get('page'), 'Props', 'elements', prID], Map())
                  : retState.getIn(['project', 'Settings', 'elements', prID], Map())

                let columns = elem.getIn(['props', 'columns'], List())

                retState = retState.setIn(['filter', pageUID, prID, 'search'], undefined)

                const processResetColumnFilter = column => {
                  if(Map.isMap(column)){
                    retState = retState.setIn(['filter', pageUID, prID, 'cols', column.get('id')], undefined)
                    if(column.get('columns', List()).size > 0){
                      column.get('columns', List()).map(processResetColumnFilter)
                    }
                  }
                }
                columns.map(processResetColumnFilter)
                break;
              }
              case 'FilterTable':{
                const appState = _.assign({}, params, portalState)

                let valueType = actionTarget.getIn(['0', 'valueType'], 'static')
                let valueField = actionTarget.getIn(['0', 'valueEl'], '')
                let valueVal = actionTarget.getIn(['0', 'valueVal'], '')

                let value = ''
                if (valueType === 'static') {
                  value = valueVal
                } else {
                  let fieldPath = String(valueField).split(':')
                  value = _.get(appState, fieldPath, '')
                }
                if(sett.getIn(['action']) === 'ClearFilterTable'){
                  value = ''
                }
                let elUID = actionTarget.getIn(['0', 'elUID'], '')
                const [pageUID, prID, peID] = String(elUID).split(':')
                const pageID = retState.getIn(['project', 'Pages'], List())
                  .find(page => page.get('uid') === pageUID)
                  ?.get?.('_id')

                if (pageID && peID && peID !== 'list_row_style') {
                  retState = retState.setIn(['filter', pageUID, prID, 'cols', peID], value)
                } else if (pageID && peID || !peID) {
                  retState = retState.setIn(['filter', pageUID, prID, 'search'], value)
                }
                break;
              }
              case 'Allow Inline Edit':
              case 'Disallow Inline Edit': {
                let expandOtp = sett.get('expandOtp', 'table')
                switch (expandOtp) {
                  case 'table': {
                    let isAllowStatus = sett.getIn(['action']) === 'Allow Inline Edit'
                    let elemListlUID = sett.getIn(['elemListlUID'], List()).toJS()
                    _.each(elemListlUID, elemPathList => {
                      let elemPath = String(elemPathList).split(':')
                      const pageID = retState.getIn(['project', 'Pages'], List())
                        .find(page => page.get('uid') === elemPath[0])
                        ?.get?.('_id')
                      let elemID = _.includes(retState.getIn(['project', 'Settings', 'RepeatedStripsID'], List()).toJS(), elemPath[1])
                        ? elemPath[2]
                        : elemPath[1]
                      let isRepeat = _.includes(retState.getIn(['project', 'Settings', 'RepeatedStripsID'], List()).toJS(), elemPath[1])
                      if (isRepeat && elemPath.length === 3 || !isRepeat && elemPath.length === 2) {
                        retState.getIn(['pages', pageID, 'Props', 'elements', elemID, 'props', 'columns'], List())
                          .map((column, columnIndex) => {
                            retState = retState.setIn(['pages', pageID, 'Props', 'elements', elemID, 'props', 'columns', columnIndex, 'meta', 'allowEdit'], isAllowStatus)
                          })
                      } else {
                        let columns = retState.getIn(['pages', pageID, 'Props', 'elements', elemID, 'props', 'columns'], List())
                        let columnIndex = columns.findIndex(col => col.get('id') === _.last(elemPath))
                        if (columnIndex !== -1) {
                          retState = retState.setIn(['pages', pageID, 'Props', 'elements', elemID, 'props', 'columns', columnIndex, 'meta', 'allowEdit'], isAllowStatus)
                        }
                      }
                    })
                    break;
                  }
                  case 'index':
                  case 'RecID':
                  case 'current': {
                    let elemListlUID = sett.getIn(['elemListlUID'], List()).toJS()
                    _.each(elemListlUID, elemPathList => {
                      let elemPath = String(elemPathList).split(':')
                      const pageID = retState.getIn(['project', 'Pages'], List())
                        .find(page => page.get('uid') === elemPath[0])
                        ?.get?.('_id')
                      let elemID = _.includes(retState.getIn(['project', 'Settings', 'RepeatedStripsID'], List()).toJS(), elemPath[1])
                        ? elemPath[2]
                        : elemPath[1]
                      const colPath = String(elemPath[1]).split('##')
                      if(String(elemPath[1]).includes('##')){
                        elemID = _.includes(retState.getIn(['project', 'Settings', 'RepeatedStripsID'], List()).toJS(), colPath[1])
                          ? colPath[2]
                          : colPath[1]
                      }
                      let useIndex = null
                      if (expandOtp === 'current') {
                        useIndex = index
                      } else if (expandOtp === 'index') {
                        let indexType = sett.getIn(['indexType'], 'static')
                        if (indexType === 'static') {
                          rowIndex = parseInt(sett.get('index', ''), 10)
                          if (Number.isNaN(rowIndex)) {
                            rowIndex = 0
                          }
                          rowIndex -= 1
                          if (rowIndex < 0) {
                            rowIndex = 0
                          }
                        } else {
                          let key = sett.get('indexEl', '')
                          let pathKey = String(key).split(':');
                          if (pathKey.length == 3 && index !== undefined && index !== null) {
                            pathKey.splice(2, 0, index);
                          }
                          rowIndex = _.get(
                            _.assign({}, params, portalState),
                            pathKey,
                            ''
                          )
                          rowIndex = parseInt(rowIndex, 10)
                          if (Number.isNaN(rowIndex)) {
                            rowIndex = 0
                          }
                          rowIndex -= 1
                          if (rowIndex < 0) {
                            rowIndex = 0
                          }
                        }
                        useIndex = rowIndex
                      } else if (expandOtp === 'RecID') {
                        let indexType = sett.getIn(['indexType'], 'static')
                        let searchValue = null
                        if (indexType === 'static') {
                          searchValue = sett.get('index', '')
                        } else {
                          let key = sett.get('indexEl', '')
                          let pathKey = String(key).split(':');
                          if (pathKey.length == 3 && index !== undefined && index !== null) {
                            pathKey.splice(2, 0, index);
                          }
                          searchValue = _.get(
                            _.assign({}, params, portalState),
                            pathKey,
                            ''
                          )
                        }
                        let rowsData = retState.getIn(['state', ..._.initial(elemPath), 'value'], List())
                        rowIndex = rowsData.findIndex(value => value === searchValue)
                        if (rowIndex === -1) {
                          rowIndex = null
                        }
                        useIndex = rowIndex
                      }
                      if (String(elemPath[1]).includes('##')) {
                        elemID = _.includes(retState.getIn(['project', 'Settings', 'RepeatedStripsID'], List()).toJS(), colPath[1])
                          ? colPath[2]
                          : colPath[1]
                        const prePath = [_.first(colPath), _.last(colPath)].join('##')
                        const colId = _.last(elemPath)
                        retState = retState.setIn(['rules', elemPath[0], prePath, 'inline', colId, `r${useIndex}`], sett.getIn(['action']) === 'Allow Inline Edit')
                      } else {
                        retState = retState.setIn(['rules', ..._.initial(elemPath), 'inline', `${_.last(elemPath)}`, `r${useIndex}`], sett.getIn(['action']) === 'Allow Inline Edit')
                      }
                    })
                    break;
                  }
                }
                break;
              }
              case 'SetBGColor':
              case 'SetColor': {
                let action = sett.getIn(['action'])
                let prefix = action === 'SetColor' ? 'color_' : action === 'SetBGColor' ? 'bg_color_' : '';

                let [pageUID, prID, peID] = String(actionTarget.getIn(['0', 'elUID'])).split(':')
                const pageID = retState.getIn(['project', 'Pages'], List())
                  .find(page => page.get('uid') === pageUID)
                  ?.get?.('_id')
                const appState = portalState
                if (pageID && peID && peID !== 'list_row_style') {
                  let tableState = retState.getIn(['state', pageUID, prID], Map())
                  let totalRows = tableState.get(peID, List()).size

                  let colorType = actionTarget.getIn(['0', 'colorType'], 'static')
                  let colorField = actionTarget.getIn(['0', 'colorEl'], '')
                  let colorVal = actionTarget.getIn(['0', 'colorVal'], '')

                  const base = ['rules', pageUID, prID]
                  const baseRules = retState.getIn(base)
                  if(List.isList(baseRules)){
                    retState = retState.setIn(base, Map())
                  }

                  const processRowByIndex = index => {
                    let rules = retState.getIn(['rules', pageUID, prID, peID, `${index}`], List())
                    if (!List.isList(rules)) {
                      rules = List()
                    }
                    rules = rules.filter(rule => !_.startsWith(rule, prefix))
                    let color = ''
                    if (colorType === 'static') {
                      color = colorVal
                    } else {
                      let fieldPath = String(colorField).split(':')
                      if (fieldPath[1] === prID) {
                        color = tableState.getIn([fieldPath[2], index], '')
                      } else {
                        color = _.get(
                          appState,
                          fieldPath,
                          _.get(params, fieldPath, '')
                        )
                      }
                    }
                    rules = rules.push(`${prefix}${color}`)
                    retState = retState.setIn(['rules', pageUID, prID, peID, `${index}`], rules)
                  }

                  if (index !== null) {
                    processRowByIndex(index)
                  } else if (rowIndex !== null && rowIndex !== undefined) {
                    processRowByIndex(rowIndex)
                  } else {
                    _.times(
                      totalRows,
                      processRowByIndex
                    )
                  }
                } else if (String(prID).includes('##') && (pageID && peID || !peID)) {
                  const [__, ...colIDList] = String(prID).split('##')
                  const prIDList = String(prID).split('##')
                  prID = [_.first(prIDList), _.last(prIDList)].join('##')
                  let [elemID, peID] = String(prID).split('##')
                  const columns = retState.getIn(['pages', state.get('page'), 'Props', 'elements', elemID, 'props', 'columns'], List())
                  let tableState = retState.getIn(['state', pageUID, prID], Map())
                  let totalRows = tableState.get(peID, List()).size
                  let colorType = actionTarget.getIn(['0', 'colorType'], 'static')
                  let colorField = actionTarget.getIn(['0', 'colorEl'], '')
                  let colorVal = actionTarget.getIn(['0', 'colorVal'], '')
                  const base = ['rules', pageUID, prID]
                  const baseRules = retState.getIn(base)
                  if(List.isList(baseRules)){
                    retState = retState.setIn(base, Map())
                  }
                  const applyColumnRule = column => {
                    const processRowByIndex = index => {
                      let peID = column.get('id')
                      let rules = retState.getIn(['rules', pageUID, prID, peID, `${index}`], List())
                      if (!List.isList(rules)) {
                        rules = List()
                      }
                      rules = rules.filter(rule => !_.startsWith(rule, prefix))
                      let color = ''
                      if (colorType === 'static') {
                        color = colorVal
                      } else {
                        let fieldPath = String(colorField).split(':')
                        if (fieldPath[1] === prID) {
                          color = tableState.getIn([fieldPath[2], index], '')
                        } else {
                          color = _.get(appState, fieldPath, '')
                        }
                      }
                      rules = rules.push(`${prefix}${color}`)
                      retState = retState.setIn(['rules', pageUID, prID, peID, `${index}`], rules)
                    }
                    if (index !== null) {
                      processRowByIndex(index)
                    } else if (rowIndex !== null && rowIndex !== undefined) {
                      processRowByIndex(rowIndex)
                    } else {
                      _.times(
                        totalRows,
                        processRowByIndex
                      )
                    }
                  }
                  let subColumns = List()
                  const findColumns = col => {
                    if (col.get('id') === _.last(colIDList) && col.getIn(['meta', 'subCtrl', 'enable'])) {
                      subColumns = col.getIn(['meta', 'subCtrl', 'Props', 'columns'], List())
                    }
                    col.getIn(['meta', 'subCtrl', 'Props', 'columns'], List()).map(findColumns)
                  }
                  columns.map(findColumns)
                  subColumns.map(applyColumnRule)
                } else if (pageID && peID || !peID) {
                  const columns = retState.getIn(['pages', state.get('page'), 'Props', 'elements', prID, 'props', 'columns'], List())
                  let tableState = retState.getIn(['state', pageUID, prID], Map())
                  let peID = columns.getIn([0, 'id'])
                  let totalRows = tableState.get(peID, List()).size
                  let colorType = actionTarget.getIn(['0', 'colorType'], 'static')
                  let colorField = actionTarget.getIn(['0', 'colorEl'], '')
                  let colorVal = actionTarget.getIn(['0', 'colorVal'], '')
                  const base = ['rules', pageUID, prID]
                  const baseRules = retState.getIn(base)
                  if(List.isList(baseRules)){
                    retState = retState.setIn(base, Map())
                  }
                  const applyColumnRule = column => {
                    const processRowByIndex = index => {
                      let peID = column.get('id')
                      let rules = retState.getIn(['rules', pageUID, prID, peID, `${index}`], List())
                      if (!List.isList(rules)) {
                        rules = List()
                      }
                      rules = rules.filter(rule => !_.startsWith(rule, prefix))
                      let color = ''
                      if (colorType === 'static') {
                        color = colorVal
                      } else {
                        let fieldPath = String(colorField).split(':')
                        if (fieldPath[1] === prID) {
                          color = tableState.getIn([fieldPath[2], index], '')
                        } else {
                          color = _.get(appState, fieldPath, '')
                        }
                      }
                      rules = rules.push(`${prefix}${color}`)
                      retState = retState.setIn(['rules', pageUID, prID, peID, `${index}`], rules)
                    }
                    if (index !== null) {
                      processRowByIndex(index)
                    } else if (rowIndex !== null && rowIndex !== undefined) {
                      processRowByIndex(rowIndex)
                    } else {
                      _.times(
                        totalRows,
                        processRowByIndex
                      )
                    }
                  }
                  columns.map(applyColumnRule)
                }
                break;
              }
              case 'ShowRow':
              case 'HideRow': {
                let action = sett.getIn(['action'])
                let isHide = action === 'HideRow'
                const elUID = sett.get('elUID', '')
                let [pageUID, elemID, ...rest] = String(elUID).split(':')
                if(String(elemID).includes('##')){
                  const elemPath = String(elemID).split('##')
                  elemID = elemPath[0]
                }
                const pageID = retState.getIn(['project', 'Pages'], List())
                  .find(page => page.get('uid') === pageUID)
                  ?.get?.('_id')
                const appState = _.assign({}, params, portalState)
                const element = retState.getIn(['pages', pageID, 'Props', 'elements', elemID], Map())
                if (element.get('type') !== 'PowerTable') {
                  break;
                }
                const indexType = sett.getIn(['indexType'])
                let applyIndex = null
                switch (indexType) {
                  case 'field':
                    const el = sett.get('indexEl', '')
                    const elPath = String(el).split(':')
                    let value = ''
                    if (elPath[1] === elemID) {
                      value = _.get(appState, [...elPath, rowIndex], '')
                    } else {
                      let isRepeat = _.includes(retState.getIn(['project', 'Settings', 'RepeatedStripsID'], List()).toJS(), elPath[1])
                      if (isRepeat) {
                        value = _.get(appState, [...elPath, index], '')
                      } else {
                        value = _.get(appState, elPath, '')
                      }
                    }
                    applyIndex = parseInt(value, 10)
                    if (Number.isNaN(applyIndex)) {
                      applyIndex = null
                    }
                    applyIndex -= 1
                    break;
                  case 'static':
                    applyIndex = parseInt(sett.get('indexVal', ''), 10)
                    if (Number.isNaN(applyIndex)) {
                      applyIndex = null
                    }
                    applyIndex -= 1
                    break;
                  case 'current':
                    if (rowIndex !== null && rowIndex !== undefined) {
                      applyIndex = rowIndex
                    } else if (index !== null && index !== undefined) {
                      applyIndex = index
                    }
                    break;
                }
                if(applyIndex !== null && applyIndex < 0){
                  applyIndex = 0
                }
                let ptPath = elemID
                if (String(elUID).includes('##')) {
                  const [__, elemID] = String(elUID).split(':')
                  const elemPath = String(elemID).split('##')
                  ptPath = [_.first(elemPath), _.last(elemPath)].join('##')
                }
                if (indexType === 'table') {
                  let tableState = _.get(appState, [pageUID, elemID], {})
                  let total = getMappingCount(tableState)
                  _.times(total, n => {
                    retState = retState.setIn(['rules', pageUID, ptPath, 'ptRow', String(n), 'hide'], isHide)
                  })
                } else {
                  retState = retState.setIn(['rules', pageUID, ptPath, 'ptRow', String(applyIndex), 'hide'], isHide)
                }
                break;
              }
              case 'Allow Bulk update': {
                const [pageUID, prID, peID] = String(actionTarget.getIn(['0', 'elUID'])).split(':')
                const pageID = retState.getIn(['project', 'Pages'], List())
                  .find(page => page.get('uid') === pageUID)
                  ?.get?.('_id')
                if (pageID) {
                  let path = []
                  if (retState.hasIn([...getElementDataRoot(pageID), 'elements', prID])) {
                    path = [...getElementDataRoot(pageID), 'elements', prID]
                  } else if (retState.hasIn([...getElementDataRoot(pageID), 'elements', peID])) {
                    path = [...getElementDataRoot(pageID), 'elements', peID]
                  }
                  if (path.length > 0) {
                    retState = retState.setIn([...path, 'props', 'allowBulkUpdate'], true)
                  }
                }
                // setTimeout(function(){
                //   window.print();
                // }, 300);
                break;
              }
              case 'Disallow Bulk': {
                const [pageUID, prID, peID] = String(actionTarget.getIn(['0', 'elUID'])).split(':')
                const pageID = retState.getIn(['project', 'Pages'], List())
                  .find(page => page.get('uid') === pageUID)
                  ?.get?.('_id')
                if (pageID) {
                  let path = []
                  if (retState.hasIn([...getElementDataRoot(pageID), 'elements', prID])) {
                    path = [...getElementDataRoot(pageID), 'elements', prID]
                  } else if (retState.hasIn([...getElementDataRoot(pageID), 'elements', peID])) {
                    path = [...getElementDataRoot(pageID), 'elements', peID]
                  }
                  if (path.length > 0) {
                    retState = retState.setIn([...path, 'props', 'allowBulkUpdate'], false)
                  }
                }
                // setTimeout(function(){
                //   window.print();
                // }, 300);
                break;
              }
              case 'Select Row':
              case 'Clear Row Selection': {
                let action = sett.getIn(['action'])
                let isSetSelection = action === 'Select Row'
                const selectionPath = [...String(actionTarget.getIn(['0', 'elUID'])).split(':'), 'selected']
                const selectedItemsPath = String(String(actionTarget.getIn(['0', 'elUID'])) + '-selectedItems').split(':')
                const selectedItemsCountPath = String(String(actionTarget.getIn(['0', 'elUID'])) + '-selectedCount').split(':')
                let selected = retState.getIn(['state', ...selectionPath], List()).toJS()
                let selectedItems = String(retState.getIn(['state', ...selectedItemsPath], '')).split(',')
                let values = toJS(retState.getIn(['state', ...String(actionTarget.getIn(['0', 'elUID'])).split(':'), 'value'], List()))
                if (!_.isArray(values)) {
                  values = _.compact([values])
                }
                const [pageUID, elemPath] = String(actionTarget.getIn(['0', 'elUID'])).split(':')
                let elemID = elemPath
                let colID = null
                if (String(elemPath).includes('##')) {
                  elemID = _.first(String(elemPath).split('##'))
                  colID = _.last(String(elemPath).split('##'))
                }
                const isProject = retState.hasIn(['project', 'Settings', 'elements', elemID, 'type'])
                const elem = retState.getIn([...getElementDataRoot(isProject ? 'project' : retState.get('page')), 'elements', elemID], Map())
                let isSingleSelect = false
                if (String(elemPath).includes('##')) {
                  const processCol = col => {
                    if (col.get('id') === colID && col.getIn(['meta', 'subCtrl', 'Type']) === 'PowerTable') {
                      isSingleSelect = col.getIn(['meta', 'subCtrl', 'Props', 'allowSelection']) && col.getIn(['meta', 'subCtrl', 'Props', 'forceSingleSelection'])
                    }
                    col.getIn(['meta', 'subCtrl', 'Props', 'columns'], List()).map(processCol)
                  }
                  elem.getIn(['props', 'columns'], List()).map(processCol)
                } else {
                  isSingleSelect = elem.getIn(['props', 'allowSelection']) && elem.getIn(['props', 'forceSingleSelection'])
                }
                let isOldSelection = -1;
                if (isSingleSelect) {
                  selected = _.map(selected, (val, index) => {
                    if(val) {
                      isOldSelection = index;
                    }
                    return false;
                  })
                }
                selected[index] = isSetSelection
                selected = _.map(selected, val => val === undefined ? false : val)
                selectedItems = []
                if (isSetSelection) {
                  if (isSingleSelect) {
                    selectedItems = _.compact(_.uniq([values[index]]))
                  } else {
                    selectedItems = _.compact(_.uniq([...selectedItems, values[index]]))
                  }
                } else {
                  selectedItems = _.filter(selectedItems, v => v !== values[index])
                }
                if (_.compact(_.values(selected)).length !== selectedItems.length) {
                  let items = []
                  _.each(
                    selected,
                    (val, index) => {
                      if (val) {
                        items.push(values[index])
                      }
                    }
                  )
                  selectedItems = items
                }
                retState = retState
                  .setIn(['state', ...selectedItemsPath], selectedItems.join(','))
                  .setIn(['state', ...selectionPath], fromJS(selected))
                  .setIn(['state', ...selectedItemsCountPath], _.compact(_.values(selected)).length)

                const changes = [
                  selectedItemsPath,
                  selectionPath,
                  selectedItemsCountPath
                ]

                retState = doProcessRules(retState, false, null, [], compactArrayPath(changes), false, isOnload, index)
                if(typeof index === 'number' && isOldSelection > -1) {
                  retState = doProcessRules(retState, false, null, [], compactArrayPath(changes), false, isOnload, isOldSelection)
                }
                break;
              }
              case 'Select All': {
                const path = String(String(actionTarget.getIn(['0', 'elUID'])) + '-selectedItems').split(':')
                let pathSelected = String(actionTarget.getIn(['0', 'elUID'])).split(':');
                let values = retState.getIn(['state', ...String(actionTarget.getIn(['0', 'elUID'])).split(':'), 'value'], List()).toJS()
                retState = retState.setIn(['state', ...path], values.join(','))
                retState = retState.setIn(['state', ...pathSelected, 'selected'], _.times(_.size(values), ()=>true))
                // console.log('>>>', String(actionTarget.getIn(['0', 'elUID'])), path, values.join(','))
                // const path2 = String(String(actionTarget.getIn(['0', 'elUID'])) + '-selectedRows').split(':')
                // retState = retState.setIn(['state', ...path2], '')
                break;
              }
              case 'Reset table': {
                const elUID = String(actionTarget.getIn(['0', 'elUID']))
                const paths = [
                  { suffix: '-selectedItems', value: '' },
                  { suffix: '-selectedRows', value: '' },
                  { suffix: '-selectedCount', value: 0 }
                ]
                paths.forEach(({ suffix, value }) => {
                  const path = (elUID + suffix).split(':');
                  retState = retState.setIn(['state', ...path], value);
                })

                const selectionPath = [...elUID.split(':'), 'selected'];
                retState = retState.setIn(['state', ...selectionPath], fromJS([]));

                break;
              }
              case 'Refresh table': {
                const path = String(actionTarget.getIn(['0', 'elUID'])).split(':')
                const elemID = _.last(path)
                let key = retState.getIn(['project', 'Settings', 'sfMapping'], Map())
                  .findKey(config => config.get('elemUID') === elemID)
                console.log('Refresh table >>>', path, key)
                if (key) {
                  retState = retState
                    .setIn(['sfActions', 'needCall'], true)
                    .setIn(['sfActions', 'params'], retState.getIn(['sfActions', 'params'], List())
                      .push(fromJS({
                        "items": [
                          {
                            "label": '',
                            "value": key,
                            "order": ""
                          }
                        ],
                        "elemUID": elemID,
                        processUID,
                        processIndex,
                        path,
                        index,
                        ruleUID: currentSingleRule.get('uid'),
                        "isParallelLoad": false,
                        "isVerifyCaptcha": false,
                        "customOrder": false,
                        "runInBackground": false,
                        "options": {}
                      })));
                }
                break;
              }
            }
          }
        } else if (key === 'sfAction' && !isNotNeedProcessSF) {
          if (actionTarget.getIn([0, 'items'], List()).size) {
            let items = actionTarget.getIn([0, 'items'], List()).toJS();

            let mappingList = retState.getIn(['project', 'Settings', 'sfMapping'], Map()).toJS();
            let pushMappingList = retState.getIn(['project', 'Settings', 'pushToSalesforce'], List());
            pushMappingList.map(row => {
              if (row && isImmutable(row)) {
                mappingList[row.get('uid')] = row.toJS();
              }
            })
            pushMappingList = pushMappingList.toJS();
            items = _.filter(items, function (row) {
              if (row && row.value && mappingList[row.value]) {
                if (mappingList[row.value].type != "custom" && !row.isPush) {
                  return false;
                }
                if (!isOnload || mappingList[row.value].runAlways) {
                  return true;
                }

                if (retState.getIn(['historySF', row.value])) {
                  return false;
                } else {
                  if (!isOnload && !mappingList[row.value].runAlways) {
                    retState = retState.setIn(['historySF', row.value], true);
                  }
                  return true;
                }
              }
            })
            let hashRules = {};
            let firstErrorField = null, firstErrorFieldIndex = index;
            _.each(items, function (row) {
              if (row && row.value && mappingList[row.value] && mappingList[row.value].fields) {
                _.each(mappingList[row.value].fields, function (field) {
                  let fieldUID;
                  if (field && typeof field == 'object') {
                    fieldUID = field.value;
                  } else {
                    fieldUID = String(field).split('##')[1];
                  }

                  if (fieldUID && String(fieldUID).indexOf('ft_search') === -1) {
                    fieldUID = String(fieldUID).split(':');
                    let pageUID = fieldUID[0];
                    let elemUID = fieldUID[1];
                    let repeatRoot = retState.getIn(['project', 'Settings', 'RepeatedStripsID'], List()).toJS()
                    if ((index !== undefined && index !== null) || (repeatRoot.indexOf(fieldUID[1]) > -1)) {
                      elemUID = fieldUID[2];
                    }
                    let page = retState.getIn(['project', 'Pages'], List()).find(page => page.get('uid') === pageUID);
                    if (page) {
                      let component = retState.getIn(['pages', page.get('_id'), 'Props', 'elements', elemUID], Map())
                      const parentStatus = getParentRulesStatus(
                        component.get('parent'),
                        page.get('_id'),
                        pageUID,
                        index,
                        elemUID,
                        fieldUID[1],
                        retState
                      )
                      let localPath = ['formFieldStatuses', pageUID, elemUID];
                      let rulesPath = ['rules', pageUID, elemUID];
                      if (repeatRoot.indexOf(fieldUID[1]) > -1 && (index === undefined || index === null)) {
                        let maxItems = 0;
                        let repData = retState.getIn(['state', pageUID, fieldUID[1]], Map());
                        if (repData && isImmutable(repData)) {
                          repData = repData.toJS()
                          maxItems = getMappingCount(repData)
                        }
                        _.times(maxItems, function (localIndex) {
                          let localPath2 = ['formFieldStatuses', pageUID, fieldUID[1], fieldUID[2], String(localIndex)];
                          let rulesPath = ['rules', pageUID, fieldUID[1], fieldUID[2], localIndex]
                          let dataPath = [fieldUID[2]];
                          if (fieldUID.length == 4 && component.getIn(['props', 'control']) !== 'signature') {
                            dataPath.push(fieldUID[3]);
                          }
                          dataPath.push(localIndex);
                          const rulesStatus = retState.getIn(rulesPath, List())
                          let rules = List.isList(rulesStatus) ? rulesStatus.toJS() : []
                          let value;
                          if (component.get('type') === 'FormField' && component.getIn(['props', 'control']) === 'daterange') {
                            value = _.get(repData, [fieldUID[2], localIndex, 'endDate']);
                          } else if (component.get('type') === 'FormField' && component.getIn(['props', 'control']) === 'radio') {
                            value = _.get(repData, [fieldUID[2], localIndex, fieldUID[3]]);
                          } else if (component.get('type') === 'FormField' && component.getIn(['props', 'control']) === 'lookup') {
                            value = _.get(repData, [fieldUID[2], localIndex]);
                          } else {
                            value = _.get(repData, dataPath)
                          }
                          let ruleStatus = processValueRules(fieldUID[2], component, undefined, localIndex, value, rulesPath, 'sfValidation', retState.getIn(localPath2))(null, () => retState);
                          //@note error for visible elements
                          if (ruleStatus.status && rules.indexOf('hide') === -1 && parentStatus.indexOf('hide') === -1) {
                            if (!firstErrorField) {
                              firstErrorField = field
                              firstErrorFieldIndex = localIndex;
                            }
                            if (!currentRule.get('isNotSetValueRule')) {
                              retState = retState.setIn(localPath2, fromJS(ruleStatus.ruleStatus))
                            }
                            hashRules[elemUID] = ruleStatus.error;
                          }
                        })

                      } else {
                        const rulesStatus = retState.getIn(rulesPath, List())
                        let rules = List.isList(rulesStatus) ? rulesStatus.toJS() : []
                        let ruleStatus;
                        let value = undefined;
                        let localIndex = undefined;
                        let localPath2 = [...localPath];
                        if (index !== undefined && index !== null) {
                          localIndex = index;
                          rulesPath = ['rules', pageUID, fieldUID[1], fieldUID[2], index]
                          let dataPath = [fieldUID[2]];
                          if (fieldUID.length == 4 && component.getIn(['props', 'control']) !== 'signature') {
                            dataPath.push(fieldUID[3]);
                          }
                          dataPath.push(index);
                          let repData = retState.getIn(['state', pageUID, fieldUID[1]], Map())
                          if (repData && isImmutable(repData)) {
                            repData = repData.toJS();
                          } else {
                            repData = {};
                          }
                          if (component.get('type') === 'FormField' && component.getIn(['props', 'control']) === 'daterange') {
                            value = _.get(repData, [fieldUID[2], localIndex, 'endDate']);
                          } else if (component.get('type') === 'FormField' && component.getIn(['props', 'control']) === 'radio') {
                            value = _.get(repData, [fieldUID[2], localIndex, fieldUID[3]]);
                          } else if (component.get('type') === 'FormField' && component.getIn(['props', 'control']) === 'lookup') {
                            value = _.get(repData, [fieldUID[2], localIndex]);
                          } else {
                            value = _.get(repData, dataPath);
                          }
                          localPath2 = ['formFieldStatuses', pageUID, fieldUID[1], fieldUID[2], String(localIndex)];
                        }
                        ruleStatus = processValueRules(elemUID, component, undefined, localIndex, value, rulesPath, 'sfValidation', retState.getIn(localPath2))(null, () => retState);
                        //@note error for visible elements
                        if (ruleStatus.status && rules.indexOf('hide') === -1 && parentStatus.indexOf('hide') === -1) {
                          if (!firstErrorField) {
                            firstErrorField = field
                          }
                          if (!currentRule.get('isNotSetValueRule')) {
                            retState = retState.setIn(localPath2, fromJS(ruleStatus.ruleStatus))
                          }
                          hashRules[elemUID] = ruleStatus.error;
                        }
                      }
                    }
                  }

                });
              }
            });
            if (firstErrorField) {
              retState = retState.setIn(
                ['__cache__'],
                retState.getIn(['__cache__'], List())
                  .push(fromJS({
                    type: 'FocusErrorField',
                    payload: {
                      field: firstErrorField,
                      index: firstErrorFieldIndex
                    }
                  }))
              )
            }
            if (retState.get('IS_ALLOW_DEBUG_MODE') && retState.getIn(['project', 'Settings', 'debugModeSettings', 'skipValidations'])) {
              hashRules = {};
            }
            if (Object.keys(hashRules).length) {
              retState = retState
                .setIn(['widgets', 'isShowSFMessage'], true)
                .setIn(['widgets', 'sfMessages'], fromJS(hashRules))
                .setIn(['widgets', 'clientY', 'sfMessages'], currentRule.getIn(['options', 'clientY'], window.ftLastClientY))
            } else if (items.length) {
              if (index === undefined || index === null) {
                retState = setVisibilityOfSFMappingElem(mappingList, items, true, null, retState)
              }else{
                try {
                  _.map(items,(elem)=>{
                    const val = elem.value
                    if(val && mappingList[val] && mappingList[val].elemUID){
                      const isSubComp = String(mappingList[val].elemUID).includes('##')
                      if(isSubComp){
                        const [parendId] = mappingList[val].elemUID.split('##')
                        retState = retState.setIn(['isLoadingElements', `${parendId}-subComp`],true)

                      }
                    }
                  })
                } catch(err) {
                  console.error(err);
                }
              }

              retState = processActionsSFItem(mappingList, items, false, 'duringIntegration', null, retState);
              retState = processActionsSFItem(pushMappingList, items, false, 'duringIntegration', null, retState);
              let ruleUID;
              if (currentSingleRule) {
                ruleUID = currentSingleRule.get('uid');
              }

              const payload = {
                ruleUID: ruleUID,
                processUID,
                processIndex,
                elemUID: currentRule.get('uid'),
                items: items,
                ignoreValidations: actionTarget.getIn([0, 'ignoreValidations'], false),
                runInBackground: actionTarget.getIn([0, 'runInBackground'], false),
                isVerifyCaptcha: actionTarget.getIn([0, 'isVerifyCaptcha'], false),
                customOrder: actionTarget.getIn([0, 'customOrder'], false),
                isParallelLoad: actionTarget.getIn([0, 'isParallelLoad'], false),
                path,
                index,
                options: currentRule.get('options', Map())
              };
              if (index !== null && typeof index !== 'undefined') {
                payload.path = false;
                payload.widgetPath = [index];
              }
              retState = retState
                .setIn(['sfActions', 'needCall'], true)
                .setIn(['sfActions', 'params'], retState.getIn(['sfActions', 'params'], List())
                  .push(fromJS(payload)));
            }
          }
        } else if (key === 'surveySubmit' && !isOnlyEffects) {
          retState = retState.setIn(
            ['__cache__'],
            retState.getIn(['__cache__'], List())
              .push(fromJS({
                type: 'surveySubmit',
                payload: {
                  uid: uuid(),
                  options: currentRule.get('options', Map()).toJS()
                }
              }))
          )
        } else if (key === 'pwaClearSfCache' || key === 'pwaUpdateSfCache' && !isOnlyEffects) {
          retState = retState.setIn(
            ['__cache__'],
            retState.getIn(['__cache__'], List())
              .push(fromJS({
                type: key,
                payload: {
                  uid: uuid(),
                  options: currentRule.get('options', Map()).toJS()
                }
              }))
          )
        } else if (key === 'ReadBarcode' && !isOnlyEffects) {
          retState = retState.setIn(
            ['__cache__'],
            retState.getIn(['__cache__'], List())
              .push(fromJS({
                type: 'ReadBarcode',
                payload: Object.assign({options: currentRule.get('options', Map()).toJS()},
                  actionTarget.get('0', Map()).toJS()
                )
              }))
          )
        } else if (key === 'ChatBotNextMessage' && !isOnlyEffects) {
          retState = retState.setIn(
            ['__cache__'],
            retState.getIn(['__cache__'], List())
              .push(fromJS({
                type: 'ChatBotNextMessage',
                payload: {
                  uid: uuid(),
                  id: actionTarget.getIn(['0', 'id'])
                }
              }))
          )
        } else if (key === 'sfLWC' && !isOnlyEffects && actionTarget.getIn(['0', 'enabled'])) {
          const payload = actionTarget.getIn(['0'], Map());
          let recordID = getValueByField(payload.get('recordID', Map()), params, portalState, index)
          let url = '';
          if (payload.getIn(['redirect', 'type']) == 'field') {
            url = getValueByField(payload.get('redirect', Map()), params, portalState, index)
          } else {
            url = payload.get('customURL')
          }
          if (url && recordID) {
            retState = retState.setIn(
              ['__cache__'],
              retState.getIn(['__cache__'], List())
                .push(fromJS({
                  type: 'SfLWCRedirect',
                  payload: {
                    recordID,
                    url
                  }
                }))
            )
          }
        } else if (key === 'QCounterInteractivity' && !isOnlyEffects) {
          let action = actionTarget.getIn(['0'], Map())
          const target = action.getIn(['elem'])
          const [pageUID, ...rest] = String(target).split(':')
          const pageID = state.getIn(['project', 'Pages'], List())
            .find(page => page.get('uid') === pageUID)
            ?.get?.('_id')
          const formID = _.last(rest)
          const isPossibleRepeat = detectIsTargetKeyInRepeatEl(target, retState)
          if (retState.getIn(['pages', pageID, 'Props', 'elements', formID, 'type']) === 'TextCounter') {
            let setStatus = ''
            let removeStatus = ''
            switch (action.getIn(['action'])) {
              case 'ShowTrash': {
                setStatus = 'ShowTrash'
                removeStatus = 'HideTrash'
                break;
              }
              case 'HideTrash': {
                setStatus = 'HideTrash'
                removeStatus = 'ShowTrash'
                break;
              }
              case 'EnableTrash': {
                setStatus = 'EnableTrash'
                removeStatus = 'DisableTrash'
                break;
              }
              case 'DisableTrash': {
                setStatus = 'DisableTrash'
                removeStatus = 'EnableTrash'
                break;
              }
            }
            let rules = retState.getIn(['rules', pageUID, ..._.initial(rest), `${_.last(rest)}-trash`, ...isPossibleRepeat && index !== null && index !== undefined ? [index] : []], List())
            if (!List.isList(rules)) {
              rules = List()
            }
            rules = rules
              .push(setStatus)
              .filter(val => val !== removeStatus)
            retState = retState.setIn(['rules', pageUID, ..._.initial(rest), `${_.last(rest)}-trash`, ...isPossibleRepeat && index !== null && index !== undefined ? [index] : []], rules)
          }
        } else if (key === 'schedulerInteractivity' && !isOnlyEffects && actionTarget.getIn(['0', 'enabled'])) {
          let action = actionTarget.getIn(['0'], Map())
          let day = action.getIn(['day'])
          const dayFrom = action.getIn(['dayFrom'], 'static')
          const dayEl = action.getIn(['dayEl'], '')
          if (dayFrom === 'static') {
          } else if (dayFrom === 'field') {
            const isPossibleRepeat = detectIsTargetKeyInRepeatEl(dayEl, retState)
            const appState = _.assign({}, params, portalState)
            day = _.get(
              appState,
              [
                ...String(dayEl).split(':'),
                ...isPossibleRepeat && typeof index === 'number' ? [index] : []
              ],
              null
            )
          }
          switch (action.getIn(['action'])) {
            case 'Reset': {
              const target = action.getIn(['form'])
              const [pageUID, ...rest] = String(target).split(':')
              const pageID = state.getIn(['project', 'Pages'], List())
                .find(page => page.get('uid') === pageUID)
                ?.get?.('_id')
              const formID = _.last(rest)
              if (retState.getIn(['pages', pageID, 'Props', 'elements', formID, 'props', 'data', 'Type']) === 'Scheduler') {
                let elem = retState.getIn(['pages', pageID, 'Props', 'elements', formID], Map())
                _.each(LAYOUT_MODE, mode => {
                  elem = elem
                    .setIn(['props', mode, 'isLimitDay'], false)
                    .setIn(['props', mode, 'isLimitFromDay'], false)
                    .setIn(['props', mode, 'isLimitToDay'], false)
                    .setIn(['props', mode, 'limitDay'], null)
                    .setIn(['props', mode, 'limitFromDay'], null)
                    .setIn(['props', mode, 'limitToDay'], null)
                })
                retState = retState.setIn(['pages', pageID, 'Props', 'elements', formID], elem)
              }
              break;
            }
            case 'Limit Day': {
              const target = action.getIn(['form'])
              const [pageUID, ...rest] = String(target).split(':')
              const pageID = state.getIn(['project', 'Pages'], List())
                .find(page => page.get('uid') === pageUID)
                ?.get?.('_id')
              const formID = _.last(rest)
              if (retState.getIn(['pages', pageID, 'Props', 'elements', formID, 'props', 'data', 'Type']) === 'Scheduler') {
                let elem = retState.getIn(['pages', pageID, 'Props', 'elements', formID], Map())
                _.each(LAYOUT_MODE, mode => {
                  elem = elem
                    .setIn(['props', mode, 'isLimitDay'], true)
                    .setIn(['props', mode, 'limitDay'], day)
                })
                retState = retState.setIn(['pages', pageID, 'Props', 'elements', formID], elem)
              }
              break;
            }
            case 'Limit From Day': {
              const target = action.getIn(['form'])
              const [pageUID, ...rest] = String(target).split(':')
              const pageID = state.getIn(['project', 'Pages'], List())
                .find(page => page.get('uid') === pageUID)
                ?.get?.('_id')
              const formID = _.last(rest)
              if (retState.getIn(['pages', pageID, 'Props', 'elements', formID, 'props', 'data', 'Type']) === 'Scheduler') {
                let elem = retState.getIn(['pages', pageID, 'Props', 'elements', formID], Map())
                _.each(LAYOUT_MODE, mode => {
                  elem = elem
                    .setIn(['props', mode, 'isLimitFromDay'], true)
                    .setIn(['props', mode, 'limitFromDay'], day)
                })
                retState = retState.setIn(['pages', pageID, 'Props', 'elements', formID], elem)
              }
              break;
            }
            case 'Limit To Day': {
              const target = action.getIn(['form'])
              const [pageUID, ...rest] = String(target).split(':')
              const pageID = state.getIn(['project', 'Pages'], List())
                .find(page => page.get('uid') === pageUID)
                ?.get?.('_id')
              const formID = _.last(rest)
              if (retState.getIn(['pages', pageID, 'Props', 'elements', formID, 'props', 'data', 'Type']) === 'Scheduler') {
                let elem = retState.getIn(['pages', pageID, 'Props', 'elements', formID], Map())
                _.each(LAYOUT_MODE, mode => {
                  elem = elem
                    .setIn(['props', mode, 'isLimitToDay'], true)
                    .setIn(['props', mode, 'limitToDay'], day)
                })
                retState = retState.setIn(['pages', pageID, 'Props', 'elements', formID], elem)
              }
              break;
            }
          }
        } else if (key === 'VarInteractivity' && !isOnlyEffects && actionTarget.getIn(['0', 'enabled'])) {
          let action = actionTarget.getIn(['0'], Map())
          const paramsHash = {}
          retState.getIn(['project', 'params'], List()).map(v => {
            paramsHash[v.get('id')] = v.get('systemValue')
          })
          retState.getIn(['pages', retState.get('page'), 'Props', 'params'], List()).map(v => {
            paramsHash[v.get('id')] = v.get('systemValue')
          })
          let projectVarID = retState.getIn(['project', 'params'], List())
            .filter(param => !param.get('isEnvVariable'))
            .map(v => v.get('id')).toJS()
          const pageUID = retState.getIn(['project', 'Pages'], List())
            .find(page => page.get('_id') === retState.get('page'))
            ?.get?.('uid')
          let changes = retState.getIn(['ft', 'changes'], List()).toJS()
          switch (action.get('action')) {
            case 'refresh': {
              action.get('variables', List()).map(param => {
                let id = param.get('value')
                let value = getSystemVariable(paramsHash[id], retState)
                if (projectVarID.includes(id)) {
                  retState = retState.setIn(['params', id], value)
                  changes.push([id])
                } else {
                  retState = retState.setIn(['state', pageUID, id], value)
                  changes.push([pageUID, id])
                }
              })
              break;
            }
            case 'clear': {
              action.get('variables', List()).map(param => {
                let id = param.get('value')
                if (projectVarID.includes(id)) {
                  retState = retState.setIn(['params', id], '')
                  changes.push([id])
                } else {
                  retState = retState.setIn(['state', pageUID, id], '')
                  changes.push([pageUID, id])
                }
              })
              break;
            }
            case 'set_value': {
              action.get('affected', Map()).map(
                (val, id) => {
                  try {
                    let type = val.get('type', '')
                    if (type === '') {
                      if (projectVarID.includes(id)) {
                        retState = retState.setIn(['params', id], val.get('static', ''))
                        changes.push([id])
                      } else {
                        retState = retState.setIn(['state', pageUID, id], val.get('static', ''))
                        changes.push([pageUID, id])
                      }
                    } else {
                      let isList = false
                      let type = val.getIn(['el', 'type'])
                      if (type == 'SurveyList') {
                        isList = true
                      } else if (type === 'FormField') {
                        let elUID = isBtnRepeat && index !== null && typeof index !== 'undefined' && isPossibleRepeat ?
                          keyPath[2] : keyPath[1]
                        const elem = retState.getIn([...getElementDataRoot(['Header', 'Footer'].includes(keyPath[0]) ? 'project' : retState.get('page')), 'elements', elUID], Map())
                        if (elem.getIn(['props', 'control'])) {
                          type = elem.getIn(['props', 'control'])
                        }
                        if (LIST_BASED_FIELDS.includes(type) || type === 'checkbox' && elem.getIn(['props', 'source'], 'single') !== 'single') {
                          isList = true
                        }
                      }
                      let value = '';
                      let repeatRoot = retState.getIn(['project', 'Settings', 'RepeatedStripsID'], List()).toJS()
                      let isTableMode = false;
                      if (val.getIn(['el', 'subType']) == 'fileupload') {
                        try {
                          let path = String(updateOldValue(val.getIn(['el', 'value'], ''))).replace(/:/g, '.').split('.');
                          path[path.length - 1] = val.getIn(['el', 'uid'], '');
                          path.push('ft_fileupload')
                          if (index !== undefined && index !== null) {
                            path = [
                              ...path,
                              index
                            ]
                          }
                          value = _.get(portalState, path, '');
                        } catch (err) {

                        }
                      } else if (_.endsWith(String(val.getIn(['el', 'value'])), ':ftStripRow')) {
                        if (typeof index == 'number') {
                          value = index + 1;
                        } else {
                          value = index;
                        }
                      } else if (_.endsWith(String(val.getIn(['el', 'value'])), '-totalRows') && repeatRoot.indexOf(val.getIn(['el', 'uid'])) > -1) {
                        let stripPageUID = String(val.getIn(['el', 'value'])).split(':')[0];
                        const stripState = retState.getIn(['state', stripPageUID, val.getIn(['el', 'uid'])], Map());
                        value = getMappingCount(stripState.toJS());
                      } else if (val.getIn(['el', 'group']) === 'pageParam') {
                        value = _.get(portalState, String(val.getIn(['el', 'value'], '')).replace(/:/g, '.'), '')
                      } else if (val.getIn(['el', 'group']) === 'param') {
                        value = _.get(params, String(val.getIn(['el', 'value'], '')).replace(/:/g, '.'), '')
                      } else if (_.startsWith(val.getIn(['el', 'group']), 'PowerTableWidget')) {
                        isTableMode = true;
                        let key = String(val.getIn(['el', 'value'], '')).split(':')
                        value = _.get(portalState, key, '');
                        if (_.isArray(value)) {
                          value = value[index];
                        }
                      } else if (_.startsWith(val.getIn(['el', 'group']), 'tableWidget')) {
                        isTableMode = true;
                        let key = String(val.getIn(['el', 'value'], '')).split(':')
                        key = [
                          ..._.initial(key),
                          index,
                          _.last(key)
                        ]
                        value = _.get(portalState, key, '');
                      } else {
                        let path = String(updateOldValue(val.getIn(['el', 'value'], ''))).replace(/:/g, '.').split('.');
                        const isPossibleRepeat = detectIsTargetKeyInRepeatEl(path, retState)
                        if (index !== undefined && index !== null && isPossibleRepeat) {
                          const elem = retState.getIn([...getElementDataRoot(['Header', 'Footer'].includes(path[0]) ? 'project' : retState.get('page')), 'elements', path[2]], Map())
                          if (elem.get('type') === 'FormField' && ['daterange', 'radio', 'lookup'].includes(elem.getIn(['props', 'control']))) {
                            path.splice(path.length - 1, 0, index)
                          } else {
                            path = [
                              ...path,
                              index
                            ]
                          }
                        }
                        value = _.get(portalState, path, '');
                      }
                      if (projectVarID.includes(id)) {
                        retState = retState.setIn(['params', id], value)
                        changes.push([id])
                      } else {
                        retState = retState.setIn(['state', pageUID, id], value)
                        changes.push([pageUID, id])
                      }
                    }
                  } catch (error) {
                    console.error(error)
                  }
                }
              )
              break;
            }
          }
          retState = retState.setIn(
            ['ft', 'changes'],
            fromJS(changes)
          )
        } else if (key === 'chatBot' && !isOnlyEffects && actionTarget.getIn(['0', 'enabled'])) {
          if (parent && typeof parent.postMessage == "function") {
            parent.postMessage("newSubmission", "*");
          }
        } else if (key === 'ai' && !isOnlyEffects && actionTarget.getIn(['0', 'enabled'])) {
          if (actionTarget.getIn(['0', 'actions'])) {
            let jobs = {};
            const appState = _.assign({}, params, portalState)
            actionTarget.getIn(['0', 'actions'], Map()).map((action, key) => {
              if (action.get('enabled')) {
                const textKey = action.getIn(['source'])
                const textPath = String(textKey).split(':')
                let text = _.get(appState, textPath, '')
                jobs[key] = {
                  text: text,
                  params: action.toJS()
                }
              }
            })
            if (Object.keys(jobs).length) {
              retState = retState.setIn(
                ['__cache__'],
                retState.getIn(['__cache__'], List())
                  .push(fromJS({
                    type: 'ChatBotAIAction',
                    payload: {
                      jobs: jobs
                    }
                  }))
              )
            }
          }



        } else if (key === 'msgDlg') {
          const payload = actionTarget.getIn(['0'], Map()).toJS();
          if (payload.enabled) {
            if (_.get(payload, 'variant', 'message') === 'slack') {
              if (_.get(payload, 'sendTo', 'channel') === 'channel') {
                if (_.get(payload, 'channelType', 'static') === 'field') {
                  let key = _.get(payload, ['channelField'], '')
                  let pathKey = String(key).split(':');
                  if (pathKey.length == 3 && index !== undefined && index !== null) {
                    pathKey.splice(2, 0, index);
                  }
                  let val = _.get(
                    _.assign({}, params, portalState),
                    pathKey,
                    ''
                  )
                  payload.channel = val
                }
              } else {
                if (_.get(payload, 'channelType', 'static') === 'field') {
                  let key = _.get(payload, ['userField'], '')
                  let pathKey = String(key).split(':');
                  if (pathKey.length == 3 && index !== undefined && index !== null) {
                    pathKey.splice(2, 0, index);
                  }
                  let val = _.get(
                    _.assign({}, params, portalState),
                    pathKey,
                    ''
                  )
                  payload.user = val
                }
              }
              let message = compileMessageWithValues(payload.toastMessage, params, portalState, isBtnRepeat, path, index, retState)
              if (!IS_SERVER) {
                if (retState.getIn(['project', 'ProjectType'], 'web') == CHAT_BOT_TYPE) {
                  requestAnimationFrame(() => {
                    if (window.__FT_PROJECT__API__ && window.__FT_PROJECT__API__.forwardFlow) {
                      window.__FT_PROJECT__API__.forwardFlow({
                        meta: {
                          type: 'ruleNotification'
                        },
                        message: message
                      })
                    }
                  });
                } else {
                  retState = retState.setIn(
                    ['__cache__'],
                    retState.getIn(['__cache__'], List())
                      .push(fromJS({
                        type: 'slackMsg',
                        payload: {
                          uid: uuid(),
                          message: clearHTML(message),
                          channel: payload.channel,
                          sendTo: _.get(payload, 'sendTo', 'channel'),
                          user: payload.user,
                          cloneChannel: _.get(payload, 'cloneChannel', true)
                        }
                      }))
                  )
                }

              }
            } else if (_.get(payload, 'variant', 'message') === 'confirm') {
              payload.confirmMessage = compileMessageWithValues(payload.confirmMessage, params, portalState, isBtnRepeat, path, index, retState)
              retState = retState.setIn(
                ['__cache__'],
                retState.getIn(['__cache__'], List())
                  .push(fromJS({
                    type: 'confirmDlg',
                    payload: {
                      uid: uuid(),
                      index:index,
                      clientY:currentRule.getIn(['options', 'clientY'], window.ftLastClientY),
                      ...payload
                    }
                  }))
              )
            } else if (_.get(payload, 'variant', 'message') === 'message') {
              payload.message = compileMessageWithValues(payload.message, params, portalState, isBtnRepeat, path, index, retState)
              retState = retState.setIn(
                ['__cache__'],
                retState.getIn(['__cache__'], List())
                  .push(fromJS({
                    type: 'msgDlg',
                    payload: {
                      uid: uuid(),
                      ...payload,
                      clientY: currentRule.getIn(['options', 'clientY']) || window.ftLastClientY
                    }
                  }))
              )
            } else {
              if (isAllowFeatureState('Toast', retState)) {
                let message = compileMessageWithValues(payload.toastMessage, params, portalState, isBtnRepeat, path, index, retState)
                if (!IS_SERVER) {
                  payload.appearance = payload.appearance || _.get(payload, 'appearance', 'info')
                  payload.id = uuid()
                  requestAnimationFrame(() => {
                    window.__FT_PROJECT__API__.addToast(message, payload)
                  })
                }
              }
            }
          }
        } else if (key === 'SetLanguage') {
          if (isAllowFeatureState('Translation', retState)) {
            const options = actionTarget.getIn(['0'], Map()).toJS();
            if (options.enabled) {
              if (options.action) {
                if (options.isStatic) {
                  retState = retState
                    .set('FTLang', options.action || '')
                } else {
                  retState = retState.set('FTLang', params[options.action] || '')
                }
              }
            }
          }
        } else if (key === 'WorkFlow' && !isOnlyEffects) {
          if (isAllowFeatureState('Workflow', retState)) {
            const options = actionTarget.getIn(['0'], Map()).toJS();
            if (options.enabled) {
              retState = retState.setIn(
                ['__cache__'],
                retState.getIn(['__cache__'], List())
                  .push(fromJS({
                    type: 'WorkFlow',
                    payload: {
                      uid: uuid(),
                      action: options.action,
                      testMode: options.testMode,
                      returnParams:options.returnParams,
                      runInBackGround: options.runInBackGround ?? true,
                      modalMsg: options.modalMsg || '',
                      params: options.params ? buildParams(retState, fromJS(options.params)) : {},
                      options: currentRule.get('options', Map()),
                      paramsRequested: options.params,
                      flow: options.flow
                    }
                  }))
              )
            }
          }
        } else if (key === 'markOnPage' && !isOnlyEffects) {
          const options = actionTarget.getIn(['0'], Map()).toJS();
          if (options.enabled) {
            let payload = {
              value: ''
            }
            const type = _.get(options, ['text', 'type'], 'static')
            if (type === 'static') {
              payload.value = _.get(options, ['text', 'textValue'], '')
            } else if (type === 'field') {
              let key = _.get(options, ['text', 'field'], '')
              let pathKey = String(key).split(':');
              if (pathKey.length == 3 && index !== undefined && index !== null) {
                pathKey.splice(2, 0, index);
              }
              let val = _.get(
                _.assign({}, params, portalState),
                pathKey,
                ''
              )
              payload.value = val
            }

            retState = retState.setIn(
              ['__cache__'],
              retState.getIn(['__cache__'], List())
                .push(fromJS({
                  type: 'markOnPage',
                  payload: {
                    uid: uuid(),
                    ...payload
                  }
                }))
            )
          }
        } else if (key === 'paymentIntegration' && !isOnlyEffects && actionTarget.getIn(['0', 'enabled'])) {
          let sett = actionTarget.getIn(['0'], Map());
          if (sett.get('selected')) {
            retState = retState.setIn(
              ['__cache__'],
              retState.getIn(['__cache__'], List())
                .push(fromJS({
                  type: 'paymentIntegration',
                  payload: {
                    uid: sett.get('selected'),
                    currentRule:currentRule
                  }
                }))
            )
          }
        } else if (key === 'UnloadInteractivity' && !isOnlyEffects && actionTarget.getIn(['0', 'enabled'])) {
          if (typeof window?.__FT_PROJECT__API__?.unloadCB) {
            window.removeEventListener('beforeunload', window?.__FT_PROJECT__API__?.unloadCB)
            window.close()
          }
        } else if (key === 'sendEmail' && !isOnlyEffects && actionTarget.getIn(['0', 'enabled'])) {
          const confKey = actionTarget.getIn(['0', 'selected'])
          if (confKey) {
            const appState = _.assign({}, params, portalState)
            const fields = retState.getIn(['project', 'Settings', 'store', 'public', confKey, 'fields'], List()).toJS()
            let docGen = retState.getIn(['project', 'Settings', 'store', 'public', confKey, 'docGen'], List()).toJS()
            let repeatRoot = retState.getIn(['project', 'Settings', 'RepeatedStripsID'], List()).toJS()
            const reqState = {}
            const files = []
            _.each(fields, field => {
              let pathKey = String(field).split(':');
              if (pathKey.length == 3 && index !== undefined && index !== null) {
                pathKey.splice(2, 0, index);
              }
              let val = _.get(appState, pathKey, '')
              if(_.last(pathKey) == 'value_html') {
                let tmlAction = fromJS([{
                  enabled:true,
                  elUID:`${pathKey[0]}:${pathKey[1]}`
                }])
                val = processDownloadCSV(tmlAction, portalState, retState, true);
                if(repeatRoot.includes(pathKey[1])) {
                  let tableValue = '';
                  if(val.length) {
                    let title = _.keys(val[0]);
                    _.each(val, function(row, index){
                      tableValue += '<div>';
                      tableValue += `<h2>Row ${index + 1}</h2>`
                      tableValue += `<table style="width: 100%;" border="1" cellspacing="0">`
                      _.each(title, head=>{
                        tableValue += '<tr>'
                        tableValue += `<td>${head}</td>`;
                        tableValue += `<td>${row[head]}</td>`;
                        tableValue += '</tr>'
                      })
                      tableValue += `</table>`
                      tableValue += '</div>';
                    });
                  }
                  reqState[field] = tableValue;
                } else {
                  let tableVale = '<table style="width: 100%;" border="1" cellspacing="0">';
                  _.each(val, function(row, index){
                    let tag = 'td';
                    if(index == 0) {
                      tag = 'td';
                    }

                    tableVale += '<tr>'
                    _.each(row, function(val){
                      tableVale += `<${tag}>${val}</${tag}>`;
                    })
                    tableVale += '</tr>'
                  })
                  tableVale += '</table>';
                  reqState[field] = tableVale;
                }
              }
              else if(_.last(pathKey) == 'cart') {
                let tmlAction = fromJS([{
                  enabled:true,
                  elUID:`${pathKey[0]}`
                }])

                val = processDownloadCart(tmlAction, portalState, retState, true);
                if(repeatRoot.includes(pathKey[1])) {
                  let tableValue = '';
                  if(val.length) {
                    let title = _.keys(val[0]);
                    _.each(val, function(row, index){
                      tableValue += '<div>';
                      tableValue += `<h2>Row ${index + 1}</h2>`
                      tableValue += `<table style="width: 100%;" border="1" cellspacing="0">`
                      _.each(title, head=>{
                        tableValue += '<tr>'
                        tableValue += `<td>${head}</td>`;
                        tableValue += `<td>${row[head]}</td>`;
                        tableValue += '</tr>'
                      })
                      tableValue += `</table>`
                      tableValue += '</div>';
                    });
                  }
                  reqState[field] = tableValue;
                } else {
                  let tableVale = '<table style="width: 100%;" border="1" cellspacing="0">';
                  _.each(val, function(row, index){
                    let tag = 'td';
                    if(index == 0) {
                      tag = 'td';
                    }
                    tableVale += '<tr>'
                    _.each(row, function(val){
                      if (typeof val === 'string' && val.indexOf("https:") === 0) {
                          tableVale += `<${tag}> <img src="${val}" style="max-width:300px"/> </${tag}>`;
                      } else {
                          tableVale += `<${tag}>${val}</${tag}>`;
                      }
                  });
                    tableVale += '</tr>'
                  })
                  tableVale += '</table>';
                  reqState[field] = tableVale;
                }
              }
              else if (retState.hasIn(['project', 'Settings', 'store', 'public', field])) {
                files.push(field)
              } else if (_.isObject(val) && _.keys(val).indexOf('ft_fileupload') !== -1) {
                files.push(field)
              } else {
                reqState[field] = val
              }
            })
            const currState = getState(retState);
            const isUserSignIn = Boolean(getPreviewDynamicData().user || getPreviewDynamicData().messageValue);
            _.each(
              toJS(retState.getIn(['project', 'Settings', 'store', 'public', confKey, 'docGenList'], List())),
              genID => {
                if(retState.getIn(['project', 'Settings', 'store', 'public', genID, 'type']) === 'AUTO_PDF'){
                  if(_.isArray(docGen)){
                    docGen.push(genID)
                  }else{
                    docGen = [genID]
                  }
                }
                const templateFields = state.getIn(['project', 'Settings', 'store', 'public', genID, 'templateFields'], List())
                let hashFields = {};
                try {
                  let fieldsList = templateFields.toJS()
                  _.each(fieldsList, row => {
                    if (row && row.value) {
                      hashFields[row.value] = row;
                    }
                  })
                } catch (err) {

                }
                const fields = templateFields
                  .reduce((r, v) => {
                    const group = v.get('group')
                    if (group === 'param') {
                      return r.set(
                        v.get('value'),
                        state.getIn(['params', String(v.get('value')).replace('param', '')], '')
                      )
                    } else if (group === 'pageParam') {
                      const [pageUID, paramID] = String(v.get('value')).split(':')
                      return r.set(
                        v.get('value'),
                        state.getIn(['state', pageUID, paramID], '')
                      )
                    } else {
                      const value = String(v.get('value'))
                      const wordControl = v.get('control')
                      if (_.startsWith(group, 'formWidget:') || _.startsWith(group, 'listWidget:')) {
                        return r.set(
                          value,
                          toPlainValue(_.get(currState, value.replace(/:/g, '.'), ''))
                        )
                      } else if (_.startsWith(group, 'form:')) {
                        return r.set(
                          value,
                          toPlainValue(_.get(currState, `${_.get(window.__FT_APP_STATE__, 'widget._id')}.${value}`, null))
                        )
                      } else if (group === 'smartv') {
                        return r.set(
                          value,
                          isUserSignIn ? 'true' : ''
                        )
                      } else {
                        let path = updateOldValue(value).split(':')
                        let stripPath = updateOldValue(value).split(/:/g).slice(0, 2).join(':');
                        let elem = getElementFromPath(path, state)
                        let strip = getStripElementFromPath(path, state)
                        if (strip.get('type') === 'RepeatAutoFit' || strip.get('type') === 'Strip' && (strip.getIn(['props', 'isRepeat'], false) || strip.getIn(['props', 'isRepeatCol'], false))) {
                          let stripState = fixObjectArrayState(_.get(currState, updateOldValue(value).split(/:/g).slice(0, 2), ''))

                          try {
                            _.each(stripState, (value, elID) => {
                              const elem = getElementFromPath([...path.slice(0, 2), elID], state)
                              if (Map.isMap(elem) && elem.get('type') === 'Image') {
                                if (value && value.IMG_SRC && _.isArray(value.IMG_SRC)) {
                                  _.set(stripState, [elID], [])
                                  _.each(value.IMG_SRC, (val, index) => {
                                    _.set(stripState, [elID, index], toPlainValue(val))
                                  });
                                }
                              } else if (Map.isMap(elem) && elem.get('type') === 'FormField'
                                && ['time', 'date', 'datetime'].includes(elem.getIn(['props', 'control']))) {
                                if (_.isArray(value)) {
                                  _.each(value, (val, index) => {
                                    let format = getFormDateFormat(elem.getIn(['props', state.get('layoutMode', 'lg')], Map()).toJS(), elem.getIn(['props', 'control']))
                                    if (_.get(hashFields, [`${path.join(':')}:${elID}`, 'control'])) {
                                      if (elem.getIn(['props', 'control']) === 'time') {
                                        format = 'HH:mm';
                                      } else if (['datetime'].includes(elem.getIn(['props', 'control']))) {
                                        format = 'YYYY-MM-DDTHH:mm';
                                      } else if (elem.getIn(['props', 'control']) === 'date') {
                                        format = 'YYYY-MM-DD';
                                      }
                                    }
                                    let date = moment(val)
                                    if (date.format() !== 'Invalid date') {
                                      _.set(stripState, [elID, index], date.format(format))
                                    } else {
                                      _.set(stripState, [elID, index], toPlainValue(val))
                                    }
                                  })
                                } else {
                                  let val = value
                                  let format = getFormDateFormat(elem.getIn(['props', state.get('layoutMode', 'lg')], Map()).toJS(), elem.getIn(['props', 'control']))
                                  let date = moment(val)
                                  if (date.format() !== 'Invalid date') {
                                    _.set(stripState, [elID], date.format(format))
                                  } else {
                                    _.set(stripState, [elID], toPlainValue(val))
                                  }
                                }
                              }
                            })
                          } catch (error) {
                            console.error(error)
                          }
                          return r.set(
                            stripPath,
                            stripState
                          )
                        } else {
                          if (elem.get('type') === 'Image') {
                            return r.set(
                              value,
                              toPlainValue(_.get(currState, [...path, 'IMG_SRC'], ''))
                            )
                          } else if (elem.get('type') === 'Widget' && elem.getIn(['props', 'data', 'Type']) === 'ImageChoice') {
                            if (_.last(path) === 'ftListLabel') {
                              return r.set(
                                value,
                                toPlainValue(_.get(currState, [..._.initial(path), 'ftListValue'], ''))
                              )
                            }
                            return r.set(
                              value,
                              toPlainValue(_.get(currState, [...path, 'ftListValue'], ''))
                            )
                          } else if (elem.get('type') === 'FormField' && ['time'].includes(elem.getIn(['props', 'control']))) {
                            let val = toPlainValue(_.get(currState, updateOldValue(value).replace(/:/g, '.'), ''))
                            let format = getFormDateFormat(elem.getIn(['props', state.get('layoutMode', 'lg')], Map()).toJS(), elem.getIn(['props', 'control']))
                            if (wordControl) {
                              format = 'HH:mm';
                            }
                            let date = moment(val)
                            if (date.format() !== 'Invalid date') {
                              return r.set(
                                value,
                                date.format(format)
                              )
                            } else {
                              date = moment(moment().format('YYYY-MM-DD') + 'T' + val)
                              if (date.format() !== 'Invalid date') {
                                return r.set(
                                  value,
                                  date.utc().format(format)
                                )
                              }
                            }
                            return r.set(
                              value,
                              val
                            )
                          } else if (wordControl && elem.get('type') === 'FormField' && ['date', 'datetime'].includes(elem.getIn(['props', 'control']))) {
                            let val = toPlainValue(_.get(currState, updateOldValue(value).replace(/:/g, '.'), ''))
                            let date = moment(val)
                            if (date.format() !== 'Invalid date') {
                              let format = '';
                              if (['datetime'].includes(elem.getIn(['props', 'control']))) {
                                format = 'YYYY-MM-DDTHH:mm';
                              } else if (elem.getIn(['props', 'control']) === 'date') {
                                format = 'YYYY-MM-DD';
                              }
                              return r.set(value, date.format(format))
                            } else {
                              return r.set(
                                value,
                                toPlainValue(_.get(currState, updateOldValue(value).replace(/:/g, '.'), ''))
                              )
                            }
                          } else if (elem.get('type') === 'FormField' && ['time', 'date', 'datetime'].includes(elem.getIn(['props', 'control']))) {
                            let val = toPlainValue(_.get(currState, updateOldValue(value).replace(/:/g, '.'), ''))
                            let format = getFormDateFormat(elem.getIn(['props', state.get('layoutMode', 'lg')], Map()).toJS(), elem.getIn(['props', 'control']))
                            let date = moment(val)
                            if (date.format() !== 'Invalid date') {
                              return r.set(
                                value,
                                date.format(format)
                              )
                            } else {
                              return r.set(
                                value,
                                toPlainValue(_.get(currState, updateOldValue(value).replace(/:/g, '.'), ''))
                              )
                            }
                          }
                          return r.set(
                            value,
                            toPlainValue(_.get(currState, updateOldValue(value).replace(/:/g, '.'), ''))
                          )
                        }
                      }
                    }
                  }, Map()).toJS()
                  _.each(fields, (val, key) => {
                    reqState[key] = val
                  })
              }
            )
            retState = retState.setIn(
              ['__cache__'],
              retState.getIn(['__cache__'], List())
                .push(fromJS({
                  type: 'sendEmail',
                  payload: {
                    uid: confKey,
                    state: reqState,
                    files,
                    docGen,
                    options: currentRule.get('options', Map()),
                    onSuccess: actionTarget.getIn(['0', 'success'], List()),
                    onError: actionTarget.getIn(['0', 'fail'], List()),
                  }
                }))
            )
          }
        } else if (key === 'InteractiveImg' && !isOnlyEffects) {
          // console.log('actionTarget >>>', actionTarget.toJS())
          let sett = actionTarget.getIn([0], actionTarget.getIn(['0'], Map()));
          const elemPath = sett.get('form')
            ? String(sett.get('form')).split(':')
            : String(sett.getIn(['elem'], '')).split(':')
          const elemState = toJS(retState.getIn(['state', ...elemPath], Map())) || {}
          let tagsList = []
          if (_.isArray(elemState.value)) {
            _.each(elemState.value, (val, index) => {
              tagsList.push({
                value: _.get(elemState.value, index),
                left: _.get(elemState.left, index),
                top: _.get(elemState.top, index),
                label: _.get(elemState.label, index),
              })
            })
          } else if (elemState.value) {
            tagsList.push({
              value: elemState.value,
              left: elemState.left,
              top: elemState.top,
              label: elemState.label,
            })
          }
          switch (sett.getIn(['action'])) {
            case 'Reset': {
              tagsList = []
              break
            }
            case 'RefreshIndexes': {
              tagsList = _.map(tagsList, (tag, index) => ({
                ...tag,
                label: index + 1
              }))
              break
            }
            case 'addTag': {
              tagsList.push({
                value: sett.get('value'),
                left: sett.get('left'),
                top: sett.get('top'),
                label: sett.get('label'),
              })
              break;
            }
            case 'removeTag': {
              tagsList.splice(sett.get('index'), 1)
              break;
            }
            case 'moveTag': {
              _.set(
                tagsList,
                [sett.get('index', 0), 'left'],
                sett.get('left', 0)
              )
              _.set(
                tagsList,
                [sett.get('index', 0), 'top'],
                sett.get('top', 0)
              )
              break;
            }
          }
          const interactiveState = {
            value: [],
            left: [],
            top: [],
            label: [],
          }
          _.each(tagsList, tag => {
            interactiveState.value.push(tag.value)
            interactiveState.left.push(tag.left)
            interactiveState.top.push(tag.top)
            interactiveState.label.push(tag.label)
          })
          retState = retState.setIn(['state', ...elemPath], fromJS(interactiveState))
          retState = retState.setIn(['state', ..._.initial(elemPath), `${_.last(elemPath)}-size`], _.size(interactiveState.value))
          retState = retState.setIn(
            ['ft', 'changes'],
            retState.getIn(['ft', 'changes'], List())
              .push(fromJS([..._.initial(elemPath), `${_.last(elemPath)}-size`]))
          )
          _.each(
            ['left', 'top', 'value', 'label'],
            key => {
              retState = retState.setIn(
                ['ft', 'changes'],
                retState.getIn(['ft', 'changes'], List())
                  .push(fromJS([...elemPath, key]))
              )
            }
          )
        } else if (key === 'chartInteractivity' && !isOnlyEffects) {
          let sett = actionTarget.getIn([0], actionTarget.getIn(['0'], Map()));
          const elemUID = sett.getIn(['elemUID'], '')
          if(sett.getIn(['action']) && elemUID){
            let [pageUID, elemID, ...rest] = String(elemUID).split(':')
            if(retState.getIn(['project', 'Settings', 'RepeatedStripsID'], List()).findIndex(v => v === elemID) !== -1){
              elemID = rest[0]
            }
            const pageID = retState.getIn(['project', 'Pages'], List()).find(page => page.get('uid') === pageUID)?.get?.('_id')
            let elem = retState.getIn(['pages', pageID, 'Props', 'elements', elemID], Map())
            if(pageID && elem?.size > 0 && elem.get('type') === "Widget" && elem.getIn(['props', 'data', 'Type']) === 'chart'){
              let propKey = 'axisYStep'
              switch (sett.getIn(['action'])) {
                case 'Set Y Axis Step':
                  propKey = 'axisYStep'
                  break;
                case 'Set X Axis Step':
                  propKey = 'axisStep'
                  break;
                case 'Set X Min Step':
                  propKey = 'axisMin'
                  break;
                case 'Set Y Min Step':
                  propKey = 'axisYMin'
                  break;
                case 'Set X Max Step':
                  propKey = 'axisMax'
                  break;
                case 'Set Y Max Step':
                  propKey = 'axisYMax'
                  break;
              }
              let value = sett.get(`valueStatic`, '')
              let type = sett.get(`valueType`, 'static')
              const el = sett.getIn([`valueEl`], '')
              if (type === 'static') {
                value = sett.get(`valueStatic`, '')
              } else if (type === 'field') {
                const isPossibleRepeat = detectIsTargetKeyInRepeatEl(el, retState)
                const appState = _.assign({}, params, portalState)
                value = _.get(
                  appState,
                  [
                    ...String(el).split(':'),
                    ...isPossibleRepeat && typeof index === 'number' ? [index] : []
                  ],
                  0
                )
              }
              value = parseInt(value, 10)
              if (Number.isNaN(value)) {
                value = undefined
              }
              elem = elem.setIn(['props', 'data', 'Props', propKey], value)
              retState = retState.setIn(['pages', pageID, 'Props', 'elements', elemID], elem)
            }
          }
        } else if (key === 'cartInteractivity' && !isOnlyEffects) {
          if (isAllowFeatureState('Commerce', retState)) {
            let sett = actionTarget.getIn([0], actionTarget.getIn(['0'], Map()));
            if (sett.getIn(['enabled'])) {
              switch (sett.getIn(['action'])) {
                case 'Add Cart Item': {
                  let obj = {}
                  const variables = retState.getIn(['project', 'Settings', 'eCommerce', 'pages', 'e_product', 'Props', 'productVariables'], List())
                  const floatFields = ['price', 'discountPrice']
                  const intFields = ['quantity', 'count']
                  const boolFields = ['isOnSale', 'isShippable']
                  const fieldList = _.reduce(
                    variables.toJS(),
                    (prev, prodVar) => [
                      ...prev,
                      {
                        label: prodVar.name,
                        key: `var:${prodVar.id}`
                      }
                    ],
                    [...eCartFields]
                  )
                  _.each(fieldList, ({ key }) => {
                    let value = sett.get(`${key}Static`, '')
                    let type = sett.get(`${key}Type`, 'static')
                    const el = sett.getIn([`${key}El`], '')
                    if (type === 'static') {
                      value = sett.get(`${key}Static`, '')
                    } else if (type === 'field') {
                      const isPossibleRepeat = detectIsTargetKeyInRepeatEl(el, retState)
                      const appState = _.assign({}, params, portalState)
                      value = _.get(
                        appState,
                        [
                          ...String(el).split(':'),
                          ...isPossibleRepeat && typeof index === 'number' ? [index] : []
                        ],
                        0
                      )
                    }
                    if (floatFields.includes(key)) {
                      value = parseFloat(value)
                      if (Number.isNaN(value)) {
                        value = null
                      }
                    } else if (intFields.includes(key)) {
                      value = parseInt(value, 10)
                      if (Number.isNaN(value)) {
                        value = null
                      }
                    } else if (boolFields.includes(key)) {
                      if (_.toLower(value) === 'false' || _.toLower(value) === 'off' || value === 0 || value === '0') {
                        value = false
                      } else {
                        value = Boolean(value)
                      }
                    }
                    _.set(obj, String(key).replace(':', '.'), value)
                  })
                  retState = retState.setIn(
                    ['__cache__'],
                    retState.getIn(['__cache__'], List())
                      .push(fromJS({
                        type: 'addCartItem',
                        payload: {
                          item: obj,
                          onAdd: sett.getIn(['onAdd'], List()),
                          onUpdate: sett.getIn(['onUpdate'], List())
                        }
                      }))
                  )
                  break;
                }
                case 'Update Cart Item': {
                  let currentItem = retState.getIn(['state', 'eCommerce', 'item'], Map())
                  let cartList = retState.getIn(['state', 'eCommerce', 'e_cart'], List())
                  let attr = _.compact(currentItem.get('attr', List()).toJS())
                  let itemInex = cartList.findIndex(item => {
                    if (item.get('value') === currentItem.get('value')) {
                      let isSame = true
                      let itemAttr = _.compact(item.get('attr', List()).toJS() || [])
                      _.each(attr, val => {
                        if (_.findIndex(itemAttr, v => v.value === val?.value) === -1) {
                          isSame = false
                          return false
                        }
                      })
                      return isSame
                    } else {
                      return false
                    }
                  })
                  if (itemInex !== -1) {
                    retState = retState.setIn(['state', 'eCommerce', 'e_cart', itemInex], currentItem)
                    setCartToLocalStorage(retState.getIn(['state', 'eCommerce', 'e_cart'], List()), retState)
                  }
                  break;
                }
                case 'Delete Cart Item': {
                  let currentItem = retState.getIn(['state', 'eCommerce', 'item'], Map())
                  let cartList = retState.getIn(['state', 'eCommerce', 'e_cart'], List())
                  let attr = _.compact(currentItem.get('attr', List()).toJS())
                  let itemInex = cartList.findIndex(item => {
                    if (item.get('value') === currentItem.get('value')) {
                      let isSame = true
                      let itemAttr = _.compact(item.get('attr', List()).toJS() || [])
                      _.each(attr, val => {
                        if (_.findIndex(itemAttr, v => v.value === val?.value) === -1) {
                          isSame = false
                          return false
                        }
                      })
                      return isSame
                    } else {
                      return false
                    }
                  })
                  if (itemInex !== -1) {
                    retState = retState.deleteIn(['state', 'eCommerce', 'e_cart', itemInex])
                    setCartToLocalStorage(retState.getIn(['state', 'eCommerce', 'e_cart'], List()), retState)
                  }
                  break;
                }
                case 'Reset Cart': {
                  retState = retState.setIn(['state', 'eCommerce', 'e_cart'], List());
                  setCartToLocalStorage(List(), retState)
                  break;
                }
              }
            }
          }
        } else if ((key === 'repeatInteractivity' || key === 'repeatAutoFitInteractivity') && !isOnlyEffects) {
          let sett = actionTarget.getIn([0], actionTarget.getIn(['0'], Map()));
          if (sett.getIn(['enabled'])) {
            let [pageUID, stripID] = String(sett.get('form')).split(':')
            let pageID = retState.getIn(['project', 'Pages'], List()).find(page => page.get('uid') === pageUID)?.get?.('_id')
            let elementPath = [];
            if (pageID) {
              elementPath = ['pages', pageID, 'Props']
            } else {
              elementPath = ['project', 'Settings']
            }
            if(!pageID && retState.getIn(['project', 'Settings', 'ui', 'Modal'], List()).includes(pageUID)){
              pageID = pageUID
            }
            if (pageID) {
              const elemRoot = getElementDataRoot(pageID)
              let stripData = retState.getIn(['state', pageUID, stripID], Map())
              switch (sett.get('action')) {
                case 'Delete': {
                  let useIndex = null
                  if (sett.get('indexFrom') === 'current') {
                    useIndex = index
                  } else if (sett.get('indexFrom', 'static') === 'static') {
                    useIndex = parseInt(sett.get('index', ''), 10) - 1
                  } else if (sett.get('indexFrom') === 'field') {
                    let fromEl = sett.get('indexEl', '')
                    const isPossibleRepeat = detectIsTargetKeyInRepeatEl(fromEl, retState)
                    const appState = _.assign({}, params, portalState)
                    let pageTo = _.get(
                      appState,
                      [
                        ...String(fromEl).split(':'),
                        ...isPossibleRepeat && typeof index === 'number' ? [index] : []
                      ],
                      0
                    )
                    useIndex = parseInt(pageTo, 10) - 1
                    if (_.isNaN(useIndex)) {
                      useIndex = 0
                    }
                  }
                  retState = retState.setIn(['rules', pageUID, stripID, String(useIndex)], fromJS({}))

                  const deleteIndex = (val, key) => {
                    if (List.isList(val)) {
                      const res = val.delete(useIndex)

                      const isLastElement = val.size === 1 && useIndex === 0
                      const isHide = List.isList(val.getIn([useIndex])) && val.getIn([useIndex]).includes('hide')

                      if (isLastElement && isHide) {
                        return res.insert(useIndex, fromJS(['hide']));
                      }

                      return res
                    } else if (Map.isMap(val)) {
                      let localVal = val.toJS();
                      let keys = Object.keys(localVal);
                      let isListObject = true;
                      _.each(keys, function (key) {
                        key = parseInt(key);
                        if (isNaN(key)) {
                          isListObject = false;
                        }
                      })
                      if (isListObject) {
                        let list = Map();
                        val.map((row, index) => {
                          if (parseInt(index) != useIndex) {
                            let localIndex = parseInt(index);
                            if (localIndex > useIndex) {
                              localIndex--;
                            }
                            if (typeof index == 'number') {
                              list = list.set(localIndex, row);
                            } else {
                              list = list.set(String(localIndex), row);
                            }
                          }
                        })
                        return list;
                      } else {
                        return val.map(deleteIndex)
                      }
                    } else {
                      return val
                    }
                  }

                  let resultData = stripData.map(deleteIndex)
                  try {
                    if (_.get(window, ['__FT_PROJECT__API__FILES__', 'filesRelation', stripID])) {
                      _.each(_.get(window, ['__FT_PROJECT__API__FILES__', 'filesRelation', stripID]), function (val, uid) {
                        let files = _.get(window, ['__FT_PROJECT__API__FILES__', 'files', uid])
                        let updateFiles = {};
                        if (files) {
                          _.each(files, function (file, index) {
                            let localIndex = parseInt(index);
                            if (!isNaN(localIndex)) {
                              if (localIndex < useIndex) {
                                updateFiles[localIndex] = file
                              } else if (localIndex > useIndex) {
                                localIndex--;
                                updateFiles[localIndex] = file
                              }
                            }
                          })
                        }
                        _.set(window, ['__FT_PROJECT__API__FILES__', 'files', uid], updateFiles);
                      });
                      _.each(_.get(window, ['__FT_PROJECT__API__FILES__', 'filesRelation', stripID]), function (val, uid) {
                        let files = _.get(window, ['__FT_PROJECT__API__FILES__', 'files', uid])
                        if (files) {
                          _.each(files, function (file, index) {
                            let localIndex = parseInt(index);
                            if(!Number.isNaN(localIndex)){
                              let selectedFiles = window.__FT_PROJECT__API__.getFilesByID(uid, localIndex);
                              resultData = resultData.setIn([uid, localIndex, 'ft_fileupload'], fromJS(_.map(selectedFiles, function (row) {
                                return row?.name || ''
                              })))
                            }
                          })
                        }

                      });

                    }
                  } catch (err) {
                    console.error(err.stack);
                  }

                  const size = getMappingCount(resultData.toJS())
                  retState = retState.setIn(['state', pageUID, stripID], resultData)
                  retState = retState
                    .setIn(['state', pageUID, `${stripID}-totalRows`], size)
                    .setIn(['ft', 'changes'], retState.getIn(['ft', 'changes'], List()).push(fromJS([pageUID, `${stripID}-totalRows`])))

                  const stripRules = retState.getIn(['rules', pageUID, stripID], Map())
                  const resultRules = stripRules.map(deleteIndex)
                  retState = retState.setIn(['rules', pageUID, stripID], resultRules)

                  const formFieldStatuses = retState.getIn(['formFieldStatuses', pageUID, stripID], Map())
                  const resultFormFieldStatuses = formFieldStatuses.map(deleteIndex)
                  retState = retState.setIn(['formFieldStatuses', pageUID, stripID], resultFormFieldStatuses)
                  const elemChildren = retState.getIn([...elementPath, 'elements', stripID, 'children'], List()).toJS()
                  const children = collectAllChildren(elemChildren, ['pages', retState.getIn(['page']), 'Props'], retState)
                  const stripParams = retState.getIn([...elementPath, 'elements', stripID, 'props', 'params'], List()).map(param => param.get('id')).toJS()
                  const changes = _.reduce(
                    [...children, ...stripParams],
                    (r,v) => [
                      ...r,
                      [pageUID, stripID, v]
                    ],
                    [[pageUID, stripID], [pageUID, `${stripID}-totalRows`]]
                  )
                  const [st, _changes] = recalculatePowerFields(retState, changes)
                  retState = st
                  retState = doProcessRules(retState, false, null, [], [[pageUID, stripID], [pageUID, `${stripID}-totalRows`]], false, isOnload)
                    publish(generateEventName(nameSpaces.REPEAT, events.DELETE), {pageUID, stripID, useIndex})
                    break;
                }
                case 'Reset': {
                  retState = retState.setIn(['state', pageUID, stripID], Map())
                  retState = retState.setIn(['state', pageUID, `${stripID}-totalRows`], 0)
                  const elemChildren = retState.getIn([...elementPath, 'elements', stripID, 'children'], List()).toJS()
                  const children = collectAllChildren(elemChildren, ['pages', retState.getIn(['page']), 'Props'], retState)
                  const stripParams = retState.getIn([...elementPath, 'elements', stripID, 'props', 'params'], List()).map(param => param.get('id')).toJS()
                  const changes = _.reduce(
                    [...children, ...stripParams],
                    (r,v) => [
                      ...r,
                      [pageUID, stripID, v]
                    ],
                    [[pageUID, stripID], [pageUID, `${stripID}-totalRows`]]
                  )
                  const [st, _changes] = recalculatePowerFields(retState, changes)
                  retState = st
                  retState = doProcessRules(retState, false, null, [], [[pageUID, stripID], [pageUID, `${stripID}-totalRows`]], false, isOnload)
                  let isDisplayEmpty = retState.getIn([...elementPath, 'elements', stripID, 'props', 'allowEmptyRow'], false)
                  if (!isDisplayEmpty) {
                    break;
                  }
                  stripData = Map()
                }
                case 'Insert': {
                  let size = getMappingCount(stripData.toJS())
                  let isDisplayEmpty;
                  let isInvisibleByDefault = retState.getIn([...elementPath, 'elements', stripID, 'props', 'isInvisibleByDefault'], false);
                  let stripParams = retState.getIn([...elementPath, 'elements', stripID, 'props', 'params'], List())
                  const pushEmptyValue = (val, key,element) => {
                    let isList = false
                    let control = ''
                    let defVal = '';
                    let defUID = '';
                    let defLabel = '';
                    let elem;
                    if (key != 'value') {
                      elem = retState.getIn([...elementPath, 'elements', key])
                    }else{
                      elem = element
                    }
                    if(elem && TAB_TYPES.includes(elem.get('type'))) {
                      isList = true;
                      control = 'radio'
                    }
                    let layoutMode = retState.getIn(['layoutMode'], 'lg')

                    if (key != 'value') {
                      if (elem) {
                        defVal = getValueForMode(elem, layoutMode, ['props'], ['value'], '')
                        if (getValueForMode(elem, layoutMode, ['props'], ['useCurrentDate'], '')) {
                          defVal = new Date()
                        }
                        if(!control) {
                          control = elem.getIn(['props', 'control'])
                        }
                        let isListFields = LIST_BASED_FIELDS.includes(elem.getIn(['props', 'control']));
                        if (elem.getIn(['props', 'control']) == 'checkbox' && elem.getIn(['props', 'source'], 'single') != 'single') {
                          isListFields = true;
                        }
                        if (elem.get('type') === 'FormField' && isListFields && elem.getIn(['props', 'source']) === 'static') {
                          isList = true
                          let items = elem.getIn(['props', 'items'], List())
                          let item = items.find(v => v.get('value') === defVal)
                          if (item) {
                            defLabel = item.get('label')
                            defUID = item.get('uid')
                          }
                        }
                        if (elem.getIn(['props', 'control']) === 'currency') {
                          if (Map.isMap(val)) {
                            try {
                              //when mapped value, but not formatted value yet, make empty list for it.
                              if (List.isList(val.get('value')) && !List.isList(val.get('formattedValue'))) {
                                let size = val.get('value', List()).size
                                let formatted = val.get('formattedValue', List())
                                if (List.isList(formatted) && formatted.size < size) {
                                  _.times(size, n => {
                                    formatted = formatted.set(n, formatted.get(n, ''))
                                  })
                                  val = val.set('formattedValue', formatted)
                                }
                              }
                              if(List.isList(val.get('value')) && List.isList(val.get('formattedValue'))) {
                                return val.set('value', val.get('value', List()).push(defVal))
                                  .set('formattedValue', val.get('formattedValue', List()).push(defVal))
                              } else if (Map.isMap(val.get('value')) || Map.isMap(val.get('formattedValue'))) {
                                let localVal = Map();
                                localVal = localVal.set('value', List())
                                localVal = localVal.set('formattedValue', List())
                                val.get('value', List()).map((row, index)=>{
                                  localVal = localVal.setIn(['value', index], row)
                                })
                                val.get('formattedValue', List()).map((row, index)=>{
                                  localVal = localVal.setIn(['formattedValue', index], row)
                                })
                                return localVal.set('value', localVal.get('value', List()).push(defVal))
                                .set('formattedValue', localVal.get('formattedValue', List()).push(defVal));
                              } else {
                                let localVal = Map();
                                localVal = localVal.set('value', List())
                                localVal = localVal.set('formattedValue', List())
                                return localVal
                                .set('value', localVal.get('value', List()).push(defVal))
                                .set('formattedValue', localVal.get('formattedValue', List()).push(defVal))
                              }
                            } catch(err) {
                              console.error(err);
                              return val;
                            }
                          }
                        }
                      } else {
                        let param = stripParams.find(v => v.get('id') === key)
                        if (param && param.get('paramType') === 'static') {
                          defVal = param.get('value', '')
                        }
                      }
                    }else{
                      defVal = getValueForMode(elem, layoutMode, ['props'], ['value'], '')
                    }
                  if (isImmutable(elem) && elem.getIn(['props', 'control']) === 'daterange') {
                    if (elem.getIn(['props', layoutMode, 'useCurrentDate'], false)) {
                      defVal = fromJS({
                        startDate: new moment(elem.getIn(['props', retState.get('layoutMode', 'lg'), 'startDate']) || new Date()),
                        endDate: new moment(elem.getIn(['props', retState.get('layoutMode', 'lg'), 'endDate']) || new Date()),
                      })
                    } else {
                      let startDate = new moment(elem.getIn(['props', retState.get('layoutMode', 'lg'), 'startDate']))
                      if(startDate.format() === 'Invalid date'){
                        startDate = undefined
                      }
                      let endDate = new moment(elem.getIn(['props', retState.get('layoutMode', 'lg'), 'endDate']))
                      if(endDate.format() === 'Invalid date'){
                        endDate = undefined
                      }
                      defVal = fromJS({
                        startDate,
                        endDate,
                      })
                    }

                      if(List.isList(val)){
                        return val.push(defVal)
                      } else
                      if (Map.isMap(val)) {
                        let localVal = val.toJS();
                        let keys = Object.keys(localVal);
                        let isListObject = true;
                        let maxItem = -1;
                        _.each(keys, function (key) {
                          key = parseInt(key);
                          if (isNaN(key)) {
                            isListObject = false;
                          } else {
                            if (maxItem < key) {
                              maxItem = key;
                            }

                          }
                        })
                        if(maxItem>-1){
                          return val.set(maxItem+1, defVal)
                        }
                      }
                    } else if (List.isList(val)) {
                      if (isList || isImmutable(elem) && elem.get('type') === 'FormField' && control === 'radio') {
                        return val.push(fromJS({
                          ftListValue: defVal,
                          ftListLabel: defLabel
                        }))
                      } else {
                        return val.push(defVal)
                      }
                    } else if (Map.isMap(val)) {
                      let localVal = val.toJS();
                      let keys = Object.keys(localVal);
                      let isListObject = true;
                      let maxItem = -1;
                      _.each(keys, function (key) {
                        key = parseInt(key);
                        if (isNaN(key)) {
                          isListObject = false;
                        } else {
                          if (maxItem < key) {
                            maxItem = key;
                          }
                        }
                      })
                      if (isListObject && maxItem > -1) {
                        return val.set(String(maxItem + 1), defVal)
                      } else {
                        if (isList) {
                          if(control === 'radio'){
                            return val
                              .setIn([String(size), 'ftListLabel'], defLabel)
                              .setIn([String(size), 'ftListValue'], defVal)
                              .setIn([String(size), 'uid'], defUID)
                          }
                          if (size == 1 && (val.getIn(['ftListLabel', '0']) === undefined && val.getIn(['ftListLabel', 0]))) {
                            return val
                              .setIn(['ftListLabel', '0'], defLabel)
                              .setIn(['ftListValue', '0'], defVal)
                              .setIn(['ftListLabel', '1'], defLabel)
                              .setIn(['ftListValue', '1'], defVal)
                          } else {
                            return val
                              .setIn(['ftListLabel', size], defLabel)
                              .setIn(['ftListValue', size], defVal)
                          }
                        } else {
                          return val.map((val,key)=>pushEmptyValue(val,key,elem))
                        }
                      }
                    } else {
                      return val
                    }
                  }
                  let childrens = _.uniq(getChildUIDs(retState, stripID))
                  if (size === 0) {
                    isDisplayEmpty = retState.getIn([...elementPath, 'elements', stripID, 'props', 'allowEmptyRow'], false)
                    if (sett.get('action') == 'Reset') {
                      isDisplayEmpty = false;
                    }
                    if (isDisplayEmpty) {
                      let defaultValues = {
                        value: ['']
                      }
                      stripParams.map(param => {
                        if (param.get('paramType') === 'static') {
                          defaultValues[param.get('id')] = [param.get('value', '')]
                        }
                      })
                      _.each(childrens, childID => {
                        let elem = retState.getIn([...elementPath, 'elements', childID], Map())
                        if (elem.get('type') === 'FormField') {
                          let value = elem.getIn(['props', retState.getIn(['layoutMode'], 'lg'), 'value'], '')
                          if (elem.getIn(['props', retState.getIn(['layoutMode'], 'lg'), 'useCurrentDate'])) {
                            value = new Date();
                          }
                          let isListFields = LIST_BASED_FIELDS.includes(elem.getIn(['props', 'control']));
                          if (elem.getIn(['props', 'control']) == 'checkbox' && elem.getIn(['props', 'source'], 'single') != 'single') {
                            isListFields = true;
                          }
                          if (elem.get('type') === 'FormField' && isListFields && elem.getIn(['props', 'source']) === 'static') {
                            let items = elem.getIn(['props', 'items'], List())
                            let item = items.find(v => v.get('value') === value)
                            if (elem.getIn(['props', 'control']) === 'radio') {
                              if (item) {
                                defaultValues[childID] = [{
                                  ftListValue: value,
                                  ftListLabel: item.get('label'),
                                  uid: item.get('uid'),
                                }]
                              } else {
                                defaultValues[childID] = [{
                                  ftListValue: value,
                                  ftListLabel: ''
                                }]
                              }
                            } else {
                              if (item) {
                                defaultValues[childID] = {
                                  ftListValue: [value],
                                  ftListLabel: [item.get('label')]
                                }
                              } else {
                                defaultValues[childID] = {
                                  ftListValue: [value]
                                }
                              }
                            }
                          } else if (elem.getIn(['props', 'control']) == 'currency') {
                            defaultValues[childID] = {
                              value: [value],
                              formattedValue: [value],
                            }
                          } else {
                            defaultValues[childID] = [value]
                          }
                        }
                      })
                      retState = retState.setIn(['state', pageUID, stripID], fromJS(defaultValues));
                    } else {
                      let defaultValues = {
                        value: []
                      }
                      stripParams.map(param => {
                        if (param.get('paramType') === 'static') {
                          defaultValues[param.get('id')] = []
                        }
                      })
                      _.each(childrens, childID => {
                        let elem = retState.getIn([...elementPath, 'elements', childID], Map())
                        if (elem.get('type') === 'FormField') {
                          let value = elem.getIn(['props', retState.getIn(['layoutMode'], 'lg'), 'value'], '')
                          if (elem.getIn(['props', retState.getIn(['layoutMode'], 'lg'), 'useCurrentDate'])) {
                            value = new Date();
                          }
                          let isListFields = LIST_BASED_FIELDS.includes(elem.getIn(['props', 'control']));
                          if (elem.getIn(['props', 'control']) == 'checkbox' && elem.getIn(['props', 'source'], 'single') != 'single') {
                            isListFields = true;
                          }
                          if (elem.get('type') === 'FormField' && isListFields) {
                            let item;
                            if(elem.getIn(['props', 'source']) === 'static') {
                              let items = elem.getIn(['props', 'items'], List())
                              item = items.find(v => v.get('value') === value)
                            }

                            if (elem.getIn(['props', 'control']) === 'radio') {
                              if (item) {
                                defaultValues[childID] = []
                              } else {
                                defaultValues[childID] = []
                              }
                            } else {
                              if (item) {
                                defaultValues[childID] = {
                                  ftListValue: [],
                                  ftListLabel: []
                                }
                              } else {
                                defaultValues[childID] = {
                                  ftListValue: []
                                }
                              }
                            }
                          } else if (elem.getIn(['props', 'control']) == 'currency') {
                            defaultValues[childID] = {
                              value: [],
                              formattedValue: [],
                            }
                          } else {
                            defaultValues[childID] = []
                          }
                        }
                      })
                      retState = retState.setIn(['state', pageUID, stripID], fromJS(defaultValues));
                    }
                  }
                  stripData = retState.getIn(['state', pageUID, stripID], Map())
                  const resultData = stripData.map(pushEmptyValue)
                  retState = retState.setIn(['state', pageUID, stripID], resultData)

                  let size2 = getMappingCount(stripData.toJS())
                  if (isDisplayEmpty && size2 < 1) {
                    size2 = 1;
                  }
                  let ftChanges = retState.getIn(['ft', 'changes'], List());
                  ftChanges = ftChanges.push(fromJS([pageUID, `${stripID}-totalRows`]));
                  retState = retState
                    .setIn(['state', pageUID, `${stripID}-totalRows`], getMappingCount(resultData.toJS()))
                    .setIn(['ft', 'changes'], ftChanges)
                  let rules = retState.getIn(['rules', pageUID, stripID]);
                  if (rules && isImmutable(rules)) {
                    rules = rules.toJS();
                    _.each(childrens, function (key) {
                      let row = rules[key];
                      if (row && _.isArray(row)) {
                        if (isInvisibleByDefault) {
                          if (row[0] && _.isArray(row[0])) {
                            row[size2] = row[0];
                          } else {
                            row[size2] = [];
                          }
                        } else {
                          if (retState.getIn([...elementPath, 'elements', key, 'props', 'isInvisibleByDefault'], false)) {
                            row[size2] = ['hide'];
                          }
                        }
                      }
                    });
                    retState = retState.setIn(['rules', pageUID, stripID], fromJS(rules));
                  }
                  retState = doProcessRules(retState, false, null, [], [[pageUID, stripID]], false, isOnload, size)
                  break;
                }
              }
            }
            let stripPath = String(sett.get('form')).split(':')
            let videoParams = {}
            let isApply = true
            if (['Set Background Image', 'Set Background Video'].includes(sett.get('action'))) {
              let url = ''
              let urlType = sett.get('url', 'static')
              if (urlType === 'static') {
                url = sett.get('urlStatic', '')
              } else if (urlType === 'field') {
                let urlEl = sett.get('urlEl', '')
                const isPossibleRepeat = detectIsTargetKeyInRepeatEl(urlEl.split(':'), retState)
                const appState = _.assign({}, params, portalState)
                url = _.get(
                  appState,
                  [
                    ...String(urlEl).split(':'),
                    ...isPossibleRepeat && typeof index === 'number' ? [index] : []
                  ],
                  ''
                )
              }
              videoParams.url = url
              videoParams.videoType = sett.get('videoType', '')
              videoParams.color = ''
            } else if (sett.get('action') === 'Set Background Color') {
              let color = ''
              let colorType = sett.get('color', 'static')
              if (colorType === 'static') {
                color = sett.get('colorStatic', '')
              } else if (colorType === 'field') {
                let colorEl = sett.get('colorEl', '')
                const isPossibleRepeat = detectIsTargetKeyInRepeatEl(colorEl.split(':'), retState)
                const appState = _.assign({}, params, portalState)
                color = _.get(
                  appState,
                  [
                    ...String(colorEl).split(':'),
                    ...isPossibleRepeat && typeof index === 'number' ? [index] : []
                  ],
                  ''
                )
              }
              videoParams.color = color
              videoParams.url = ''
              videoParams.videoType = ''
            } else if (sett.get('action') === 'Reset style') {
              videoParams.color = ''
              videoParams.url = ''
              videoParams.videoType = ''
            }else{
              isApply = false
            }
            if(isApply){
              const isPossibleRepeat = detectIsTargetKeyInRepeatEl(stripPath, retState)
              if (isPossibleRepeat && index !== null && index !== undefined) {
                retState = retState.setIn(['rules', ...stripPath, String(index)], fromJS(videoParams))
              } else if (isPossibleRepeat && (index === null || index === undefined)) {
                let stripState = _.get(portalState, [stripPath[0], stripPath[1]], {})
                let size = getMappingCount(stripState)
                _.times(size, n => {
                  retState = retState.setIn(['rules', ...stripPath, String(n)], fromJS(videoParams))
                })
              } else {
                retState = retState.setIn(['rules', ...stripPath], fromJS(videoParams))
              }
            }
          }
        } else if (key === 'formInteractivity' && !isOnlyEffects) {
          let sett = actionTarget.getIn([0], actionTarget.getIn(['0'], Map()));
          if (sett.getIn(['enabled'])) {
            let [parentUID, formID, formID2] = String(sett.getIn(['form'])).split(':')
            let stripUID = []
            if(retState.getIn(['project', 'Settings', 'RepeatedStripsID'], List()).findIndex(v => v === formID) !== -1){
              stripUID = [formID]
              formID = formID2
            }
            switch (sett.getIn(['action'])) {
              case 'Validate fields': {
                const target = sett.getIn(['form'])
                const mapToEl = sett.getIn(['mapToEl'])
                const targetIndex = index
                const [pageUID, ...rest] = String(target).split(':')
                const state = retState
                const pageID = state.getIn(['project', 'Pages'], List())
                  .find(page => page.get('uid') === pageUID)
                  ?.get?.('_id')
                let component = state.getIn(['pages', pageID, 'Props', 'elements', _.last(rest)]);
                let allElements = state.getIn(['pages', pageID, 'Props', 'elements'], Map())
                if(!component) {
                  allElements = state.getIn(['project', 'Settings','elements'], Map())
                  component = state.getIn(['project', 'Settings','elements', _.last(rest)], Map());
                }
                let isRepeat = isParentRepeat(state, component.get('parent'))
                let repeatUID = getParentRepeatUID(state, component.get('parent'))
                const children = component.get('children', List())
                if (targetIndex !== undefined && targetIndex !== null) {
                  index = parseInt(targetIndex, 10)
                  index = _.isNaN(index) ? null : index
                }

                let errorsList = [];
                let errorFieldsList = []
                const processValidate = uid => {
                  let elem = allElements.getIn([uid], Map());

                    let localRepeatUID = getParentRepeatUID(state, component.get('parent'))
                    const parentElementStatus = getParentRulesStatus(
                      elem.get('parent'),
                      pageID,
                      pageUID,
                        index,
                        uid,
                        localRepeatUID,
                        state
                        );

                    let firstParentUID = getFirstParentElement(state.getIn(['pages', pageID, 'Props', 'elements'], List()), uid)
                      try {
                        let parentRuleRulesPath = isRepeat ? ['rules', pageUID, localRepeatUID, localRepeatUID, index] : ['rules', pageUID,`${firstParentUID}-Col1` ]

                        const parentRuleStatus = state.getIn(parentRuleRulesPath, List());
                        let parentRules = List.isList(parentRuleStatus) ? parentRuleStatus.toJS() : parentElementStatus;

                      if(parentRules.includes('hide')) {
                        return
                      }
                  } catch(err) {
                      console.error(err);
                  }
                  if (['FormField', 'CES', 'Widget'].some(e => e === elem.get('type'))) {
                    const control = elem.getIn(['props', 'control'], 'text')
                    let isListCheckbox = false;
                    if (control == 'checkbox') {
                      isListCheckbox = component.getIn(['props', 'source'], 'single') !== 'single';
                    }
                    const getRepeatPath = (prefix = 'state', isFullValue) => {
                      let propName = [];
                      if (control === 'currency' && prefix !== 'formFieldStatuses' && prefix !== 'rules') {
                        propName = ['value']
                      }
                      if ((LIST_BASED_FIELDS.indexOf(control) > -1 || isListCheckbox || elem.get('type') === 'CES') && prefix == 'state' && !isFullValue) {
                        propName = ['ftListValue'];
                      }
                      return pageUID === 'project'
                        ? isRepeat ? [prefix, parent, repeatUID, uid, ...propName, String(index)]
                          : [prefix, parent, uid, ...propName]
                        : isRepeat ? [prefix, pageUID, repeatUID, uid, ...propName, String(index)]
                          : [prefix, pageUID, uid, ...propName]
                    }
                    let ruleStatus = processValueRules(uid, elem, getRepeatPath, index)(null, () => retState)
                    retState = retState.setIn(getRepeatPath('formFieldStatuses'), fromJS(ruleStatus.ruleStatus))
                    if (ruleStatus.status) {
                      errorFieldsList.push(uid)
                      errorsList.push(ruleStatus.error)
                    }
                  }
                }

                if (isRepeat) {
                  if (targetIndex !== undefined && targetIndex !== null) {
                    index = parseInt(targetIndex, 10)
                    index = _.isNaN(index) ? null : index
                    children.map(processValidate)
                  } else {
                    let repeatState = state.getIn(['state', pageUID, repeatUID], Map())
                    let repeatCount = getMappingCount(repeatState.toJS())
                    if(repeatCount === 0){
                      children.map(processValidate)
                    }else{
                      _.times(repeatCount, repeatIndex => {
                        index = repeatIndex
                        children.map(processValidate)
                      })
                    }

                  }
                } else {
                  children.map(processValidate)
                }
                if (mapToEl) {
                  retState = setValueByField(retState, mapToEl, errorsList.join(', '))
                }

                if (errorFieldsList?.length > 0) {
                  const currentPageID = state.get('page')
                  const tabOrderEnabled = state.getIn(['project', 'Settings', 'ui', 'autoTabOrder'], false)
                  const pageTabOrder = state.getIn(['pages', currentPageID, 'Props', 'TabOrder'], 'auto') === 'auto'
                  const projectTabOrder = state.getIn(['project', 'Settings', 'ui', 'TabOrder'], 'auto') === 'auto'
                  const useAutoTabOrder = currentPageID !== 'project'
                    ? pageTabOrder === 'auto'
                    : projectTabOrder === 'auto'

                  if (tabOrderEnabled && !useAutoTabOrder) {
                    const layoutMode = state.getIn(['layoutMode'], 'lg')
                    errorFieldsList = _.sortBy(
                      errorFieldsList,
                      child => {
                        return parseInt(state.getIn([...getElementDataRoot(currentPageID), 'elements', child, 'props', layoutMode, 'tabOrder'], ''), 10)
                      })
                  }

                  retState = retState.setIn(
                    ['__cache__'],
                    retState.getIn(['__cache__'], List())
                      .push(fromJS({
                        type: 'revealInTabsContainer',
                        payload: {
                          elemUID: errorFieldsList[0],
                          index: originIndex !== undefined ? originIndex : index,
                        }
                      }))
                      .push(fromJS({
                        type: 'set_focus',
                        payload: {
                          uid: errorFieldsList[0],
                          index: originIndex !== undefined ? originIndex : index,
                          noScrollFix: true,
                          noReveal: true,
                          action: sett.get('onInValid', List()),
                          actionOptions: currentRule.get('options', Map())
                        }
                      }))
                  )
                }
                let actions = List()
                if(errorsList.length > 0){
                  // actions =sett.get('onInValid', List())
                }else{
                  actions =sett.get('onValid', List())
                }
                if(List.isList(actions) && actions.size > 0){
                  retState = retState.setIn(
                    ['__cache__'],
                    retState.getIn(['__cache__'], List())
                      .push(fromJS({
                        type: 'runAsyncAction',
                        payload: {
                          action: actions,
                          index:originIndex !== undefined?originIndex:index,
                          options: currentRule.get('options', Map())
                        }
                      }))
                  )
                }
                break;
              }
              case 'Editable Form':
              case 'Read Only Form':
              case 'Disabled':
              case 'Enabled':{
                const target = sett.getIn(['form'])
                const targetIndex = index
                const [pageUID, ...rest] = String(target).split(':')
                const state = retState
                const pageID = state.getIn(['project', 'Pages'], List())
                  .find(page => page.get('uid') === pageUID)
                  ?.get?.('_id')
                let component;

                if (pageID) {
                  component = state.getIn(['pages', pageID, 'Props', 'elements', _.last(rest)], Map())
                } else {
                  //Could be a modal element, search for it in project.Settings
                  component = state.getIn(['project', 'Settings','elements',_.last(rest)])
                }

                if (!component) {
                  break;
                }

                const children = component.get('children', List())

                let isRepeat = isParentRepeat(state, component.get('parent'))
                let repeatUID = getParentRepeatUID(state, component.get('parent'))

                if (targetIndex !== undefined && targetIndex !== null) {
                  index = parseInt(targetIndex, 10)
                  index = _.isNaN(index) ? null : index
                }
                const changeReadOnly = uid => {
                  let elem;
                  if (pageID) {
                    elem = state.getIn(['pages', pageID, 'Props', 'elements', uid], Map())
                  } else {
                    //Could be a modal element, search for it in project.Settings
                    elem = state.getIn(['project', 'Settings','elements', uid], Map())
                  }

                  if (!elem) return

                  if (ALLOW_MANDATORY_TYPE.includes(elem.get('type'))) {
                    const parent = getParentIdInModal(state, component.get('parent'), pageUID === 'project')
                    let keyPath = [pageUID, uid]
                    if (pageUID === 'project') {
                      keyPath = isRepeat
                                ? [parent, repeatUID, uid, String(index)]
                                : [parent, uid]
                    }
                    else if (isRepeat) {
                      keyPath = [pageUID, repeatUID, uid, String(index)]
                    }
                    const oldRules = toJS(retState.getIn(['rules', ...keyPath]))
                    let newRules = fromJS(['disable'])
                    if (sett.getIn(['action']) === 'Read Only Form') {
                      newRules = fromJS(['readOnly'])
                    } else if (sett.getIn(['action']) === 'Editable Form') {
                      newRules = fromJS(['notReadOnly'])
                    } else if (sett.getIn(['action']) === 'Enabled') {
                      newRules = fromJS(['enable'])
                    } else if (sett.getIn(['action']) === 'Disabled') {
                      newRules = fromJS(['disable'])
                    }
                    const ruleState = setNewRules(toJS(oldRules), newRules, keyPath)
                    retState = retState.setIn(
                      ['rules', ...keyPath],
                      ruleState
                    );
                  }
                }

                if (isRepeat) {
                  if (targetIndex !== undefined && targetIndex !== null) {
                    index = parseInt(targetIndex, 10)
                    index = _.isNaN(index) ? null : index
                    children.map(changeReadOnly)
                  } else {
                    let repeatState = state.getIn(['state', pageUID, repeatUID], Map())
                    let repeatCount = getMappingCount(repeatState.toJS())
                    _.times(repeatCount, repeatIndex => {
                      index = repeatIndex
                      children.map(changeReadOnly)
                    })
                  }
                } else {
                  children.map(changeReadOnly)
                }
                break;
              }
              case 'Set as not mandatory':
              case 'Set as mandatory':{
                const target = sett.getIn(['form'])
                const targetIndex = index
                const [pageUID, ...rest] = String(target).split(':')
                const state = retState
                const pageID = state.getIn(['project', 'Pages'], List())
                  .find(page => page.get('uid') === pageUID)
                  ?.get?.('_id')
                let component;

                if (pageID) {
                  component = state.getIn(['pages', pageID, 'Props', 'elements', _.last(rest)], Map())
                } else {
                  //Could be a modal element, search for it in project.Settings
                  component = state.getIn(['project', 'Settings','elements',_.last(rest)])
                }

                if (!component) {
                  break;
                }

                const children = component.get('children', List())

                let isRepeat = isParentRepeat(state, component.get('parent'))
                let repeatUID = getParentRepeatUID(state, component.get('parent'))

                if (targetIndex !== undefined && targetIndex !== null) {
                  index = parseInt(targetIndex, 10)
                  index = _.isNaN(index) ? null : index
                }
                const changeMandatory = uid => {
                  let elem;
                  if (pageID) {
                    elem = state.getIn(['pages', pageID, 'Props', 'elements', uid], Map())
                  } else {
                    //Could be a modal element, search for it in project.Settings
                    elem = state.getIn(['project', 'Settings','elements', uid], Map())
                  }

                  if (!elem) return

                  if (ALLOW_MANDATORY_TYPE.includes(elem.get('type'))) {
                    const parent = getParentIdInModal(state, component.get('parent'), pageUID === 'project')
                    let keyPath = [pageUID, uid]
                    if (pageUID === 'project') {
                      keyPath = isRepeat
                                ? [parent, repeatUID, uid, String(index)]
                                : [parent, uid]
                    }
                    else if (isRepeat) {
                      keyPath = [pageUID, repeatUID, uid, String(index)]
                    }
                    const oldRules = toJS(retState.getIn(['rules', ...keyPath]))
                    let newRules = fromJS(['mandatory'])
                    if (sett.getIn(['action']) === 'Set as not mandatory') {
                      newRules = ['notMandatory']
                    }
                    const ruleState = setNewRules(toJS(oldRules), newRules, keyPath)
                    retState = retState.setIn(
                      ['rules', ...keyPath],
                      ruleState
                    );
                  }
                }

                if (isRepeat) {
                  if (targetIndex !== undefined && targetIndex !== null) {
                    index = parseInt(targetIndex, 10)
                    index = _.isNaN(index) ? null : index
                    children.map(changeMandatory)
                  } else {
                    let repeatState = state.getIn(['state', pageUID, repeatUID], Map())
                    let repeatCount = getMappingCount(repeatState.toJS())
                    _.times(repeatCount, repeatIndex => {
                      index = repeatIndex
                      children.map(changeMandatory)
                    })
                  }
                } else {
                  children.map(changeMandatory)
                }
                break;
              }
              case 'ResetChanged': {
                const target = sett.getIn(['form'])
                let path = String(target).split(':')
                const RepeatedStripsID = toJS(retState.getIn(['project', 'Settings', 'RepeatedStripsID'], List())) || []
                let elemUID = RepeatedStripsID.includes(path[1]) ? path[2] : path[1]
                const elPath = getElementDataRoot(
                  retState.hasIn(['project', 'Settings', 'elements', elemUID]) ? 'project' : retState.get('page')
                )
                let component = retState.getIn([...elPath, 'elements', elemUID], Map())
                let repeatUID = getParentRepeatUID(state, component.get('parent'))
                let isRepeat = isParentRepeat(state, component.get('parent'))
                let isChanged
                if (isRepeat && index !== null && index !== undefined) {
                  retState = retState.setIn(['state', path[0], repeatUID, `${_.last(path)}-isChanged`, String(index)], false)
                  retState = retState.setIn(
                    ['ft', 'changes'],
                    retState.getIn(['ft', 'changes'], List()).push(fromJS([..._.initial(path), `${_.last(path)}-isChanged`, String(index)]))
                  )
                } else {
                  retState = retState.setIn(['state', ..._.initial(path), `${_.last(path)}-isChanged`], false)
                  retState = retState.setIn(
                    ['ft', 'changes'],
                    retState.getIn(['ft', 'changes'], List()).push(fromJS([..._.initial(path), `${_.last(path)}-isChanged`]))
                  )
                }
                break;
              }
              case 'Is Changed':{
                const target = sett.getIn(['form'])
                let path = String(target).split(':')
                const RepeatedStripsID = toJS(retState.getIn(['project', 'Settings', 'RepeatedStripsID'], List())) || []
                let elemUID = RepeatedStripsID.includes(path[1]) ? path[2] : path[1]
                const elPath = getElementDataRoot(
                  retState.hasIn(['project', 'Settings', 'elements', elemUID]) ? 'project' : retState.get('page')
                )
                let component = retState.getIn([...elPath, 'elements', elemUID], Map())
                let repeatUID = getParentRepeatUID(state, component.get('parent'))
                let isRepeat = isParentRepeat(state, component.get('parent'))
                let isChanged
                if (isRepeat && index !== null && index !== undefined) {
                  isChanged = retState.getIn(['state', path[0], repeatUID, `${_.last(path)}-isChanged`, String(index)])
                } else {
                  isChanged = retState.getIn(['state', ..._.initial(path), `${_.last(path)}-isChanged`])
                }
                let actions = List()
                if(isChanged){
                  actions =sett.get('onChanged', List())
                }else{
                  actions =sett.get('onNotChanged', List())
                }
                if(List.isList(actions) && actions.size > 0){
                  retState = retState.setIn(
                    ['__cache__'],
                    retState.getIn(['__cache__'], List())
                      .push(fromJS({
                        type: 'runAsyncAction',
                        payload: {
                          action: actions,
                          index,
                          options: currentRule.get('options', Map()),
                        }
                      }))
                  )
                }
                break;
              }
              case 'Submit': {
                retState = retState.setIn(
                  ['__cache__'],
                  retState.getIn(['__cache__'], List())
                    .push(fromJS({
                      type: 'FormSubmit',
                      payload: {
                        uid: formID,
                        target: sett.getIn(['form']),
                        index
                      }
                    }))
                )
                break;
              }
              case 'Reset': {
                const layoutMode = retState.get('layoutMode', 'lg')
                const pageID = retState.getIn(['project', 'Pages'], List())
                  .find(page => page.get('uid') === parentUID)
                  ?.get?.('_id')
                const elemsPath = (parentUID === 'Header' || parentUID === 'Footer' || pageID === undefined)
                  ? ['project', 'Settings', 'elements']
                  : ['pages', pageID, 'Props', 'elements']
                const children = getAllChildren(
                  retState.getIn(
                    [...elemsPath, formID, 'children'],
                    List()
                  ).toJS(),
                  retState.getIn(elemsPath, Map())
                )
                let changes = []
                _.map(children, childUID => {
                  try {
                    const child = retState.getIn([...elemsPath, childUID], Map())
                    if (stripUID.length > 0) {
                      let type = child.get('type')
                      let defaultVal = undefined
                      if (type === 'FormField') {
                        if (child.getIn(['props', 'control'])) {
                          type = child.getIn(['props', 'control'])
                        }
                        defaultVal = child.getIn(['props', layoutMode, 'value'], '')
                        if (LIST_BASED_FIELDS.includes(type) || type === 'checkbox' ) {
                          defaultVal = getDefaultValueForFormFieldByType(child,layoutMode, type)
                        }
                        if(type === 'lookup'){
                          defaultVal = Map()
                        }
                      }
                      changes.push([parentUID, ...stripUID, childUID])
                      if (child.get('type') === 'FormField') {
                        if ((LIST_BASED_FIELDS.includes(child.getIn(['props', 'control'])) > -1 || child.getIn(['props', 'control']) === 'checkbox' && child.getIn(['props', 'source'], 'single') !== 'single')) {
                          retState = retState
                            .setIn(
                              ['state', parentUID, ...stripUID, childUID, 'ftListValue', String(index)],
                              defaultVal?.ftListValue
                            )
                            .setIn(
                              ['state', parentUID, ...stripUID, childUID, 'ftListLabel', String(index)],
                              defaultVal?.ftListLabel
                            )
                        }
                        if (List.isList(retState.getIn(['state', parentUID, ...stripUID, childUID, 'ftListValue']))) {
                          retState = retState.setIn(
                            ['state', parentUID, ...stripUID, childUID, 'ftListValue', String(index)],
                            defaultVal?.ftListValue
                          )
                        }
                        if (List.isList(retState.getIn(['state', parentUID, ...stripUID, childUID, 'ftListLabel']))) {
                          retState = retState.setIn(
                            ['state', parentUID, ...stripUID, childUID, 'ftListLabel', String(index)],
                            defaultVal?.ftListLabel
                          )
                        }
                        if (child.getIn(['props', 'control']) === 'lookup') {
                          retState = retState
                            .setIn(
                              ['formFieldStatuses', parentUID, ...stripUID, childUID, String(index)],
                              fromJS({ status: 'initial' })
                            )
                            .setIn(
                              ['state', parentUID, ...stripUID, childUID, String(index)],
                              defaultVal
                            )
                        } else if(child.getIn(['props', 'control']) === 'currency'){
                          retState = retState
                            .setIn(
                              ['formFieldStatuses', parentUID, ...stripUID, childUID, String(index)],
                              fromJS({ status: 'initial' })
                            )
                            .setIn(
                              ['state', parentUID, ...stripUID, childUID, 'value', String(index)],
                              defaultVal
                            )
                        } else {
                          retState = retState
                            .setIn(
                              ['formFieldStatuses', parentUID, ...stripUID, childUID, String(index)],
                              fromJS({ status: 'initial' })
                            )
                            .setIn(
                              ['state', parentUID, ...stripUID, childUID, String(index)],
                              defaultVal
                            )
                        }
                      } else if (TAB_TYPES.includes(child.get('type'))) {
                        retState = retState.setIn(
                          ['state', parentUID, ...stripUID, childUID, index],
                          Map()
                        )
                      } else if (child.get('type') === 'Search') {
                        retState = retState.setIn(
                          ['state', parentUID, ...stripUID, childUID, String(index)],
                          ''
                        )
                      }
                    } else {
                      let type = child.get('type')
                      let defaultVal = undefined
                      if (type === 'FormField') {
                        if (child.getIn(['props', 'control'])) {
                          type = child.getIn(['props', 'control'])
                        }
                        defaultVal = child.getIn(['props', layoutMode, 'value'], '')
                        if (LIST_BASED_FIELDS.includes(type) || type === 'checkbox' ) {
                          defaultVal = getDefaultValueForFormFieldByType(child,layoutMode, type)
                        }
                      }
                      changes.push([parentUID, childUID])
                      if (child.get('type') === 'FormField') {
                        retState = retState
                          .setIn(
                            ['formFieldStatuses', parentUID, childUID],
                            fromJS({ status: 'initial' })
                          )
                          .setIn(
                            ['state', parentUID, childUID],
                            fromJS(defaultVal)
                          )
                      } else if (TAB_TYPES.includes(child.get('type'))) {
                        retState = retState.setIn(
                          ['state', parentUID, childUID],
                          Map()
                        )
                      } else if (child.get('type') === 'Search') {
                        retState = retState.setIn(
                          ['state', parentUID, childUID],
                          ''
                        )
                      }
                    }
                  } catch (error) {
                    console.error(error)
                  }
                })
                const target = sett.getIn(['form'])
                let path = String(target).split(':')
                if (detectIsTargetKeyInRepeatEl(path, retState) && index !== null && index !== undefined) {
                  retState = retState.setIn(['state', ..._.initial(path), `${_.last(path)}-isChanged`, String(index)], false)
                  changes.push([..._.initial(path), `${_.last(path)}-isChanged`, index])
                } else {
                  retState = retState.setIn(['state', ..._.initial(path), `${_.last(path)}-isChanged`], false)
                  changes.push([..._.initial(path), `${_.last(path)}-isChanged`])
                }
                retState = retState.setIn(
                  ['ft', 'changes'],
                  fromJS(changes)
                )
                break;
              }
              case 'Next Page': {
                let path = ['FTFORM', parentUID, formID]
                if(stripUID.length > 0){
                  path = ['FTFORM', parentUID, ...stripUID, formID, index]
                }
                const currentPage = retState.getIn(path, '0')
                retState = retState.setIn(path, String(~~currentPage + 1))
                break;
              }
              case 'Prev Page': {
                let path = ['FTFORM', parentUID, formID]
                if(stripUID.length > 0){
                  path = ['FTFORM', parentUID, ...stripUID, formID, index]
                }
                const currentPage = retState.getIn(path, '0')
                if (~~currentPage > 0) {
                  retState = retState.setIn(path, String(~~currentPage - 1))
                }
                break;
              }
              case 'Go to Page': {
                let path = ['FTFORM', parentUID, formID]
                if(stripUID.length > 0){
                  path = ['FTFORM', parentUID, ...stripUID, formID, index]
                }
                let page = ~~sett.getIn(['page'])
                const pageFrom = sett.getIn(['pageFrom'], 'static')
                const fromEl = sett.getIn(['fromEl'], '')
                if (pageFrom === 'static') {
                  if (page > 0) { //page start from 0
                    page = page - 1
                  }
                  retState = retState.setIn(path, page)
                } else if (pageFrom === 'field') {
                  const isPossibleRepeat = detectIsTargetKeyInRepeatEl(fromEl, retState)
                  const appState = _.assign({}, params, portalState)
                  let pageTo = _.get(
                    appState,
                    [
                      ...String(fromEl).split(':'),
                      ...isPossibleRepeat && typeof index === 'number' ? [index] : []
                    ],
                    0
                  )
                  pageTo = parseInt(pageTo, 10)
                  if (pageTo > 0) { //pages start from 0
                    pageTo = pageTo - 1
                  } else if (pageTo < 0) {
                    pageTo = 0
                  }
                  retState = retState.setIn(path, pageTo)
                }
                break;
              }
              // no default
            }
          }
        } else if ((key === 'docGen') && !isOnlyEffects) {
          let sett = actionTarget.getIn([0], actionTarget.getIn(['0'], Map()));
          if (sett.get('enabled')) {
            if (sett.getIn(['method'], 'web') == 'titanSign') {
              if (sett.get('selectedTitanSign')) {
                let recordID = getValueByField(sett.getIn(['recordID'], Map()), params, portalState, index);
                if (recordID) {
                  let recordIdProt = '';
                  if(sett.getIn(['recordID', 'group']) == 'param') {
                    recordIdProt = _.get(params, ['prot_' + sett.getIn(['recordID', 'value'])], '')
                  }
                  let webState = {}
                  sett.get('templateFields', List()).map(field => {
                    if(Map.isMap(field) && field.get('value')){
                      webState[field.get('value')] = toPlainValue(getValueByField(field, params, portalState, index))
                    }
                  })
                  retState = retState.setIn(
                    ['__cache__'],
                    retState.getIn(['__cache__'], List())
                      .push(fromJS({
                        type: 'DocGenTitanSign',
                        payload: {
                          actionID: sett.get('selectedTitanSign'),
                          recordID: recordID,
                          recordIdProt: recordIdProt,
                          mapURLTo: sett.getIn(['mapURLTo'], Map()),
                          callbackAction: sett.getIn(['callbackAction'], 'modal'),
                          titanSignAction: sett.getIn(['titanSignAction'], 'sign'),
                          options: currentRule.get('options', Map()),
                          onSubmit: sett.get('onSubmit'),
                          onClose: sett.get('onClose'),
                          sign: sett.get('sign'),
                          signCancel: sett.get('signCancel'),
                          previewActionsList: sett.get('previewActionsList'),
                          hideDownloadButton: sett.get('hideDownloadButton'),
                          webState,
                          allowDynamicSize: sett.get('allowDynamicSize', false),
                          dynamic: sett.getIn(['dynamic'], Map()),
                          customSizes: sett.getIn(['customSizes'], Map()),
                        }
                      }))
                  )
                }
              }
            } else {
              if (sett.get('selected')) {
                let action = retState.getIn(['project', 'Settings', 'store', 'public', sett.get('selected')]);
                if (action) {
                  if(action.get('type') === 'AUTO_PDF'){
                    let fileName = action.getIn(['fields', 'customFileName'], '');
                    if (action.getIn(['fields', 'isDynamicName'], '')) {
                      fileName = getValueByField(action.getIn(['fields', 'dynamicName'], Map()), params, portalState, index);
                    }
                    let recordID = 'AUTO_PDF'
                    retState = retState.setIn(
                      ['__cache__'],
                      retState.getIn(['__cache__'], List())
                        .push(fromJS({
                          type: 'DocGen',
                          payload: {
                            action: action,
                            actionID: sett.get('selected'),
                            nextNode: sett.get('nextNode'),
                            fileName,
                            recordID,
                            options: currentRule.get('options', Map())
                          }
                        }))
                    )
                  }else{
                    let recordID = getValueByField(action.getIn(['fields', 'recordID'], Map()), params, portalState, index);
                    let recordIdProt = '';
                    if(action.getIn(['fields', 'recordID', 'group']) == 'param') {
                      recordIdProt = _.get(params, ['prot_' + action.getIn(['fields', 'recordID', 'value'])], '')
                    }
                    let fileName = action.getIn(['fields', 'customFileName'], '');
                    if (action.getIn(['fields', 'isDynamicName'], '')) {
                      fileName = getValueByField(action.getIn(['fields', 'dynamicName'], Map()), params, portalState, index);
                    }

                    retState = retState.setIn(
                      ['__cache__'],
                      retState.getIn(['__cache__'], List())
                        .push(fromJS({
                          type: 'DocGen',
                          payload: {
                            action: action,
                            previewActions: action.get('previewActions'),
                            editActions: action.get('editActions'),
                            actionID: sett.get('selected'),
                            nextNode: sett.get('nextNode'),
                            buttonAction: sett.get('action'),
                            fileName,
                            recordID,
                            recordIdProt,
                            options: currentRule.get('options', Map()),
                            onSubmit: sett.get('onSubmit'),
                            onClose: sett.get('onClose'),
                            previewActionsList: sett.get('previewActionsList'),
                            hideDownloadButton: sett.get('hideDownloadButton'),
                          }
                        }))
                    )
                  }
                }
              }
            }
          }
        } else if (isAllowFeatureState('Timer', retState) && (key === 'timerInteractivity') && !isOnlyEffects) {
          let sett = actionTarget.getIn([0], actionTarget.getIn(['0'], Map()));
          if (sett.getIn(['enabled'])) {
            let action = List();
            if(isImmutable(sett.get('onTimeout', List()))) {
              action = sett.get('onTimeout', List()).map(row => {
                if(row && isImmutable(row)) {
                  return row.set(
                    'options',
                    currentRule.get('options', Map())
                      .set('processUID', currentRule.get('processUID'))
                  )
                }
              })
            }

            let onFinish = List();
            if(isImmutable(sett.get('onTimeout', List()))) {
              onFinish = sett.get('onFinish', List())
              .map(row => {
                if(row && isImmutable(row)) {
                  return row.set(
                    'options',
                    currentRule.get('options', Map())
                      .set('processUID', currentRule.get('processUID'))
                  )
                }
              })
            }
            let id = sett.get('id')
            let timerAction = sett.get('action')
            let interval = parseInt(sett.get('interval', ''), 10)
            let intervalType = sett.get('intervalType', 'static')
            const intervalEl = sett.getIn(['intervalEl'], '')
            if (intervalType === 'static') {
              interval = parseInt(sett.get('interval', ''), 10)
            } else if (intervalType === 'field') {
              const isPossibleRepeat = detectIsTargetKeyInRepeatEl(intervalEl, retState)
              const appState = _.assign({}, params, portalState)
              interval = _.get(
                appState,
                [
                  ...String(intervalEl).split(':'),
                  ...isPossibleRepeat && typeof index === 'number' ? [index] : []
                ],
                0
              )
              interval = parseInt(interval, 10)
            }
            let repeat = parseInt(sett.get('repeat', ''), 10)
            let repeatType = sett.get('repeatType', 'static')
            const repeatEl = sett.getIn(['repeatEl'], '')
            if (repeatType === 'static') {
              repeat = parseInt(sett.get('repeat', ''), 10)
            } else if (repeatType === 'field') {
              const isPossibleRepeat = detectIsTargetKeyInRepeatEl(repeatEl, retState)
              const appState = _.assign({}, params, portalState)
              repeat = _.get(
                appState,
                [
                  ...String(repeatEl).split(':'),
                  ...isPossibleRepeat && typeof index === 'number' ? [index] : []
                ],
                0
              )
              repeat = parseInt(repeat, 10)
            }
            retState = retState.setIn(
              ['__cache__'],
              retState.getIn(['__cache__'], List())
                .push(fromJS({
                  type: 'TimerAction',
                  payload: {
                    id,
                    timerAction,
                    action,
                    interval,
                    repeat,
                    index,
                    onFinish
                  }
                }))
            )
          }
        } else if (key === 'TrackerInteractivity' || key === 'AnimatedInteractivity') {
          const isAnimated = key === 'AnimatedInteractivity'
          let sett = actionTarget.getIn([0], actionTarget.getIn(['0'], Map()));
          if (sett.getIn(['enabled'])) {
            const layoutMode = retState.getIn(['layoutMode'], 'lg')
            let pathData = String(sett.getIn(['form'])).split(':')
            const isProjectElm = retState.hasIn(['project', 'Settings', 'elements', _.first(pathData)])
            let parentID = _.first(pathData)
            let stepID = _.last(pathData)
            const pageID = retState.getIn(['project', 'Pages'], List())
              .find(page => page.get('uid') === parentID)
              ?.get?.('_id')
            const [parentUID, ...rest] = String(sett.getIn(['form'])).split(':')
            let component = retState.getIn(
              parentUID === 'Header' || parentUID === 'Footer' || isProjectElm
                ? ['project', 'Settings', 'elements', stepID]
                : ['pages', pageID, 'Props', 'elements', stepID],
              Map()
            )
            let choices = _.flatMap(
              component.getIn(['props', layoutMode, 'options'], List())
                .map(item => item.set(
                  'options',
                  item.get('options', List()).filter(item => !item.get('isHide', false) && !item.getIn(['isRepeatHide', String(index)], false))
                ))
                .filter(item => !item.get('isHide', false) && !item.getIn(['isRepeatHide', String(index)], false) && item.get('options', List()).size > 0)
                .toJS(),
              group => group.options || []
            )
            if (key === 'AnimatedInteractivity') {
              choices = _.flatMap(
                component.getIn(['props', layoutMode, 'options'], List()).toJS(),
                group => group.options || []
              )
            }
            const isPossibleRepeat = detectIsTargetKeyInRepeatEl(String(sett.getIn(['form'])).split(':'), retState)
            if (isAnimated) {
              choices = component.getIn(['props', layoutMode, 'options'], List())
                .filter(item => !item.get('isHide', false) && (isPossibleRepeat ? !item.getIn(['isRepeatHide', String(index)], false) : true))
                .toJS()
            }
            const formID = _.last(rest)
            const path = String(sett.getIn(['form'])).split(':')
            const extraPath = isPossibleRepeat ? [String(index)] : []
            retState = retState.setIn(
              ['ft', 'changes'],
              retState.getIn(['ft', 'changes'], List()).push(fromJS([parentUID, formID]))
            )
            let value = null
            let isFinish = false
            let ftSVGValue = null
            switch (sett.getIn(['action'])) {
              case 'Auto Play':
              case 'Stop Auto Play': {
                const autoPlay = sett.getIn(['action']) === 'Auto Play'
                _.each(LAYOUT_MODE, mode => {
                  component = component.setIn(['props', mode, 'isLottieAutoPlay'], autoPlay)
                })
                retState = retState.setIn(
                  parentUID === 'Header' || parentUID === 'Footer' || isProjectElm
                    ? ['project', 'Settings', 'elements', stepID]
                    : ['pages', pageID, 'Props', 'elements', stepID],
                  component
                )
                const fnName = autoPlay ? 'play' : 'stop'
                const tryCall = (n = 0) => {
                  if (n > 12) { return null }
                  try {
                    const api = _.get(
                      window,
                      ['__FT_PROJECT__LOTTIE__API__', ..._.tail(path), ...extraPath],
                      {}
                    )
                    const fn = api[fnName]
                    if (typeof fn === 'function') {
                      if (fnName === 'play') {
                        const currentValue = retState.getIn(['state', ...path, 'ftListValue', ...extraPath], _.first(choices)?.id || null)
                        let valueIndex = _.findIndex(choices, v => v?.id === currentValue)
                        if (valueIndex !== -1) {
                          value = choices[valueIndex] || {}
                          let playID = value?.meta?._id ? `ft${value?.meta?._id}` : value?.id
                          fn(playID)
                        } else {
                          fn()
                        }
                      } else {
                        fn()
                      }
                    } else {
                      setTimeout(tryCall, 500, n + 1)
                    }
                  } catch (error) {
                    console.error(error)
                  }
                }
                tryCall()
                break;
              }
              case 'Play Layer': {
                let valueIndex = _.findIndex(choices, option => option.id === sett.get('animationID'))
                if (valueIndex !== -1) {
                  value = choices[valueIndex]
                  let playID = value?.meta?._id ? `ft${value?.meta?._id}` : value?.id
                  isFinish = valueIndex === _.size(choices) - 1
                  let layerIndex = _.findIndex(value.layers, val => val.id === sett.get('layerID'))
                  if (layerIndex !== -1) {
                    const layer = value.layers?.[layerIndex]
                    const fnName = 'playSegments'
                    const tryCall = (n = 0) => {
                      if (n > 12) { return null }
                      try {
                        const api = _.get(
                          window,
                          ['__FT_PROJECT__LOTTIE__API__', ..._.tail(path), ...extraPath],
                          {}
                        )
                        const fn = api[fnName]
                        if (typeof fn === 'function') {
                          fn(playID, layer.frames, true)
                        } else {
                          setTimeout(tryCall, 500, n + 1)
                        }
                      } catch (error) {
                        console.error(error)
                      }
                    }
                    setTimeout(tryCall, 50, 0)
                  }
                }
                break;
              }
              case 'Play':
              case 'Pause':
              case 'Stop':
              case 'Destroy': {
                const fnName = _.toLower(sett.getIn(['action']))
                const tryCall = (n = 0) => {
                  if (n > 12) { return null }
                  try {
                    const api = _.get(
                      window,
                      ['__FT_PROJECT__LOTTIE__API__', ..._.tail(path), ...extraPath],
                      {}
                    )
                    const fn = api[fnName]
                    if (typeof fn === 'function') {
                      if (fnName === 'play') {
                        const currentValue = retState.getIn(['state', ...path, 'ftListValue', ...extraPath], _.first(choices)?.id || null)
                        let valueIndex = _.findIndex(choices, v => v?.id === currentValue)
                        if (valueIndex !== -1) {
                          value = choices[valueIndex] || {}
                          let playID = value?.meta?._id ? `ft${value?.meta?._id}` : value?.id
                          fn(playID)
                        } else {
                          fn()
                        }
                      } else {
                        fn()
                      }
                    } else {
                      setTimeout(tryCall, 500, n + 1)
                    }
                  } catch (error) {
                    console.error(error)
                  }
                }
                tryCall()
                break;
              }
              case 'Finish': {
                value = _.last(choices)
                isFinish = true
                break;
              }
              case 'Reset': {
                value = _.first(choices)
                break;
              }
              case 'Next Step': {
                const modChoices = getTrackerVisibleChoices(component, layoutMode);
                const currentValue = retState.getIn(['state', ...path, 'ftListValue', ...extraPath], _.first(modChoices)?.id || null)
                let valueIndex = _.findIndex(modChoices, v => v?.id === currentValue)
                if (valueIndex !== -1) {
                    value = modChoices[valueIndex + 1] || modChoices[valueIndex]
                    if (currentValue === value?.id) {
                      isFinish = true
                    }
                }
                break;
              }
              case 'Prev Step': {
                const currentValue = retState.getIn(['state', ...path, 'ftListValue', ...extraPath], _.first(choices)?.id || null)
                const ftListFinish = retState.getIn(['state', ...path, 'ftListFinish', ...extraPath], false)
                const modChoices = getTrackerVisibleChoices(component, layoutMode);
                let valueIndex = _.findIndex(modChoices, v => v?.id === currentValue)
                if (valueIndex === modChoices.length - 1 && ftListFinish && key !== 'AnimatedInteractivity') {
                  value = modChoices[valueIndex]
                } else if (valueIndex !== -1) {
                    value = modChoices[valueIndex - 1] || modChoices[valueIndex]
                    if(value.type === 'svg' && value?.options?.length > 0){
                      ftSVGValue = _.last(value?.options)?.id
                    }
                }
                break;
              }
              case 'Go to Step': {
                const stateCurrentValue = retState.getIn(['state', ...path, 'ftListValue', ...extraPath], _.first(choices)?.id || null)
                const ftListFinish = retState.getIn(['state', ...path, 'ftListFinish', ...extraPath], false)
                let page = sett.getIn(['page'])
                const pageFrom = sett.getIn(['pageFrom'], 'static')
                const fromEl = sett.getIn(['fromEl'], '')
                if (pageFrom === 'static') {
                  let rootItem;
                  rootItem = _.find(choices, val => val.id === page || val.label === page)
                  if (!rootItem) {
                    //supports format groupID:itemId (mostly for Tracker-go to page)
                    rootItem = _.find(choices, {value:page})
                  }
                  if(rootItem){
                    value = rootItem
                  }else{
                    const item = _.find(choices, val => val.id === page || val.label === page || _.find(val.options, v => v.id === page || v.label === val))
                    if(item){
                      value = item
                      ftSVGValue = _.find(item, val => val.id === page || val.label === page)?.id ?? null
                    }
                  }
                } else if (pageFrom === 'field') {
                  const isPossibleRepeat = detectIsTargetKeyInRepeatEl(fromEl, retState)
                  const appState = _.assign({}, params, portalState)
                  page = _.get(
                    appState,
                    [
                      ...String(fromEl).split(':'),
                      ...isPossibleRepeat && typeof index === 'number' ? [index] : []
                    ],
                    0
                  )
                  let rootItem = _.find(choices, val => val.id === page || val.label === page)
                  if(rootItem){
                    value = rootItem
                  }else{
                    const item = _.find(choices, val => val.id === page || val.label === page || _.find(val.options, v => v.id === page || v.label === val))
                    if(item){
                      value = item
                      ftSVGValue = _.find(item, val => val.id === page || val.label === page)?.id ?? null
                    }
                  }
                }
                if(key === 'TrackerInteractivity' && stateCurrentValue === page){
                  break;
                }
                let valueIndex = _.findIndex(choices, v => v?.id === page)
                if (value && valueIndex===-1) {
                    break;
                } else if (valueIndex === choices.length - 1 && ftListFinish && key !== 'AnimatedInteractivity') {
                  value = choices[valueIndex]
                } else if (valueIndex !== -1) {
                  value = choices[valueIndex]
                  if (stateCurrentValue === value?.id) {
                    isFinish = true
                  }
                }
                break;
              }
              case 'Hide':
              case 'Show': {
                let options = component.getIn(['props', layoutMode, 'options'], List())
                let applyAction = sett.getIn(['action']) === 'Hide'
                let list = sett.getIn(['visibilityList'], List()).toJS()
                _.each(list, item => {
                  let itemIndex = options.findIndex(val => val.get('id') === item.value)
                  if (itemIndex !== -1) {
                    if (isPossibleRepeat) {
                      options = options
                        .deleteIn([itemIndex, 'isHide'])
                        .setIn([itemIndex, 'isRepeatHide', String(index)], applyAction)
                    } else {
                      options = options
                        .setIn([itemIndex, 'isHide'], applyAction)
                    }
                  } else {
                    options = options.map(eItem => {
                      if (eItem.get('options', List()).size > 0) {
                        const nextOptions = eItem.get('options', List()).map(oElem => {
                          if (oElem.get('id') === item.value) {
                            if (isPossibleRepeat) {
                              return oElem
                                .deleteIn(['isHide'])
                                .setIn(['isRepeatHide', String(index)], applyAction)
                            } else {
                              return oElem.setIn(['isHide'], applyAction)
                            }
                          }
                          return oElem
                        })
                        return eItem.set('options', nextOptions)
                      }
                      return eItem
                    })
                  }
                })
                retState = alterTrackerOptions(retState, parentUID, isProjectElm, stepID, layoutMode, pageID, options)
              }
              case 'Change Layer Text': {
                let text = sett.getIn(['text'], '')
                const textFrom = sett.getIn(['textFrom'], 'static')
                const textEl = sett.getIn(['textEl'], '')
                if (textFrom === 'field') {
                  const isPossibleRepeat = detectIsTargetKeyInRepeatEl(textEl, retState)
                  const appState = _.assign({}, params, portalState)
                  text = _.get(
                    appState,
                    [
                      ...String(textEl).split(':'),
                      ...isPossibleRepeat && typeof index === 'number' ? [index] : []
                    ],
                    ''
                  )
                }
                const fromEl = sett.get('form', '')
                const isPossibleRepeat = detectIsTargetKeyInRepeatEl(fromEl, retState)
                const path = [
                  'state',
                  ..._.initial(String(fromEl).split(':')),
                  `${_.last(String(fromEl).split(':'))}-layer`,
                  ...isPossibleRepeat && typeof index === 'number' ? [index] : [],
                  sett.get('layerID', null),
                ]
                retState = safeSetIn(retState, path, reverseIt(text))
                break;
              }
              case 'renameGroup':
                retState = handleRenameGroup(sett, params, component, layoutMode, retState, parentUID, isProjectElm, stepID, pageID);
            }
            if (value) {
              let valId = value.id;
              let valLabel = value.label;
              if(isFinish) {
                valId = '';
                valLabel = '';
              }
              retState = retState
                .setIn(['state', ...path, 'ftListValue', ...extraPath], valId)
                .setIn(['state', ...path, 'ftListLabel', ...extraPath], valLabel)
                .setIn(['state', ...path, 'ftListFinish', ...extraPath], isFinish)
                .setIn(['state', ...path, 'ftSVGValue', ...extraPath], ftSVGValue)
            }
            if (sett.get('scroll') && value?.id) {
              retState = retState.setIn(
                ['__cache__'],
                retState.getIn(['__cache__'], List())
                  .push(fromJS({
                    type: 'StepScrollAction',
                    payload: {
                      scroll: sett.get('scroll'),
                      uid: formID,
                      value: value?.id,
                      index
                    }
                  }))
              )
            }
          }
        } else if ((key === 'stepInteractivity' || key === 'multiStepInteractivity' || key === 'carouselInteractivity' || key === 'tabInteractivity' || key === 'barcodeInteractivity')) {
          let sett = actionTarget.getIn([0], actionTarget.getIn(['0'], Map()));
          if (sett.getIn(['enabled'])) {
            let layoutMode = retState.getIn(['layoutMode'], 'lg')
            const skipValidations = retState.getIn(['project', 'Settings', 'debugModeSettings', 'skipValidations'], false)
            const isPreview = true
            let pathData = String(sett.getIn(['form'])).split(':')
            const isProjectElm = retState.hasIn(['project', 'Settings', 'elements', _.first(pathData)])
            let parentID = _.first(pathData)
            let stepID = _.last(pathData)
            const pageID = retState.getIn(['project', 'Pages'], List())
              .find(page => page.get('uid') === parentID)
              ?.get?.('_id')
            let metaInfo = retState.getIn(['metaInfo', parentID, stepID], Map())
            let metaChoices = retState.getIn(['meta', parentID, stepID], List())

            let tabRules = retState.getIn(['rules', parentID, ...pathData[1] !== _.last(pathData) ? [pathData[1]] : [], `${stepID}-tab`, ...pathData[1] !== _.last(pathData) ? [index] : []], Map())
            const [parentUID, ...rest] = String(sett.getIn(['form'])).split(':')

            let allComponents = retState.getIn(
              parentUID === 'Header' || parentUID === 'Footer' || isProjectElm
                ? ['project', 'Settings', 'elements']
                : ['pages', pageID, 'Props', 'elements'],
              Map()
            )

            let component = retState.getIn(
              parentUID === 'Header' || parentUID === 'Footer' || isProjectElm
                ? ['project', 'Settings', 'elements', stepID]
                : ['pages', pageID, 'Props', 'elements', stepID],
              Map()
            )
            const disableValid = component.getIn(['props', layoutMode, 'disableValid'], false) || skipValidations
            const isStatic = component.getIn(['props', 'source'], 'static') === 'static'
            let choices;
            let tabs = toJS(
              updateTabValue(getValueForMode(component, layoutMode, ['props'], ['tabs'], List()))
            )
            if (!_.isArray(tabs)) {
              tabs = []
            }
            if (isStatic && !isPreview) {
              choices = tabs;
            } else if (isStatic && !metaInfo.get('isDynamic')) {
              choices = tabs;
            } else {
              const children = _.get(_.first(tabs), 'children', []) || []
              choices = metaChoices.map(v => ({
                label: v.get('label'),
                id: v.get('value') || v.get('id'),
                ftValue: v.get('ftValue') || v.get('value') || v.get('id'),
                children
              })).toJS();
            }
            if (isPreview && (component.getIn(['props', layoutMode, 'isRandomize']) || component.getIn(['props', layoutMode, 'isDistinct']))) {
              const children = _.get(tabs, [0, 'children'], []) || []
              choices = _.uniqBy(
                metaChoices.map(v => ({
                  label: v.get('label'),
                  id: v.get('value') || v.get('id'),
                  ftValue: v.get('ftValue') || v.get('value') || v.get('id'),
                  children
                })).toJS(),
                'id'
              );
            }

            choices = _.filter(choices, (tab) => {
              if (tab) {
                if ((tab.hide && !tabRules.get(tab?.id, List()).includes('show') || tabRules.get(tab?.id, List()).indexOf('hide') !== -1) && tabRules.get(tab?.id, List()).indexOf('show') === -1) {
                  return false;
                } else {
                  return true;
                }
              } else {
                return false;
              }
            })
            const isPossibleRepeat = detectIsTargetKeyInRepeatEl(String(sett.getIn(['form'])).split(':'), retState)
            const formID = _.last(rest)
            let path = String(sett.getIn(['form']))
            const pathArray = String(path).split(':')
            if (isPossibleRepeat) {
              path += `:${index}`
              if (key === 'tabInteractivity') {
                pathArray.push(index)
              } else {
                pathArray.push(String(index))
              }
            }
            let stepValue = null
            switch (sett.getIn(['action'])) {
              case 'Finish': {
                const val = _.last(choices)
                retState = retState.setIn(['state', ...path.split(':')], fromJS({
                  ftListValue: val?.ftValue,
                  ftListLabel: val?.label,
                  ftIsFirst: false,
                  ftIsLast: true,
                }))
                retState = addPathToStateChanges(retState, path.split(':'))
                stepValue = val?.ftValue
                retState = retState.setIn(
                  ['__cache__'],
                  retState.getIn(['__cache__'], List())
                    .push(fromJS({
                      type: 'StepAction',
                      payload: {
                        uid: formID,
                        action: component.getIn(['props', 'onFinish'], List()).toJS()
                      }
                    }))
                )
                break;
              }
              case 'Disabled':
              case 'Enabled': {
                if (key === 'barcodeInteractivity') {
                  const action = sett.getIn(['action']);
                  let rulesArray = retState.getIn(['rules', ...String(path).split(":")],List()).toJS();
                  if (action === 'Disabled') //toggle disabled enabled (pause/resume)
                    rulesArray = _.filter(rulesArray, v => v !== 'Enabled' && v !== 'Reset')
                  else
                    rulesArray = _.filter(rulesArray, v => v !== 'Disabled' && v !== 'Reset')

                  rulesArray.push(action);

                  retState = retState.setIn(
                    ['rules', ...String(path).split(":")],
                    setNewRules(retState.getIn(['rules', path], List()), rulesArray, ...String(path).split(":"))
                  );
                }
                break;
              }
              case 'Reset': {
                // const pageID = retState.getIn(['project', 'Pages'], List())
                //   .find(page => page.get('uid') === parentUID)
                //   ?.get?.('_id')
                // const elemsPath = (parentUID === 'Header' || parentUID === 'Footer' || pageID == undefined)
                //   ? ['project', 'Settings', 'elements']
                //   : ['pages', pageID, 'Props', 'elements']
                // const children = retState.getIn(
                //   [...elemsPath, formID, 'children'],
                //   List()
                // )
                // children.map(childUID => {
                //   const child = retState.getIn([...elemsPath, childUID], Map())
                //   if (child.get('type') === 'FormField') {
                //     const defaultVal = getDefaultValueForFormFieldByType(child,layoutMode,child.getIn(['props', 'control']))
                //     retState = retState
                //       .setIn(
                //         ['formFieldStatuses', parentUID, childUID],
                //         fromJS({ status: 'initial' })
                //       )
                //       .setIn(
                //         ['state', parentUID, childUID],
                //         defaultVal
                //       )
                //       .setIn(
                //         ['ft', 'changes'],
                //         retState.getIn(['ft', 'changes'], List()).push(fromJS([parentUID, childUID]))
                //       )
                //   }
                // })
                const val = _.first(choices)
                stepValue = val?.ftValue
                if (key === 'barcodeInteractivity') {
                  retState = retState.setIn(['state', ...path.split(':')], fromJS({}))
                  let rulesArray = retState.getIn(['rules', ...String(path).split(":")],List()).toJS();
                  rulesArray = ['Reset']
                  retState = retState.setIn(
                    ['rules', ...String(path).split(":")],
                    setNewRules(retState.getIn(['rules', path], List()), rulesArray, ...String(path).split(":"))
                  )
                } else {
                  retState = retState.setIn(['state', ...path.split(':')], fromJS({
                    ftListValue: val?.ftValue,
                    ftListLabel: val?.label,
                    ftIsFirst: true,
                    ftIsLast: false
                  }))
                  retState = addPathToStateChanges(retState, path.split(':'))
                }
                retState = retState.setIn(
                  ['__cache__'],
                  retState.getIn(['__cache__'], List())
                    .push(fromJS({
                      type: 'StepAction',
                      payload: {
                        uid: formID,
                        action: val?.action || []
                      }
                    }))
                )
                break;
              }
              case 'Next Step': {
                const currentValue = retState.getIn(['state', ...pathArray, 'ftListValue'], null)
                const currentRules = retState.getIn(['rules', ...pathArray], List())
                if(List.isList(currentRules) && currentRules.includes('hide')){
                  break;
                }
                let cIndex = _.findIndex(choices, v => v?.ftValue === currentValue)
                let isProcessValidation = {};
                if (cIndex === -1) {
                  const val = _.first(choices)
                  retState = retState.setIn(['state', ...pathArray], fromJS({
                    ftListValue: val?.ftValue,
                    ftListLabel: val?.label,
                    ftIsFirst: cIndex === 0,
                    ftIsLast: _.size(choices) - 1 === cIndex,
                  }))
                  retState = addPathToStateChanges(retState, pathArray)
                  stepValue = val?.ftValue
                  retState = retState.setIn(
                    ['__cache__'],
                    retState.getIn(['__cache__'], List())
                      .push(fromJS({
                        type: 'StepAction',
                        payload: {
                          uid: formID,
                          action: val?.action || []
                        }
                      }))
                  )
                } else {
                  if (key === 'carouselInteractivity') {
                    if (cIndex !== -1) {
                      if (component.get('type') === 'CarouselContainer' && !disableValid) {
                        const elements = getAllChildren(_.get(choices, [cIndex, 'children'], []), allComponents)
                        let { isValid, retState: rs } = isElementsValid(elements, retState, isBtnRepeat, index, String(sett.getIn(['form'])).split(':')[1], parentID)
                        retState = rs
                        if (!isValid) {
                          break;
                        }
                      }
                    }
                  } else if (key === 'stepInteractivity' || key === 'multiStepInteractivity') {
                    if (cIndex !== -1) {
                      if (['Stepper', 'MultiStepper'].includes(component.get('type')) && !disableValid) {
                        const elements = getAllChildren(_.get(choices, [cIndex, 'children'], []), allComponents)
                        let list = [];
                        let componentParentRoot = getParentIdInModal(retState, component.get('parent'), isProjectElm)
                        let parentType = retState.getIn([...getElementDataRoot(isProjectElm ? 'project' : retState.get('page')), 'elements', componentParentRoot, 'type'])
                        let useParentID = ['Modal', 'DrawerEl'].includes(parentType) ? componentParentRoot : parentID

                        _.each(elements, (uid)=>{
                          let parentRepeat = getRepeatParent(retState, uid, isProjectElm)

                          if(parentRepeat) {
                            list.push(`${useParentID}:${parentRepeat}:${uid}`);
                          } else {
                            list.push(`${useParentID}:${uid}`);
                          }
                        })
                        isProcessValidation = {
                          status:true,
                          elements:list,
                          scroll:sett.get('scroll'),
                          index
                        }
                      }
                    }
                  }

                  const val = choices[cIndex + 1]
                  if (val) {
                    if(isProcessValidation && !disableValid) {
                      isProcessValidation.value = {
                        path:['state', ...pathArray],
                        value:{
                          ftListValue: val?.ftValue,
                          ftListLabel: val?.label,
                          ftIsFirst: cIndex + 1 === 0,
                          ftIsLast: _.size(choices) - 1 == cIndex + 1,
                        }
                      }
                    } else {
                      retState = retState.setIn(['state', ...pathArray], fromJS({
                        ftListValue: val?.ftValue,
                        ftListLabel: val?.label,
                        ftIsFirst: cIndex + 1 === 0,
                        ftIsLast: _.size(choices) - 1 == cIndex + 1,
                      }))
                      retState = addPathToStateChanges(retState, pathArray)
                    }
                    stepValue = val?.ftValue
                    retState = retState.setIn(
                      ['__cache__'],
                      retState.getIn(['__cache__'], List())
                        .push(fromJS({
                          type: 'StepAction',
                          payload: {
                            uid: formID,
                            action: val?.action || [],
                            isProcessValidation
                          }
                        }))
                    )
                  }
                }
                break;
              }
              case 'Prev Step': {
                const currentValue = retState.getIn(['state', ...pathArray, 'ftListValue'], null)
                let index = _.findIndex(choices, v => v?.ftValue === currentValue)
                if (index === -1) {
                  const val = _.first(choices)
                  retState = retState.setIn(['state', ...pathArray], fromJS({
                    ftListValue: val?.ftValue,
                    ftListLabel: val?.label,
                    ftIsFirst: index === 0,
                    ftIsLast: _.size(choices) - 1 === index,
                  }))
                  retState = addPathToStateChanges(retState, pathArray)
                  stepValue = val?.ftValue
                  retState = retState.setIn(
                    ['__cache__'],
                    retState.getIn(['__cache__'], List())
                      .push(fromJS({
                        type: 'StepAction',
                        payload: {
                          uid: formID,
                          action: val?.action || []
                        }
                      }))
                  )
                } else {
                  const val = choices[index - 1]
                  if (val) {
                    retState = retState.setIn(['state', ...pathArray], fromJS({
                      ftListValue: val?.ftValue,
                      ftListLabel: val?.label,
                      ftIsFirst: index - 1 === 0,
                      ftIsLast: _.size(choices) - 1 === index -1,
                    }))
                    retState = addPathToStateChanges(retState, pathArray)
                    stepValue = val?.ftValue
                    retState = retState.setIn(
                      ['__cache__'],
                      retState.getIn(['__cache__'], List())
                        .push(fromJS({
                          type: 'StepAction',
                          payload: {
                            uid: formID,
                            action: val?.action || []
                          }
                        }))
                    )
                  }
                }
                break;
              }
              case 'Go to Step': {
                const currentRules = retState.getIn(['rules', ...pathArray], List())
                let layoutMode = retState.getIn(['layoutMode'], 'lg')
                const disableValid = component.getIn(['props', layoutMode, 'disableValid'], false) || component.getIn(['props', layoutMode, 'allowStepSkip']) || skipValidations
                let page = sett.getIn(['page'])
                const pageFrom = sett.getIn(['pageFrom'], 'static')
                const fromEl = sett.getIn(['fromEl'], '')
                if (pageFrom === 'static') {
                  if(/^[0-9]*$/.test(page)){
                    page = ~~page
                    if (page > 0) { //page start from 0
                      if (!sett.getIn(['directIndex'])) {
                        page = page - 1
                      }
                    }
                  }else{
                    page = _.findIndex(choices, val => val.id === page || val.value === page || val.label === page || val.ftValue === page)
                    if(page === -1){
                      page = 0
                    }
                  }
                } else if (pageFrom === 'field') {
                  const isPossibleRepeat = detectIsTargetKeyInRepeatEl(fromEl, retState)
                  const appState = _.assign({}, params, portalState)
                  let pageTo = _.get(
                    appState,
                    [
                      ...String(fromEl).split(':'),
                      ...isPossibleRepeat && typeof index === 'number' ? [index] : []
                    ],
                    0
                  )
                  pageTo = parseInt(pageTo, 10)
                  if (pageTo > 0) { //pages start from 0
                    pageTo = pageTo - 1
                  } else if (pageTo < 0) {
                    pageTo = 0
                  }
                  page = pageTo
                }
                const currentValue = retState.getIn(['state', ...pathArray, 'ftListValue'], null)
                let cIndex = _.findIndex(choices, v => v?.ftValue === currentValue)
                let val = choices[page]
                if (val) {
                  if(List.isList(currentRules) && currentRules.includes('hide') && cIndex < page){
                    break;
                  }
                  if (key === 'stepInteractivity' || key === 'multiStepInteractivity') {
                    if (page !== -1) {
                      if (['Stepper', 'MultiStepper'].includes(component.get('type')) && !(disableValid || skipValidations)) {
                        let valid = true
                        for (let i = cIndex; i < page; i++) {
                          const elements = getAllChildren(_.get(choices, [i, 'children'], []), allComponents)
                          let { isValid, retState: rs } = isElementsValid(elements, retState, isBtnRepeat, index, String(sett.getIn(['form'])).split(':')[1], parentID)
                          if (!isValid && valid) {
                            valid = false
                            val = choices[i]
                          }
                          retState = rs
                        }
                        if (!valid) {
                          let valIndex = _.findIndex(choices, v => v.ftValue === val?.id)
                          retState = retState.setIn(['state', ...pathArray], fromJS({
                            ftListValue: val?.ftValue,
                            ftListLabel: val?.label,
                            ftIsFirst: valIndex === 0,
                            ftIsLast: _.size(choices) - 1 === valIndex,
                          }))
                          retState = addPathToStateChanges(retState, pathArray)
                          stepValue = val?.ftValue
                          retState = retState.setIn(
                            ['__cache__'],
                            retState.getIn(['__cache__'], List())
                              .push(fromJS({
                                type: 'StepAction',
                                payload: {
                                  uid: formID,
                                  action: val?.action || []
                                }
                              }))
                          )
                          break;
                        }
                      }
                    }
                  }

                  let valIndex = _.findIndex(choices, v => (v.ftValue === val?.id || v.id === val?.id))
                  retState = retState.setIn(['state', ...pathArray], fromJS({
                    ftListValue: val?.ftValue,
                    ftListLabel: val?.label,
                    ftIsFirst: valIndex === 0,
                    ftIsLast: _.size(choices) - 1 === valIndex,
                  }))
                  retState = addPathToStateChanges(retState, pathArray)
                  stepValue = val?.ftValue
                  retState = retState.setIn(
                    ['__cache__'],
                    retState.getIn(['__cache__'], List())
                      .push(fromJS({
                        type: 'StepAction',
                        payload: {
                          uid: formID,
                          action: val?.action || []
                        }
                      }))
                  )
                }
                break;
              }
            }
            if (sett.get('scroll')) {
              retState = retState.setIn(
                ['__cache__'],
                retState.getIn(['__cache__'], List())
                  .push(fromJS({
                    type: 'StepScrollAction',
                    payload: {
                      scroll: sett.get('scroll'),
                      uid: formID,
                      value: stepValue,
                      index
                    }
                  }))
              )
            }
          }
        } else if (key === 'TextReviewInteractivity') {
          const { path, state } = handleTextReviewInteractivity(actionTarget, retState, index);

          retState = retState.setIn(
            ['__cache__'],
            retState
              .getIn(['__cache__'], List())
              .push(fromJS({
                type: 'TextReviewInteractivityAction',
                payload: {
                  path,
                  state
                }
              }))
          );
        } else if (key === 'pageInteractivity' && !isOnlyEffects) {
          let sett = actionTarget.getIn([0], actionTarget.getIn(['0'], Map()));
          if (sett.getIn(['enabled'])) {
            retState = retState.setIn(
              ['__cache__'],
              retState.getIn(['__cache__'], List())
                .push(fromJS({
                  type: 'PageAction',
                  payload: {
                    action: sett.getIn(['action'])
                  }
                }))
            )
          }
        } else if ((key === 'actionFlow') && !isOnlyEffects) {
          if (currentRule.get('modeType') === 'flow'
            && actionTarget.getIn(['0', 'enabled'], true)
            && actionTarget.getIn(['0', 'list'], List()).size > 1
            ) {
              let localCurentRule = currentRule;
              if(localCurentRule && isImmutable(localCurentRule) && processMeta) {
                localCurentRule = localCurentRule.set('processMeta', fromJS(processMeta));
              }
                const current = actionTarget.getIn(['0', 'list'], List())
                  .find(node => node.get('type') === 'input')
                  ?.get?.('id');
                retState = retState.setIn(
                  ['__cache__'],
                  retState.getIn(['__cache__'], List())
                    .push(fromJS({
                      type: 'FlowActionStep',
                      payload: {
                        list: actionTarget.getIn(['0', 'list'], List()),
                        elemUID: actionTarget.getIn(['0', 'elemUID']),
                        current,
                        index,
                        currentRule:localCurentRule,
                        currentSingleRule,
                        isOnlyEffects,
                        path,
                        oldState,
                        oldParams,
                        processUID: currentRule.getIn(['options', 'processUID']) || processUID
                      }
                    }))
                );
              }
        } else if ((key === 'accordionInteractivity' || key === 'continualFormInteractivity')) {
          let sett = actionTarget.getIn([0], actionTarget.getIn(['0'], Map()));
          if (sett.getIn(['enabled'])) {
            let layoutMode = retState.getIn(['layoutMode'], 'lg')
            const skipValidations = retState.getIn(['project', 'Settings', 'debugModeSettings', 'skipValidations'], false)
            const isPreview = sett.getIn(['isPreview'], true)
            const parentID = _.first(String(sett.getIn(['form'])).split(':'))
            const stepID = _.last(String(sett.getIn(['form'])).split(':'))
            const pageID = retState.getIn(['project', 'Pages'], List())
              .find(page => page.get('uid') === parentID)
              ?.get?.('_id')
            let metaInfo = retState.getIn(['metaInfo', pageID, stepID], Map())
            let metaChoices = retState.getIn(['meta', pageID, stepID], List())

            let component = retState.getIn(['pages', pageID, 'Props', 'elements', stepID]);
            if(!component) {
              component = retState.getIn(['project', 'Settings', 'elements', stepID], Map());
            }

            let elemPath = String(sett.getIn(['form'])).split(':')
            let tabRules = retState.getIn(['rules', ..._.initial(elemPath), `${stepID}-tab`], Map())

            const notPageCondForm = component.get('type') !== 'PageConditionalForm'
            const isStatic = !notPageCondForm
              ? true
              : component.getIn(['props', 'source'], 'static') === 'static'
            const disableValid = component.getIn(['props', layoutMode, 'disableValid'], false) || !isPreview || skipValidations
            let choices;
            let tabs = toJS(
              getValueForMode(component, layoutMode, ['props'], ['tabs'], List())
            )
            if (!_.isArray(tabs)) {
              tabs = []
            }
            if (!notPageCondForm) {
              tabs = makeFormViewList(component, layoutMode, retState)
            }
            if (isStatic && isPreview || !notPageCondForm) {
              choices = tabs;
            } else if (isStatic && !metaInfo.get('isDynamic') && notPageCondForm) {
              choices = tabs;
            } else {
              const children = _.get(_.first(tabs), 'children', []) || []
              choices = metaChoices.map(v => ({
                label: v.get('label'),
                id: v.get('value') || v.get('id'),
                children
              })).toJS();
            }
            if (isPreview && notPageCondForm && (component.getIn(['props', layoutMode, 'isRandomize']) || component.getIn(['props', layoutMode, 'isDistinct']))) {
              const children = _.get(tabs, [0, 'children'], []) || []
              choices = _.uniqBy(
                metaChoices.map(v => ({
                  label: v.get('label'),
                  id: v.get('value') || v.get('id'),
                  children
                })).toJS(),
                'id'
              );
            }
            const isEmailProject = retState.getIn(['project', 'ProjectType']) === 'surveyEmail'
            choices = _.filter(choices, (tab) => {
              if (tab) {
                if(isEmailProject && tab.isStart){
                  return false
                }
                if (tab?.hide === true && !tabRules.get(tab?.id, List()).includes('show') ||
                  tabRules.get(tab?.id, List()) &&
                  tabRules.get(tab?.id, List()).indexOf('hide') !== -1 &&
                  tabRules.get(tab?.id, List()).indexOf('show') === -1
                ) {
                  return false;
                } else {
                  return true;
                }
              } else {
                return false;
              }
            })

            const [parentUID, formID] = String(sett.getIn(['form'])).split(':')
            const path = String(sett.getIn(['form']))
            switch (sett.getIn(['action'])) {
              case 'Finish': {
                retState = retState.setIn(
                  ['__cache__'],
                  retState.getIn(['__cache__'], List())
                    .push(fromJS({
                      type: 'StepAction',
                      payload: {
                        uid: formID,
                        action: component.getIn(['props', 'onFinish'], List()).toJS()
                      }
                    }))
                )
                break;
              }
              case 'Go to Step': {
                let page = sett.getIn(['page'])
                const pageFrom = sett.getIn(['pageFrom'], 'static')
                const fromEl = sett.getIn(['fromEl'], '')
                if (pageFrom === 'static') {
                  if (/^[0-9]*$/.test(page)) {
                    page = ~~page
                    if (page > 0) { //page start from 0
                      if (!sett.getIn(['directIndex'])) {
                        page = page - 1
                      }
                    }
                    page = choices[page]
                  } else {
                    page = _.find(choices, val => val.ftValue === page || val.id === page || val.value === page || val.label === page)
                    if (page === -1) {
                      page = 0
                    }
                  }
                } else if (pageFrom === 'field') {
                  const isPossibleRepeat = detectIsTargetKeyInRepeatEl(fromEl, retState)
                  const appState = _.assign({}, params, portalState)
                  let pageTo = _.get(
                    appState,
                    [
                      ...String(fromEl).split(':'),
                      ...isPossibleRepeat && typeof index === 'number' ? [index] : []
                    ],
                    null
                  )
                  page = _.find(choices, v => v.ftValue === pageTo || v.id === pageTo || v.label === pageTo)
                }
                const val = page
                if (val) {
                  if ((component.get('type') === 'PageConditionalForm' || component.get('type') === 'ConditionalForm' || component.get('type') === 'ContinualForm') && !disableValid) {
                    const elements = _.get(choices, [page, 'children'], [])
                    let { isValid, retState: rs } = isElementsValid(elements, retState, isBtnRepeat, index, String(sett.getIn(['form'])).split(':')[1], parentID)
                    retState = rs
                    if (!isValid) {
                      break;
                    }
                  }

                  const path = String(sett.getIn(['form']))
                  retState = retState.setIn(['state', ...path.split(':')], fromJS({
                    ftListValue: val?.ftValue || val?.id,
                    ftListLabel: val?.label
                  }))
                  retState = retState.setIn(
                    ['__cache__'],
                    retState.getIn(['__cache__'], List())
                      .push(fromJS({
                        type: 'AccordionActionAction',
                        payload: {
                          uid: formID,
                          action: val?.action || []
                        }
                      }))
                  )
                }
                break;
              }
              case 'Reset': {
                retState = retState.setIn(['state', ...path.split(':')], fromJS({
                  ftListValue: null,
                  ftListLabel: null
                }))
                retState = retState.setIn(
                  ['__cache__'],
                  retState.getIn(['__cache__'], List())
                    .push(fromJS({
                      type: 'AccordionActionAction',
                      payload: {
                        uid: formID,
                        action: []
                      }
                    }))
                )
                break;
              }
              case 'Next': {
                const currentValue = retState.getIn(['state', ...path.split(':'), 'ftListValue'], null)
                let cIndex = currentValue === null ? 0 : _.findIndex(choices, v => (v?.id === currentValue || v?.ftValue === currentValue))
                if (cIndex !== -1) {
                  if ((component.get('type') === 'PageConditionalForm' || component.get('type') === 'ConditionalForm' || component.get('type') === 'ContinualForm') && !disableValid) {
                    const elements = _.get(choices, [cIndex, 'children'], [])
                    let { isValid, retState: rs } = isElementsValid(elements, retState, isBtnRepeat, index, String(sett.getIn(['form'])).split(':')[1], parentID)
                    retState = rs
                    if (!isValid) {
                      break;
                    }
                  }
                }
                if (cIndex === -1) {
                  const val = choices[1];
                  const path = String(sett.getIn(['form']))
                  retState = retState.setIn(['state', ...path.split(':')], fromJS({
                    ftListValue: val?.id,
                    ftListLabel: val?.label
                  }))
                  retState = retState.setIn(
                    ['__cache__'],
                    retState.getIn(['__cache__'], List())
                      .push(fromJS({
                        type: 'AccordionAction',
                        payload: {
                          uid: formID,
                          action: val?.action || []
                        }
                      }))
                  )
                } else {
                  const val = choices[cIndex + 1]
                  if (val) {
                    const path = String(sett.getIn(['form']))
                    retState = retState.setIn(['state', ...path.split(':')], fromJS({
                      ftListValue: val?.ftValue || val?.id,
                      ftListLabel: val?.label
                    }))
                    retState = retState.setIn(
                      ['__cache__'],
                      retState.getIn(['__cache__'], List())
                        .push(fromJS({
                          type: 'AccordionAction',
                          payload: {
                            uid: formID,
                            action: val?.action || []
                          }
                        }))
                    )
                  }
                }
                break;
              }
              case 'Prev': {
                const currentValue = retState.getIn(['state', ...path.split(':'), 'ftListValue'], null)
                let index = _.findIndex(choices, v => v?.ftValue === currentValue || v?.id === currentValue)
                if (index === -1) {
                  const val = _.first(choices)
                  const path = String(sett.getIn(['form']))
                  retState = retState.setIn(['state', ...path.split(':')], fromJS({
                    ftListValue: val?.ftValue || val?.id,
                    ftListLabel: val?.label
                  }))
                  retState = retState.setIn(
                    ['__cache__'],
                    retState.getIn(['__cache__'], List())
                      .push(fromJS({
                        type: 'AccordionAction',
                        payload: {
                          uid: formID,
                          action: val?.action || []
                        }
                      }))
                  )
                } else {
                  const val = choices[index - 1]
                  if (val) {
                    const path = String(sett.getIn(['form']))
                    retState = retState.setIn(['state', ...path.split(':')], fromJS({
                      ftListValue: val?.ftValue || val?.id,
                      ftListLabel: val?.label
                    }))
                    retState = retState.setIn(
                      ['__cache__'],
                      retState.getIn(['__cache__'], List())
                        .push(fromJS({
                          type: 'AccordionAction',
                          payload: {
                            uid: formID,
                            action: val?.action || []
                          }
                        }))
                    )
                  }
                }
                break;
              }
            }
          }
        } else if (key === 'redirect' && !isOnlyEffects) {
          if (actionTarget.getIn([0, 'enabled']) && actionTarget.getIn([0, 'customURL']) && actionTarget.getIn([0, 'isForce'])) {
            requestAnimationFrame(() => {
              window.location.href = actionTarget.getIn([0, 'customURL'])
            })
          } else if (actionTarget.getIn([0, 'enabled'])) {
            const type = actionTarget.getIn([0, 'redirect', 'type'])
            const group = actionTarget.getIn([0, 'redirect', 'group'])
            const isForce = actionTarget.getIn([0, 'redirect', 'isForce'])
            const redirectData = toJS(actionTarget.getIn([0, 'redirect'], { value: 'other' }))
            const redirect = updateOldValue(toJS(actionTarget.getIn([0, 'redirect'], { value: 'other' })).value)
            const target = actionTarget.getIn([0, 'target'], 'self')
            let otherURL = ''
            let cacheType = 'redirect', cacheUID;

            if (['redirectToCatalog', 'redirectToCart', 'redirectToCheckout', 'redirectToProduct'].indexOf(redirectData.value) > -1) {
              cacheType = redirectData.value;
              cacheUID = redirectData.value;
            } else if (group === 'envParam') {
              cacheType = 'redirectToEnvParams';
              cacheUID = redirectData.value;
            } else if (type === 'param' || type === 'pageParam') {
              const appState = _.assign({}, params, portalState)
              const valID = String(actionTarget.getIn([0, 'redirect', 'value'], '')).replace(/:/g, '.')
              const val = _.get(appState, valID, '')
              cacheType = 'redirectToPage';
              cacheUID = val
            } else if (redirectData.type === 'page' && target == 'self') {
              cacheType = 'redirectToPage';
              cacheUID = redirectData.value;
            } else if (redirectData.type === 'page') {
              let page = retState.getIn(['project', 'Pages'], List()).find(page => page.get('uid') === redirectData.value)
              if (page) {
                if (typeof window?.__FT_PROJECT__API__?.FTGetPortalURL === 'function') {
                  otherURL = window.__FT_PROJECT__API__.FTGetPortalURL(`/${page.get('url')}`);
                } else {
                  otherURL = `//${location.host}/ftproject/${retState.getIn(['project', 'URL'])}/${page.get('url')}`
                }
                if (String(location.href).indexOf('ftnocache') > -1 && String(otherURL).indexOf('ftnocache') == -1) {
                  otherURL += '?ftnocache';
                  let params = parseURLParameters();
                  if(String(params.ftnocache).length) {
                    otherURL += '=' + params.ftnocache;
                  }
                }
              }
            } else if (redirectData.value === 'other' && actionTarget.getIn([0, 'customURL'])) {
              otherURL = actionTarget.getIn([0, 'customURL'], '')
            } else if (String(redirect).indexOf(':') == -1) {
              otherURL = _.get(params, redirect.split(':'), '')
            } else {
              let localData = portalState;
              let pathToData = [
                ...String(redirect).split(':')
              ];


              otherURL = _.get(localData, pathToData, '');
              if (isBtnRepeat && index !== undefined && index !== null) {
                if (_.isArray(otherURL) || (otherURL && typeof otherURL == 'object')) {
                  otherURL = _.get(otherURL, [index])
                }
              }
            }
            let modalParams = {}
            const appState = _.assign(
              {},
              params,
              portalState
            )
            if (actionTarget.getIn([0, 'typeOfRedirect'], '') == 'Internal') {
              actionTarget.getIn([0, 'internalRedirectParams'], Map()).map((row, name) => {
                if (name && String(name).length > 0) {
                  if (row.get('valueType', 'value') == 'value') {
                    modalParams[name] = row.get('value', '')
                  } else {
                    let field = row.get('field', '')
                    const [fieldKey, group] = String(updateOldValue(field)).split('##-##')
                    if (group === 'pageParam') {
                      modalParams[name] = _.get(
                        appState,
                        [
                          ...String(fieldKey)
                            .split(':')
                        ],
                        ''
                      )
                    } else if (group === 'param') {
                      modalParams[name] = _.get(params, String(fieldKey)
                        .replace(/\:/g, '.'), '')
                    } else if (_.startsWith(group, 'tableWidget')) {
                      let key = String(fieldKey).split(':')
                      key = [
                        ..._.initial(key),
                        index,
                        _.last(key)
                      ]
                      modalParams[name] = _.get(
                        appState,
                        key,
                        ''
                      )
                    } else {
                      let path = String(fieldKey).split(':');
                      if ((isBtnRepeat && index !== undefined && index !== null)) {
                        if (_.isArray(_.get(appState, path))) {
                          path.push(index)
                        }
                      }

                      modalParams[name] = _.get(appState, path, '');
                    }
                  }
                }
              })
              if (target == 'self') {
                let pageJobs = retState.getIn(['pageJob'], List());
                pageJobs = pageJobs.push(fromJS({
                  action: 'set_page_params',
                  params: modalParams
                }))
                retState = retState.setIn(['pageJob'], pageJobs);
                modalParams = {};
              } else if (target == 'modal') {
                modalParams['ft_internal_open'] = true;

              }
            } else {
              actionTarget.getIn([0, 'redirectParams'], Map()).map((name, field) => {
                if (name && String(name).length > 0) {
                  const [fieldKey, group] = String(updateOldValue(field)).split('##-##')
                  if (group === 'param') {
                    modalParams[name] = _.get(params, String(fieldKey)
                      .replace(/\:/g, '.'), '')
                  } else if (_.startsWith(group, 'tableWidget')) {
                    let key = String(fieldKey).split(':')
                    key = [
                      ..._.initial(key),
                      index,
                      _.last(key)
                    ]
                    modalParams[name] = _.get(
                      portalState,
                      key,
                      ''
                    )
                  } else if(group) {
                    let path = String(fieldKey).split(':');

                    if ((isBtnRepeat && index !== undefined && index !== null)) {
                      if (_.isArray(_.get(appState, path))) {
                        path.push(index)
                      }
                    }

                    modalParams[name] = _.get(appState, path, '');
                  }
                }
              })
            }
            let isDisabled = false;
            try {
              if (window) {
                if (actionTarget.getIn([0, 'typeOfRedirect'], '') == 'Internal') {
                  if(!actionTarget.getIn([0, 'redirect', 'value'], '')) {
                    isDisabled = true;
                  }
                } else if (String(window.location.href).indexOf('ftDisableRedirect') > -1) {
                  isDisabled = true;
                }
              }
            } catch (err) {
              console.error(err);
            }
            if (!isDisabled && (otherURL || cacheUID)) {

              const redirectParams = []
              _.each(modalParams, (v, k) => redirectParams.push(`${k}=${encodeURIComponent(v)}`))
              if (actionTarget.getIn([0, 'typeOfRedirect'], '') == 'Internal' && actionTarget.getIn([0, 'disableRedirectInside'], false)) {
                redirectParams.push('ftDisableRedirect=1');
              }
              let modalWidth = actionTarget.getIn([0, 'width'], '')
              let modalHeight = actionTarget.getIn([0, 'height'], '')
              if(actionTarget.getIn([0, 'allowDynamicSize'])){
                let layoutMode = retState.getIn(['layoutMode'], 'lg')
                let deviceWidth = actionTarget.getIn([0, 'dynamic', layoutMode, 'width'])
                if(deviceWidth){
                  modalWidth = deviceWidth
                }
                let deviceHeight = actionTarget.getIn([0, 'dynamic', layoutMode, 'height'])
                if(deviceHeight){
                  modalHeight = deviceHeight
                }
              }
              let modalTitle = compileMessageWithValues(actionTarget.getIn([0, 'customTitle','settings', 'expression'], ''), params, portalState, isBtnRepeat, path, index, retState, true)
              const allowCustomTitle = actionTarget.getIn([0, 'allowCustomTitle'], false)
              retState = retState.setIn(
                ['__cache__'],
                retState.getIn(['__cache__'], List())
                  .push(fromJS({
                    type: cacheType,
                    payload: {
                      uid: cacheUID,
                      isForce: isForce,
                      target,
                      positionOfModal: actionTarget.getIn([0, 'positionOfModal'], 'center'),
                      forceEmbedPosition: actionTarget.getIn([0, 'forceEmbedPosition'], false),
                      uri: otherURL + (String(otherURL).indexOf('?') === -1 ? '?' : '&') + redirectParams.join('&'),
                      ...target === 'modal' ? {
                        allowCustomTitle,
                        modalTitle,
                        uri: otherURL,
                        isExternal: actionTarget.getIn([0, 'typeOfRedirect'], '') != 'Internal',
                        isScrolling: actionTarget.getIn([0, 'isScrolling'], true),
                        width: modalWidth,
                        height: modalHeight,
                        hideMenu: actionTarget.getIn([0, 'hideMenu'], ''),
                        isHideHeader: actionTarget.getIn([0, 'isHideHeader'], false),
                        params: redirectParams,
                        ...window.self !== window.top ? { top: currentRule.getIn(['options', 'modalTop']) } :{},
                        clientY: currentRule.getIn(['options', 'clientY'], window.ftLastClientY)
                      } : {
                        params: redirectParams.join('&')
                      }
                    }
                  }))
              )
            } else if (!isDisabled) {
              if (String(location.href).includes('ftnocache')) {
                console.log('Redirecting to a non existing page/URL')
              }
              try {
                if (actionTarget.getIn([0, 'typeOfRedirect'], '') == 'Internal' && actionTarget.getIn([0, 'redirect'])) {
                  requestAnimationFrame(() => {
                    window.__FT_PROJECT__API__.navigation.page404()
                  })
                }
              } catch (error) {
                console.log('>>>', error)
              }
            }
          }
        } else {
          actionTarget.map((action, key) => {
            if (!isImmutable(action)) { action = Map() }
            let additionalPath = index !== null && typeof index !== 'undefined' && isPossibleRepeat ? [index] : [];
            let elemType = action.get('elemType');

            if (elemType === ELEM_TYPES.PAGE_PARAM) {
              additionalPath = [];
            }
            if (elemType === ELEM_TYPES.FIELD) {
              keyPath = String(keyIndex).split(':');
              keyPath = [
                ...keyPath,
                ...additionalPath,
              ];
            }
            else if (elemType === ELEM_TYPES.LIST_FIELD) {
              keyPath = String(keyIndex).split(':');
              keyPath = [
                ...keyPath,
                ...additionalPath,
              ];
            }
            else if (elemType === ELEM_TYPES.TABLE_FIELD) {
              keyPath = String(keyIndex).split(':');
              keyPath = [
                ..._.initial(keyPath),
                ...additionalPath,
                _.last(keyPath)
              ];
            }
            else {
              keyPath = String(keyIndex).split(':')
              keyPath = [
                ...keyPath,
                ...additionalPath,
              ];
            }
            const actionType = action.get('type');

            if (actionType === ACTION_TYPES.ACTIVATE && elemType === ELEM_TYPES.FORM_FIELD) {
              const keyPath = String(keyIndex).split(':')
              const ch = _.last(keyPath)
              let elemUID;
              if (index !== null && index !== undefined) {
                elemUID = keyPath[2];
              } else {
                elemUID = keyPath[1];
              }
              let elemPath = getElementDataRoot(['Header', 'Footer'].includes(keyPath[0]) ? 'project' : retState.get('page'));
              const elem = retState.getIn([...elemPath, 'elements', elemUID], Map())
              elem.getIn(['props', 'items'], List()).map(row => {
                if (row && row.get('uid') == ch) {
                  let statePath = [];
                  let additionalPath = [];
                  if (index !== null && index !== undefined) {
                    statePath = [keyPath[0], keyPath[1], elemUID];
                    if(elem.getIn(['props', 'control']) === 'radio'){
                      statePath = [keyPath[0], keyPath[1], elemUID, index];
                      additionalPath = []
                    }else{
                      additionalPath = [index]
                    }
                  } else {
                    statePath = [keyPath[0], elemUID];
                  }
                  retState = updateState(retState, [...statePath, 'ftListValue', ...additionalPath], row.get('value'));
                  retState = updateState(retState, [...statePath, 'ftListLabel', ...additionalPath], row.get('label'));

                  retState = retState.setIn(
                    ['ft', 'changes'],
                    retState.getIn(['ft', 'changes'], List())
                      .push(fromJS([...statePath, 'ftListLabel', ...additionalPath]))
                      .push(fromJS([...statePath, 'ftListValue', ...additionalPath]))
                  )
                }
              })
            } else if (actionType === ACTION_TYPES.ACTIVATE) {
              let layoutMode = retState.getIn(['layoutMode'], 'lg')
              const keyPath = String(keyIndex).split(':')
              const tab = _.last(keyPath)
              let parentUID = _.first(keyPath)
              const tabEl = _.first(String(_.last(_.initial(keyPath))).split('-'))
              const additionalPath = index !== null && isPossibleRepeat && typeof index !== 'undefined' ? [index] : []
              isNeedOnValueChange = true;

              const isProjectElm = retState.hasIn(['project', 'Settings', 'elements', _.first(tabEl)])
              let parentID = _.first(keyPath)
              let stepID = tabEl
              const pageID = retState.getIn(['project', 'Pages'], List())
                .find(page => page.get('uid') === parentID)
                ?.get?.('_id')
              let metaInfo = retState.getIn(['metaInfo', pageID, stepID], Map())
              let metaChoices = retState.getIn(['meta', pageID, stepID], List())

              let tabRules = retState.getIn(['rules', parentID, `${stepID}-tab`], Map())

              let component = retState.getIn(
                parentUID === 'Header' || parentUID === 'Footer' || isProjectElm
                  ? ['project', 'Settings', 'elements', stepID]
                  : ['pages', pageID, 'Props', 'elements', stepID],
                Map()
              )

              const disableValid = component.getIn(['props', layoutMode, 'disableValid'], false)
              const isStatic = component.getIn(['props', 'source'], 'static') === 'static'

              let choices;
              let tabs = toJS(
                getValueForMode(component, layoutMode, ['props'], ['tabs'], List())
              )
              if (!_.isArray(tabs)) {
                tabs = []
              }
              let isPreview = true
              if (isStatic && !isPreview) {
                choices = tabs;
              } else if (isStatic && !metaInfo.get('isDynamic')) {
                choices = tabs;
              } else {
                const children = _.get(_.first(tabs), 'children', []) || []
                choices = metaChoices.map(v => ({
                  label: v.get('label'),
                  id: v.get('value') || v.get('id'),
                  children
                })).toJS();
              }
              if (isPreview && (component.getIn(['props', layoutMode, 'isRandomize']) || component.getIn(['props', layoutMode, 'isDistinct']))) {
                const children = _.get(tabs, [0, 'children'], []) || []
                choices = _.uniqBy(
                  metaChoices.map(v => ({
                    label: v.get('label'),
                    id: v.get('value') || v.get('id'),
                    children
                  })).toJS(),
                  'id'
                );
              }

              choices = _.filter(choices, (tab) => {
                if (tab) {
                  if (tabRules.get(tab?.id, List()) && tabRules.get(tab?.id, List()).indexOf('hide') !== -1 && tabRules.get(tab?.id, List()).indexOf('show') === -1) {
                    return false;
                  } else {
                    return true;
                  }
                } else {
                  return false;
                }
              })
              let changes = []
              if (_.size(choices) > 0) {
                let tabOption = _.find(choices, v => v.id === tab || v.value === tab)
                if (tabOption) {
                  retState = updateState(retState, [..._.slice(keyPath, 0, _.size(keyPath) - 2), tabEl, ...additionalPath, 'ftListValue'], tab);
                  retState = updateState(retState, [..._.slice(keyPath, 0, _.size(keyPath) - 2), tabEl, ...additionalPath, 'ftListLabel'], tabOption.label);
                  changes.push([..._.slice(keyPath, 0, _.size(keyPath) - 2), tabEl, ...additionalPath, 'ftListValue'])
                  changes.push([..._.slice(keyPath, 0, _.size(keyPath) - 2), tabEl, ...additionalPath, 'ftListLabel'])
                } else {
                  retState = updateState(retState, [..._.slice(keyPath, 0, _.size(keyPath) - 2), tabEl, ...additionalPath, 'ftListValue'], tab);
                  changes.push([..._.slice(keyPath, 0, _.size(keyPath) - 2), tabEl, ...additionalPath, 'ftListValue'])
                }
              } else {
                retState = updateState(retState, [..._.slice(keyPath, 0, _.size(keyPath) - 2), tabEl, ...additionalPath, 'ftListValue'], tab);
                changes.push([..._.slice(keyPath, 0, _.size(keyPath) - 2), tabEl, ...additionalPath, 'ftListValue'])
              }
              isNeedOnValueChange = true;

              retState = doProcessRules(
                retState,
                false,
                [],
                [],
                compactArrayPath(changes),
                false,
                false
              )

              retState = retState.setIn(
                ['__cache__'],
                retState.getIn(['__cache__'], List())
                  .push(fromJS({
                    type: 'activateTab',
                    payload: {
                      uid: tabEl,
                      tab,
                      ...isPossibleRepeat ? {
                        isRepeat: isBtnRepeat,
                        index
                      } : {}
                    }
                  }))
              )
            } else if (actionType === ACTION_TYPES.SET_FOCUS) {
              let elemUID = String(keyIndex).split(':')[1];
              if (elemUID) {
                retState = retState.setIn(
                  ['__cache__'],
                  retState.getIn(['__cache__'], List())
                    .push(fromJS({
                      type: 'set_focus',
                      payload: {
                        uid: elemUID,
                        index
                      }
                    }))
                )
              }
            } else if (actionType === ACTION_TYPES.SET_PARAM && !isOnlyEffects) {
              isNeedOnValueChange = true;
              const readOnlyId = getReadOnlyParameters(retState)
              if (!readOnlyId.includes(keyIndex) && retState.getIn(['params', keyIndex], '') !== action.getIn(['value'])) {
                retState = retState.setIn(['params', keyIndex], action.getIn(['value']))
                  .setIn(['portal', 'reloadWidgets'], true)
                  .setIn(['portal', 'paramsUpdated'], retState.getIn(['portal', 'paramsUpdated'], List()).push(fromJS({
                    key: [keyIndex],
                    value: action.getIn(['value'])
                  })));
                retState = retState.setIn(
                  ['ft', 'changes'],
                  retState.getIn(['ft', 'changes'],List()).push(fromJS([keyIndex]))
                )
              }
            } else if (actionType === ACTION_TYPES.SET_VALUE_CUSTOM && !isOnlyEffects) {
              let isList = false;
              let elemType = action.get('elemType');
              const isPossibleRepeat = detectIsTargetKeyInRepeatEl(keyPath, retState);
              const isRepeatContainer = isBtnRepeat && !_.isNil(index) && isPossibleRepeat;
              if (elemType === ELEM_TYPES.FORM_FIELD) {
                let elUID = isRepeatContainer ? keyPath[2] : keyPath[1];
                const baseRoot = ['Header', 'Footer'].includes(keyPath[0]) ? 'project' : retState.get('page');
                const elem = retState.getIn([...getElementDataRoot(baseRoot), 'elements', elUID], new Map());
                if (elem.getIn(['props', 'control'])) {
                  elemType = elem.getIn(['props', 'control']);
                } else if (elem.getIn(['type'])) {
                  elemType = elem.getIn(['type']);
                }
                if (LIST_BASED_FIELDS.includes(elemType)) {
                  isList = true;
                }
              }
              let expression = evaluateCustomExpression(action, params, portalState, isBtnRepeat, retState, index);
              isNeedOnValueChange = true;
              if (isRepeatContainer) {
                const statePath = elemType === ELEM_TYPES.PARAM ? ['params', ...keyPath] : _.initial(keyPath);
                let additionalPath = index !== null && typeof index !== 'undefined' ? [index] : [];
                if (isList && !statePath.includes('ftListValue')) {
                  expression = {
                    ftListValue: expression
                  };
                }
                if (elemType === ELEM_TYPES.BUTTON) {
                  retState = retState.setIn(['state', ...statePath, 'BTN_TEXT', ...additionalPath], expression);
                } else if (elemType === ELEM_TYPES.IMAGE) {
                  retState = retState.setIn(['state', ...statePath, 'IMG_SRC', ...additionalPath], expression);
                } else if (elemType === ELEM_TYPES.TYPOGRAPHY) {
                  retState = retState.setIn(['state', ...statePath, 'TYPO_TEXT', ...additionalPath], expression);
                } else if ([ELEM_TYPES.YOUTUBE, ELEM_TYPES.VIMEO].indexOf(elemType) !== -1) {
                  retState = updateState(retState, [...statePath, ...additionalPath], expression);
                } else if ((keyPath[_.size(keyPath) - 2] === 'ftIsSelVal') && elemType === 'Strip') {
                  retState = updateState(retState, [...keyPath], expression);
                  let selectedValues = [];
                  let values = retState.getIn(['state', ..._.slice(keyPath, 0, - 2), 'value'], List()).toJS();
                  let ftIsSelVal = toJS(retState.getIn(['state', ..._.slice(keyPath, 0, - 2), 'ftIsSelVal']));
                  _.each(values, (value, valIndex) => {
                    if (ftIsSelVal && ftIsSelVal[valIndex]) {
                      selectedValues.push(value);
                    }
                  })
                  retState = updateState(retState, [..._.slice(keyPath, 0, -2), 'ftSelVal'], selectedValues.join(','));
                } else {
                  if (elemType === ELEM_TYPES.PARAM) {
                    try {
                      retState = retState.setIn([...statePath], expression);
                    } catch (error) { }
                  } else if(elemType === ELEM_TYPES.POWER_TABLE_WIDGET) {
                    retState = updateState(retState, [...statePath, ...additionalPath], expression);
                  } else {
                    retState = updateState(retState, [...statePath, ...additionalPath], expression);
                  }
                }
              } else {
                const readOnlyId = getReadOnlyParameters(retState);
                const currentPageUID = retState.getIn(['project', 'Pages'], List())
                  .find(page => page.get('_id') === retState.get('page'))
                  ?.get?.('uid');
                if (isList && !keyPath.includes('ftListValue')) {
                  expression = {
                    ftListValue: expression
                  };
                }
                if (elemType === ELEM_TYPES.PAGE_PARAM && keyPath[0] !== currentPageUID) {
                  if (!readOnlyId.includes(keyPath[1])) {
                    retState = updateState(retState, [...keyPath], '');
                  }
                } else if (elemType === ELEM_TYPES.BUTTON) {
                  retState = retState.setIn(['state', ...keyPath, 'BTN_TEXT'], expression);
                } else if (elemType === ELEM_TYPES.IMAGE) {
                  retState = retState.setIn(['state', ...keyPath, 'IMG_SRC'], expression);
                } else if (elemType === ELEM_TYPES.TYPOGRAPHY) {
                  retState = retState.setIn(['state', ...keyPath, 'TYPO_TEXT'], expression);
                } else if ([ELEM_TYPES.YOUTUBE, ELEM_TYPES.VIMEO].indexOf(elemType) !== -1) {
                  retState = updateState(retState, [...keyPath], expression);
                } else {
                  const readOnlyId = getReadOnlyParameters(retState);
                  if (elemType === ELEM_TYPES.PARAM) {
                    if (!readOnlyId.includes(_.last(keyPath))) {
                      retState = retState.setIn(['params', ...keyPath], expression);
                    }
                  } else {
                    if (!readOnlyId.includes(_.last(keyPath))) {
                      retState = updateState(retState, [...keyPath], expression);
                    }
                  }
                }
              }
            } else if (actionType === ACTION_TYPES.SET_VALUE && !isOnlyEffects) {
              isNeedOnValueChange = true;
              let elementData;

              if(elemType === ELEM_TYPES.SURVEY_LIST) {
                action = action.set('value', fromJS({
                  ftListValue: action.get('value')
                }));
              } else if (elemType === ELEM_TYPES.FORM_FIELD) {
                let elUID = isBtnRepeat && index !== null &&
                typeof index !== 'undefined' && isPossibleRepeat ?
                  keyPath[2] : keyPath[1];
                elementData = retState.getIn([...getElementDataRoot(['Header', 'Footer'].includes(keyPath[0]) ? 'project' : retState.get('page')), 'elements', elUID], Map());
                if (elementData.getIn(['props', 'control'])) {
                  elemType = elementData.getIn(['props', 'control']);
                }
                if(isBtnRepeat && index !== null && typeof index !== 'undefined' && isPossibleRepeat) {
                  if (elemType === ELEM_TYPES.RADIO) {
                    action = action.set('value', fromJS({
                      ftListValue: action.get('value'),
                      ftListLabel: action.get('value'), // this is probably wrong (the key and not the text) but let's keep it for now just in case
                      uid: '',
                    }));
                  }
                } else if (LIST_BASED_FIELDS.includes(elemType) || elemType === ELEM_TYPES.CHECKBOX && elementData.getIn(['props', 'source'], 'single') !== 'single') {
                    if(!keyPath.includes('ftListValue') && !keyPath.includes('ftListLabel')) {
                      action = action.set('value', fromJS({
                        ftListValue: action.get('value'),
                        ftListLabel: action.get('value'),
                        uid: '',
                      }));
                    }
                }
              }
              if (isBtnRepeat && index !== null && typeof index !== 'undefined' && isPossibleRepeat) {
                retState = handleSetValueForRepeatElements(action, retState, keyPath,
                  index, keyIndex, isPossibleRepeat, elementData);
              } else {
                let isProcessRule = true;
                let repeatRoot = retState.getIn(['project', 'Settings', 'RepeatedStripsID'], List()).toJS()
                if (repeatRoot.indexOf(keyPath[1]) > -1) {
                  try {
                    let isFound = false;
                    let repState = retState.getIn(['state', keyPath[0], keyPath[1]], List())
                    if (repState) {
                      repState.map(row => {
                        if (row && row.size) {
                          isFound = true;
                        }
                      })
                      if (!isFound) {
                        isProcessRule = false;
                      }
                    }
                  } catch (err) {

                  }
                }
                if (isProcessRule) {
                  const currentPageUID = retState.getIn(['project', 'Pages'], List())
                    .find(page => page.get('_id') === retState.get('page'))
                    ?.get?.('uid')

                  if(action.get('elemType') === 'Ranking'){
                    if(_.size(keyPath) === 3){
                      if(Map.isMap(retState.getIn(['state', ..._.initial(keyPath)]))){
                        retState = retState.setIn(['state', ...keyPath], ~~parseInt(action.getIn(['value'])))
                      }else{
                        retState = retState.setIn(['state', ..._.initial(keyPath)], fromJS({
                          [_.last(keyPath)]: ~~parseInt(action.getIn(['value']))
                        }))
                      }
                    }
                  }else if (action.get('elemType') === 'pageParam' && keyPath[0] != currentPageUID) {
                    const readOnlyId = getReadOnlyParameters(retState)
                    if (!readOnlyId.includes(keyPath[1])) {
                      retState = updateState(retState, [...keyPath], '');
                    }
                  } else if (action.get('elemType') === 'Button') {
                    retState = retState.setIn(['state', ...keyPath, 'BTN_TEXT'], action.get('value'));
                  } else if (action.get('elemType') === 'Image') {
                    retState = retState.setIn(['state', ...keyPath, 'IMG_SRC'], action.get('value'));
                  } else if (action.get('elemType') === 'Typography') {
                    retState = retState.setIn(['state', ...keyPath, 'TYPO_TEXT'], action.get('value'));
                  } else if (['YouTube', 'Vimeo'].indexOf(action.get('elemType')) !== -1) {
                    retState = updateState(retState, [...keyPath], action.get('value'));
                  } else if ((keyPath[_.size(keyPath) - 2] === 'ftIsSelVal') && action.get('elemType') === 'Strip') {
                    retState = updateState(retState, [...keyPath], action.get('value'));
                    let selectedValues = []
                    let values = retState.getIn(['state', ..._.slice(keyPath, 0, - 2), 'value'], List()).toJS()
                    let ftIsSelVal = toJS(retState.getIn(['state', ..._.slice(keyPath, 0, - 2), 'ftIsSelVal']))
                    _.each(values, (value, valIndex) => {
                      if (ftIsSelVal[valIndex]) {
                        selectedValues.push(value)
                      }
                    })
                    retState = updateState(retState, [..._.slice(keyPath, 0, -2), 'ftSelVal'], selectedValues.join(','));
                  } else {
                    const readOnlyId = getReadOnlyParameters(retState)
                    let value = action.get('value');
                    if (action.get('elemType') == 'FormField') {
                      if (elementData && elementData.getIn(['props', 'control']) == 'checkbox') {
                        if (typeof value == 'string' && elementData.getIn(['props', 'source'], 'single') === 'single') {
                          value = String(value).toLowerCase();
                          if (value === 'true' || value === '1' || value === 'yes' || value === 'on' || value === 'check') {
                            value = true;
                          } else {
                            value = false;
                          }
                        }
                      }
                    }
                    if (action.get('elemType') === 'FormField' && elementData && elementData.getIn(['props', 'control']) === 'currency' && !readOnlyId.includes(_.last(keyPath))) {
                      retState = updateState(retState, [...keyPath, 'value'], value);
                    } else if (!readOnlyId.includes(_.last(keyPath))) {
                      if(keyPath.length == 1) {
                        retState = retState.setIn(['params', keyPath[0]], value)
                      } else {
                        retState = updateState(retState, [...keyPath], value);
                      }
                    }
                  }
                }
              }
              if (action.get('elemType') === ELEM_TYPES.TAB) {
                const [pageID, id1, id2, ...rest] = keyPath
                const isPossibleRepeat = detectIsTargetKeyInRepeatEl(keyPath, retState)
                let page = retState.hasIn(['project', 'Settings', 'elements', id1])
                  ? 'project'
                  : retState.get('page')
                let uid = null
                let tab = action.get('value')
                let el1Type = retState.getIn([...getElementDataRoot(page), 'elements', id1, 'type'])
                let el2Type = retState.getIn([...getElementDataRoot(page), 'elements', id2, 'type'])
                if (el1Type === 'Tab') {
                  uid = id1
                } else if (el2Type === 'Tab') {
                  uid = id2
                }
                if (uid && tab) {
                  retState = retState.setIn(
                    ['__cache__'],
                    retState.getIn(['__cache__'], List())
                      .push(fromJS({
                        type: 'activateTab',
                        payload: {
                          uid,
                          tab,
                          ...isPossibleRepeat ? {
                            isRepeat: isBtnRepeat,
                            index
                          } : {}
                        }
                      }))
                  )
                }
              }
            } else if (actionType === ACTION_TYPES.RESET_VALUE && !isOnlyEffects) {
              let layoutMode = retState.getIn(['layoutMode'], 'lg');

              isNeedOnValueChange = true;
              let elemType = action.get('elemType');
              action = action.set('value');
              let elUID = isBtnRepeat && index !== null && typeof index !== 'undefined' && isPossibleRepeat ?
                  keyPath[2] : keyPath[1];
              const elementData = retState.getIn([...getElementDataRoot(['Header', 'Footer'].includes(keyPath[0]) ? 'project' : retState.get('page')), 'elements', elUID], Map())
              if (elemType === ELEM_TYPES.FORM_FIELD) {
                if (elementData.getIn(['props', 'control'])) {
                  elemType = elementData.getIn(['props', 'control']);
                }
                action = setResetValueOnAction(elemType, elUID, index, elementData, layoutMode, action);
              }

              // handle repeat elements
              if (isBtnRepeat && index !== null && typeof index !== 'undefined' && isPossibleRepeat) {
                retState = updateResetStateForRepeatElements(keyPath, index, elemType, retState, action, elementData);
              } else {
                const currentPageUID = retState.getIn(['project', 'Pages'], List())
                  .find(page => page.get('_id') === retState.get('page'))?.get?.('uid');
                const control = elementData.getIn(['props', 'control'], 'text');
                if (elemType === ELEM_TYPES.PAGE_PARAM && keyPath[0] != currentPageUID) {
                  const readOnlyId = getReadOnlyParameters(retState);
                  if (!readOnlyId.includes(keyPath[1])) {
                    retState = updateState(retState, [...keyPath], '');
                  }
                } else if (elemType === ELEM_TYPES.BUTTON) {
                  retState = retState.setIn(['state', ...keyPath, 'BTN_TEXT'], action.get('value'));
                } else if (elemType === ELEM_TYPES.IMAGE) {
                  retState = retState.setIn(['state', ...keyPath, 'IMG_SRC'], action.get('value'));
                } else if (elemType === ELEM_TYPES.TYPOGRAPHY) {
                  retState = retState.setIn(['state', ...keyPath, 'TYPO_TEXT'], action.get('value'));
                } else if ([ELEM_TYPES.YOUTUBE, ELEM_TYPES.VIMEO].indexOf(elemType) !== -1) {
                  retState = updateState(retState, [...keyPath], action.get('value'));
                } else if (action.get('elemType') === ELEM_TYPES.FORM_FIELD && (control == 'time' || control == 'datetime' || control == 'date')) {
                  const readOnlyId = getReadOnlyParameters(retState)
                  if (!readOnlyId.includes(_.last(keyPath))) {
                    if(_.last(keyPath === 'ftListValue') || _.last(keyPath) === 'ftListLabel'){
                      keyPath = _.initial(keyPath);
                    }
                    keyPath = keyPath.slice(0,2);
                    retState = updateState(retState, [...keyPath], action.get('value'));
                    const [firstElem, secondElem] = keyPath;

                    keyPath = [firstElem, `${secondElem}-formattedValue`];
                    retState = updateState(retState, [...keyPath], action.get('value'));
                  }
                } else {
                  const readOnlyId = getReadOnlyParameters(retState);
                  if (!readOnlyId.includes(_.last(keyPath))) {
                    if(_.last(keyPath === 'ftListValue') || _.last(keyPath) === 'ftListLabel'){
                      keyPath = _.initial(keyPath);
                    }
                    keyPath = keyPath.slice(0,2);
                    retState = updateState(retState, [...keyPath], action.get('value'));
                  }
                }
                if(keyPath[0] && keyPath[1]){
                  retState = retState.setIn(['formFieldStatuses', keyPath[0],keyPath[1]], fromJS({status: '', error: '', errorCode: ''}));
                  if (keyPath[1].endsWith("-formattedValue")) {
                    retState = retState.setIn(['formFieldStatuses', keyPath[0],keyPath[1].split('-formattedValue')[0]], fromJS({status: '', error: '', errorCode: ''}));
                  }
                }
              }
              if (elemType === ELEM_TYPES.TAB) {
                retState = resetTabValue(keyPath, retState, action, isBtnRepeat, index);
              }
            } else if (actionType === ACTION_TYPES.SET_PARAM_FROM && !isOnlyEffects) {
              isNeedOnValueChange = true;
              let value = '';
              let repeatRoot = retState.getIn(['project', 'Settings', 'RepeatedStripsID'], List()).toJS()
              if (_.endsWith(String(action.getIn(['from', 'value'])), ':ftStripRow')) {
                if (typeof index == 'number') {
                  value = index + 1;
                } else {
                  value = index;
                }
              } else if (_.endsWith(String(action.getIn(['from', 'value'])), '-totalRows') && repeatRoot.indexOf(action.getIn(['from', 'uid'])) > -1) {
                let stripPageUID = String(action.getIn(['from', 'value'])).split(':')[0];
                const stripState = retState.getIn(['state', stripPageUID, action.getIn(['from', 'uid'])], Map());
                value = getMappingCount(stripState.toJS());
              } else if (action.getIn(['from', 'group']) === 'param') {
                value = _.get(params, String(action.getIn(['from', 'value'], '')).replace(/:/g, '.'), '');
              } else if (_.startsWith(action.getIn(['from', 'group']), 'PowerTableWidget')) {
                let key = String(action.getIn(['from', 'value'], '')).split(':')
                value = _.get(portalState, key, '');
                if (_.isArray(value)) {
                  value = value[index];
                }
              } else if (_.startsWith(action.getIn(['from', 'group']), 'tableWidget')) {
                let key = String(action.getIn(['from', 'value'], '')).split(':')
                if (isBtnRepeat && index !== null && typeof index !== 'undefined') {
                  key = [
                    ..._.initial(key),
                    index,
                    _.last(key)
                  ]
                }
                value = _.get(portalState, key, '');
              } else {
                let key = String(action.getIn(['from', 'value'], '')).split(':')
                const isPossibleRepeat = detectIsTargetKeyInRepeatEl(key, retState)
                let valuePath = String(updateOldValue(action.getIn(['from', 'value'], ''))).replace(/:/g, '.');

                let isNeedFixRepeat = false;
                if(isPossibleRepeat) {
                  if(isBtnRepeat && index !== null && typeof index !== 'undefined') {
                    if(["lookup", 'radio'].includes(action.getIn(['from', 'subType']))) {
                      isNeedFixRepeat = true;
                    } else if(_.last(key) == 'endDate' || _.last(key) == 'startDate') {
                      isNeedFixRepeat = true;
                    }
                  }
                }

                if(isNeedFixRepeat) {
                  valuePath = valuePath.split('.');
                  valuePath.splice(valuePath.length - 1, 0, index)
                  value = _.get(portalState, valuePath, '');
                } else {
                  value = _.get(portalState, valuePath, '');
                  if (isBtnRepeat && index !== null && typeof index !== 'undefined' && isPossibleRepeat) {
                    value = _.get(value, index)
                  }
                }
              }
              const readOnlyId = getReadOnlyParameters(retState)
              if (!readOnlyId.includes(keyIndex)) {
                if (retState.getIn(['params', keyIndex], '') !== value) {
                  retState = retState.setIn(['params', keyIndex], value);
                  retState = retState.setIn(
                    ['ft', 'changes'],
                    retState.getIn(['ft', 'changes'],List()).push(fromJS([keyIndex]))
                  )
                  retState = retState
                    .setIn(['portal', 'reloadWidgets'], true)
                    .setIn(['portal', 'paramsUpdated'], retState.getIn(['portal', 'paramsUpdated'], List()).push(fromJS({
                      key: [keyIndex],
                      value
                    })));
                }
              }
            } else if (actionType === ACTION_TYPES.SET_OPTIONS_FROM && !isOnlyEffects) {
              let value = '';
              if (action.getIn(['from', 'group']) === 'pageParam') {
                value = _.get(portalState, String(action.getIn(['from', 'value'], '')).replace(/:/g, '.'), '')
              } else if (action.getIn(['from', 'group']) === 'param') {
                value = _.get(params, String(action.getIn(['from', 'value'], '')).replace(/:/g, '.'), '')
              } else if (_.startsWith(action.getIn(['from', 'group']), 'tableWidget')) {
                let key = String(action.getIn(['from', 'value'], '')).split(':')
                key = [
                  ..._.initial(key),
                  index,
                  _.last(key)
                ]
                value = _.get(portalState, key, '');
              } else if(detectIsTargetKeyInRepeatEl(String(action.getIn(['from', 'value'], '')).split(':'), retState) && index !== null && index !== undefined){
                value = _.get(portalState, [...String(updateOldValue(action.getIn(['from', 'value'], ''))).split(':'), index], '');
              } else {
                value = _.get(portalState, String(updateOldValue(action.getIn(['from', 'value'], ''))).replace(/:/g, '.'), '');
              }
              if (typeof value == 'string') {
                let list = [];
                try {
                  list = value.includes(';') ? value.split(';') : [value];
                  if (!value.includes(';') && isValidJSON(value)) {
                    list = JSON.parse(value);
                  }
                } catch (err) {
                  console.error('err >>> ', err);
                }
                try {
                  let lisItems = Array();
                  _.each(list, function (row) {
                    if (row) {
                      if (typeof row == "string") {
                        row = {
                          label: row
                        }
                      } else if (typeof row == "object" && (row.value && !row.label)) {
                        row.label = row.value;
                      }

                      if (row.label) {
                        var newItem = {
                          label: row.label,
                          uid: uuid(),
                          value: row.label
                        };
                        if (row.value) {
                          newItem.value = row.value;
                        }
                        lisItems.push(newItem)
                      }
                    }
                  });
                  let path = keyIndex.split(':');
                  let itemsPath = keyIndex.split(':');
                  if(action.get('elemType') === 'FormField' && isBtnRepeat && index !== null && typeof index !== 'undefined' && isPossibleRepeat){
                    itemsPath = [..._.initial(itemsPath), `${_.last(itemsPath)}-${index}`]
                  }
                  retState = retState.setIn(['meta', ...itemsPath], fromJS(lisItems));
                  let metaInfo = retState.getIn(['metaInfo', ...path], Map())
                  metaInfo = metaInfo.set('isDynamic', true);
                  if(action.get('elemType') === 'FormField' && isBtnRepeat && index !== null && typeof index !== 'undefined' && isPossibleRepeat){
                    retState = retState.setIn(['metaInfo', ...itemsPath], metaInfo);
                  }else{
                    retState = retState.setIn(['metaInfo', ...path], metaInfo);
                  }
                } catch (err) {
                  console.error('err >>> ', err);
                }
              }
            } else if (actionType === ACTION_TYPES.CLEAR_ITEMS && !isOnlyEffects) {
              let path = String(keyIndex).split(':');
              if (path.length > 1) {
                retState = retState.setIn(['meta', ...path], List());
              }
            } else if ((actionType === ACTION_TYPES.INCREMENT_ONE || actionType === ACTION_TYPES.DECREMENT_ONE) && !isOnlyEffects) {
              isNeedOnValueChange = true;
              let localPath = []
              if(action.get('elemType') === 'PowerTableWidget'){
                let elPath = String(keyIndex).split(':');
                const elem = state.getIn(['pages', state.get('page'), 'Props', 'elements', elPath[1]], Map())
                if (elem.size > 0) {
                  let column = null
                  const findColumn = col => {
                    if (col.get('id') === _.last(elPath)) {
                      column = col
                    }
                    if (col.getIn(['meta', 'subCtrl', 'enable'])) {
                      col.getIn(['columns'], List()).map(findColumn)
                    }
                  }
                  elem.getIn(['props', 'columns'], List()).map(findColumn)
                  if (column && ['input', 'field'].includes(column.getIn(['meta', 'role']))) {
                    if (index !== undefined && index !== null) {
                      localPath = ['state', ...keyPath, index]
                    } else if (rowIndex !== undefined && rowIndex !== null) {
                      localPath = ['state', ...keyPath, rowIndex]
                    } else if (currentRule.get('index') !== undefined && currentRule.get('index') !== null) {
                      localPath = ['state', ...keyPath, currentRule.get('index')]
                    }
                  }
                }
              } else if (action.get('elemType') === 'param') {
                localPath = ['params', keyIndex]
              } else if (action.get('elemType') === 'pageParam') {
                const readOnlyId = getReadOnlyParameters(retState)
                if (!readOnlyId.includes(_.last(keyPath))) {
                  localPath = ['state', ...keyPath];
                }
              } else if (action.get('elemType') === 'Typography') {
                let lPath = ['state', ...keyPath];
                if (index !== null) {
                  lPath.splice(localPath.length - 1, 0, 'TYPO_TEXT')
                } else {
                  lPath.push('TYPO_TEXT')
                }
                localPath = lPath;
              } else {
                const readOnlyId = getReadOnlyParameters(retState)
                if (!readOnlyId.includes(_.last(keyPath))) {
                  const GUID_RE = /^[0-9A-F]{8}-[0-9A-F]{4}-4[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i
                  if (GUID_RE.test(_.last(keyPath)) && !GUID_RE.test(_.last(_.initial(keyPath)))) {
                    localPath = ['state', ..._.initial(keyPath)];
                  } else {
                    localPath = ['state', ...keyPath];
                  }
                }
              }
              if (localPath.length) {
                let val = parseFloat(retState.getIn(localPath));
                if (isNaN(val)) {
                  val = 0;
                }
                if (action.get('type') === 'increment_1') {
                  val++;
                } else {
                  val--;
                }
                retState = retState.setIn(localPath, val)
                retState = retState.setIn(
                  ['ft', 'changes'],
                  retState.getIn(['ft', 'changes'],List()).push(fromJS(_.tail(localPath)))
                )
              }
            } else if (actionType === ACTION_TYPES.SET_VALUE_FROM && !isOnlyEffects) {
              isNeedOnValueChange = true;

              const { isList, elemType } = getElementInfo(action, keyPath, retState, index, isBtnRepeat, isPossibleRepeat);

              let { value, isTableMode } = extractSourceValue(
                action,
                index,
                portalState,
                retState,
                params,
                keyPath,
                isList
              );


              let localIndex = index;
              if (isTableMode) {
                localIndex = null;
              }
              if (elemType === ELEM_TYPES.RANGE && !_.isNil(localIndex)) {
                let fixPath = _.initial(keyPath);
                retState = retState.setIn(['state', ..._.initial(fixPath), localIndex, _.last(fixPath)], value);
              } else if (elemType === ELEM_TYPES.PAGE_PARAM) {
                const readOnlyId = getReadOnlyParameters(retState)
                if (!readOnlyId.includes(_.last(keyPath))) {
                  retState = retState.setIn(['state', ...keyPath], value);
                }
              } else if (elemType === ELEM_TYPES.BUTTON) {
                retState = retState.setIn(['state', ...keyPath, 'BTN_TEXT'], value);
              } else if (elemType === ELEM_TYPES.IMAGE) {
                retState = retState.setIn(['state', ...keyPath, 'IMG_SRC'], value);
              } else if (elemType === ELEM_TYPES.TYPOGRAPHY) {
                let localPath = ['state', ...keyPath];
                let repeatRoot = retState.getIn(['project', 'Settings', 'RepeatedStripsID'], List()).toJS()
                let isRepeatedIndex = false
                if (repeatRoot.indexOf(keyPath[1]) > -1) {
                  if (!_.isNil(localIndex)) {
                    isRepeatedIndex = true
                  }
                }
                if (isRepeatedIndex) {
                  localPath.splice(localPath.length - 1, 0, 'TYPO_TEXT')
                  // localPath = [..._.initial(localPath), String(_.last(localPath))]
                  let list = retState.getIn(_.initial(localPath), Map()).toList()
                  list = list.set(_.last(localPath), value)
                  retState = safeSetIn(retState, _.initial(localPath), list);
                } else {
                  localPath.push('TYPO_TEXT')
                  retState = safeSetIn(retState, localPath, value);
                }
              } else if ([ELEM_TYPES.YOUTUBE, ELEM_TYPES.VIMEO].indexOf(elemType) !== -1) {
                if (!_.isNil(localIndex) && isPossibleRepeat) {
                  keyPath.splice(keyPath.length - 1, 1);
                }
                retState = updateState(retState, [...keyPath], value);
              } else if ((keyPath[_.size(keyPath) - 2] === 'ftIsSelVal') && elemType === ELEM_TYPES.STRIP) {
                retState = updateState(retState, [...keyPath], value);
                let selectedValues = []
                let values = retState.getIn(['state', ..._.slice(keyPath, 0, - 2), 'value'], List()).toJS()
                let ftIsSelVal = toJS(retState.getIn(['state', ..._.slice(keyPath, 0, - 2), 'ftIsSelVal']))
                _.each(values, (value, valIndex) => {
                  if (ftIsSelVal[valIndex]) {
                    selectedValues.push(value)
                  }
                })
                retState = updateState(retState, [..._.slice(keyPath, 0, -2), 'ftSelVal'], selectedValues.join(','));
              } else {
                const readOnlyId = getReadOnlyParameters(retState)
                if (!readOnlyId.includes(_.last(keyPath))) {

                  try {
                    let pageId = retState.get('page');
                    let elemUID = keyPath[1];
                    if (!_.isNil(localIndex)) {
                      elemUID = keyPath[2]
                    }
                    let elem = retState.getIn(['pages', pageId, 'Props', 'elements', elemUID])
                    if (elem && elem.get('type') === ELEM_TYPES.FORM_FIELD) {
                      const control = elem.getIn(['props', 'control'])
                      if (control === ELEM_TYPES.RADIO) {
                        if (!_.isNil(index) && _.endsWith(keyPath, index)) {
                          const len = keyPath.length;
                          // repairs the path for radio button, that has a different state structure for a repeat container
                          [keyPath[len - 2], keyPath[len - 1]] = [keyPath[len - 1], keyPath[len - 2]];
                        }
                      } else if (control === ELEM_TYPES.CURRENCY) {
                        value = parseFloat(value);
                        if (isNaN(value)) {
                          value = 0;
                        }
                        if (localIndex !== null && localIndex !== undefined) {
                          keyPath.splice(3, 0, 'value');
                        } else {
                          keyPath.push('value');
                        }
                      } else if (control === 'lookup' && isPossibleRepeat && (_.endsWith(keyIndex, 'ft_text') || _.endsWith(keyIndex, 'ft_value'))) {
                        const key = String(keyIndex)
                        keyPath = String(key).replace(/:/g, '.').split('.');
                        keyPath = [..._.initial(keyPath), index, _.last(keyPath)]
                      }
                    }
                  } catch (err) {
                    console.error('err >>> ', err);
                  }

                  const GUID_RE = /^[0-9A-F]{8}-[0-9A-F]{4}-4[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i
                  if (keyPath.length > 2 && GUID_RE.test(_.last(keyPath)) && !GUID_RE.test(_.last(_.initial(keyPath)))) {
                    retState = updateState(retState, [..._.initial(keyPath)], value);
                  } else {
                    retState = updateState(retState, [...keyPath], value);
                  }
                }
              }
              if (elemType === ELEM_TYPES.TAB) {
                const [pageID, id1, id2, ...rest] = keyPath
                const isPossibleRepeat = detectIsTargetKeyInRepeatEl(keyPath, retState)
                let page = retState.hasIn(['project', 'Settings', 'elements', id1])
                  ? 'project'
                  : retState.get('page')
                let uid = null
                let tab = value
                let el1Type = retState.getIn([...getElementDataRoot(page), 'elements', id1, 'type'])
                let el2Type = retState.getIn([...getElementDataRoot(page), 'elements', id2, 'type'])
                if (el1Type === 'Tab') {
                  uid = id1
                } else if (el2Type === 'Tab') {
                  uid = id2
                }
                if (uid && tab) {
                  retState = retState.setIn(
                    ['__cache__'],
                    retState.getIn(['__cache__'], List())
                      .push(fromJS({
                        type: 'activateTab',
                        payload: {
                          uid,
                          tab,
                          ...isPossibleRepeat ? {
                            isRepeat: isBtnRepeat,
                            index: localIndex
                          } : {}
                        }
                      }))
                  )
                }
              }
            } else if (actionType === 'redirect_to' && !isOnlyEffects) {
              if (retState.getIn(['page']) !== key) {
                retState = retState.setIn(
                  ['__cache__'],
                  retState.getIn(['__cache__'], List())
                    .push(fromJS({
                      type: 'redirectToPage',
                      payload: {
                        uid: key
                      }
                    }))
                )
                // retState = retState.setIn(['redirectToPage'], key);
              }
            } else if (actionType === 'postMessage' && action.get('enabled')) {
              const targetIFrame = keyPath;
              const targetIFrameStr = targetIFrame.join(':');
              const iframes = document.querySelectorAll('iframe[data-target]');
              let iframe = null;
              iframes.forEach(frame => {
                if (String(frame.dataset.target) === targetIFrameStr) {
                  iframe = frame;
                }
              });
              const data = _.reduce(action.getIn(['fields'], Map()).toJS(), (ret, field, key) => {
                if (field.use) {
                  let value = _.get(
                    path.length > 0
                      ? _.get(portalState, path)
                      : portalState,
                    [
                      ...String(updateOldValue(key))
                        .split(':'),
                      ...isBtnRepeat ? [index] : []
                    ],
                    ''
                  )
                  return {
                    ...ret,
                    [field.name]: value
                  };
                } else {
                  return ret
                }
              }, {});
              if (typeof window !== 'undefined') {
                if (iframe !== null) {
                  iframe.contentWindow.postMessage(JSON.stringify(data), window.location.origin);
                }
                else {
                  window.postMessage(JSON.stringify(data), window.location.origin);
                }
              }
            } else if (isColorAction({ actionType, withBorderColor: true })) {
              let keyPath = String(keyIndex).split(':')
              const additionalPath = isPossibleRepeat ? [index] : []
              keyPath = [...keyPath, ...additionalPath]
              const resolvedColor = resolveColorValue(action, retState)
              const actionTypeValue = action.get('type')
              const currentActionPrefix = colorPrefixesActionMap[actionTypeValue]
              let values = toJS(retState.getIn(['rules', ...keyPath])) || []
              values = _.filter(values, v => !_.startsWith(v, currentActionPrefix))

              if(action.get('isJs')) {
                if(!values.includes('isJs')) {
                  values.push('isJs')
                }
              } else {
                values = _.filter(values, v => v !== 'isJs')
              }

              if (resolvedColor) {
                // Store the resolved color directly without sanitizing
                const val = `${currentActionPrefix}${resolvedColor}`
                values.push(val)
              }

              retState = retState.setIn(['rules', ...keyPath], values)
            }
            if (['show', 'hide'].indexOf(actionType) > -1) {
              isNeedOnValueChange = true;
            }
            portalState = getState(retState, true);
            params = getParams(retState);
          });
        }
        if (_.isNull(index) && typeof currentRule?.get('index') != 'number') {
          if (keyPath[2] == 'items') {
            keyPath = [keyPath[0], `${keyPath[1]}-${keyPath[2]}`, keyPath[3]];
          }
        } else {
          if (keyPath[3] == 'items') {
            keyPath = [keyPath[0], keyPath[1], `${keyPath[2]}-${keyPath[3]}`, index, keyPath[4]];
          } else if (keyPath[2] == 'items') {
            keyPath = [keyPath[0], `${keyPath[1]}-${keyPath[2]}`, keyPath[3]];
          }
        }
        if (_.isNull(index) && typeof currentRule?.get('index') != 'number') {
          const oldRules = toJS(retState.getIn(['rules', ...keyPath]))
          const newRules = actionTarget.map(action => {
            if (!isImmutable(action)) { action = Map() }
            if (action.get('type') === 'mandatory' && !ALLOW_MANDATORY_TYPE.includes(action.get('elemType'))) {
              return ''
            } else if (action.get('type') === 'runAnimation') {
              return action.getIn(['animation', 'value'])
            } else if (isColorAction({ actionType: action.get('type'), withBorderColor: true })) {
              return getColorValueFromAction(action, retState)
            } else {
              return action.get('type')
            }
          })
          if (keyPath[1] === keyPath[2]) {
            if (retState.getIn(['rules', ..._.slice(keyPath, 0, 3)])) {
              retState = retState.deleteIn(['rules', ..._.slice(keyPath, 0, 3)]);
            }
          }

          const ruleState = setNewRules(toJS(retState.getIn(['rules', ...keyPath], List())), newRules, keyPath)
          retState = retState.setIn(
            ['rules', ...keyPath],
            ruleState
          );
          if (!isSkipReRun) {
            if (newRules.size && !shallowEqual(oldRules, newRules.toJS())) {
              let fullPath = keyIndex.split(':');
              if (fullPath[1]) {
                // retState = doProcessRules(retState, false, fullPath[1], fullPath, [fullPath], true, isOnload, oldState)
                retState = retState.setIn(
                  ['ft', 'changes'], effectElementsInsideCondition(retState, fullPath)

                )
              }
            }
          }
        } else {
          if (rowIndex === undefined || rowIndex === null) {
            let repeatRoot = retState.getIn(['project', 'Settings', 'RepeatedStripsID'], List()).toJS()
            if (repeatRoot.indexOf(keyPath[1]) > -1) {
              let stripID = keyPath[1];
              let pageID = retState.get('page');
              let elemID = keyPath[2];

              let isInvisibleByDefault = retState.getIn(['pages', pageID, 'Props', 'elements', stripID, 'props', 'isInvisibleByDefault'], false);
              if (isInvisibleByDefault && typeof elemID === 'number') {
                let isResetHideOnload = false;

                actionTarget.map(action => {
                  if (action && action.get('type') == 'show') {
                    isResetHideOnload = true;
                  }
                });
                if (isResetHideOnload) {
                  retState = retState.setIn(['pages', pageID, 'Props', 'elements', stripID, 'props', 'isDefaultInvisibleByDefault'], true);
                  retState = retState.setIn(['pages', pageID, 'Props', 'elements', stripID, 'props', 'isInvisibleByDefault'], false);
                }
              } else if(keyPath[1] === keyPath[2]) {
                let isSetHideOnload = false;
                let isResetHideOnload = false;
                actionTarget.map(action => {
                  if (action && action.get('type') == 'hide') {
                    isSetHideOnload = true;
                  }
                  if (action && action.get('type') == 'show') {
                    isResetHideOnload = true;
                  }
                });
                if (isResetHideOnload) {
                  retState = retState.setIn(['pages', pageID, 'Props', 'elements', stripID, 'props', 'isDefaultInvisibleByDefault'], true);
                  retState = retState.setIn(['pages', pageID, 'Props', 'elements', stripID, 'props', 'isInvisibleByDefault'], false);
                }
                if(isSetHideOnload) {
                  retState = retState.setIn(['pages', pageID, 'Props', 'elements', stripID, 'props', 'isInvisibleByDefault'], true);
                }
              }
            }
          }
          if (isBtnRepeat) {
            const oldRules = toJS(retState.getIn(['rules', ...keyPath]))
            let isEffectPowerTable = false;
            const newRules = actionTarget.map(action => {
              if (!isImmutable(action)) { action = Map() }
              if((action.get('type') == 'hide' || action.get('type') == 'show')
                  && action.get('elemType') == 'PowerTable') {
                isEffectPowerTable = true;
              }
              if (action.get('type') === 'mandatory' && !ALLOW_MANDATORY_TYPE.includes(action.get('elemType'))) {
                return ''
              } else if (action.get('type') === 'runAnimation') {
                return action.getIn(['animation', 'value'])
              } else if (isColorAction({ actionType: action.get('type'), withBorderColor: true })) {
                return getColorValueFromAction(action, retState)
              } else {
                return action.get('type')
              }
            })
            let rules = retState.getIn(['rules'], Map()).toJS();
            if(isEffectPowerTable && typeof keyPath[2] === 'number') {
                  keyPath = keyPath.splice(0,2)
            }

            const repeatRoot = retState.getIn(['project', 'Settings', 'RepeatedStripsID'], List()).toJS();

            if (keyPath[1] === keyPath[2] && repeatRoot.includes(keyPath[1])) {
              const elem = retState.getIn(['pages', retState.getIn(['page']), 'Props', 'elements', keyPath[1]])
              if (elem && elem.getIn(['props', 'isRepeatCol'])) {
                keyPath[3] = 0
              }
            }

              let setRules = setNewRules(retState.getIn(['rules', ...keyPath], List()), fromJS(newRules), keyPath);
              if (keyPath.length > 3) {
                let stripKeyPath = [...keyPath].splice(0, 2);
                let stripKeyPath2 = [...keyPath].splice(0, 3);
                if (typeof _.get(rules, stripKeyPath, {}) === 'undefined' || _.isArray(_.get(rules, stripKeyPath, {}))) {
                  let fixRules = {};
                  if(_.get(rules, stripKeyPath)) {
                    _.each(_.get(rules, stripKeyPath), function(val, key){
                      fixRules[key] = val;
                    })
                  }
                  rules = _.set(rules, stripKeyPath, fixRules);
                }
                if (typeof _.get(rules, [...keyPath].splice(0, 3), []) === 'undefined') {
                  rules = _.set(rules, stripKeyPath2, []);
                }
                if (typeof index !== 'undefined' && index !== null) {
                  rules = _.set(rules, keyPath, []);
                }
              }
              rules = _.set(rules, keyPath, setRules.toJS());


            const stripID = keyPath[1];
            const pageID = retState.get('page');
            const isInvisibleByDefault = retState.getIn(['pages', pageID, 'Props', 'elements', stripID, 'props', 'isInvisibleByDefault'], false);
            const isDefaultInvisibleByDefault = retState.getIn(['pages', pageID, 'Props', 'elements', stripID, 'props', 'isDefaultInvisibleByDefault'], false);

            const [pageUID, repeatId, targetId]  = keyPath;
            const isRepeatElement = repeatRoot.includes(repeatId)
            const hasSpecificIndex = index != null
            if(isRepeatElement && (isInvisibleByDefault || isDefaultInvisibleByDefault)){
                  if (hasSpecificIndex) {
                    rules = applyRuleForSingleRepeatItem(retState, rules, pageUID, repeatId, targetId, index, newRules);
                  } else {
                    const repState = retState.getIn(['state', pageUID, repeatId], Map()).toJS();
                    const count = getMappingCount(repState);
                    rules = applyRuleForAllRepeatItems(retState, rules, pageUID, repeatId, targetId, count, newRules);
                  }
            }

            retState = retState.setIn(
              ['rules'], fromJS(rules)
            )

            if (!isSkipReRun) {
              if (!shallowEqual(oldRules, newRules.toJS())) {
                try {

                  let fullPath = keyIndex.split(':');
                  const elem = retState.getIn(['pages', retState.getIn(['page']), 'Props', 'elements', fullPath[1]])
                  //@todo gem:20213
                  ///&& _.size(fullPath) === 2
                  if (elem && (elem.get('type') == 'Strip' || elem.get('type') == 'RepeatAutoFit')) {
                    let isChangeVisiblity = false;
                    actionTarget.map(row => {
                      if (row) {
                        if (row.get('type') == 'hide') {
                          if (oldRules && !oldRules.includes('hide')) {
                            isChangeVisiblity = true;
                          }
                        } else if (row.get('type') == 'show') {
                          if (oldRules && oldRules.includes('hide')) {
                            isChangeVisiblity = true;
                          }
                        }
                      }
                    })
                    if (isChangeVisiblity) {
                      let repeatRoot = retState.getIn(['project', 'Settings', 'RepeatedStripsID'], List()).toJS()
                      if (repeatRoot.includes(fullPath[1])) {
                        let children = collectAllChildren(elem.get('children', List()).toJS(), ['pages', retState.getIn(['page']), 'Props'], retState);
                        let changesPath = [
                          [fullPath[0], fullPath[1]],
                          [fullPath[0], fullPath[1] + '-totalRows']
                        ];
                        _.each(children, row=>{
                          changesPath.push([fullPath[0], fullPath[1], row])
                        })
                        if(_.size(fullPath) === 2 || fullPath[1] === fullPath[2]){
                          retState = retState.setIn(
                            ['ft', 'changes'],
                            fromJS(changesPath)
                          )
                        }
                        // retState = doProcessRules(retState, false, null, null, changesPath, false, isOnload, index, true, toJS(currentRule.get('options', Map())) || {})
                      }
                    }
                  }
                } catch (err) {
                  console.error(err);
                }
              }
            }
          } else {
            const oldRules = toJS(retState.getIn(['rules', ...keyPath, index]))
            const newRules = actionTarget.map(action => {
              if (!isImmutable(action)) { action = Map() }
              if (action.get('type') === 'mandatory' && !ALLOW_MANDATORY_TYPE.includes(action.get('elemType'))) {
                return ''
              } else if (action.get('type') === 'runAnimation') {
                return action.getIn(['animation', 'value'])
              } else if (isColorAction({ actionType: action.get('type'), withBorderColor: true })) {
                return getColorValueFromAction(action, retState)
              } else {
                return action.get('type')
              }
            }).toJS()
            let keyPath2 = keyPath;
            if (keyIndex.indexOf(':link:') !== -1) {
              keyPath2 = String(keyIndex).split(':')
              keyPath2 = [
                ..._.slice(keyPath2, 0, keyPath2.length - 2),
                index,
                ..._.slice(keyPath2, keyPath2.length - 2, keyPath2.length)
              ]
            }
            let rules = retState.getIn(['rules'], Map()).toJS();
            rules = _.set(rules, keyPath2, setNewRules(retState.getIn(['rules', ...keyPath2], List()), fromJS(newRules), keyPath2));
            retState = retState.setIn(
              ['rules'], fromJS(rules)
            )
            if (!isSkipReRun) {
              if (!shallowEqual(oldRules, newRules)) {
                let fullPath = keyIndex.split(':');
                if (fullPath[1]) {
                  if (index !== undefined && index !== null && isAllowIndexForPath(retState, fullPath)) {
                    fullPath.push(index);
                  }
                  // retState = doProcessRules(retState, false, fullPath[1], fullPath, [fullPath], true, isOnload, oldState)
                  retState = retState.setIn(
                    ['ft', 'changes'],
                    effectElementsInsideCondition(retState, fullPath)
                  )
                }
              }
            }
          }
        }
        if (isNeedOnValueChange && !isOnlyEffects) {
          let fullPath = keyIndex.split(':');
          if (fullPath[1]) {
            if (index !== undefined && index !== null && isAllowIndexForPath(retState, fullPath)) {
              fullPath.push(index);
            }
            retState = retState.setIn(
              ['ft', 'changes'],
              effectElementsInsideCondition(retState, fullPath)
            )
            // retState = doProcessRules(retState, false, fullPath[1], fullPath, [fullPath], true, isOnload, oldState)
          }
        } else {
          if (isNeedOnValueChange) {
            let fullPath = keyIndex.split(':');
            if (fullPath[1]) {
              const [st, changes] = recalculatePowerFields(retState, [fullPath])
              retState = st;
            }
          }
        }
      }
    });
    return {
      retState,
      portalState,
      params
    };
  };
}

export const processSingleRuleProps = function (props) {
  // providedCurrentRule, path, portalState, params, smartVParams, retState, isOnlyEffects, isOnload, oldState = {}, oldParams = {}, fullPath = []
  let {
    providedCurrentRule,
    path,
    portalState,
    params,
    smartVParams,
    retState,
    isOnlyEffects,
    isOnload,
    oldState,
    oldParams,
    fullPath,
    processUID,
    processIndex,
    processMeta,
    isForce,
    rowIndex
  } = props

  if(typeof rowIndex !== 'number') {
    rowIndex = null;
  }
  if (oldState === undefined) {
    oldState = {};
  }
  if (oldParams === undefined) {
    oldParams = {};
  }
  if (fullPath === undefined) {
    fullPath = [];
  }

  let currentRule = providedCurrentRule;
  if (currentRule.get('enable', true) === false) {
    return retState;
  }

  if (processUID) {
    if (processIndex > 0 && !isForce && !isNeedProcessQueCondition(retState, processUID, providedCurrentRule)) {
      let condCache = retState.getIn(['__cond__cache__', 'list', processUID], List());
      condCache = condCache.push(fromJS({
        providedCurrentRule,
        isOnlyEffects: false,
        isOnload,
        fullPath,
        processIndex,
        path
      }))
      return retState.setIn(['__cond__cache__', 'list', processUID], condCache);
    }
  }

  // let portalState = getState(retState)
  // let params = getParams(retState)
  let isNotNeedProcessSF = false;

  if (!currentRule.get('name') && currentRule.getIn(['action', 0, 'name'])) {
    currentRule = currentRule.set('name', currentRule.getIn(['action', 0, 'name']));
  }

  if (currentRule.get('action')) {
    currentRule = currentRule.set('action', currentRule.get('action', List()).filter(row => {
      return row.get('enable', true) !== false;
    }))
  }

  const IS_ALLOW_DEBUG_MODE = retState.getIn(['IS_ALLOW_DEBUG_MODE'], false);

  const processRuleTargets = getProcessTargetsFunction(retState, currentRule, isOnlyEffects, portalState, params, isNotNeedProcessSF, isOnload, processUID, processIndex, oldState, oldParams, path);
  let isTargetTable = false, isListTarget = false;
  if (currentRule.get('isActionRule', false)) {
    if (currentRule.get('modeType')=== 'flow') {  // if undefined == classic conditions
      let nodes = currentRule.getIn(['actions','actionFlow', '0', 'list'], List())
      nodes.map(node => {
        if(node.get('type') ==='affectElements'){
          node.get('data', Map()).map((v, key) => {
            if(v && List.isList(v)) {
              v.map(action=>{
                if (!isImmutable(action)) { action = Map() }
                if(action && isColorAction({ actionType: action.get('type') })) {
                  if(action.get('elemType') == 'PowerTableWidget') {
                    isListTarget = true;
                  }
                }
              })
            }
            if (String(key).indexOf(':list_row_style') !== -1) {
              if (v.size) {
                isListTarget = true;
              }
            } else if (String(key).indexOf(':row_style') !== -1) {
              if (v.size) {
                isTargetTable = true;
              }
            } else {
              return false
            }
          })
        }
      })
    } else {
      const rules = currentRule.get('action', List())
      rules.map(rule => {
        rule.get('actions', Map())?.find?.((v, key) => {
          if(v && List.isList(v)) {
            v.map(action=>{
              if (!isImmutable(action)) { action = Map() }
              if(action && isColorAction({ actionType: action.get('type') })) {
                if(action.get('elemType') == 'PowerTableWidget') {
                  isListTarget = true;
                }
              }
            })
          }
          if (String(key).indexOf(':list_row_style') !== -1) {
            if (v.size) {
              isListTarget = true;
            }
          } else if (String(key).indexOf(':row_style') !== -1) {
            if (v.size) {
              isTargetTable = true;
            }
          } else {
            return false
          }
        })
      })
    }
  }
  if (!isTargetTable && !isListTarget && currentRule.get('isActionRule', false)) {
    let rules = currentRule.get('action', List())
    if (!processUID) {
      processUID = uuid();
    }
    let actionProcessIndex = 0;
    processIndex = 0;
    rules.map(rule => {
      let localRule = currentRule.set('modeType', rule.get('modeType'))
      const processRuleTargets = getProcessTargetsFunction(retState, localRule, isOnlyEffects, portalState, params, isNotNeedProcessSF, isOnload, processUID, processIndex, oldState, oldParams, path);
      rule = rule.setIn(['options'], currentRule.getIn(['options']));

      const page = retState.get('page')
      const repeatStripRaw = retState.getIn(['pages', page, 'Props', 'Grid'], List())
        .map(uid => {
          const elem = retState.getIn(['pages', page, 'Props', 'elements', uid], Map())
          if (elem.getIn(['props', 'isRepeat']) || elem.getIn(['props', 'isRepeatCol'])) {
            return uid
          } else {
            return false
          }
        }).toJS()
      let repeatRoot = retState.getIn(['project', 'Settings', 'RepeatedStripsID'], List()).toJS()
      const repeatStrip = _.compact(repeatStripRaw.concat(repeatRoot))
      let isTargetRepeat = repeatStrip.length > 0 && Boolean(rule.get('actions', Map())?.find?.((v, key) => {
        if (String(key).indexOf(':') !== -1 && v && List.isList(v) && v.size) {
          const repeatUID = String(key).split(':')[1]
          return repeatStrip.indexOf(repeatUID) !== -1
        } else {
          return false
        }
      }))
      let isTargetRepeatOwner = false;
      if (!isTargetRepeat && fullPath && fullPath.length) {
        if (repeatStrip.indexOf(fullPath[1]) > -1) {
          isTargetRepeatOwner = true;
        }
      }
      let isTableRule = false;
      let isListRule = false;
      let isParamCondition = false;
      try {
        if(isImmutable(rule.get('actions', List()))){
          rule.get('actions', List()).map(groupActions => {
            if(groupActions && List.isList(groupActions)) {
              groupActions.map(action=>{
                if (!isImmutable(action)) { action = Map() }
                if(action && isColorAction({ actionType: action.get('type') })) {
                  if(action.get('elemType') == 'PowerTableWidget') {
                    isListRule = true;
                  }
                }
              })
            }
          });
        }
      } catch(err) {
        console.error(err);
      }

      rule.get('conditions', List()).map(condition => {
        if (_.startsWith(condition.getIn(['field', 'group'], ''), 'tableWidget:')) {
          isTableRule = true
        }
        if (_.startsWith(condition.getIn(['value', 'group'], ''), 'tableWidget:')) {
          isTableRule = true
        }
        if (_.startsWith(condition.getIn(['field', 'group'], ''), 'listWidget:') || _.startsWith(condition.getIn(['field', 'group'], ''), 'PowerTableWidget:')) {
          isListRule = true
        }
        if (_.startsWith(condition.getIn(['value', 'group'], ''), 'listWidget:') || _.startsWith(condition.getIn(['value', 'group'], ''), 'PowerTableWidget:')) {
          isListRule = true
        }
        if (condition.getIn(['field', 'group']) == 'param') {
          isParamCondition = true;
        }
      })
      if ((isTargetRepeat || isTargetRepeatOwner) && currentRule.get('index') !== 0 && !currentRule.get('index')) {
        let allRepeatedUID = [];
        rule.get('actions', Map()).map((v, key) => {
          const repeatUID = String(key).split(':')[1]
          if (allRepeatedUID.indexOf(repeatUID) == -1) {
            allRepeatedUID.push({
              repeatUID,
              key
            });
          }
        })
        let num = 1;
        let localFullPath = [...fullPath];
        if (isTargetRepeatOwner) {
          localFullPath.splice(0, localFullPath.length - 1);
        }
        let maxNumState = retState.get('state', Map()).toJS();
        _.each(allRepeatedUID, function (row) {
          if (isTargetRepeatOwner) {
            let localFullPath2 = [...fullPath];
            row.key = localFullPath2.splice(0, localFullPath2.length - 1).join(':')
          }
          const repeatPath = String(row.key).split(':')
          const repeatState = _.get(
            path.length > 0 ? _.get(maxNumState, path) : maxNumState,
            repeatPath.slice(0, 2),
            []
          )
          let localNum = getMappingCount(repeatState);
          num = _.max([num, localNum]);
        });
        if (actionProcessIndex > 0 && !isNeedProcessQueCondition(retState, processUID)) {
          let condCache = retState.getIn(['__cond__cache__', 'list', processUID], List());
          condCache = condCache.push(fromJS({
            providedCurrentRule: rule,
            isOnlyEffects: false,
            isOnload,
            fullPath,
            index: null,
            processIndex: actionProcessIndex,
            path,
            options: currentRule.getIn(['options']),
            isActionRule: currentRule.get('isActionRule', false),
            isTableRule: rule.get('isTableRule', false)
          }))
          retState = retState.setIn(['__cond__cache__', 'list', processUID], condCache);

          return false;
        }
        _.times(num, (index) => {
          const processRuleTargets = getProcessTargetsFunction(retState, currentRule, isOnlyEffects, portalState, params, isNotNeedProcessSF, isOnload, processUID, processIndex, oldState, oldParams, path);
          if (localFullPath && localFullPath.length == 1 && typeof localFullPath[0] == 'number' && localFullPath[0] != index) {
            return true;
          }

          // no conditions (simple action / on load)
          if (rule.get('isAction', false) || rule.get('conditions', List()).size == 0) {
            if (IS_ALLOW_DEBUG_MODE) {
              console.log('run rule >>> ', rule.get('name', 'Unnamed'))
            }
            const result = processRuleTargets(index, true, false, rule, rule.get('actions', Map()))
            retState = result.retState
            portalState = result.portalState
            params = result.params
          } else {
            const ruleRunResult = processRuleCondition(
              rule.get('conditions', List()).toJS(),
              portalState,
              params,
              smartVParams,
              index,
              {},
              isOnload,
              oldState,
              oldParams,
              retState
            ) || rule.get('modeType') === 'flow'

            if (ruleRunResult) {
              if (IS_ALLOW_DEBUG_MODE) {
                console.log('run rule >>> ', rule.get('name', currentRule.get('name', 'Unnamed')))
              }
              const result = processRuleTargets(index, true, false, rule, rule.get('actions', Map()))
              retState = result.retState
              portalState = result.portalState
              params = result.params
            } else {
              if (rule.get('supportOpposite', false)) { // only for classic conditions - checkbox "support opposite"
                if (IS_ALLOW_DEBUG_MODE) {
                  console.log('run rule opposite >>> ', rule.get('name', currentRule.get('name', 'Unnamed')))
                }
                transformActions(rule.get('actions', Map())).map((actionTarget, key) => {
                  const keyPath = String(key).split(':');
                  const isPossibleRepeat = detectIsTargetKeyInRepeatEl(keyPath, retState) && typeof index === 'number'
                  const index = index
                  const rulesKey = ['rules', ...keyPath, ...isPossibleRepeat ? [index] : []]
                  retState = retState.setIn(
                    rulesKey,
                    setNewRules(
                      retState.getIn(rulesKey, List()),
                      actionTarget.map(action => {
                        if (!isImmutable(action)) { action = Map() }
                        if (action.get('type') === 'mandatory' && !ALLOW_MANDATORY_TYPE.includes(action.get('elemType'))) {
                          return ''
                        } else {
                          return getOpposite(action.get('type'))
                        }
                      }),
                      keyPath
                    )
                  )

                  retState = refreshOnProcessOpposite(retState, actionTarget, isOnload, oldState);

                });
              }
            }
          }
        })
        actionProcessIndex++;
        processIndex = actionProcessIndex;
      } else {
        if (actionProcessIndex > 0 && !isNeedProcessQueCondition(retState, processUID)) {
          let condCache = retState.getIn(['__cond__cache__', 'list', processUID], List());
          condCache = condCache.push(fromJS({
            providedCurrentRule: rule,
            isOnlyEffects: false,
            isOnload,
            fullPath,
            processIndex: actionProcessIndex,
            path,
            options: currentRule.getIn(['options']),
            isActionRule: currentRule.get('isActionRule', false),
            isTableRule: currentRule.get('isTableRule', false) || isTargetTable,
            index: currentRule.get('index'),
          }))
          retState = retState.setIn(['__cond__cache__', 'list', processUID], condCache);
          return false;
        }
        if ((rule.get('isAction', false) || rule.get('conditions', List()).size == 0)) {
          if (IS_ALLOW_DEBUG_MODE) {
            console.log('run rule >>> ', rule.get('name', 'Unnamed'))
          }
          const result = processRuleTargets(currentRule.get('index'), true, false, rule, rule.get('actions', Map()))
          retState = result.retState
          portalState = result.portalState
          params = result.params
        } else {
          const ruleRunResult = processRuleCondition(
            rule.get('conditions', List()).toJS(),
            portalState,
            params,
            smartVParams,
            currentRule.get('index') ?? null,
            {},
            isOnload,
            oldState,
            oldParams,
            retState
          ) || rule.get('modeType') === 'flow'

          if (ruleRunResult) {
            if (IS_ALLOW_DEBUG_MODE) {
              console.log('run rule >>> ', rule.get('name', 'Unnamed'))
            }
            const result = processRuleTargets(currentRule.get('index'), true, false, rule, rule.get('actions', Map()))
            retState = result.retState
            portalState = result.portalState
            params = result.params
          } else {
            if (rule.get('supportOpposite', false)) {
              if (IS_ALLOW_DEBUG_MODE) {
                console.log('run rule opposite >>> ', rule.get('name', 'Unnamed'))
              }
              transformActions(rule.get('actions', Map())).map((actionTarget, key) => {
                let keyPath = String(key).split(':');
                const isPossibleRepeat = detectIsTargetKeyInRepeatEl(keyPath, retState) && typeof _.last(path) === 'number'
                const index = currentRule.get('index')
                let rulesKey = ['rules', ...keyPath, ...isPossibleRepeat ? [index] : []]
                if(isPossibleRepeat) {
                  if (keyPath[3] == 'items') {
                    rulesKey = ['rules', keyPath[0], keyPath[1], `${keyPath[2]}-${keyPath[3]}`, index, keyPath[4]];
                  }
                } else {
                  if (keyPath[2] == 'items') {
                    rulesKey = ['rules', keyPath[0], `${keyPath[1]}-${keyPath[2]}`, keyPath[3]];
                  }
                }

                retState = retState.setIn(
                  rulesKey,
                  setNewRules(
                    retState.getIn(rulesKey, List()),
                    actionTarget.map(action => {
                      if (!isImmutable(action)) { action = Map() }
                      if (action.get('type') === 'mandatory' && !ALLOW_MANDATORY_TYPE.includes(action.get('elemType'))) {
                        return ''
                      } else {
                        return getOpposite(action.get('type'))
                      }
                    }),
                    keyPath
                  )
                )
                retState = refreshOnProcessOpposite(retState, actionTarget, isOnload, oldState);
              });
            }
          }
        }
        actionProcessIndex++;
        processIndex = actionProcessIndex;
      }
      portalState = getState(retState)
    })

    let changes = _.uniqBy(retState.getIn(['ft', 'changes'], List()).toJS(), v => v.join(':'))
    // we set on the state all the changes needs to be done
    // cleans it
    retState = retState.setIn(
      ['ft', 'changes'],
      List()
    )
    // process for the changes to be made (inside there's a protection not to re-process what was processed already)
    if (changes.length > 0) {
      retState = doProcessRules(retState, false, null, [], compactArrayPath(changes), false, isOnload, oldState)
    }

    return retState;
  }
  // if (currentRule.get('isButtonRule') && currentRule.get('isTableRule', false) === false) {
  if (currentRule.get('isButtonRule')) {
    if (IS_ALLOW_DEBUG_MODE) {
      console.log('run rule >>> ', currentRule.get('name', 'Unnamed'), currentRule.toJS())
    }
    const result = processRuleTargets(currentRule.get('index'), true, false, undefined, currentRule.get('actions', Map()))
    retState = result.retState
    portalState = result.portalState
    params = result.params
    return retState;
  }
  // if (currentRule.get('isTableRule', false)) {
  //   currentRule.get('actions', Map()).map(processRuleTargets(currentRule.get('index'), true));
  //   return retState;
  // }
  const page = retState.get('page')
  const repeatStripRaw = retState.getIn(['pages', page, 'Props', 'Grid'], List())
    .map(uid => {
      const elem = retState.getIn(['pages', page, 'Props', 'elements', uid], Map())
      if (elem.getIn(['props', 'isRepeat']) || elem.getIn(['props', 'isRepeatCol'])) {
        return uid
      } else {
        return false
      }
    }).toJS()
  let repeatRoot = retState.getIn(['project', 'Settings', 'RepeatedStripsID'], List()).toJS()
  const repeatStrip = _.compact(repeatStripRaw.concat(repeatRoot))
  let isTargetRepeat = repeatStrip.length > 0 && Boolean(currentRule.get('actions', Map()).find((v, key) => {
    if (String(key).indexOf(':') !== -1) {
      const repeatUID = String(key).split(':')[1]
      return repeatStrip.indexOf(repeatUID) !== -1
    } else {
      return false
    }
  }))
  if (!isTargetRepeat) {
    isTargetRepeat = Boolean(currentRule.get('conditions', List()).find((cond, key) => {
      let left = String(cond.getIn(['field', 'value'])).split(':')
      if (repeatStrip.includes(left[1])) {
        return true
      }
      if (cond.getIn(['valueType']) === 'field') {
        let right = String(cond.getIn(['value', 'value'], '')).split(':')
        if (repeatStrip.includes(right[1])) {
          return true
        }
      }
      if (String(key).indexOf(':') !== -1) {
        const repeatUID = String(key).split(':')[1]
        return repeatStrip.indexOf(repeatUID) !== -1
      } else {
        return false
      }
    }))
  }
  let isTargetRepeatOwner = false;
  if (!isTargetRepeat && fullPath && fullPath.length) {
    if (repeatStrip.indexOf(fullPath[1]) > -1) {
      isTargetRepeatOwner = true;
    }
  }
  let isTableRule = isTargetTable;
  let isListRule = isListTarget;
  let isParamCondition = false;

  let isListResult = isListCondition(currentRule);
  if(isListResult.isTableRule) {
    isTableRule = true;
  }
  if(isListResult.isListRule) {
    isListRule = true;
  }
  if(isListResult.isParamCondition) {
    isParamCondition = true;
  }

  if ((isTargetRepeat || isTargetRepeatOwner) && currentRule.get('modeType') !== 'flow') {
    let allRepeatedUID = [];
    currentRule.get('actions', Map()).map((v, key) => {
      const repeatUID = String(key).split(':')[1]
      if (repeatUID && allRepeatedUID.indexOf(repeatUID) == -1) {
        allRepeatedUID.push({
          repeatUID,
          key
        });
      }
    })
    currentRule.get('conditions', List()).map(cond => {
      let left = String(cond.getIn(['field', 'value'])).split(':')
      if (repeatStrip.includes(left[1]) && !allRepeatedUID.includes(left[1])) {
        allRepeatedUID.push({
          repeatUID: left[1],
          key: cond.getIn(['field', 'value'])
        });
      }
      if (cond.getIn(['valueType']) === 'field') {
        let right = String(cond.getIn(['value', 'value'], '')).split(':')
        if (repeatStrip.includes(right[1]) && !allRepeatedUID.includes(right[1])) {
          allRepeatedUID.push({
            repeatUID: right[1],
            key: cond.getIn(['value', 'value'])
          });
        }
      }
    })
    let num = 1;
    let localFullPath = [...fullPath];
    if (isTargetRepeatOwner) {
      localFullPath.splice(0, localFullPath.length - 1);
    }
    let maxNumState = retState.get('state', Map()).toJS();
    _.each(allRepeatedUID, function (row) {
      if (isTargetRepeatOwner) {
        let localFullPath2 = [...fullPath];
        row.key = localFullPath2.splice(0, localFullPath2.length - 1).join(':')
      }
      const repeatPath = String(row.key).split(':')
      const repeatState = _.get(
        path.length > 0 ? _.get(maxNumState, path) : maxNumState,
        repeatPath.slice(0, 2),
        []
      )
      let localNum = getMappingCount(repeatState);
      num = _.max([num, localNum]);
    });
    _.times(num, (index) => {
      if (localFullPath && localFullPath.length == 1 && typeof localFullPath[0] == 'number' && localFullPath[0] != index) {
        return true;
      }
      if (localFullPath && localFullPath.length == 4 && typeof localFullPath[3] == 'number' && localFullPath[3] != index) {
        return true;
      }
      if (processRuleCondition(
        currentRule.get('conditions', List()).toJS(),
        path.length > 0 ? _.get(portalState, path) : portalState,
        path.length > 0 ? _.get(params, path) : params,
        smartVParams, index, {}, isOnload, oldState, oldParams, retState
      )) {
        if (IS_ALLOW_DEBUG_MODE) {
          console.log('run rule >>> ', currentRule.get('name', 'Unnamed'))
        }
        transformActions(currentRule.get('actions', Map()))
          .map((row, key) => {
            const processRuleTargets = getProcessTargetsFunction(retState, currentRule, isOnlyEffects, portalState, params, isNotNeedProcessSF, isOnload, processUID, processIndex, oldState, oldParams, path);
            if (String(key).indexOf(':') > -1) {
              const repeatUID = String(key).split(':')[1]
              const elemUID = String(key).split(':')[2]
              if (repeatUID === elemUID) {
                const result = processRuleTargets(index, true, false, undefined, fromJS({
                  [key]: row
                }))
                retState = result.retState
                portalState = result.portalState
                params = result.params
                return retState
              } else if (repeatStrip.indexOf(repeatUID) === -1) {
                // if (index > 0 && repeatUID !== elemUID) {
                  // return true;
                // }
                const result = processRuleTargets(null, undefined, undefined, undefined, fromJS({
                  [key]: row
                }))
                retState = result.retState
                portalState = result.portalState
                params = result.params
                return retState
              }
            }
            const result = processRuleTargets(index, true, true, undefined, fromJS({
              [key]: row
            }))
            retState = result.retState
            portalState = result.portalState
            params = result.params
          });
      } else {
        if (currentRule.get('supportOpposite', false)) {
          if (IS_ALLOW_DEBUG_MODE) {
            console.log('run rule opposite >>> ', currentRule.get('name', 'Unnamed'))
          }
          transformActions(currentRule.get('actions', Map())).map((actionTarget, key) => {
            let keyPath = String(key).split(':');
            if (String(key).indexOf(':') > -1) {
              const repeatUID = keyPath[1]
              if (repeatStrip.indexOf(repeatUID) === -1) {
                if (index > 0) {
                  return true;
                }

                let oppositeRules = actionTarget.map(action => {
                  if (!isImmutable(action)) { action = Map() }
                  if (action.get('type') === 'mandatory' && !ALLOW_MANDATORY_TYPE.includes(action.get('elemType'))) {
                    return ''
                  } else {
                    return getOpposite(action.get('type'))
                  }
                });
                let newRules = setNewRules(retState.getIn(['rules', ...keyPath], List()), oppositeRules, keyPath);
                retState = retState.setIn(['rules', ...keyPath], newRules);
                retState = refreshOnProcessOpposite(retState, actionTarget, isOnload, oldState);
                return true;
              }
            }
            let updateKeyPath = [...keyPath, index];
            if (keyPath[3] == 'items') {
              keyPath = [keyPath[0], keyPath[1], `${keyPath[2]}-${keyPath[3]}`, index, keyPath[4]];
              updateKeyPath = keyPath;
            } else if (keyPath[1] === 'portal') {
              keyPath[1] = retState.getIn(['portal', 'selectedPage'])
              updateKeyPath = [...keyPath, index];
            }
            let oppositeRules2 = actionTarget.map(action => {
              if (action.get('type') === 'mandatory' && !ALLOW_MANDATORY_TYPE.includes(action.get('elemType'))) {
                return ''
              } else {
                return getOpposite(action.get('type'))
              }
            });
            let setNewRules2 = setNewRules(retState.getIn(['rules', ...updateKeyPath], List()), oppositeRules2, keyPath).toJS();
            let rules = retState.getIn(['rules'], Map()).toJS();
            rules = _.set(rules, updateKeyPath, setNewRules2);
            retState = retState.setIn(['rules'], fromJS(rules))
            retState = refreshOnProcessOpposite(retState, actionTarget, isOnload, oldState);
          });
        }
      }
    })
  } else if (isTableRule) {
    let conditionList = [currentRule];
    if (currentRule.get('isActionRule', false)) {
      conditionList = [];
      currentRule.get('action', List()).map(rule => {
        conditionList.push(rule)
      })
    };
    if(currentRule.get('modeType') === 'flow'){
      const current = currentRule.getIn(['actions', 'actionFlow', '0', 'list'], List())
        .find(node => node.get('type') === 'input')
        ?.get?.('id');
      retState = retState.setIn(
        ['__cache__'],
        retState.getIn(['__cache__'], List())
          .push(fromJS({
            type: 'FlowActionStep',
            payload: {
              list: currentRule.getIn(['actions', 'actionFlow', '0', 'list'], List()),
              elemUID: currentRule.getIn(['actions', 'actionFlow', '0', 'elemUID']),
              current,
              index: null,
              currentRule,
              currentSingleRule: Map(),
              isOnlyEffects: false,
              path: [],
              oldState,
              oldParams,
              processUID
            }
          }))
      );
      return retState
    }

    _.each(conditionList, (currentRule) => {
      let tablePath = []

      let isPathFound = false
      currentRule.get('conditions', List()).map(condition => {
        if (_.startsWith(condition.getIn(['field', 'group'], ''), 'PowerTableWidget:') && !isPathFound) {
          tablePath = _.initial(condition.getIn(['field', 'value'], '').split(':'))
          isPathFound = true
        }
        if (_.startsWith(condition.getIn(['field', 'group'], ''), 'tableWidget:') && !isPathFound) {
          tablePath = _.initial(condition.getIn(['field', 'value'], '').split(':'))
          isPathFound = true
        }
        if (_.startsWith(condition.getIn(['value', 'group'], ''), 'tableWidget:') && !isPathFound) {
          tablePath = _.initial(condition.getIn(['value', 'value'], '').split(':'))
          isPathFound = true
        }
      })

      const tableState = _.get(
        portalState,
        tablePath,
        []
      )

      _.each(tableState, (row, index) => {
        const processRuleTargets = getProcessTargetsFunction(retState, currentRule, isOnlyEffects, portalState, params, isNotNeedProcessSF, isOnload, processUID, processIndex, oldState, oldParams, path);
        const condResult = processRuleCondition(
          currentRule.get('conditions', List()).toJS(),
          portalState,
          params,
          smartVParams,
          null,
          { tableIndex: index },
          isOnload,
          oldState,
          oldParams,
          retState
        ) || currentRule.get('modeType') === 'flow'


        if (condResult) {
          if (IS_ALLOW_DEBUG_MODE) {
            console.log('run rule >>> ', currentRule.get('name', 'Unnamed'))
          }
          const result = processRuleTargets(index, true, false, Map(), currentRule.get('actions', Map()))
          retState = result.retState
          portalState = result.portalState
          params = result.params
        } else {
          if (currentRule.get('supportOpposite', false)) {
            if (IS_ALLOW_DEBUG_MODE) {
              console.log('run rule opposite >>> ', currentRule.get('name', 'Unnamed'))
            }
            transformActions(currentRule.get('actions', Map())).map((actionTarget, key) => {
              let keyPath = String(key).split(':')
              const initialKey = _.slice(keyPath, 0, keyPath.length - 2)
              if(!isImmutable(retState.getIn(['rules', ...initialKey]))){
                retState = retState.setIn(['rules', ...initialKey], Map())
              }
              if(!isImmutable(retState.getIn(['rules', ...initialKey, String(index)]))){
                retState = retState.setIn(['rules', ...initialKey, String(index)], Map())
              }
              if (_.endsWith(key, ':row_style')) {
                keyPath = String(key).split(':')
                let preKey = _.initial(keyPath)
                preKey[preKey.length - 1] = `${preKey[preKey.length - 1]}-row_style`
                keyPath = [...preKey, String(index), _.last(keyPath)]
                if (actionTarget.getIn([0, 'value'], '')) {
                  try {
                    retState = retState.setIn(
                      ['rules', ...keyPath],
                      ''
                    )
                  } catch (error) {
                    console.error(error)
                  }
                }
              } else if (key.indexOf(':fieldStyle:') !== -1) {
                keyPath = String(key).split(':')
                keyPath = [
                  ..._.slice(keyPath, 0, keyPath.length - 2),
                  String(index),
                  ..._.slice(keyPath, keyPath.length - 2, keyPath.length)
                ]

                try {
                  let value = {
                    ...actionTarget.getIn([0, 'value'], '') ? { backgroundColor: '' } : {},
                    ...actionTarget.getIn([0, 'valueColor'], '') ? { color: '' } : {},
                    ...getOpposite(actionTarget.getIn([0, 'type'], '')) == 'hide' ? { display: 'none' } : {},
                  }
                  retState = retState.setIn(
                    ['rules', ...keyPath],
                    fromJS(value)
                  )
                } catch (error) {
                  console.error(error)
                }

              } else {
                keyPath = String(key).split(':')
                keyPath = [
                  ..._.slice(keyPath, 0, keyPath.length - 1),
                  index,
                  ..._.slice(keyPath, keyPath.length - 1, keyPath.length)
                ]
                let newRule = setNewRules(retState.getIn(['rules', ...keyPath], List()), actionTarget.map(action => {
                  if (!isImmutable(action)) { action = Map() }
                  if (action.get('type') === 'mandatory' && !ALLOW_MANDATORY_TYPE.includes(action.get('elemType'))) {
                    return ''
                  } else {
                    return getOpposite(action.get('type'))
                  }
                }), keyPath)
                try {
                  retState = retState.setIn(['rules', ...keyPath], newRule);
                } catch (error) {
                  console.error(error)
                }

                retState = refreshOnProcessOpposite(retState, actionTarget, isOnload, oldState);
              }
            });
          }
        }
      })
    })
  } else if (isListRule) {
    let conditionList = [currentRule];
    if (currentRule.get('isActionRule', false)) {
      conditionList = [];
      currentRule.get('action', List()).map(rule => {
        conditionList.push(rule)
      })
    };
    if(currentRule.get('modeType') === 'flow'){
      currentRule.getIn(['actions', 'actionFlow', '0', 'list'], List()).map(node=>{
        if(node.get('type') === 'condition' || node.get('type') === 'affectElements'){
          conditionList.push(currentRule);
        }
      })
    }
    let hashProcessFlows = {};
    _.each(conditionList, (currentRule) => {
      let listPath = []
      const allListPaths = []
      let isPowerTable = false;
      if(currentRule.get('modeType') === 'flow'){
        currentRule.getIn(['actions', 'actionFlow', '0', 'list'], List()).map(node=>{
          if(node.get('type') === 'affectElements'){
            node.get('data', Map()).map((groupActions, key) => {
              if(groupActions && List.isList(groupActions)) {
                groupActions.map(action=>{
                  if(action && isColorAction({ actionType: action.get('type') })) {
                    if(action.get('elemType') == 'PowerTableWidget') {
                      isPowerTable = true;
                      listPath = String(key).split(':')
                      allListPaths.push(String(key).split(':'))
                    }
                  }
                })
              }
            })
          } else if(node.get('type') === 'condition'){
            node.get('data', List()).map(condGroup => {
              condGroup.get('conditions', List()).map(condition => {
                if(_.startsWith(condition.getIn(['field', 'group'], ''), 'PowerTableWidget:')) {
                  isPowerTable = true;
                }
                if (_.startsWith(condition.getIn(['field', 'group'], ''), 'listWidget:') || _.startsWith(condition.getIn(['field', 'group'], ''), 'PowerTableWidget:')) {
                  listPath = condition.getIn(['field', 'value'], '').split(':')
                  allListPaths.push(condition.getIn(['field', 'value'], '').split(':'))
                }
                if(_.startsWith(condition.getIn(['value', 'group'], ''), 'PowerTableWidget:')) {
                  isPowerTable = true;
                }
                if (_.startsWith(condition.getIn(['value', 'group'], ''), 'listWidget:') || _.startsWith(condition.getIn(['value', 'group'], ''), 'PowerTableWidget:')) {
                  listPath = condition.getIn(['value', 'value'], '').split(':')
                  allListPaths.push(condition.getIn(['value', 'value'], '').split(':'))
                }
              })
            })
          }
        })
        if(isPowerTable) {
          if(currentRule.get('uid')) {
            if(hashProcessFlows[currentRule.get('uid')]) {
              return true;
            }
            hashProcessFlows[currentRule.get('uid')] = true;
          }
          const result = processRuleTargets(rowIndex, true, false, Map(), currentRule.get('actions', Map()), rowIndex, processMeta)
          retState = result.retState
          portalState = result.portalState
          params = result.params
          return true;
        }

      } else {
        currentRule.get('actions', List()).map((groupActions, key) => {
          if(groupActions && List.isList(groupActions)) {
            groupActions.map(action=>{
              if(action && isColorAction({ actionType: action.get('type') })) {
                if(action.get('elemType') == 'PowerTableWidget') {
                  listPath = String(key).split(':')
                  allListPaths.push(String(key).split(':'))
                }
              }
            })
          }
        });
      }
      currentRule.get('conditions', List()).map(condition => {
        if (_.startsWith(condition.getIn(['field', 'group'], ''), 'listWidget:') || _.startsWith(condition.getIn(['field', 'group'], ''), 'PowerTableWidget:')) {
          listPath = condition.getIn(['field', 'value'], '').split(':')
          allListPaths.push(condition.getIn(['field', 'value'], '').split(':'))
        }
        if (_.startsWith(condition.getIn(['value', 'group'], ''), 'listWidget:') || _.startsWith(condition.getIn(['value', 'group'], ''), 'PowerTableWidget:')) {
          listPath = condition.getIn(['value', 'value'], '').split(':')
          allListPaths.push(condition.getIn(['value', 'value'], '').split(':'))
        }
      })

      let listState = _.get(
        portalState,
        listPath,
        []
      )
      if(!_.isArray(listState)){
        listState = [listState]
      }
      if(listPath.length === 0) {
        listState = [true]
      }
      //16231Web - Power table select row improvments
      //need for power table to not run all items
      if(typeof rowIndex === 'number'){
        let index = rowIndex
        let localRowIndex = rowIndex;
        const processRuleTargets = getProcessTargetsFunction(retState, currentRule, isOnlyEffects, portalState, params, isNotNeedProcessSF, isOnload, processUID, processIndex, oldState, oldParams, path);
        if(currentRule.get('modeType') === 'flow'){
          const result = processRuleTargets(index, true, false, Map(), currentRule.get('actions', Map()), localRowIndex)
          retState = result.retState
          portalState = result.portalState
          params = result.params
        }else{
          let condResult = true;
          if(currentRule.get('conditions', List()).size) {
            condResult = processRuleCondition(
              currentRule.get('conditions', List()).toJS(),
              portalState,
              params,
              smartVParams,
              null,
              { listIndex: index },
              isOnload,
              oldState,
              oldParams,
              retState
            ) || currentRule.get('modeType') === 'flow'
          }
          if (condResult) {
            if (IS_ALLOW_DEBUG_MODE) {
              console.log('run rule >>> ', currentRule.get('name', 'Unnamed'))
            }
            const result = processRuleTargets(index, true, false, Map(), currentRule.get('actions', Map()), localRowIndex)
            retState = result.retState
            portalState = result.portalState
            params = result.params
          } else {
            if (currentRule.get('supportOpposite', false)) {
              if (IS_ALLOW_DEBUG_MODE) {
                console.log('run rule opposite >>> ', currentRule.get('name', 'Unnamed'))
              }
              transformActions(currentRule.get('actions', Map())).map((actionTarget, key) => {
                let keyPath;
                if (_.endsWith(key, ':list_row_style')) {
                  let keyPath = String(key).split(':')
                  keyPath = [..._.initial(keyPath), index, _.last(keyPath)]
                  if (actionTarget.getIn([0, 'value'], '')) {
                    let rules = retState.getIn(['rules'], Map()).toJS()
                    rules = _.set(rules, keyPath);
                    retState = retState.setIn(['rules'], fromJS(rules))
                  }
                } else if (key.indexOf(':listFieldStyle:') !== -1) {
                  let keyPath = String(key).split(':')
                  keyPath = [..._.initial(keyPath), index, _.last(keyPath)]

                  retState = retState.setIn(
                    ['rules', ...keyPath],
                    Map({
                      ...actionTarget.getIn([0, 'value'], '') ? { backgroundColor: '' } : {},
                      ...actionTarget.getIn([0, 'valueColor'], '') ? { color: '' } : {},
                      ...actionTarget.getIn([0, 'type'], '') == 'hide' ? { display: 'none' } : {},
                    })
                  )
                } else {
                  keyPath = String(key).split(':')
                  keyPath = [
                    ...keyPath,
                    index,
                  ]
                  let isBGColog = actionTarget.find(v => isImmutable(v) && v.get('type') === 'set_bg_color')
                  let oldRulesList = retState.getIn(['rules', ...keyPath], List())
                  if (isBGColog) {
                    oldRulesList = retState.getIn(['rules', ...keyPath], List())
                      .filter(v => !_.startsWith(v, 'bg_color'))
                  }
                  let oppositeRule = setNewRules(oldRulesList,
                    actionTarget.map(action => {
                      if (!isImmutable(action)) { action = Map() }
                      if (action.get('type') === 'mandatory' && !ALLOW_MANDATORY_TYPE.includes(action.get('elemType'))) {
                        return ''
                      } else {
                        return getOpposite(action.get('type'))
                      }
                    }), keyPath)

                    retState = setValueToObject(retState, ['rules', ...keyPath], oppositeRule, true);
                  retState = refreshOnProcessOpposite(retState, actionTarget, isOnload, oldState);
                }
              });
            }
          }
        }
      } else {
        if(allListPaths.length > 1){
          _.each(
            allListPaths,
            path => {
              let pathState = _.get(portalState, path, [])
              if(!_.isArray(pathState)){
                pathState = [pathState]
              }
              if(_.size(listState) < _.size(pathState)){
                listState = pathState
              }
            }
          )
        }
        _.map(listState, (row, index) => {
          let localRowIndex = rowIndex;
          const processRuleTargets = getProcessTargetsFunction(retState, currentRule, isOnlyEffects, portalState, params, isNotNeedProcessSF, isOnload, processUID, processIndex, oldState, oldParams, path);
          if(listPath.length === 0) {
            localRowIndex = null;
            index = null;
          } else if (rowIndex !== undefined && rowIndex !== null) {
            if (rowIndex !== index) {
              return false;
            }
          }
          if(currentRule.get('modeType') === 'flow'){
            const result = processRuleTargets(index, true, false, Map(), currentRule.get('actions', Map()), localRowIndex)
            retState = result.retState
            portalState = result.portalState
            params = result.params
          }else{
            let condResult = true;
            if(currentRule.get('conditions', List()).size) {
              condResult = processRuleCondition(
                currentRule.get('conditions', List()).toJS(),
                portalState,
                params,
                smartVParams,
                null,
                { listIndex: index },
                isOnload,
                oldState,
                oldParams,
                retState
              ) || currentRule.get('modeType') === 'flow'
            }

            // console.log('list row >>>', index, condResult)
            if (condResult) {
              if (IS_ALLOW_DEBUG_MODE) {
                console.log('run rule >>> ', currentRule.get('name', 'Unnamed'))
              }
              const result = processRuleTargets(index, true, false, Map(), currentRule.get('actions', Map()), localRowIndex)
              retState = result.retState
              portalState = result.portalState
              params = result.params
            } else {
              if (currentRule.get('supportOpposite', false)) {
                if (IS_ALLOW_DEBUG_MODE) {
                  console.log('run rule opposite >>> ', currentRule.get('name', 'Unnamed'))
                }
                transformActions(currentRule.get('actions', Map())).map((actionTarget, key) => {
                  let keyPath;
                  if (_.endsWith(key, ':list_row_style')) {
                    let keyPath = String(key).split(':')
                    keyPath = [..._.initial(keyPath), index, _.last(keyPath)]
                    if (actionTarget.getIn([0, 'value'], '')) {
                      let rules = retState.getIn(['rules'], Map()).toJS()
                      rules = _.set(rules, keyPath);
                      retState = retState.setIn(['rules'], fromJS(rules))
                    }
                  } else if (key.indexOf(':listFieldStyle:') !== -1) {
                    let keyPath = String(key).split(':')
                    keyPath = [..._.initial(keyPath), index, _.last(keyPath)]

                    retState = retState.setIn(
                      ['rules', ...keyPath],
                      Map({
                        ...actionTarget.getIn([0, 'value'], '') ? { backgroundColor: '' } : {},
                        ...actionTarget.getIn([0, 'valueColor'], '') ? { color: '' } : {},
                        ...actionTarget.getIn([0, 'type'], '') == 'hide' ? { display: 'none' } : {},
                      })
                    )
                  } else {
                    keyPath = String(key).split(':')
                    keyPath = [
                      ...keyPath,
                      index,
                    ]
                    let isBGColog = actionTarget.find(v => isImmutable(v) && v.get('type') === 'set_bg_color')
                    let oldRulesList = retState.getIn(['rules', ...keyPath], List())
                    if (isBGColog) {
                      oldRulesList = retState.getIn(['rules', ...keyPath], List())
                        .filter(v => !_.startsWith(v, 'bg_color'))
                    }
                    let oppositeRule = setNewRules(oldRulesList,
                      actionTarget.map(action => {
                        if (!isImmutable(action)) { action = Map() }
                        if (action.get('type') === 'mandatory' && !ALLOW_MANDATORY_TYPE.includes(action.get('elemType'))) {
                          return ''
                        } else {
                          return getOpposite(action.get('type'))
                        }
                      }), keyPath)

                      retState = setValueToObject(retState, ['rules', ...keyPath], oppositeRule, true);
                    retState = refreshOnProcessOpposite(retState, actionTarget, isOnload, oldState);
                  }
                });
              }
            }
          }
        })
      }
    })
  } else {
    const ruleRunResult = processRuleCondition(
      currentRule.get('conditions', List()).toJS(),
      portalState,
      params,
      smartVParams,
      null,
      {},
      isOnload,
      oldState,
      oldParams,
      retState
    ) || currentRule.get('modeType') === 'flow'

    // window.RULE_ITERATION = window.RULE_ITERATION + 1 || 0
    // if (window.RULE_ITERATION > 25) {
    //   return retState
    // }

    if (ruleRunResult) {
      if (IS_ALLOW_DEBUG_MODE) {
        console.log('run rule >>> ', currentRule.get('name', 'Unnamed'))
      }
      let localIndex = null;
      if(currentRule.get('modeType') === 'flow') {
        localIndex = rowIndex;
      }

      let filteredActions = currentRule.get('actions', Map())
      .filter((v, k) => k.indexOf(':REPEAT:') === -1)
      const result = processRuleTargets(localIndex, true, false, Map(), filteredActions, null, processMeta)
      retState = result.retState
      portalState = result.portalState
      params = result.params
    } else {
      if (currentRule.get('supportOpposite', false)) {
        if (IS_ALLOW_DEBUG_MODE) {
          console.log('run rule opposite >>> ', currentRule.get('name', 'Unnamed'))
        }
        transformActions(currentRule.get('actions', Map())).map((actionTarget, key) => {
          if (!actionTarget) {
            return true;
          }
          if (!List.isList(actionTarget)) {
            return true;
          }
          if (!actionTarget.size) {
            return true;
          }
          let keyPath = String(key).split(':');
          if (typeof currentRule?.get('index') != 'number') {
            if (keyPath[2] == 'items') {
              keyPath = [keyPath[0], `${keyPath[1]}-${keyPath[2]}`, keyPath[3]];
            }
          } else {
            if (keyPath[3] == 'items') {
              keyPath = [keyPath[0], keyPath[1], `${keyPath[2]}-${keyPath[3]}`, currentRule?.get('index'), keyPath[4]];
            }
          }

          const oldRules = toJS(retState.getIn(['rules', ...keyPath]))
          const newRules = actionTarget.map(action => {
            if (!isImmutable(action)) { action = Map() }
            if (action.get('type') === 'mandatory' && !ALLOW_MANDATORY_TYPE.includes(action.get('elemType'))) {
              return ''
            } else {
              return getOpposite(action.get('type'))
            }
          })
          retState = retState.setIn(
            ['rules', ...keyPath],
            setNewRules(retState.getIn(['rules', ...keyPath], List()), newRules, keyPath)

          );
          if (!shallowEqual(oldRules, newRules.toJS())) {
            let fullPath = key.split(':');
            if (fullPath[1]) {
              // retState = doProcessRules(retState, false, fullPath[1], fullPath, null, true, isOnload, oldState)
              retState = retState.setIn(
                ['ft', 'changes'],
                effectElementsInsideCondition(retState, fullPath)
              )
            }
          }
        });
      }
    }
  }
  let changes = _.uniqBy(retState.getIn(['ft', 'changes'], List()).toJS(), v => v.join(':'))
  retState = retState.setIn(
    ['ft', 'changes'],
    List()
  )

  if (changes.length > 0) {
    let key = fullPath.join(':');
    changes = _.filter(changes, function (row) {
      if (row) {
        return row.join(':') != key;
      }
      return true;
    })
  }
  if (changes.length > 0) {
    retState = doProcessRules(retState, false, null, [], compactArrayPath(changes), true, isOnload, null)
  }
  return retState;
}
